import { g as Nk } from "./_commonjsHelpers-DaMA6jEr.js";
import YT from "react";
var rC = { exports: {} }, Qr = {}, wm = { exports: {} }, tC = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VT;
function zk() {
  return VT || (VT = 1, function(le) {
    function Ae(P, ve) {
      var Z = P.length;
      P.push(ve);
      e: for (; 0 < Z; ) {
        var Ie = Z - 1 >>> 1, qe = P[Ie];
        if (0 < ht(qe, ve)) P[Ie] = ve, P[Z] = qe, Z = Ie;
        else break e;
      }
    }
    function N(P) {
      return P.length === 0 ? null : P[0];
    }
    function ur(P) {
      if (P.length === 0) return null;
      var ve = P[0], Z = P.pop();
      if (Z !== ve) {
        P[0] = Z;
        e: for (var Ie = 0, qe = P.length, Gr = qe >>> 1; Ie < Gr; ) {
          var Rn = 2 * (Ie + 1) - 1, Pi = P[Rn], Vn = Rn + 1, jn = P[Vn];
          if (0 > ht(Pi, Z)) Vn < qe && 0 > ht(jn, Pi) ? (P[Ie] = jn, P[Vn] = Z, Ie = Vn) : (P[Ie] = Pi, P[Rn] = Z, Ie = Rn);
          else if (Vn < qe && 0 > ht(jn, Z)) P[Ie] = jn, P[Vn] = Z, Ie = Vn;
          else break e;
        }
      }
      return ve;
    }
    function ht(P, ve) {
      var Z = P.sortIndex - ve.sortIndex;
      return Z !== 0 ? Z : P.id - ve.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var bt = performance;
      le.unstable_now = function() {
        return bt.now();
      };
    } else {
      var S = Date, Fn = S.now();
      le.unstable_now = function() {
        return S.now() - Fn;
      };
    }
    var ge = [], fe = [], Zt = 1, ne = null, Se = 3, ae = !1, He = !1, Xe = !1, at = typeof setTimeout == "function" ? setTimeout : null, Rr = typeof clearTimeout == "function" ? clearTimeout : null, Cn = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function _e(P) {
      for (var ve = N(fe); ve !== null; ) {
        if (ve.callback === null) ur(fe);
        else if (ve.startTime <= P) ur(fe), ve.sortIndex = ve.expirationTime, Ae(ge, ve);
        else break;
        ve = N(fe);
      }
    }
    function it(P) {
      if (Xe = !1, _e(P), !He) if (N(ge) !== null) He = !0, _t(Me);
      else {
        var ve = N(fe);
        ve !== null && Na(it, ve.startTime - P);
      }
    }
    function Me(P, ve) {
      He = !1, Xe && (Xe = !1, Rr(En), En = -1), ae = !0;
      var Z = Se;
      try {
        for (_e(ve), ne = N(ge); ne !== null && (!(ne.expirationTime > ve) || P && !Bt()); ) {
          var Ie = ne.callback;
          if (typeof Ie == "function") {
            ne.callback = null, Se = ne.priorityLevel;
            var qe = Ie(ne.expirationTime <= ve);
            ve = le.unstable_now(), typeof qe == "function" ? ne.callback = qe : ne === N(ge) && ur(ge), _e(ve);
          } else ur(ge);
          ne = N(ge);
        }
        if (ne !== null) var Gr = !0;
        else {
          var Rn = N(fe);
          Rn !== null && Na(it, Rn.startTime - ve), Gr = !1;
        }
        return Gr;
      } finally {
        ne = null, Se = Z, ae = !1;
      }
    }
    var ft = !1, De = null, En = -1, mt = 5, Wt = -1;
    function Bt() {
      return !(le.unstable_now() - Wt < mt);
    }
    function lt() {
      if (De !== null) {
        var P = le.unstable_now();
        Wt = P;
        var ve = !0;
        try {
          ve = De(!0, P);
        } finally {
          ve ? we() : (ft = !1, De = null);
        }
      } else ft = !1;
    }
    var we;
    if (typeof Cn == "function") we = function() {
      Cn(lt);
    };
    else if (typeof MessageChannel < "u") {
      var vn = new MessageChannel(), Tn = vn.port2;
      vn.port1.onmessage = lt, we = function() {
        Tn.postMessage(null);
      };
    } else we = function() {
      at(lt, 0);
    };
    function _t(P) {
      De = P, ft || (ft = !0, we());
    }
    function Na(P, ve) {
      En = at(function() {
        P(le.unstable_now());
      }, ve);
    }
    le.unstable_IdlePriority = 5, le.unstable_ImmediatePriority = 1, le.unstable_LowPriority = 4, le.unstable_NormalPriority = 3, le.unstable_Profiling = null, le.unstable_UserBlockingPriority = 2, le.unstable_cancelCallback = function(P) {
      P.callback = null;
    }, le.unstable_continueExecution = function() {
      He || ae || (He = !0, _t(Me));
    }, le.unstable_forceFrameRate = function(P) {
      0 > P || 125 < P ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : mt = 0 < P ? Math.floor(1e3 / P) : 5;
    }, le.unstable_getCurrentPriorityLevel = function() {
      return Se;
    }, le.unstable_getFirstCallbackNode = function() {
      return N(ge);
    }, le.unstable_next = function(P) {
      switch (Se) {
        case 1:
        case 2:
        case 3:
          var ve = 3;
          break;
        default:
          ve = Se;
      }
      var Z = Se;
      Se = ve;
      try {
        return P();
      } finally {
        Se = Z;
      }
    }, le.unstable_pauseExecution = function() {
    }, le.unstable_requestPaint = function() {
    }, le.unstable_runWithPriority = function(P, ve) {
      switch (P) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          P = 3;
      }
      var Z = Se;
      Se = P;
      try {
        return ve();
      } finally {
        Se = Z;
      }
    }, le.unstable_scheduleCallback = function(P, ve, Z) {
      var Ie = le.unstable_now();
      switch (typeof Z == "object" && Z !== null ? (Z = Z.delay, Z = typeof Z == "number" && 0 < Z ? Ie + Z : Ie) : Z = Ie, P) {
        case 1:
          var qe = -1;
          break;
        case 2:
          qe = 250;
          break;
        case 5:
          qe = 1073741823;
          break;
        case 4:
          qe = 1e4;
          break;
        default:
          qe = 5e3;
      }
      return qe = Z + qe, P = { id: Zt++, callback: ve, priorityLevel: P, startTime: Z, expirationTime: qe, sortIndex: -1 }, Z > Ie ? (P.sortIndex = Z, Ae(fe, P), N(ge) === null && P === N(fe) && (Xe ? (Rr(En), En = -1) : Xe = !0, Na(it, Z - Ie))) : (P.sortIndex = qe, Ae(ge, P), He || ae || (He = !0, _t(Me))), P;
    }, le.unstable_shouldYield = Bt, le.unstable_wrapCallback = function(P) {
      var ve = Se;
      return function() {
        var Z = Se;
        Se = ve;
        try {
          return P.apply(this, arguments);
        } finally {
          Se = Z;
        }
      };
    };
  }(tC)), tC;
}
var nC = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jT;
function Uk() {
  return jT || (jT = 1, function(le) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var Ae = !1, N = 5;
      function ur($, de) {
        var ke = $.length;
        $.push(de), S($, de, ke);
      }
      function ht($) {
        return $.length === 0 ? null : $[0];
      }
      function bt($) {
        if ($.length === 0)
          return null;
        var de = $[0], ke = $.pop();
        return ke !== de && ($[0] = ke, Fn($, ke, 0)), de;
      }
      function S($, de, ke) {
        for (var et = ke; et > 0; ) {
          var yt = et - 1 >>> 1, Pn = $[yt];
          if (ge(Pn, de) > 0)
            $[yt] = de, $[et] = Pn, et = yt;
          else
            return;
        }
      }
      function Fn($, de, ke) {
        for (var et = ke, yt = $.length, Pn = yt >>> 1; et < Pn; ) {
          var Lt = (et + 1) * 2 - 1, $n = $[Lt], Mt = Lt + 1, gt = $[Mt];
          if (ge($n, de) < 0)
            Mt < yt && ge(gt, $n) < 0 ? ($[et] = gt, $[Mt] = de, et = Mt) : ($[et] = $n, $[Lt] = de, et = Lt);
          else if (Mt < yt && ge(gt, de) < 0)
            $[et] = gt, $[Mt] = de, et = Mt;
          else
            return;
        }
      }
      function ge($, de) {
        var ke = $.sortIndex - de.sortIndex;
        return ke !== 0 ? ke : $.id - de.id;
      }
      var fe = 1, Zt = 2, ne = 3, Se = 4, ae = 5;
      function He($, de) {
      }
      var Xe = typeof performance == "object" && typeof performance.now == "function";
      if (Xe) {
        var at = performance;
        le.unstable_now = function() {
          return at.now();
        };
      } else {
        var Rr = Date, Cn = Rr.now();
        le.unstable_now = function() {
          return Rr.now() - Cn;
        };
      }
      var _e = 1073741823, it = -1, Me = 250, ft = 5e3, De = 1e4, En = _e, mt = [], Wt = [], Bt = 1, lt = null, we = ne, vn = !1, Tn = !1, _t = !1, Na = typeof setTimeout == "function" ? setTimeout : null, P = typeof clearTimeout == "function" ? clearTimeout : null, ve = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function Z($) {
        for (var de = ht(Wt); de !== null; ) {
          if (de.callback === null)
            bt(Wt);
          else if (de.startTime <= $)
            bt(Wt), de.sortIndex = de.expirationTime, ur(mt, de);
          else
            return;
          de = ht(Wt);
        }
      }
      function Ie($) {
        if (_t = !1, Z($), !Tn)
          if (ht(mt) !== null)
            Tn = !0, cr(qe);
          else {
            var de = ht(Wt);
            de !== null && da(Ie, de.startTime - $);
          }
      }
      function qe($, de) {
        Tn = !1, _t && (_t = !1, Yi()), vn = !0;
        var ke = we;
        try {
          var et;
          if (!Ae) return Gr($, de);
        } finally {
          lt = null, we = ke, vn = !1;
        }
      }
      function Gr($, de) {
        var ke = de;
        for (Z(ke), lt = ht(mt); lt !== null && !(lt.expirationTime > ke && (!$ || Au())); ) {
          var et = lt.callback;
          if (typeof et == "function") {
            lt.callback = null, we = lt.priorityLevel;
            var yt = lt.expirationTime <= ke, Pn = et(yt);
            ke = le.unstable_now(), typeof Pn == "function" ? lt.callback = Pn : lt === ht(mt) && bt(mt), Z(ke);
          } else
            bt(mt);
          lt = ht(mt);
        }
        if (lt !== null)
          return !0;
        var Lt = ht(Wt);
        return Lt !== null && da(Ie, Lt.startTime - ke), !1;
      }
      function Rn($, de) {
        switch ($) {
          case fe:
          case Zt:
          case ne:
          case Se:
          case ae:
            break;
          default:
            $ = ne;
        }
        var ke = we;
        we = $;
        try {
          return de();
        } finally {
          we = ke;
        }
      }
      function Pi($) {
        var de;
        switch (we) {
          case fe:
          case Zt:
          case ne:
            de = ne;
            break;
          default:
            de = we;
            break;
        }
        var ke = we;
        we = de;
        try {
          return $();
        } finally {
          we = ke;
        }
      }
      function Vn($) {
        var de = we;
        return function() {
          var ke = we;
          we = de;
          try {
            return $.apply(this, arguments);
          } finally {
            we = ke;
          }
        };
      }
      function jn($, de, ke) {
        var et = le.unstable_now(), yt;
        if (typeof ke == "object" && ke !== null) {
          var Pn = ke.delay;
          typeof Pn == "number" && Pn > 0 ? yt = et + Pn : yt = et;
        } else
          yt = et;
        var Lt;
        switch ($) {
          case fe:
            Lt = it;
            break;
          case Zt:
            Lt = Me;
            break;
          case ae:
            Lt = En;
            break;
          case Se:
            Lt = De;
            break;
          case ne:
          default:
            Lt = ft;
            break;
        }
        var $n = yt + Lt, Mt = {
          id: Bt++,
          callback: de,
          priorityLevel: $,
          startTime: yt,
          expirationTime: $n,
          sortIndex: -1
        };
        return yt > et ? (Mt.sortIndex = yt, ur(Wt, Mt), ht(mt) === null && Mt === ht(Wt) && (_t ? Yi() : _t = !0, da(Ie, yt - et))) : (Mt.sortIndex = $n, ur(mt, Mt), !Tn && !vn && (Tn = !0, cr(qe))), Mt;
      }
      function xr() {
      }
      function sa() {
        !Tn && !vn && (Tn = !0, cr(qe));
      }
      function li() {
        return ht(mt);
      }
      function hn($) {
        $.callback = null;
      }
      function ca() {
        return we;
      }
      var Bn = !1, or = null, wr = -1, fa = N, Vl = -1;
      function Au() {
        var $ = le.unstable_now() - Vl;
        return !($ < fa);
      }
      function Hu() {
      }
      function $i($) {
        if ($ < 0 || $ > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        $ > 0 ? fa = Math.floor(1e3 / $) : fa = N;
      }
      var sr = function() {
        if (or !== null) {
          var $ = le.unstable_now();
          Vl = $;
          var de = !0, ke = !0;
          try {
            ke = or(de, $);
          } finally {
            ke ? Dr() : (Bn = !1, or = null);
          }
        } else
          Bn = !1;
      }, Dr;
      if (typeof ve == "function")
        Dr = function() {
          ve(sr);
        };
      else if (typeof MessageChannel < "u") {
        var Wr = new MessageChannel(), jl = Wr.port2;
        Wr.port1.onmessage = sr, Dr = function() {
          jl.postMessage(null);
        };
      } else
        Dr = function() {
          Na(sr, 0);
        };
      function cr($) {
        or = $, Bn || (Bn = !0, Dr());
      }
      function da($, de) {
        wr = Na(function() {
          $(le.unstable_now());
        }, de);
      }
      function Yi() {
        P(wr), wr = -1;
      }
      var Qi = Hu, Fu = null;
      le.unstable_IdlePriority = ae, le.unstable_ImmediatePriority = fe, le.unstable_LowPriority = Se, le.unstable_NormalPriority = ne, le.unstable_Profiling = Fu, le.unstable_UserBlockingPriority = Zt, le.unstable_cancelCallback = hn, le.unstable_continueExecution = sa, le.unstable_forceFrameRate = $i, le.unstable_getCurrentPriorityLevel = ca, le.unstable_getFirstCallbackNode = li, le.unstable_next = Pi, le.unstable_pauseExecution = xr, le.unstable_requestPaint = Qi, le.unstable_runWithPriority = Rn, le.unstable_scheduleCallback = jn, le.unstable_shouldYield = Au, le.unstable_wrapCallback = Vn, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(nC)), nC;
}
var BT;
function QT() {
  return BT || (BT = 1, process.env.NODE_ENV === "production" ? wm.exports = zk() : wm.exports = Uk()), wm.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PT;
function Ak() {
  if (PT) return Qr;
  PT = 1;
  var le = YT, Ae = QT();
  function N(n) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, l = 1; l < arguments.length; l++) r += "&args[]=" + encodeURIComponent(arguments[l]);
    return "Minified React error #" + n + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var ur = /* @__PURE__ */ new Set(), ht = {};
  function bt(n, r) {
    S(n, r), S(n + "Capture", r);
  }
  function S(n, r) {
    for (ht[n] = r, n = 0; n < r.length; n++) ur.add(r[n]);
  }
  var Fn = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), ge = Object.prototype.hasOwnProperty, fe = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Zt = {}, ne = {};
  function Se(n) {
    return ge.call(ne, n) ? !0 : ge.call(Zt, n) ? !1 : fe.test(n) ? ne[n] = !0 : (Zt[n] = !0, !1);
  }
  function ae(n, r, l, o) {
    if (l !== null && l.type === 0) return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return o ? !1 : l !== null ? !l.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function He(n, r, l, o) {
    if (r === null || typeof r > "u" || ae(n, r, l, o)) return !0;
    if (o) return !1;
    if (l !== null) switch (l.type) {
      case 3:
        return !r;
      case 4:
        return r === !1;
      case 5:
        return isNaN(r);
      case 6:
        return isNaN(r) || 1 > r;
    }
    return !1;
  }
  function Xe(n, r, l, o, c, d, h) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = o, this.attributeNamespace = c, this.mustUseProperty = l, this.propertyName = n, this.type = r, this.sanitizeURL = d, this.removeEmptyString = h;
  }
  var at = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    at[n] = new Xe(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var r = n[0];
    at[r] = new Xe(r, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    at[n] = new Xe(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    at[n] = new Xe(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    at[n] = new Xe(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    at[n] = new Xe(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    at[n] = new Xe(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    at[n] = new Xe(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    at[n] = new Xe(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var Rr = /[\-:]([a-z])/g;
  function Cn(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var r = n.replace(
      Rr,
      Cn
    );
    at[r] = new Xe(r, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var r = n.replace(Rr, Cn);
    at[r] = new Xe(r, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var r = n.replace(Rr, Cn);
    at[r] = new Xe(r, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    at[n] = new Xe(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), at.xlinkHref = new Xe("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    at[n] = new Xe(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function _e(n, r, l, o) {
    var c = at.hasOwnProperty(r) ? at[r] : null;
    (c !== null ? c.type !== 0 : o || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (He(r, l, c, o) && (l = null), o || c === null ? Se(r) && (l === null ? n.removeAttribute(r) : n.setAttribute(r, "" + l)) : c.mustUseProperty ? n[c.propertyName] = l === null ? c.type === 3 ? !1 : "" : l : (r = c.attributeName, o = c.attributeNamespace, l === null ? n.removeAttribute(r) : (c = c.type, l = c === 3 || c === 4 && l === !0 ? "" : "" + l, o ? n.setAttributeNS(o, r, l) : n.setAttribute(r, l))));
  }
  var it = le.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Me = Symbol.for("react.element"), ft = Symbol.for("react.portal"), De = Symbol.for("react.fragment"), En = Symbol.for("react.strict_mode"), mt = Symbol.for("react.profiler"), Wt = Symbol.for("react.provider"), Bt = Symbol.for("react.context"), lt = Symbol.for("react.forward_ref"), we = Symbol.for("react.suspense"), vn = Symbol.for("react.suspense_list"), Tn = Symbol.for("react.memo"), _t = Symbol.for("react.lazy"), Na = Symbol.for("react.offscreen"), P = Symbol.iterator;
  function ve(n) {
    return n === null || typeof n != "object" ? null : (n = P && n[P] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var Z = Object.assign, Ie;
  function qe(n) {
    if (Ie === void 0) try {
      throw Error();
    } catch (l) {
      var r = l.stack.trim().match(/\n( *(at )?)/);
      Ie = r && r[1] || "";
    }
    return `
` + Ie + n;
  }
  var Gr = !1;
  function Rn(n, r) {
    if (!n || Gr) return "";
    Gr = !0;
    var l = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) if (r = function() {
        throw Error();
      }, Object.defineProperty(r.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(r, []);
        } catch (_) {
          var o = _;
        }
        Reflect.construct(n, [], r);
      } else {
        try {
          r.call();
        } catch (_) {
          o = _;
        }
        n.call(r.prototype);
      }
      else {
        try {
          throw Error();
        } catch (_) {
          o = _;
        }
        n();
      }
    } catch (_) {
      if (_ && o && typeof _.stack == "string") {
        for (var c = _.stack.split(`
`), d = o.stack.split(`
`), h = c.length - 1, g = d.length - 1; 1 <= h && 0 <= g && c[h] !== d[g]; ) g--;
        for (; 1 <= h && 0 <= g; h--, g--) if (c[h] !== d[g]) {
          if (h !== 1 || g !== 1)
            do
              if (h--, g--, 0 > g || c[h] !== d[g]) {
                var C = `
` + c[h].replace(" at new ", " at ");
                return n.displayName && C.includes("<anonymous>") && (C = C.replace("<anonymous>", n.displayName)), C;
              }
            while (1 <= h && 0 <= g);
          break;
        }
      }
    } finally {
      Gr = !1, Error.prepareStackTrace = l;
    }
    return (n = n ? n.displayName || n.name : "") ? qe(n) : "";
  }
  function Pi(n) {
    switch (n.tag) {
      case 5:
        return qe(n.type);
      case 16:
        return qe("Lazy");
      case 13:
        return qe("Suspense");
      case 19:
        return qe("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = Rn(n.type, !1), n;
      case 11:
        return n = Rn(n.type.render, !1), n;
      case 1:
        return n = Rn(n.type, !0), n;
      default:
        return "";
    }
  }
  function Vn(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case De:
        return "Fragment";
      case ft:
        return "Portal";
      case mt:
        return "Profiler";
      case En:
        return "StrictMode";
      case we:
        return "Suspense";
      case vn:
        return "SuspenseList";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case Bt:
        return (n.displayName || "Context") + ".Consumer";
      case Wt:
        return (n._context.displayName || "Context") + ".Provider";
      case lt:
        var r = n.render;
        return n = n.displayName, n || (n = r.displayName || r.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case Tn:
        return r = n.displayName || null, r !== null ? r : Vn(n.type) || "Memo";
      case _t:
        r = n._payload, n = n._init;
        try {
          return Vn(n(r));
        } catch {
        }
    }
    return null;
  }
  function jn(n) {
    var r = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = r.render, n = n.displayName || n.name || "", r.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Vn(r);
      case 8:
        return r === En ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function") return r.displayName || r.name || null;
        if (typeof r == "string") return r;
    }
    return null;
  }
  function xr(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function sa(n) {
    var r = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function li(n) {
    var r = sa(n) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(n.constructor.prototype, r), o = "" + n[r];
    if (!n.hasOwnProperty(r) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var c = l.get, d = l.set;
      return Object.defineProperty(n, r, { configurable: !0, get: function() {
        return c.call(this);
      }, set: function(h) {
        o = "" + h, d.call(this, h);
      } }), Object.defineProperty(n, r, { enumerable: l.enumerable }), { getValue: function() {
        return o;
      }, setValue: function(h) {
        o = "" + h;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[r];
      } };
    }
  }
  function hn(n) {
    n._valueTracker || (n._valueTracker = li(n));
  }
  function ca(n) {
    if (!n) return !1;
    var r = n._valueTracker;
    if (!r) return !0;
    var l = r.getValue(), o = "";
    return n && (o = sa(n) ? n.checked ? "true" : "false" : n.value), n = o, n !== l ? (r.setValue(n), !0) : !1;
  }
  function Bn(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  function or(n, r) {
    var l = r.checked;
    return Z({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: l ?? n._wrapperState.initialChecked });
  }
  function wr(n, r) {
    var l = r.defaultValue == null ? "" : r.defaultValue, o = r.checked != null ? r.checked : r.defaultChecked;
    l = xr(r.value != null ? r.value : l), n._wrapperState = { initialChecked: o, initialValue: l, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function fa(n, r) {
    r = r.checked, r != null && _e(n, "checked", r, !1);
  }
  function Vl(n, r) {
    fa(n, r);
    var l = xr(r.value), o = r.type;
    if (l != null) o === "number" ? (l === 0 && n.value === "" || n.value != l) && (n.value = "" + l) : n.value !== "" + l && (n.value = "" + l);
    else if (o === "submit" || o === "reset") {
      n.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? Hu(n, r.type, l) : r.hasOwnProperty("defaultValue") && Hu(n, r.type, xr(r.defaultValue)), r.checked == null && r.defaultChecked != null && (n.defaultChecked = !!r.defaultChecked);
  }
  function Au(n, r, l) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var o = r.type;
      if (!(o !== "submit" && o !== "reset" || r.value !== void 0 && r.value !== null)) return;
      r = "" + n._wrapperState.initialValue, l || r === n.value || (n.value = r), n.defaultValue = r;
    }
    l = n.name, l !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, l !== "" && (n.name = l);
  }
  function Hu(n, r, l) {
    (r !== "number" || Bn(n.ownerDocument) !== n) && (l == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + l && (n.defaultValue = "" + l));
  }
  var $i = Array.isArray;
  function sr(n, r, l, o) {
    if (n = n.options, r) {
      r = {};
      for (var c = 0; c < l.length; c++) r["$" + l[c]] = !0;
      for (l = 0; l < n.length; l++) c = r.hasOwnProperty("$" + n[l].value), n[l].selected !== c && (n[l].selected = c), c && o && (n[l].defaultSelected = !0);
    } else {
      for (l = "" + xr(l), r = null, c = 0; c < n.length; c++) {
        if (n[c].value === l) {
          n[c].selected = !0, o && (n[c].defaultSelected = !0);
          return;
        }
        r !== null || n[c].disabled || (r = n[c]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function Dr(n, r) {
    if (r.dangerouslySetInnerHTML != null) throw Error(N(91));
    return Z({}, r, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function Wr(n, r) {
    var l = r.value;
    if (l == null) {
      if (l = r.children, r = r.defaultValue, l != null) {
        if (r != null) throw Error(N(92));
        if ($i(l)) {
          if (1 < l.length) throw Error(N(93));
          l = l[0];
        }
        r = l;
      }
      r == null && (r = ""), l = r;
    }
    n._wrapperState = { initialValue: xr(l) };
  }
  function jl(n, r) {
    var l = xr(r.value), o = xr(r.defaultValue);
    l != null && (l = "" + l, l !== n.value && (n.value = l), r.defaultValue == null && n.defaultValue !== l && (n.defaultValue = l)), o != null && (n.defaultValue = "" + o);
  }
  function cr(n) {
    var r = n.textContent;
    r === n._wrapperState.initialValue && r !== "" && r !== null && (n.value = r);
  }
  function da(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Yi(n, r) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? da(r) : n === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var Qi, Fu = function(n) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, l, o, c) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(r, l, o, c);
      });
    } : n;
  }(function(n, r) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = r;
    else {
      for (Qi = Qi || document.createElement("div"), Qi.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Qi.firstChild; n.firstChild; ) n.removeChild(n.firstChild);
      for (; r.firstChild; ) n.appendChild(r.firstChild);
    }
  });
  function $(n, r) {
    if (r) {
      var l = n.firstChild;
      if (l && l === n.lastChild && l.nodeType === 3) {
        l.nodeValue = r;
        return;
      }
    }
    n.textContent = r;
  }
  var de = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ke = ["Webkit", "ms", "Moz", "O"];
  Object.keys(de).forEach(function(n) {
    ke.forEach(function(r) {
      r = r + n.charAt(0).toUpperCase() + n.substring(1), de[r] = de[n];
    });
  });
  function et(n, r, l) {
    return r == null || typeof r == "boolean" || r === "" ? "" : l || typeof r != "number" || r === 0 || de.hasOwnProperty(n) && de[n] ? ("" + r).trim() : r + "px";
  }
  function yt(n, r) {
    n = n.style;
    for (var l in r) if (r.hasOwnProperty(l)) {
      var o = l.indexOf("--") === 0, c = et(l, r[l], o);
      l === "float" && (l = "cssFloat"), o ? n.setProperty(l, c) : n[l] = c;
    }
  }
  var Pn = Z({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Lt(n, r) {
    if (r) {
      if (Pn[n] && (r.children != null || r.dangerouslySetInnerHTML != null)) throw Error(N(137, n));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null) throw Error(N(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML)) throw Error(N(61));
      }
      if (r.style != null && typeof r.style != "object") throw Error(N(62));
    }
  }
  function $n(n, r) {
    if (n.indexOf("-") === -1) return typeof r.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Mt = null;
  function gt(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var Pt = null, Bl = null, ui = null;
  function as(n) {
    if (n = ue(n)) {
      if (typeof Pt != "function") throw Error(N(280));
      var r = n.stateNode;
      r && (r = Et(r), Pt(n.stateNode, n.type, r));
    }
  }
  function xp(n) {
    Bl ? ui ? ui.push(n) : ui = [n] : Bl = n;
  }
  function wp() {
    if (Bl) {
      var n = Bl, r = ui;
      if (ui = Bl = null, as(n), r) for (n = 0; n < r.length; n++) as(r[n]);
    }
  }
  function tf(n, r) {
    return n(r);
  }
  function nf() {
  }
  var rf = !1;
  function af(n, r, l) {
    if (rf) return n(r, l);
    rf = !0;
    try {
      return tf(n, r, l);
    } finally {
      rf = !1, (Bl !== null || ui !== null) && (nf(), wp());
    }
  }
  function Ii(n, r) {
    var l = n.stateNode;
    if (l === null) return null;
    var o = Et(l);
    if (o === null) return null;
    l = o[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (o = !o.disabled) || (n = n.type, o = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !o;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (l && typeof l != "function") throw Error(N(231, r, typeof l));
    return l;
  }
  var oi = !1;
  if (Fn) try {
    var Xr = {};
    Object.defineProperty(Xr, "passive", { get: function() {
      oi = !0;
    } }), window.addEventListener("test", Xr, Xr), window.removeEventListener("test", Xr, Xr);
  } catch {
    oi = !1;
  }
  function Pl(n, r, l, o, c, d, h, g, C) {
    var _ = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(l, _);
    } catch (H) {
      this.onError(H);
    }
  }
  var Gi = !1, $l = null, Yl = !1, Vu = null, Ql = { onError: function(n) {
    Gi = !0, $l = n;
  } };
  function is(n, r, l, o, c, d, h, g, C) {
    Gi = !1, $l = null, Pl.apply(Ql, arguments);
  }
  function ls(n, r, l, o, c, d, h, g, C) {
    if (is.apply(this, arguments), Gi) {
      if (Gi) {
        var _ = $l;
        Gi = !1, $l = null;
      } else throw Error(N(198));
      Yl || (Yl = !0, Vu = _);
    }
  }
  function qr(n) {
    var r = n, l = n;
    if (n.alternate) for (; r.return; ) r = r.return;
    else {
      n = r;
      do
        r = n, r.flags & 4098 && (l = r.return), n = r.return;
      while (n);
    }
    return r.tag === 3 ? l : null;
  }
  function mn(n) {
    if (n.tag === 13) {
      var r = n.memoizedState;
      if (r === null && (n = n.alternate, n !== null && (r = n.memoizedState)), r !== null) return r.dehydrated;
    }
    return null;
  }
  function Dp(n) {
    if (qr(n) !== n) throw Error(N(188));
  }
  function Dm(n) {
    var r = n.alternate;
    if (!r) {
      if (r = qr(n), r === null) throw Error(N(188));
      return r !== n ? null : n;
    }
    for (var l = n, o = r; ; ) {
      var c = l.return;
      if (c === null) break;
      var d = c.alternate;
      if (d === null) {
        if (o = c.return, o !== null) {
          l = o;
          continue;
        }
        break;
      }
      if (c.child === d.child) {
        for (d = c.child; d; ) {
          if (d === l) return Dp(c), n;
          if (d === o) return Dp(c), r;
          d = d.sibling;
        }
        throw Error(N(188));
      }
      if (l.return !== o.return) l = c, o = d;
      else {
        for (var h = !1, g = c.child; g; ) {
          if (g === l) {
            h = !0, l = c, o = d;
            break;
          }
          if (g === o) {
            h = !0, o = c, l = d;
            break;
          }
          g = g.sibling;
        }
        if (!h) {
          for (g = d.child; g; ) {
            if (g === l) {
              h = !0, l = d, o = c;
              break;
            }
            if (g === o) {
              h = !0, o = d, l = c;
              break;
            }
            g = g.sibling;
          }
          if (!h) throw Error(N(189));
        }
      }
      if (l.alternate !== o) throw Error(N(190));
    }
    if (l.tag !== 3) throw Error(N(188));
    return l.stateNode.current === l ? n : r;
  }
  function lf(n) {
    return n = Dm(n), n !== null ? kp(n) : null;
  }
  function kp(n) {
    if (n.tag === 5 || n.tag === 6) return n;
    for (n = n.child; n !== null; ) {
      var r = kp(n);
      if (r !== null) return r;
      n = n.sibling;
    }
    return null;
  }
  var bp = Ae.unstable_scheduleCallback, _p = Ae.unstable_cancelCallback, Lp = Ae.unstable_shouldYield, km = Ae.unstable_requestPaint, tt = Ae.unstable_now, Le = Ae.unstable_getCurrentPriorityLevel, Wi = Ae.unstable_ImmediatePriority, uf = Ae.unstable_UserBlockingPriority, ju = Ae.unstable_NormalPriority, Mp = Ae.unstable_LowPriority, of = Ae.unstable_IdlePriority, Bu = null, Kr = null;
  function Op(n) {
    if (Kr && typeof Kr.onCommitFiberRoot == "function") try {
      Kr.onCommitFiberRoot(Bu, n, void 0, (n.current.flags & 128) === 128);
    } catch {
    }
  }
  var kr = Math.clz32 ? Math.clz32 : sf, bm = Math.log, _m = Math.LN2;
  function sf(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (bm(n) / _m | 0) | 0;
  }
  var Il = 64, Zr = 4194304;
  function Xi(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function qi(n, r) {
    var l = n.pendingLanes;
    if (l === 0) return 0;
    var o = 0, c = n.suspendedLanes, d = n.pingedLanes, h = l & 268435455;
    if (h !== 0) {
      var g = h & ~c;
      g !== 0 ? o = Xi(g) : (d &= h, d !== 0 && (o = Xi(d)));
    } else h = l & ~c, h !== 0 ? o = Xi(h) : d !== 0 && (o = Xi(d));
    if (o === 0) return 0;
    if (r !== 0 && r !== o && !(r & c) && (c = o & -o, d = r & -r, c >= d || c === 16 && (d & 4194240) !== 0)) return r;
    if (o & 4 && (o |= l & 16), r = n.entangledLanes, r !== 0) for (n = n.entanglements, r &= o; 0 < r; ) l = 31 - kr(r), c = 1 << l, o |= n[l], r &= ~c;
    return o;
  }
  function Lm(n, r) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function cf(n, r) {
    for (var l = n.suspendedLanes, o = n.pingedLanes, c = n.expirationTimes, d = n.pendingLanes; 0 < d; ) {
      var h = 31 - kr(d), g = 1 << h, C = c[h];
      C === -1 ? (!(g & l) || g & o) && (c[h] = Lm(g, r)) : C <= r && (n.expiredLanes |= g), d &= ~g;
    }
  }
  function ff(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function us() {
    var n = Il;
    return Il <<= 1, !(Il & 4194240) && (Il = 64), n;
  }
  function df(n) {
    for (var r = [], l = 0; 31 > l; l++) r.push(n);
    return r;
  }
  function Ki(n, r, l) {
    n.pendingLanes |= r, r !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, r = 31 - kr(r), n[r] = l;
  }
  function Mm(n, r) {
    var l = n.pendingLanes & ~r;
    n.pendingLanes = r, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r, r = n.entanglements;
    var o = n.eventTimes;
    for (n = n.expirationTimes; 0 < l; ) {
      var c = 31 - kr(l), d = 1 << c;
      r[c] = 0, o[c] = -1, n[c] = -1, l &= ~d;
    }
  }
  function os(n, r) {
    var l = n.entangledLanes |= r;
    for (n = n.entanglements; l; ) {
      var o = 31 - kr(l), c = 1 << o;
      c & r | n[o] & r && (n[o] |= r), l &= ~c;
    }
  }
  var Ge = 0;
  function pf(n) {
    return n &= -n, 1 < n ? 4 < n ? n & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var We, vf, hf, Te, mf, xn = !1, si = [], br = null, ci = null, St = null, ut = /* @__PURE__ */ new Map(), Pu = /* @__PURE__ */ new Map(), Jt = [], _r = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function za(n, r) {
    switch (n) {
      case "focusin":
      case "focusout":
        br = null;
        break;
      case "dragenter":
      case "dragleave":
        ci = null;
        break;
      case "mouseover":
      case "mouseout":
        St = null;
        break;
      case "pointerover":
      case "pointerout":
        ut.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Pu.delete(r.pointerId);
    }
  }
  function $u(n, r, l, o, c, d) {
    return n === null || n.nativeEvent !== d ? (n = { blockedOn: r, domEventName: l, eventSystemFlags: o, nativeEvent: d, targetContainers: [c] }, r !== null && (r = ue(r), r !== null && vf(r)), n) : (n.eventSystemFlags |= o, r = n.targetContainers, c !== null && r.indexOf(c) === -1 && r.push(c), n);
  }
  function yf(n, r, l, o, c) {
    switch (r) {
      case "focusin":
        return br = $u(br, n, r, l, o, c), !0;
      case "dragenter":
        return ci = $u(ci, n, r, l, o, c), !0;
      case "mouseover":
        return St = $u(St, n, r, l, o, c), !0;
      case "pointerover":
        var d = c.pointerId;
        return ut.set(d, $u(ut.get(d) || null, n, r, l, o, c)), !0;
      case "gotpointercapture":
        return d = c.pointerId, Pu.set(d, $u(Pu.get(d) || null, n, r, l, o, c)), !0;
    }
    return !1;
  }
  function gf(n) {
    var r = ul(n.target);
    if (r !== null) {
      var l = qr(r);
      if (l !== null) {
        if (r = l.tag, r === 13) {
          if (r = mn(l), r !== null) {
            n.blockedOn = r, mf(n.priority, function() {
              hf(l);
            });
            return;
          }
        } else if (r === 3 && l.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = l.tag === 3 ? l.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function Yu(n) {
    if (n.blockedOn !== null) return !1;
    for (var r = n.targetContainers; 0 < r.length; ) {
      var l = cs(n.domEventName, n.eventSystemFlags, r[0], n.nativeEvent);
      if (l === null) {
        l = n.nativeEvent;
        var o = new l.constructor(l.type, l);
        Mt = o, l.target.dispatchEvent(o), Mt = null;
      } else return r = ue(l), r !== null && vf(r), n.blockedOn = l, !1;
      r.shift();
    }
    return !0;
  }
  function Np(n, r, l) {
    Yu(n) && l.delete(r);
  }
  function Om() {
    xn = !1, br !== null && Yu(br) && (br = null), ci !== null && Yu(ci) && (ci = null), St !== null && Yu(St) && (St = null), ut.forEach(Np), Pu.forEach(Np);
  }
  function Qu(n, r) {
    n.blockedOn === r && (n.blockedOn = null, xn || (xn = !0, Ae.unstable_scheduleCallback(Ae.unstable_NormalPriority, Om)));
  }
  function fi(n) {
    function r(c) {
      return Qu(c, n);
    }
    if (0 < si.length) {
      Qu(si[0], n);
      for (var l = 1; l < si.length; l++) {
        var o = si[l];
        o.blockedOn === n && (o.blockedOn = null);
      }
    }
    for (br !== null && Qu(br, n), ci !== null && Qu(ci, n), St !== null && Qu(St, n), ut.forEach(r), Pu.forEach(r), l = 0; l < Jt.length; l++) o = Jt[l], o.blockedOn === n && (o.blockedOn = null);
    for (; 0 < Jt.length && (l = Jt[0], l.blockedOn === null); ) gf(l), l.blockedOn === null && Jt.shift();
  }
  var Zi = it.ReactCurrentBatchConfig, Ji = !0;
  function zp(n, r, l, o) {
    var c = Ge, d = Zi.transition;
    Zi.transition = null;
    try {
      Ge = 1, ss(n, r, l, o);
    } finally {
      Ge = c, Zi.transition = d;
    }
  }
  function Up(n, r, l, o) {
    var c = Ge, d = Zi.transition;
    Zi.transition = null;
    try {
      Ge = 4, ss(n, r, l, o);
    } finally {
      Ge = c, Zi.transition = d;
    }
  }
  function ss(n, r, l, o) {
    if (Ji) {
      var c = cs(n, r, l, o);
      if (c === null) bs(n, r, o, Iu, l), za(n, o);
      else if (yf(c, n, r, l, o)) o.stopPropagation();
      else if (za(n, o), r & 4 && -1 < _r.indexOf(n)) {
        for (; c !== null; ) {
          var d = ue(c);
          if (d !== null && We(d), d = cs(n, r, l, o), d === null && bs(n, r, o, Iu, l), d === c) break;
          c = d;
        }
        c !== null && o.stopPropagation();
      } else bs(n, r, o, null, l);
    }
  }
  var Iu = null;
  function cs(n, r, l, o) {
    if (Iu = null, n = gt(o), n = ul(n), n !== null) if (r = qr(n), r === null) n = null;
    else if (l = r.tag, l === 13) {
      if (n = mn(r), n !== null) return n;
      n = null;
    } else if (l === 3) {
      if (r.stateNode.current.memoizedState.isDehydrated) return r.tag === 3 ? r.stateNode.containerInfo : null;
      n = null;
    } else r !== n && (n = null);
    return Iu = n, null;
  }
  function fs(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Le()) {
          case Wi:
            return 1;
          case uf:
            return 4;
          case ju:
          case Mp:
            return 16;
          case of:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ua = null, ds = null, Gl = null;
  function Sf() {
    if (Gl) return Gl;
    var n, r = ds, l = r.length, o, c = "value" in Ua ? Ua.value : Ua.textContent, d = c.length;
    for (n = 0; n < l && r[n] === c[n]; n++) ;
    var h = l - n;
    for (o = 1; o <= h && r[l - o] === c[d - o]; o++) ;
    return Gl = c.slice(n, 1 < o ? 1 - o : void 0);
  }
  function ps(n) {
    var r = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && r === 13 && (n = 13)) : n = r, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function vs() {
    return !0;
  }
  function hs() {
    return !1;
  }
  function Yn(n) {
    function r(l, o, c, d, h) {
      this._reactName = l, this._targetInst = c, this.type = o, this.nativeEvent = d, this.target = h, this.currentTarget = null;
      for (var g in n) n.hasOwnProperty(g) && (l = n[g], this[g] = l ? l(d) : d[g]);
      return this.isDefaultPrevented = (d.defaultPrevented != null ? d.defaultPrevented : d.returnValue === !1) ? vs : hs, this.isPropagationStopped = hs, this;
    }
    return Z(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var l = this.nativeEvent;
      l && (l.preventDefault ? l.preventDefault() : typeof l.returnValue != "unknown" && (l.returnValue = !1), this.isDefaultPrevented = vs);
    }, stopPropagation: function() {
      var l = this.nativeEvent;
      l && (l.stopPropagation ? l.stopPropagation() : typeof l.cancelBubble != "unknown" && (l.cancelBubble = !0), this.isPropagationStopped = vs);
    }, persist: function() {
    }, isPersistent: vs }), r;
  }
  var el = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, ms = Yn(el), Wl = Z({}, el, { view: 0, detail: 0 }), Nm = Yn(Wl), Cf, en, tl, Gu = Z({}, Wl, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: wf, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== tl && (tl && n.type === "mousemove" ? (Cf = n.screenX - tl.screenX, en = n.screenY - tl.screenY) : en = Cf = 0, tl = n), Cf);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : en;
  } }), Ef = Yn(Gu), zm = Z({}, Gu, { dataTransfer: 0 }), Xl = Yn(zm), Tf = Z({}, Wl, { relatedTarget: 0 }), ys = Yn(Tf), Um = Z({}, el, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Am = Yn(Um), Hm = Z({}, el, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), Ap = Yn(Hm), Rf = Z({}, el, { data: 0 }), xf = Yn(Rf), Hp = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Fp = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Fm = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Aa(n) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(n) : (n = Fm[n]) ? !!r[n] : !1;
  }
  function wf() {
    return Aa;
  }
  var Df = Z({}, Wl, { key: function(n) {
    if (n.key) {
      var r = Hp[n.key] || n.key;
      if (r !== "Unidentified") return r;
    }
    return n.type === "keypress" ? (n = ps(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? Fp[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: wf, charCode: function(n) {
    return n.type === "keypress" ? ps(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? ps(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), kf = Yn(Df), bf = Z({}, Gu, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Vp = Yn(bf), gs = Z({}, Wl, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: wf }), jp = Yn(gs), Qn = Z({}, el, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Ha = Yn(Qn), Ot = Z({}, Gu, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Fa = Yn(Ot), _f = [9, 13, 27, 32], ql = Fn && "CompositionEvent" in window, Wu = null;
  Fn && "documentMode" in document && (Wu = document.documentMode);
  var Xu = Fn && "TextEvent" in window && !Wu, Bp = Fn && (!ql || Wu && 8 < Wu && 11 >= Wu), Pp = " ", Ss = !1;
  function $p(n, r) {
    switch (n) {
      case "keyup":
        return _f.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Yp(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var Kl = !1;
  function Qp(n, r) {
    switch (n) {
      case "compositionend":
        return Yp(r);
      case "keypress":
        return r.which !== 32 ? null : (Ss = !0, Pp);
      case "textInput":
        return n = r.data, n === Pp && Ss ? null : n;
      default:
        return null;
    }
  }
  function Vm(n, r) {
    if (Kl) return n === "compositionend" || !ql && $p(n, r) ? (n = Sf(), Gl = ds = Ua = null, Kl = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length) return r.char;
          if (r.which) return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return Bp && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var jm = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Ip(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r === "input" ? !!jm[n.type] : r === "textarea";
  }
  function Lf(n, r, l, o) {
    xp(o), r = to(r, "onChange"), 0 < r.length && (l = new ms("onChange", "change", null, l, o), n.push({ event: l, listeners: r }));
  }
  var pa = null, nl = null;
  function Gp(n) {
    il(n, 0);
  }
  function qu(n) {
    var r = ea(n);
    if (ca(r)) return n;
  }
  function Bm(n, r) {
    if (n === "change") return r;
  }
  var Wp = !1;
  if (Fn) {
    var Mf;
    if (Fn) {
      var Of = "oninput" in document;
      if (!Of) {
        var Xp = document.createElement("div");
        Xp.setAttribute("oninput", "return;"), Of = typeof Xp.oninput == "function";
      }
      Mf = Of;
    } else Mf = !1;
    Wp = Mf && (!document.documentMode || 9 < document.documentMode);
  }
  function qp() {
    pa && (pa.detachEvent("onpropertychange", Kp), nl = pa = null);
  }
  function Kp(n) {
    if (n.propertyName === "value" && qu(nl)) {
      var r = [];
      Lf(r, nl, n, gt(n)), af(Gp, r);
    }
  }
  function Pm(n, r, l) {
    n === "focusin" ? (qp(), pa = r, nl = l, pa.attachEvent("onpropertychange", Kp)) : n === "focusout" && qp();
  }
  function Zp(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown") return qu(nl);
  }
  function $m(n, r) {
    if (n === "click") return qu(r);
  }
  function Jp(n, r) {
    if (n === "input" || n === "change") return qu(r);
  }
  function Ym(n, r) {
    return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
  }
  var Jr = typeof Object.is == "function" ? Object.is : Ym;
  function Ku(n, r) {
    if (Jr(n, r)) return !0;
    if (typeof n != "object" || n === null || typeof r != "object" || r === null) return !1;
    var l = Object.keys(n), o = Object.keys(r);
    if (l.length !== o.length) return !1;
    for (o = 0; o < l.length; o++) {
      var c = l[o];
      if (!ge.call(r, c) || !Jr(n[c], r[c])) return !1;
    }
    return !0;
  }
  function ev(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function Cs(n, r) {
    var l = ev(n);
    n = 0;
    for (var o; l; ) {
      if (l.nodeType === 3) {
        if (o = n + l.textContent.length, n <= r && o >= r) return { node: l, offset: r - n };
        n = o;
      }
      e: {
        for (; l; ) {
          if (l.nextSibling) {
            l = l.nextSibling;
            break e;
          }
          l = l.parentNode;
        }
        l = void 0;
      }
      l = ev(l);
    }
  }
  function di(n, r) {
    return n && r ? n === r ? !0 : n && n.nodeType === 3 ? !1 : r && r.nodeType === 3 ? di(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function Zu() {
    for (var n = window, r = Bn(); r instanceof n.HTMLIFrameElement; ) {
      try {
        var l = typeof r.contentWindow.location.href == "string";
      } catch {
        l = !1;
      }
      if (l) n = r.contentWindow;
      else break;
      r = Bn(n.document);
    }
    return r;
  }
  function Es(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
  }
  function Zl(n) {
    var r = Zu(), l = n.focusedElem, o = n.selectionRange;
    if (r !== l && l && l.ownerDocument && di(l.ownerDocument.documentElement, l)) {
      if (o !== null && Es(l)) {
        if (r = o.start, n = o.end, n === void 0 && (n = r), "selectionStart" in l) l.selectionStart = r, l.selectionEnd = Math.min(n, l.value.length);
        else if (n = (r = l.ownerDocument || document) && r.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var c = l.textContent.length, d = Math.min(o.start, c);
          o = o.end === void 0 ? d : Math.min(o.end, c), !n.extend && d > o && (c = o, o = d, d = c), c = Cs(l, d);
          var h = Cs(
            l,
            o
          );
          c && h && (n.rangeCount !== 1 || n.anchorNode !== c.node || n.anchorOffset !== c.offset || n.focusNode !== h.node || n.focusOffset !== h.offset) && (r = r.createRange(), r.setStart(c.node, c.offset), n.removeAllRanges(), d > o ? (n.addRange(r), n.extend(h.node, h.offset)) : (r.setEnd(h.node, h.offset), n.addRange(r)));
        }
      }
      for (r = [], n = l; n = n.parentNode; ) n.nodeType === 1 && r.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof l.focus == "function" && l.focus(), l = 0; l < r.length; l++) n = r[l], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var Qm = Fn && "documentMode" in document && 11 >= document.documentMode, Jl = null, Nf = null, Ju = null, zf = !1;
  function Uf(n, r, l) {
    var o = l.window === l ? l.document : l.nodeType === 9 ? l : l.ownerDocument;
    zf || Jl == null || Jl !== Bn(o) || (o = Jl, "selectionStart" in o && Es(o) ? o = { start: o.selectionStart, end: o.selectionEnd } : (o = (o.ownerDocument && o.ownerDocument.defaultView || window).getSelection(), o = { anchorNode: o.anchorNode, anchorOffset: o.anchorOffset, focusNode: o.focusNode, focusOffset: o.focusOffset }), Ju && Ku(Ju, o) || (Ju = o, o = to(Nf, "onSelect"), 0 < o.length && (r = new ms("onSelect", "select", null, r, l), n.push({ event: r, listeners: o }), r.target = Jl)));
  }
  function Ts(n, r) {
    var l = {};
    return l[n.toLowerCase()] = r.toLowerCase(), l["Webkit" + n] = "webkit" + r, l["Moz" + n] = "moz" + r, l;
  }
  var rl = { animationend: Ts("Animation", "AnimationEnd"), animationiteration: Ts("Animation", "AnimationIteration"), animationstart: Ts("Animation", "AnimationStart"), transitionend: Ts("Transition", "TransitionEnd") }, tn = {}, Af = {};
  Fn && (Af = document.createElement("div").style, "AnimationEvent" in window || (delete rl.animationend.animation, delete rl.animationiteration.animation, delete rl.animationstart.animation), "TransitionEvent" in window || delete rl.transitionend.transition);
  function Rs(n) {
    if (tn[n]) return tn[n];
    if (!rl[n]) return n;
    var r = rl[n], l;
    for (l in r) if (r.hasOwnProperty(l) && l in Af) return tn[n] = r[l];
    return n;
  }
  var tv = Rs("animationend"), nv = Rs("animationiteration"), rv = Rs("animationstart"), av = Rs("transitionend"), Hf = /* @__PURE__ */ new Map(), xs = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Lr(n, r) {
    Hf.set(n, r), bt(r, [n]);
  }
  for (var Ff = 0; Ff < xs.length; Ff++) {
    var al = xs[Ff], Im = al.toLowerCase(), Gm = al[0].toUpperCase() + al.slice(1);
    Lr(Im, "on" + Gm);
  }
  Lr(tv, "onAnimationEnd"), Lr(nv, "onAnimationIteration"), Lr(rv, "onAnimationStart"), Lr("dblclick", "onDoubleClick"), Lr("focusin", "onFocus"), Lr("focusout", "onBlur"), Lr(av, "onTransitionEnd"), S("onMouseEnter", ["mouseout", "mouseover"]), S("onMouseLeave", ["mouseout", "mouseover"]), S("onPointerEnter", ["pointerout", "pointerover"]), S("onPointerLeave", ["pointerout", "pointerover"]), bt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), bt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), bt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), bt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), bt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), bt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var eo = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Vf = new Set("cancel close invalid load scroll toggle".split(" ").concat(eo));
  function ws(n, r, l) {
    var o = n.type || "unknown-event";
    n.currentTarget = l, ls(o, r, void 0, n), n.currentTarget = null;
  }
  function il(n, r) {
    r = (r & 4) !== 0;
    for (var l = 0; l < n.length; l++) {
      var o = n[l], c = o.event;
      o = o.listeners;
      e: {
        var d = void 0;
        if (r) for (var h = o.length - 1; 0 <= h; h--) {
          var g = o[h], C = g.instance, _ = g.currentTarget;
          if (g = g.listener, C !== d && c.isPropagationStopped()) break e;
          ws(c, g, _), d = C;
        }
        else for (h = 0; h < o.length; h++) {
          if (g = o[h], C = g.instance, _ = g.currentTarget, g = g.listener, C !== d && c.isPropagationStopped()) break e;
          ws(c, g, _), d = C;
        }
      }
    }
    if (Yl) throw n = Vu, Yl = !1, Vu = null, n;
  }
  function Ye(n, r) {
    var l = r[ao];
    l === void 0 && (l = r[ao] = /* @__PURE__ */ new Set());
    var o = n + "__bubble";
    l.has(o) || (iv(r, n, 2, !1), l.add(o));
  }
  function Ds(n, r, l) {
    var o = 0;
    r && (o |= 4), iv(l, n, o, r);
  }
  var ks = "_reactListening" + Math.random().toString(36).slice(2);
  function eu(n) {
    if (!n[ks]) {
      n[ks] = !0, ur.forEach(function(l) {
        l !== "selectionchange" && (Vf.has(l) || Ds(l, !1, n), Ds(l, !0, n));
      });
      var r = n.nodeType === 9 ? n : n.ownerDocument;
      r === null || r[ks] || (r[ks] = !0, Ds("selectionchange", !1, r));
    }
  }
  function iv(n, r, l, o) {
    switch (fs(r)) {
      case 1:
        var c = zp;
        break;
      case 4:
        c = Up;
        break;
      default:
        c = ss;
    }
    l = c.bind(null, r, l, n), c = void 0, !oi || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (c = !0), o ? c !== void 0 ? n.addEventListener(r, l, { capture: !0, passive: c }) : n.addEventListener(r, l, !0) : c !== void 0 ? n.addEventListener(r, l, { passive: c }) : n.addEventListener(r, l, !1);
  }
  function bs(n, r, l, o, c) {
    var d = o;
    if (!(r & 1) && !(r & 2) && o !== null) e: for (; ; ) {
      if (o === null) return;
      var h = o.tag;
      if (h === 3 || h === 4) {
        var g = o.stateNode.containerInfo;
        if (g === c || g.nodeType === 8 && g.parentNode === c) break;
        if (h === 4) for (h = o.return; h !== null; ) {
          var C = h.tag;
          if ((C === 3 || C === 4) && (C = h.stateNode.containerInfo, C === c || C.nodeType === 8 && C.parentNode === c)) return;
          h = h.return;
        }
        for (; g !== null; ) {
          if (h = ul(g), h === null) return;
          if (C = h.tag, C === 5 || C === 6) {
            o = d = h;
            continue e;
          }
          g = g.parentNode;
        }
      }
      o = o.return;
    }
    af(function() {
      var _ = d, H = gt(l), F = [];
      e: {
        var A = Hf.get(n);
        if (A !== void 0) {
          var W = ms, J = n;
          switch (n) {
            case "keypress":
              if (ps(l) === 0) break e;
            case "keydown":
            case "keyup":
              W = kf;
              break;
            case "focusin":
              J = "focus", W = ys;
              break;
            case "focusout":
              J = "blur", W = ys;
              break;
            case "beforeblur":
            case "afterblur":
              W = ys;
              break;
            case "click":
              if (l.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              W = Ef;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              W = Xl;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              W = jp;
              break;
            case tv:
            case nv:
            case rv:
              W = Am;
              break;
            case av:
              W = Ha;
              break;
            case "scroll":
              W = Nm;
              break;
            case "wheel":
              W = Fa;
              break;
            case "copy":
            case "cut":
            case "paste":
              W = Ap;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              W = Vp;
          }
          var te = (r & 4) !== 0, Dt = !te && n === "scroll", x = te ? A !== null ? A + "Capture" : null : A;
          te = [];
          for (var T = _, k; T !== null; ) {
            k = T;
            var j = k.stateNode;
            if (k.tag === 5 && j !== null && (k = j, x !== null && (j = Ii(T, x), j != null && te.push(tu(T, j, k)))), Dt) break;
            T = T.return;
          }
          0 < te.length && (A = new W(A, J, null, l, H), F.push({ event: A, listeners: te }));
        }
      }
      if (!(r & 7)) {
        e: {
          if (A = n === "mouseover" || n === "pointerover", W = n === "mouseout" || n === "pointerout", A && l !== Mt && (J = l.relatedTarget || l.fromElement) && (ul(J) || J[Va])) break e;
          if ((W || A) && (A = H.window === H ? H : (A = H.ownerDocument) ? A.defaultView || A.parentWindow : window, W ? (J = l.relatedTarget || l.toElement, W = _, J = J ? ul(J) : null, J !== null && (Dt = qr(J), J !== Dt || J.tag !== 5 && J.tag !== 6) && (J = null)) : (W = null, J = _), W !== J)) {
            if (te = Ef, j = "onMouseLeave", x = "onMouseEnter", T = "mouse", (n === "pointerout" || n === "pointerover") && (te = Vp, j = "onPointerLeave", x = "onPointerEnter", T = "pointer"), Dt = W == null ? A : ea(W), k = J == null ? A : ea(J), A = new te(j, T + "leave", W, l, H), A.target = Dt, A.relatedTarget = k, j = null, ul(H) === _ && (te = new te(x, T + "enter", J, l, H), te.target = k, te.relatedTarget = Dt, j = te), Dt = j, W && J) t: {
              for (te = W, x = J, T = 0, k = te; k; k = pi(k)) T++;
              for (k = 0, j = x; j; j = pi(j)) k++;
              for (; 0 < T - k; ) te = pi(te), T--;
              for (; 0 < k - T; ) x = pi(x), k--;
              for (; T--; ) {
                if (te === x || x !== null && te === x.alternate) break t;
                te = pi(te), x = pi(x);
              }
              te = null;
            }
            else te = null;
            W !== null && lv(F, A, W, te, !1), J !== null && Dt !== null && lv(F, Dt, J, te, !0);
          }
        }
        e: {
          if (A = _ ? ea(_) : window, W = A.nodeName && A.nodeName.toLowerCase(), W === "select" || W === "input" && A.type === "file") var I = Bm;
          else if (Ip(A)) if (Wp) I = Jp;
          else {
            I = Zp;
            var se = Pm;
          }
          else (W = A.nodeName) && W.toLowerCase() === "input" && (A.type === "checkbox" || A.type === "radio") && (I = $m);
          if (I && (I = I(n, _))) {
            Lf(F, I, l, H);
            break e;
          }
          se && se(n, A, _), n === "focusout" && (se = A._wrapperState) && se.controlled && A.type === "number" && Hu(A, "number", A.value);
        }
        switch (se = _ ? ea(_) : window, n) {
          case "focusin":
            (Ip(se) || se.contentEditable === "true") && (Jl = se, Nf = _, Ju = null);
            break;
          case "focusout":
            Ju = Nf = Jl = null;
            break;
          case "mousedown":
            zf = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            zf = !1, Uf(F, l, H);
            break;
          case "selectionchange":
            if (Qm) break;
          case "keydown":
          case "keyup":
            Uf(F, l, H);
        }
        var pe;
        if (ql) e: {
          switch (n) {
            case "compositionstart":
              var ye = "onCompositionStart";
              break e;
            case "compositionend":
              ye = "onCompositionEnd";
              break e;
            case "compositionupdate":
              ye = "onCompositionUpdate";
              break e;
          }
          ye = void 0;
        }
        else Kl ? $p(n, l) && (ye = "onCompositionEnd") : n === "keydown" && l.keyCode === 229 && (ye = "onCompositionStart");
        ye && (Bp && l.locale !== "ko" && (Kl || ye !== "onCompositionStart" ? ye === "onCompositionEnd" && Kl && (pe = Sf()) : (Ua = H, ds = "value" in Ua ? Ua.value : Ua.textContent, Kl = !0)), se = to(_, ye), 0 < se.length && (ye = new xf(ye, n, null, l, H), F.push({ event: ye, listeners: se }), pe ? ye.data = pe : (pe = Yp(l), pe !== null && (ye.data = pe)))), (pe = Xu ? Qp(n, l) : Vm(n, l)) && (_ = to(_, "onBeforeInput"), 0 < _.length && (H = new xf("onBeforeInput", "beforeinput", null, l, H), F.push({ event: H, listeners: _ }), H.data = pe));
      }
      il(F, r);
    });
  }
  function tu(n, r, l) {
    return { instance: n, listener: r, currentTarget: l };
  }
  function to(n, r) {
    for (var l = r + "Capture", o = []; n !== null; ) {
      var c = n, d = c.stateNode;
      c.tag === 5 && d !== null && (c = d, d = Ii(n, l), d != null && o.unshift(tu(n, d, c)), d = Ii(n, r), d != null && o.push(tu(n, d, c))), n = n.return;
    }
    return o;
  }
  function pi(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function lv(n, r, l, o, c) {
    for (var d = r._reactName, h = []; l !== null && l !== o; ) {
      var g = l, C = g.alternate, _ = g.stateNode;
      if (C !== null && C === o) break;
      g.tag === 5 && _ !== null && (g = _, c ? (C = Ii(l, d), C != null && h.unshift(tu(l, C, g))) : c || (C = Ii(l, d), C != null && h.push(tu(l, C, g)))), l = l.return;
    }
    h.length !== 0 && n.push({ event: r, listeners: h });
  }
  var uv = /\r\n?/g, Wm = /\u0000|\uFFFD/g;
  function ov(n) {
    return (typeof n == "string" ? n : "" + n).replace(uv, `
`).replace(Wm, "");
  }
  function _s(n, r, l) {
    if (r = ov(r), ov(n) !== r && l) throw Error(N(425));
  }
  function vi() {
  }
  var no = null, ll = null;
  function Ls(n, r) {
    return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var Ms = typeof setTimeout == "function" ? setTimeout : void 0, jf = typeof clearTimeout == "function" ? clearTimeout : void 0, sv = typeof Promise == "function" ? Promise : void 0, nu = typeof queueMicrotask == "function" ? queueMicrotask : typeof sv < "u" ? function(n) {
    return sv.resolve(null).then(n).catch(Os);
  } : Ms;
  function Os(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function ru(n, r) {
    var l = r, o = 0;
    do {
      var c = l.nextSibling;
      if (n.removeChild(l), c && c.nodeType === 8) if (l = c.data, l === "/$") {
        if (o === 0) {
          n.removeChild(c), fi(r);
          return;
        }
        o--;
      } else l !== "$" && l !== "$?" && l !== "$!" || o++;
      l = c;
    } while (l);
    fi(r);
  }
  function va(n) {
    for (; n != null; n = n.nextSibling) {
      var r = n.nodeType;
      if (r === 1 || r === 3) break;
      if (r === 8) {
        if (r = n.data, r === "$" || r === "$!" || r === "$?") break;
        if (r === "/$") return null;
      }
    }
    return n;
  }
  function cv(n) {
    n = n.previousSibling;
    for (var r = 0; n; ) {
      if (n.nodeType === 8) {
        var l = n.data;
        if (l === "$" || l === "$!" || l === "$?") {
          if (r === 0) return n;
          r--;
        } else l === "/$" && r++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var hi = Math.random().toString(36).slice(2), ha = "__reactFiber$" + hi, ro = "__reactProps$" + hi, Va = "__reactContainer$" + hi, ao = "__reactEvents$" + hi, au = "__reactListeners$" + hi, Xm = "__reactHandles$" + hi;
  function ul(n) {
    var r = n[ha];
    if (r) return r;
    for (var l = n.parentNode; l; ) {
      if (r = l[Va] || l[ha]) {
        if (l = r.alternate, r.child !== null || l !== null && l.child !== null) for (n = cv(n); n !== null; ) {
          if (l = n[ha]) return l;
          n = cv(n);
        }
        return r;
      }
      n = l, l = n.parentNode;
    }
    return null;
  }
  function ue(n) {
    return n = n[ha] || n[Va], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function ea(n) {
    if (n.tag === 5 || n.tag === 6) return n.stateNode;
    throw Error(N(33));
  }
  function Et(n) {
    return n[ro] || null;
  }
  var Oe = [], Mr = -1;
  function ta(n) {
    return { current: n };
  }
  function rt(n) {
    0 > Mr || (n.current = Oe[Mr], Oe[Mr] = null, Mr--);
  }
  function ie(n, r) {
    Mr++, Oe[Mr] = n.current, n.current = r;
  }
  var In = {}, Ct = ta(In), $t = ta(!1), Gn = In;
  function Or(n, r) {
    var l = n.type.contextTypes;
    if (!l) return In;
    var o = n.stateNode;
    if (o && o.__reactInternalMemoizedUnmaskedChildContext === r) return o.__reactInternalMemoizedMaskedChildContext;
    var c = {}, d;
    for (d in l) c[d] = r[d];
    return o && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = r, n.__reactInternalMemoizedMaskedChildContext = c), c;
  }
  function Nt(n) {
    return n = n.childContextTypes, n != null;
  }
  function iu() {
    rt($t), rt(Ct);
  }
  function fv(n, r, l) {
    if (Ct.current !== In) throw Error(N(168));
    ie(Ct, r), ie($t, l);
  }
  function io(n, r, l) {
    var o = n.stateNode;
    if (r = r.childContextTypes, typeof o.getChildContext != "function") return l;
    o = o.getChildContext();
    for (var c in o) if (!(c in r)) throw Error(N(108, jn(n) || "Unknown", c));
    return Z({}, l, o);
  }
  function Wn(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || In, Gn = Ct.current, ie(Ct, n), ie($t, $t.current), !0;
  }
  function Ns(n, r, l) {
    var o = n.stateNode;
    if (!o) throw Error(N(169));
    l ? (n = io(n, r, Gn), o.__reactInternalMemoizedMergedChildContext = n, rt($t), rt(Ct), ie(Ct, n)) : rt($t), ie($t, l);
  }
  var ma = null, lu = !1, ja = !1;
  function zs(n) {
    ma === null ? ma = [n] : ma.push(n);
  }
  function mi(n) {
    lu = !0, zs(n);
  }
  function ya() {
    if (!ja && ma !== null) {
      ja = !0;
      var n = 0, r = Ge;
      try {
        var l = ma;
        for (Ge = 1; n < l.length; n++) {
          var o = l[n];
          do
            o = o(!0);
          while (o !== null);
        }
        ma = null, lu = !1;
      } catch (c) {
        throw ma !== null && (ma = ma.slice(n + 1)), bp(Wi, ya), c;
      } finally {
        Ge = r, ja = !1;
      }
    }
    return null;
  }
  var yi = [], gi = 0, Si = null, Ba = 0, zt = [], Nr = 0, fr = null, ga = 1, Sa = "";
  function ol(n, r) {
    yi[gi++] = Ba, yi[gi++] = Si, Si = n, Ba = r;
  }
  function dv(n, r, l) {
    zt[Nr++] = ga, zt[Nr++] = Sa, zt[Nr++] = fr, fr = n;
    var o = ga;
    n = Sa;
    var c = 32 - kr(o) - 1;
    o &= ~(1 << c), l += 1;
    var d = 32 - kr(r) + c;
    if (30 < d) {
      var h = c - c % 5;
      d = (o & (1 << h) - 1).toString(32), o >>= h, c -= h, ga = 1 << 32 - kr(r) + c | l << c | o, Sa = d + n;
    } else ga = 1 << d | l << c | o, Sa = n;
  }
  function Us(n) {
    n.return !== null && (ol(n, 1), dv(n, 1, 0));
  }
  function As(n) {
    for (; n === Si; ) Si = yi[--gi], yi[gi] = null, Ba = yi[--gi], yi[gi] = null;
    for (; n === fr; ) fr = zt[--Nr], zt[Nr] = null, Sa = zt[--Nr], zt[Nr] = null, ga = zt[--Nr], zt[Nr] = null;
  }
  var Xn = null, qn = null, st = !1, zr = null;
  function Bf(n, r) {
    var l = Vr(5, null, null, 0);
    l.elementType = "DELETED", l.stateNode = r, l.return = n, r = n.deletions, r === null ? (n.deletions = [l], n.flags |= 16) : r.push(l);
  }
  function pv(n, r) {
    switch (n.tag) {
      case 5:
        var l = n.type;
        return r = r.nodeType !== 1 || l.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (n.stateNode = r, Xn = n, qn = va(r.firstChild), !0) : !1;
      case 6:
        return r = n.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (n.stateNode = r, Xn = n, qn = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (l = fr !== null ? { id: ga, overflow: Sa } : null, n.memoizedState = { dehydrated: r, treeContext: l, retryLane: 1073741824 }, l = Vr(18, null, null, 0), l.stateNode = r, l.return = n, n.child = l, Xn = n, qn = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Pf(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function $f(n) {
    if (st) {
      var r = qn;
      if (r) {
        var l = r;
        if (!pv(n, r)) {
          if (Pf(n)) throw Error(N(418));
          r = va(l.nextSibling);
          var o = Xn;
          r && pv(n, r) ? Bf(o, l) : (n.flags = n.flags & -4097 | 2, st = !1, Xn = n);
        }
      } else {
        if (Pf(n)) throw Error(N(418));
        n.flags = n.flags & -4097 | 2, st = !1, Xn = n;
      }
    }
  }
  function Yt(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; ) n = n.return;
    Xn = n;
  }
  function Hs(n) {
    if (n !== Xn) return !1;
    if (!st) return Yt(n), st = !0, !1;
    var r;
    if ((r = n.tag !== 3) && !(r = n.tag !== 5) && (r = n.type, r = r !== "head" && r !== "body" && !Ls(n.type, n.memoizedProps)), r && (r = qn)) {
      if (Pf(n)) throw lo(), Error(N(418));
      for (; r; ) Bf(n, r), r = va(r.nextSibling);
    }
    if (Yt(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(N(317));
      e: {
        for (n = n.nextSibling, r = 0; n; ) {
          if (n.nodeType === 8) {
            var l = n.data;
            if (l === "/$") {
              if (r === 0) {
                qn = va(n.nextSibling);
                break e;
              }
              r--;
            } else l !== "$" && l !== "$!" && l !== "$?" || r++;
          }
          n = n.nextSibling;
        }
        qn = null;
      }
    } else qn = Xn ? va(n.stateNode.nextSibling) : null;
    return !0;
  }
  function lo() {
    for (var n = qn; n; ) n = va(n.nextSibling);
  }
  function Ci() {
    qn = Xn = null, st = !1;
  }
  function Pa(n) {
    zr === null ? zr = [n] : zr.push(n);
  }
  var qm = it.ReactCurrentBatchConfig;
  function sl(n, r, l) {
    if (n = l.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (l._owner) {
        if (l = l._owner, l) {
          if (l.tag !== 1) throw Error(N(309));
          var o = l.stateNode;
        }
        if (!o) throw Error(N(147, n));
        var c = o, d = "" + n;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === d ? r.ref : (r = function(h) {
          var g = c.refs;
          h === null ? delete g[d] : g[d] = h;
        }, r._stringRef = d, r);
      }
      if (typeof n != "string") throw Error(N(284));
      if (!l._owner) throw Error(N(290, n));
    }
    return n;
  }
  function Fs(n, r) {
    throw n = Object.prototype.toString.call(r), Error(N(31, n === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : n));
  }
  function vv(n) {
    var r = n._init;
    return r(n._payload);
  }
  function cl(n) {
    function r(x, T) {
      if (n) {
        var k = x.deletions;
        k === null ? (x.deletions = [T], x.flags |= 16) : k.push(T);
      }
    }
    function l(x, T) {
      if (!n) return null;
      for (; T !== null; ) r(x, T), T = T.sibling;
      return null;
    }
    function o(x, T) {
      for (x = /* @__PURE__ */ new Map(); T !== null; ) T.key !== null ? x.set(T.key, T) : x.set(T.index, T), T = T.sibling;
      return x;
    }
    function c(x, T) {
      return x = bi(x, T), x.index = 0, x.sibling = null, x;
    }
    function d(x, T, k) {
      return x.index = k, n ? (k = x.alternate, k !== null ? (k = k.index, k < T ? (x.flags |= 2, T) : k) : (x.flags |= 2, T)) : (x.flags |= 1048576, T);
    }
    function h(x) {
      return n && x.alternate === null && (x.flags |= 2), x;
    }
    function g(x, T, k, j) {
      return T === null || T.tag !== 6 ? (T = Cd(k, x.mode, j), T.return = x, T) : (T = c(T, k), T.return = x, T);
    }
    function C(x, T, k, j) {
      var I = k.type;
      return I === De ? H(x, T, k.props.children, j, k.key) : T !== null && (T.elementType === I || typeof I == "object" && I !== null && I.$$typeof === _t && vv(I) === T.type) ? (j = c(T, k.props), j.ref = sl(x, T, k), j.return = x, j) : (j = Ho(k.type, k.key, k.props, null, x.mode, j), j.ref = sl(x, T, k), j.return = x, j);
    }
    function _(x, T, k, j) {
      return T === null || T.tag !== 4 || T.stateNode.containerInfo !== k.containerInfo || T.stateNode.implementation !== k.implementation ? (T = yc(k, x.mode, j), T.return = x, T) : (T = c(T, k.children || []), T.return = x, T);
    }
    function H(x, T, k, j, I) {
      return T === null || T.tag !== 7 ? (T = Wa(k, x.mode, j, I), T.return = x, T) : (T = c(T, k), T.return = x, T);
    }
    function F(x, T, k) {
      if (typeof T == "string" && T !== "" || typeof T == "number") return T = Cd("" + T, x.mode, k), T.return = x, T;
      if (typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case Me:
            return k = Ho(T.type, T.key, T.props, null, x.mode, k), k.ref = sl(x, null, T), k.return = x, k;
          case ft:
            return T = yc(T, x.mode, k), T.return = x, T;
          case _t:
            var j = T._init;
            return F(x, j(T._payload), k);
        }
        if ($i(T) || ve(T)) return T = Wa(T, x.mode, k, null), T.return = x, T;
        Fs(x, T);
      }
      return null;
    }
    function A(x, T, k, j) {
      var I = T !== null ? T.key : null;
      if (typeof k == "string" && k !== "" || typeof k == "number") return I !== null ? null : g(x, T, "" + k, j);
      if (typeof k == "object" && k !== null) {
        switch (k.$$typeof) {
          case Me:
            return k.key === I ? C(x, T, k, j) : null;
          case ft:
            return k.key === I ? _(x, T, k, j) : null;
          case _t:
            return I = k._init, A(
              x,
              T,
              I(k._payload),
              j
            );
        }
        if ($i(k) || ve(k)) return I !== null ? null : H(x, T, k, j, null);
        Fs(x, k);
      }
      return null;
    }
    function W(x, T, k, j, I) {
      if (typeof j == "string" && j !== "" || typeof j == "number") return x = x.get(k) || null, g(T, x, "" + j, I);
      if (typeof j == "object" && j !== null) {
        switch (j.$$typeof) {
          case Me:
            return x = x.get(j.key === null ? k : j.key) || null, C(T, x, j, I);
          case ft:
            return x = x.get(j.key === null ? k : j.key) || null, _(T, x, j, I);
          case _t:
            var se = j._init;
            return W(x, T, k, se(j._payload), I);
        }
        if ($i(j) || ve(j)) return x = x.get(k) || null, H(T, x, j, I, null);
        Fs(T, j);
      }
      return null;
    }
    function J(x, T, k, j) {
      for (var I = null, se = null, pe = T, ye = T = 0, It = null; pe !== null && ye < k.length; ye++) {
        pe.index > ye ? (It = pe, pe = null) : It = pe.sibling;
        var Be = A(x, pe, k[ye], j);
        if (Be === null) {
          pe === null && (pe = It);
          break;
        }
        n && pe && Be.alternate === null && r(x, pe), T = d(Be, T, ye), se === null ? I = Be : se.sibling = Be, se = Be, pe = It;
      }
      if (ye === k.length) return l(x, pe), st && ol(x, ye), I;
      if (pe === null) {
        for (; ye < k.length; ye++) pe = F(x, k[ye], j), pe !== null && (T = d(pe, T, ye), se === null ? I = pe : se.sibling = pe, se = pe);
        return st && ol(x, ye), I;
      }
      for (pe = o(x, pe); ye < k.length; ye++) It = W(pe, x, ye, k[ye], j), It !== null && (n && It.alternate !== null && pe.delete(It.key === null ? ye : It.key), T = d(It, T, ye), se === null ? I = It : se.sibling = It, se = It);
      return n && pe.forEach(function(Mi) {
        return r(x, Mi);
      }), st && ol(x, ye), I;
    }
    function te(x, T, k, j) {
      var I = ve(k);
      if (typeof I != "function") throw Error(N(150));
      if (k = I.call(k), k == null) throw Error(N(151));
      for (var se = I = null, pe = T, ye = T = 0, It = null, Be = k.next(); pe !== null && !Be.done; ye++, Be = k.next()) {
        pe.index > ye ? (It = pe, pe = null) : It = pe.sibling;
        var Mi = A(x, pe, Be.value, j);
        if (Mi === null) {
          pe === null && (pe = It);
          break;
        }
        n && pe && Mi.alternate === null && r(x, pe), T = d(Mi, T, ye), se === null ? I = Mi : se.sibling = Mi, se = Mi, pe = It;
      }
      if (Be.done) return l(
        x,
        pe
      ), st && ol(x, ye), I;
      if (pe === null) {
        for (; !Be.done; ye++, Be = k.next()) Be = F(x, Be.value, j), Be !== null && (T = d(Be, T, ye), se === null ? I = Be : se.sibling = Be, se = Be);
        return st && ol(x, ye), I;
      }
      for (pe = o(x, pe); !Be.done; ye++, Be = k.next()) Be = W(pe, x, ye, Be.value, j), Be !== null && (n && Be.alternate !== null && pe.delete(Be.key === null ? ye : Be.key), T = d(Be, T, ye), se === null ? I = Be : se.sibling = Be, se = Be);
      return n && pe.forEach(function(cy) {
        return r(x, cy);
      }), st && ol(x, ye), I;
    }
    function Dt(x, T, k, j) {
      if (typeof k == "object" && k !== null && k.type === De && k.key === null && (k = k.props.children), typeof k == "object" && k !== null) {
        switch (k.$$typeof) {
          case Me:
            e: {
              for (var I = k.key, se = T; se !== null; ) {
                if (se.key === I) {
                  if (I = k.type, I === De) {
                    if (se.tag === 7) {
                      l(x, se.sibling), T = c(se, k.props.children), T.return = x, x = T;
                      break e;
                    }
                  } else if (se.elementType === I || typeof I == "object" && I !== null && I.$$typeof === _t && vv(I) === se.type) {
                    l(x, se.sibling), T = c(se, k.props), T.ref = sl(x, se, k), T.return = x, x = T;
                    break e;
                  }
                  l(x, se);
                  break;
                } else r(x, se);
                se = se.sibling;
              }
              k.type === De ? (T = Wa(k.props.children, x.mode, j, k.key), T.return = x, x = T) : (j = Ho(k.type, k.key, k.props, null, x.mode, j), j.ref = sl(x, T, k), j.return = x, x = j);
            }
            return h(x);
          case ft:
            e: {
              for (se = k.key; T !== null; ) {
                if (T.key === se) if (T.tag === 4 && T.stateNode.containerInfo === k.containerInfo && T.stateNode.implementation === k.implementation) {
                  l(x, T.sibling), T = c(T, k.children || []), T.return = x, x = T;
                  break e;
                } else {
                  l(x, T);
                  break;
                }
                else r(x, T);
                T = T.sibling;
              }
              T = yc(k, x.mode, j), T.return = x, x = T;
            }
            return h(x);
          case _t:
            return se = k._init, Dt(x, T, se(k._payload), j);
        }
        if ($i(k)) return J(x, T, k, j);
        if (ve(k)) return te(x, T, k, j);
        Fs(x, k);
      }
      return typeof k == "string" && k !== "" || typeof k == "number" ? (k = "" + k, T !== null && T.tag === 6 ? (l(x, T.sibling), T = c(T, k), T.return = x, x = T) : (l(x, T), T = Cd(k, x.mode, j), T.return = x, x = T), h(x)) : l(x, T);
    }
    return Dt;
  }
  var Tt = cl(!0), Y = cl(!1), dr = ta(null), Kn = null, uu = null, Yf = null;
  function Qf() {
    Yf = uu = Kn = null;
  }
  function If(n) {
    var r = dr.current;
    rt(dr), n._currentValue = r;
  }
  function Gf(n, r, l) {
    for (; n !== null; ) {
      var o = n.alternate;
      if ((n.childLanes & r) !== r ? (n.childLanes |= r, o !== null && (o.childLanes |= r)) : o !== null && (o.childLanes & r) !== r && (o.childLanes |= r), n === l) break;
      n = n.return;
    }
  }
  function dt(n, r) {
    Kn = n, Yf = uu = null, n = n.dependencies, n !== null && n.firstContext !== null && (n.lanes & r && (At = !0), n.firstContext = null);
  }
  function Ur(n) {
    var r = n._currentValue;
    if (Yf !== n) if (n = { context: n, memoizedValue: r, next: null }, uu === null) {
      if (Kn === null) throw Error(N(308));
      uu = n, Kn.dependencies = { lanes: 0, firstContext: n };
    } else uu = uu.next = n;
    return r;
  }
  var fl = null;
  function Wf(n) {
    fl === null ? fl = [n] : fl.push(n);
  }
  function Xf(n, r, l, o) {
    var c = r.interleaved;
    return c === null ? (l.next = l, Wf(r)) : (l.next = c.next, c.next = l), r.interleaved = l, pr(n, o);
  }
  function pr(n, r) {
    n.lanes |= r;
    var l = n.alternate;
    for (l !== null && (l.lanes |= r), l = n, n = n.return; n !== null; ) n.childLanes |= r, l = n.alternate, l !== null && (l.childLanes |= r), l = n, n = n.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var vr = !1;
  function qf(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function hv(n, r) {
    n = n.updateQueue, r.updateQueue === n && (r.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function $a(n, r) {
    return { eventTime: n, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function Ei(n, r, l) {
    var o = n.updateQueue;
    if (o === null) return null;
    if (o = o.shared, Ne & 2) {
      var c = o.pending;
      return c === null ? r.next = r : (r.next = c.next, c.next = r), o.pending = r, pr(n, l);
    }
    return c = o.interleaved, c === null ? (r.next = r, Wf(o)) : (r.next = c.next, c.next = r), o.interleaved = r, pr(n, l);
  }
  function Vs(n, r, l) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (l & 4194240) !== 0)) {
      var o = r.lanes;
      o &= n.pendingLanes, l |= o, r.lanes = l, os(n, l);
    }
  }
  function mv(n, r) {
    var l = n.updateQueue, o = n.alternate;
    if (o !== null && (o = o.updateQueue, l === o)) {
      var c = null, d = null;
      if (l = l.firstBaseUpdate, l !== null) {
        do {
          var h = { eventTime: l.eventTime, lane: l.lane, tag: l.tag, payload: l.payload, callback: l.callback, next: null };
          d === null ? c = d = h : d = d.next = h, l = l.next;
        } while (l !== null);
        d === null ? c = d = r : d = d.next = r;
      } else c = d = r;
      l = { baseState: o.baseState, firstBaseUpdate: c, lastBaseUpdate: d, shared: o.shared, effects: o.effects }, n.updateQueue = l;
      return;
    }
    n = l.lastBaseUpdate, n === null ? l.firstBaseUpdate = r : n.next = r, l.lastBaseUpdate = r;
  }
  function uo(n, r, l, o) {
    var c = n.updateQueue;
    vr = !1;
    var d = c.firstBaseUpdate, h = c.lastBaseUpdate, g = c.shared.pending;
    if (g !== null) {
      c.shared.pending = null;
      var C = g, _ = C.next;
      C.next = null, h === null ? d = _ : h.next = _, h = C;
      var H = n.alternate;
      H !== null && (H = H.updateQueue, g = H.lastBaseUpdate, g !== h && (g === null ? H.firstBaseUpdate = _ : g.next = _, H.lastBaseUpdate = C));
    }
    if (d !== null) {
      var F = c.baseState;
      h = 0, H = _ = C = null, g = d;
      do {
        var A = g.lane, W = g.eventTime;
        if ((o & A) === A) {
          H !== null && (H = H.next = {
            eventTime: W,
            lane: 0,
            tag: g.tag,
            payload: g.payload,
            callback: g.callback,
            next: null
          });
          e: {
            var J = n, te = g;
            switch (A = r, W = l, te.tag) {
              case 1:
                if (J = te.payload, typeof J == "function") {
                  F = J.call(W, F, A);
                  break e;
                }
                F = J;
                break e;
              case 3:
                J.flags = J.flags & -65537 | 128;
              case 0:
                if (J = te.payload, A = typeof J == "function" ? J.call(W, F, A) : J, A == null) break e;
                F = Z({}, F, A);
                break e;
              case 2:
                vr = !0;
            }
          }
          g.callback !== null && g.lane !== 0 && (n.flags |= 64, A = c.effects, A === null ? c.effects = [g] : A.push(g));
        } else W = { eventTime: W, lane: A, tag: g.tag, payload: g.payload, callback: g.callback, next: null }, H === null ? (_ = H = W, C = F) : H = H.next = W, h |= A;
        if (g = g.next, g === null) {
          if (g = c.shared.pending, g === null) break;
          A = g, g = A.next, A.next = null, c.lastBaseUpdate = A, c.shared.pending = null;
        }
      } while (!0);
      if (H === null && (C = F), c.baseState = C, c.firstBaseUpdate = _, c.lastBaseUpdate = H, r = c.shared.interleaved, r !== null) {
        c = r;
        do
          h |= c.lane, c = c.next;
        while (c !== r);
      } else d === null && (c.shared.lanes = 0);
      xa |= h, n.lanes = h, n.memoizedState = F;
    }
  }
  function Kf(n, r, l) {
    if (n = r.effects, r.effects = null, n !== null) for (r = 0; r < n.length; r++) {
      var o = n[r], c = o.callback;
      if (c !== null) {
        if (o.callback = null, o = l, typeof c != "function") throw Error(N(191, c));
        c.call(o);
      }
    }
  }
  var oo = {}, Ca = ta(oo), so = ta(oo), co = ta(oo);
  function dl(n) {
    if (n === oo) throw Error(N(174));
    return n;
  }
  function Zf(n, r) {
    switch (ie(co, r), ie(so, n), ie(Ca, oo), n = r.nodeType, n) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : Yi(null, "");
        break;
      default:
        n = n === 8 ? r.parentNode : r, r = n.namespaceURI || null, n = n.tagName, r = Yi(r, n);
    }
    rt(Ca), ie(Ca, r);
  }
  function pl() {
    rt(Ca), rt(so), rt(co);
  }
  function yv(n) {
    dl(co.current);
    var r = dl(Ca.current), l = Yi(r, n.type);
    r !== l && (ie(so, n), ie(Ca, l));
  }
  function js(n) {
    so.current === n && (rt(Ca), rt(so));
  }
  var pt = ta(0);
  function Bs(n) {
    for (var r = n; r !== null; ) {
      if (r.tag === 13) {
        var l = r.memoizedState;
        if (l !== null && (l = l.dehydrated, l === null || l.data === "$?" || l.data === "$!")) return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if (r.flags & 128) return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === n) break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === n) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var fo = [];
  function oe() {
    for (var n = 0; n < fo.length; n++) fo[n]._workInProgressVersionPrimary = null;
    fo.length = 0;
  }
  var xe = it.ReactCurrentDispatcher, Ve = it.ReactCurrentBatchConfig, Ke = 0, je = null, Ut = null, Xt = null, Ps = !1, po = !1, vl = 0, U = 0;
  function Fe() {
    throw Error(N(321));
  }
  function he(n, r) {
    if (r === null) return !1;
    for (var l = 0; l < r.length && l < n.length; l++) if (!Jr(n[l], r[l])) return !1;
    return !0;
  }
  function Ti(n, r, l, o, c, d) {
    if (Ke = d, je = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, xe.current = n === null || n.memoizedState === null ? rc : So, n = l(o, c), po) {
      d = 0;
      do {
        if (po = !1, vl = 0, 25 <= d) throw Error(N(301));
        d += 1, Xt = Ut = null, r.updateQueue = null, xe.current = ac, n = l(o, c);
      } while (po);
    }
    if (xe.current = Sl, r = Ut !== null && Ut.next !== null, Ke = 0, Xt = Ut = je = null, Ps = !1, r) throw Error(N(300));
    return n;
  }
  function na() {
    var n = vl !== 0;
    return vl = 0, n;
  }
  function yn() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Xt === null ? je.memoizedState = Xt = n : Xt = Xt.next = n, Xt;
  }
  function Rt() {
    if (Ut === null) {
      var n = je.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = Ut.next;
    var r = Xt === null ? je.memoizedState : Xt.next;
    if (r !== null) Xt = r, Ut = n;
    else {
      if (n === null) throw Error(N(310));
      Ut = n, n = { memoizedState: Ut.memoizedState, baseState: Ut.baseState, baseQueue: Ut.baseQueue, queue: Ut.queue, next: null }, Xt === null ? je.memoizedState = Xt = n : Xt = Xt.next = n;
    }
    return Xt;
  }
  function Ya(n, r) {
    return typeof r == "function" ? r(n) : r;
  }
  function Ri(n) {
    var r = Rt(), l = r.queue;
    if (l === null) throw Error(N(311));
    l.lastRenderedReducer = n;
    var o = Ut, c = o.baseQueue, d = l.pending;
    if (d !== null) {
      if (c !== null) {
        var h = c.next;
        c.next = d.next, d.next = h;
      }
      o.baseQueue = c = d, l.pending = null;
    }
    if (c !== null) {
      d = c.next, o = o.baseState;
      var g = h = null, C = null, _ = d;
      do {
        var H = _.lane;
        if ((Ke & H) === H) C !== null && (C = C.next = { lane: 0, action: _.action, hasEagerState: _.hasEagerState, eagerState: _.eagerState, next: null }), o = _.hasEagerState ? _.eagerState : n(o, _.action);
        else {
          var F = {
            lane: H,
            action: _.action,
            hasEagerState: _.hasEagerState,
            eagerState: _.eagerState,
            next: null
          };
          C === null ? (g = C = F, h = o) : C = C.next = F, je.lanes |= H, xa |= H;
        }
        _ = _.next;
      } while (_ !== null && _ !== d);
      C === null ? h = o : C.next = g, Jr(o, r.memoizedState) || (At = !0), r.memoizedState = o, r.baseState = h, r.baseQueue = C, l.lastRenderedState = o;
    }
    if (n = l.interleaved, n !== null) {
      c = n;
      do
        d = c.lane, je.lanes |= d, xa |= d, c = c.next;
      while (c !== n);
    } else c === null && (l.lanes = 0);
    return [r.memoizedState, l.dispatch];
  }
  function hl(n) {
    var r = Rt(), l = r.queue;
    if (l === null) throw Error(N(311));
    l.lastRenderedReducer = n;
    var o = l.dispatch, c = l.pending, d = r.memoizedState;
    if (c !== null) {
      l.pending = null;
      var h = c = c.next;
      do
        d = n(d, h.action), h = h.next;
      while (h !== c);
      Jr(d, r.memoizedState) || (At = !0), r.memoizedState = d, r.baseQueue === null && (r.baseState = d), l.lastRenderedState = d;
    }
    return [d, o];
  }
  function $s() {
  }
  function Ys(n, r) {
    var l = je, o = Rt(), c = r(), d = !Jr(o.memoizedState, c);
    if (d && (o.memoizedState = c, At = !0), o = o.queue, vo(Gs.bind(null, l, o, n), [n]), o.getSnapshot !== r || d || Xt !== null && Xt.memoizedState.tag & 1) {
      if (l.flags |= 2048, ml(9, Is.bind(null, l, o, c, r), void 0, null), Qt === null) throw Error(N(349));
      Ke & 30 || Qs(l, r, c);
    }
    return c;
  }
  function Qs(n, r, l) {
    n.flags |= 16384, n = { getSnapshot: r, value: l }, r = je.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, je.updateQueue = r, r.stores = [n]) : (l = r.stores, l === null ? r.stores = [n] : l.push(n));
  }
  function Is(n, r, l, o) {
    r.value = l, r.getSnapshot = o, Ws(r) && Xs(n);
  }
  function Gs(n, r, l) {
    return l(function() {
      Ws(r) && Xs(n);
    });
  }
  function Ws(n) {
    var r = n.getSnapshot;
    n = n.value;
    try {
      var l = r();
      return !Jr(n, l);
    } catch {
      return !0;
    }
  }
  function Xs(n) {
    var r = pr(n, 1);
    r !== null && bn(r, n, 1, -1);
  }
  function qs(n) {
    var r = yn();
    return typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ya, lastRenderedState: n }, r.queue = n, n = n.dispatch = gl.bind(null, je, n), [r.memoizedState, n];
  }
  function ml(n, r, l, o) {
    return n = { tag: n, create: r, destroy: l, deps: o, next: null }, r = je.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, je.updateQueue = r, r.lastEffect = n.next = n) : (l = r.lastEffect, l === null ? r.lastEffect = n.next = n : (o = l.next, l.next = n, n.next = o, r.lastEffect = n)), n;
  }
  function Ks() {
    return Rt().memoizedState;
  }
  function ou(n, r, l, o) {
    var c = yn();
    je.flags |= n, c.memoizedState = ml(1 | r, l, void 0, o === void 0 ? null : o);
  }
  function su(n, r, l, o) {
    var c = Rt();
    o = o === void 0 ? null : o;
    var d = void 0;
    if (Ut !== null) {
      var h = Ut.memoizedState;
      if (d = h.destroy, o !== null && he(o, h.deps)) {
        c.memoizedState = ml(r, l, d, o);
        return;
      }
    }
    je.flags |= n, c.memoizedState = ml(1 | r, l, d, o);
  }
  function Zs(n, r) {
    return ou(8390656, 8, n, r);
  }
  function vo(n, r) {
    return su(2048, 8, n, r);
  }
  function Js(n, r) {
    return su(4, 2, n, r);
  }
  function ho(n, r) {
    return su(4, 4, n, r);
  }
  function yl(n, r) {
    if (typeof r == "function") return n = n(), r(n), function() {
      r(null);
    };
    if (r != null) return n = n(), r.current = n, function() {
      r.current = null;
    };
  }
  function ec(n, r, l) {
    return l = l != null ? l.concat([n]) : null, su(4, 4, yl.bind(null, r, n), l);
  }
  function mo() {
  }
  function tc(n, r) {
    var l = Rt();
    r = r === void 0 ? null : r;
    var o = l.memoizedState;
    return o !== null && r !== null && he(r, o[1]) ? o[0] : (l.memoizedState = [n, r], n);
  }
  function nc(n, r) {
    var l = Rt();
    r = r === void 0 ? null : r;
    var o = l.memoizedState;
    return o !== null && r !== null && he(r, o[1]) ? o[0] : (n = n(), l.memoizedState = [n, r], n);
  }
  function Jf(n, r, l) {
    return Ke & 21 ? (Jr(l, r) || (l = us(), je.lanes |= l, xa |= l, n.baseState = !0), r) : (n.baseState && (n.baseState = !1, At = !0), n.memoizedState = l);
  }
  function yo(n, r) {
    var l = Ge;
    Ge = l !== 0 && 4 > l ? l : 4, n(!0);
    var o = Ve.transition;
    Ve.transition = {};
    try {
      n(!1), r();
    } finally {
      Ge = l, Ve.transition = o;
    }
  }
  function ed() {
    return Rt().memoizedState;
  }
  function go(n, r, l) {
    var o = wa(n);
    if (l = { lane: o, action: l, hasEagerState: !1, eagerState: null, next: null }, hr(n)) gv(r, l);
    else if (l = Xf(n, r, l, o), l !== null) {
      var c = Vt();
      bn(l, n, o, c), nt(l, r, o);
    }
  }
  function gl(n, r, l) {
    var o = wa(n), c = { lane: o, action: l, hasEagerState: !1, eagerState: null, next: null };
    if (hr(n)) gv(r, c);
    else {
      var d = n.alternate;
      if (n.lanes === 0 && (d === null || d.lanes === 0) && (d = r.lastRenderedReducer, d !== null)) try {
        var h = r.lastRenderedState, g = d(h, l);
        if (c.hasEagerState = !0, c.eagerState = g, Jr(g, h)) {
          var C = r.interleaved;
          C === null ? (c.next = c, Wf(r)) : (c.next = C.next, C.next = c), r.interleaved = c;
          return;
        }
      } catch {
      } finally {
      }
      l = Xf(n, r, c, o), l !== null && (c = Vt(), bn(l, n, o, c), nt(l, r, o));
    }
  }
  function hr(n) {
    var r = n.alternate;
    return n === je || r !== null && r === je;
  }
  function gv(n, r) {
    po = Ps = !0;
    var l = n.pending;
    l === null ? r.next = r : (r.next = l.next, l.next = r), n.pending = r;
  }
  function nt(n, r, l) {
    if (l & 4194240) {
      var o = r.lanes;
      o &= n.pendingLanes, l |= o, r.lanes = l, os(n, l);
    }
  }
  var Sl = { readContext: Ur, useCallback: Fe, useContext: Fe, useEffect: Fe, useImperativeHandle: Fe, useInsertionEffect: Fe, useLayoutEffect: Fe, useMemo: Fe, useReducer: Fe, useRef: Fe, useState: Fe, useDebugValue: Fe, useDeferredValue: Fe, useTransition: Fe, useMutableSource: Fe, useSyncExternalStore: Fe, useId: Fe, unstable_isNewReconciler: !1 }, rc = { readContext: Ur, useCallback: function(n, r) {
    return yn().memoizedState = [n, r === void 0 ? null : r], n;
  }, useContext: Ur, useEffect: Zs, useImperativeHandle: function(n, r, l) {
    return l = l != null ? l.concat([n]) : null, ou(
      4194308,
      4,
      yl.bind(null, r, n),
      l
    );
  }, useLayoutEffect: function(n, r) {
    return ou(4194308, 4, n, r);
  }, useInsertionEffect: function(n, r) {
    return ou(4, 2, n, r);
  }, useMemo: function(n, r) {
    var l = yn();
    return r = r === void 0 ? null : r, n = n(), l.memoizedState = [n, r], n;
  }, useReducer: function(n, r, l) {
    var o = yn();
    return r = l !== void 0 ? l(r) : r, o.memoizedState = o.baseState = r, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: r }, o.queue = n, n = n.dispatch = go.bind(null, je, n), [o.memoizedState, n];
  }, useRef: function(n) {
    var r = yn();
    return n = { current: n }, r.memoizedState = n;
  }, useState: qs, useDebugValue: mo, useDeferredValue: function(n) {
    return yn().memoizedState = n;
  }, useTransition: function() {
    var n = qs(!1), r = n[0];
    return n = yo.bind(null, n[1]), yn().memoizedState = n, [r, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, r, l) {
    var o = je, c = yn();
    if (st) {
      if (l === void 0) throw Error(N(407));
      l = l();
    } else {
      if (l = r(), Qt === null) throw Error(N(349));
      Ke & 30 || Qs(o, r, l);
    }
    c.memoizedState = l;
    var d = { value: l, getSnapshot: r };
    return c.queue = d, Zs(Gs.bind(
      null,
      o,
      d,
      n
    ), [n]), o.flags |= 2048, ml(9, Is.bind(null, o, d, l, r), void 0, null), l;
  }, useId: function() {
    var n = yn(), r = Qt.identifierPrefix;
    if (st) {
      var l = Sa, o = ga;
      l = (o & ~(1 << 32 - kr(o) - 1)).toString(32) + l, r = ":" + r + "R" + l, l = vl++, 0 < l && (r += "H" + l.toString(32)), r += ":";
    } else l = U++, r = ":" + r + "r" + l.toString(32) + ":";
    return n.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, So = {
    readContext: Ur,
    useCallback: tc,
    useContext: Ur,
    useEffect: vo,
    useImperativeHandle: ec,
    useInsertionEffect: Js,
    useLayoutEffect: ho,
    useMemo: nc,
    useReducer: Ri,
    useRef: Ks,
    useState: function() {
      return Ri(Ya);
    },
    useDebugValue: mo,
    useDeferredValue: function(n) {
      var r = Rt();
      return Jf(r, Ut.memoizedState, n);
    },
    useTransition: function() {
      var n = Ri(Ya)[0], r = Rt().memoizedState;
      return [n, r];
    },
    useMutableSource: $s,
    useSyncExternalStore: Ys,
    useId: ed,
    unstable_isNewReconciler: !1
  }, ac = { readContext: Ur, useCallback: tc, useContext: Ur, useEffect: vo, useImperativeHandle: ec, useInsertionEffect: Js, useLayoutEffect: ho, useMemo: nc, useReducer: hl, useRef: Ks, useState: function() {
    return hl(Ya);
  }, useDebugValue: mo, useDeferredValue: function(n) {
    var r = Rt();
    return Ut === null ? r.memoizedState = n : Jf(r, Ut.memoizedState, n);
  }, useTransition: function() {
    var n = hl(Ya)[0], r = Rt().memoizedState;
    return [n, r];
  }, useMutableSource: $s, useSyncExternalStore: Ys, useId: ed, unstable_isNewReconciler: !1 };
  function ra(n, r) {
    if (n && n.defaultProps) {
      r = Z({}, r), n = n.defaultProps;
      for (var l in n) r[l] === void 0 && (r[l] = n[l]);
      return r;
    }
    return r;
  }
  function td(n, r, l, o) {
    r = n.memoizedState, l = l(o, r), l = l == null ? r : Z({}, r, l), n.memoizedState = l, n.lanes === 0 && (n.updateQueue.baseState = l);
  }
  var ic = { isMounted: function(n) {
    return (n = n._reactInternals) ? qr(n) === n : !1;
  }, enqueueSetState: function(n, r, l) {
    n = n._reactInternals;
    var o = Vt(), c = wa(n), d = $a(o, c);
    d.payload = r, l != null && (d.callback = l), r = Ei(n, d, c), r !== null && (bn(r, n, c, o), Vs(r, n, c));
  }, enqueueReplaceState: function(n, r, l) {
    n = n._reactInternals;
    var o = Vt(), c = wa(n), d = $a(o, c);
    d.tag = 1, d.payload = r, l != null && (d.callback = l), r = Ei(n, d, c), r !== null && (bn(r, n, c, o), Vs(r, n, c));
  }, enqueueForceUpdate: function(n, r) {
    n = n._reactInternals;
    var l = Vt(), o = wa(n), c = $a(l, o);
    c.tag = 2, r != null && (c.callback = r), r = Ei(n, c, o), r !== null && (bn(r, n, o, l), Vs(r, n, o));
  } };
  function Sv(n, r, l, o, c, d, h) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(o, d, h) : r.prototype && r.prototype.isPureReactComponent ? !Ku(l, o) || !Ku(c, d) : !0;
  }
  function lc(n, r, l) {
    var o = !1, c = In, d = r.contextType;
    return typeof d == "object" && d !== null ? d = Ur(d) : (c = Nt(r) ? Gn : Ct.current, o = r.contextTypes, d = (o = o != null) ? Or(n, c) : In), r = new r(l, d), n.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = ic, n.stateNode = r, r._reactInternals = n, o && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = c, n.__reactInternalMemoizedMaskedChildContext = d), r;
  }
  function Cv(n, r, l, o) {
    n = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(l, o), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(l, o), r.state !== n && ic.enqueueReplaceState(r, r.state, null);
  }
  function Co(n, r, l, o) {
    var c = n.stateNode;
    c.props = l, c.state = n.memoizedState, c.refs = {}, qf(n);
    var d = r.contextType;
    typeof d == "object" && d !== null ? c.context = Ur(d) : (d = Nt(r) ? Gn : Ct.current, c.context = Or(n, d)), c.state = n.memoizedState, d = r.getDerivedStateFromProps, typeof d == "function" && (td(n, r, d, l), c.state = n.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof c.getSnapshotBeforeUpdate == "function" || typeof c.UNSAFE_componentWillMount != "function" && typeof c.componentWillMount != "function" || (r = c.state, typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount(), r !== c.state && ic.enqueueReplaceState(c, c.state, null), uo(n, l, c, o), c.state = n.memoizedState), typeof c.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function Cl(n, r) {
    try {
      var l = "", o = r;
      do
        l += Pi(o), o = o.return;
      while (o);
      var c = l;
    } catch (d) {
      c = `
Error generating stack: ` + d.message + `
` + d.stack;
    }
    return { value: n, source: r, stack: c, digest: null };
  }
  function nd(n, r, l) {
    return { value: n, source: null, stack: l ?? null, digest: r ?? null };
  }
  function rd(n, r) {
    try {
      console.error(r.value);
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  var uc = typeof WeakMap == "function" ? WeakMap : Map;
  function Ev(n, r, l) {
    l = $a(-1, l), l.tag = 3, l.payload = { element: null };
    var o = r.value;
    return l.callback = function() {
      hu || (hu = !0, Rl = o), rd(n, r);
    }, l;
  }
  function ad(n, r, l) {
    l = $a(-1, l), l.tag = 3;
    var o = n.type.getDerivedStateFromError;
    if (typeof o == "function") {
      var c = r.value;
      l.payload = function() {
        return o(c);
      }, l.callback = function() {
        rd(n, r);
      };
    }
    var d = n.stateNode;
    return d !== null && typeof d.componentDidCatch == "function" && (l.callback = function() {
      rd(n, r), typeof o != "function" && (Di === null ? Di = /* @__PURE__ */ new Set([this]) : Di.add(this));
      var h = r.stack;
      this.componentDidCatch(r.value, { componentStack: h !== null ? h : "" });
    }), l;
  }
  function id(n, r, l) {
    var o = n.pingCache;
    if (o === null) {
      o = n.pingCache = new uc();
      var c = /* @__PURE__ */ new Set();
      o.set(r, c);
    } else c = o.get(r), c === void 0 && (c = /* @__PURE__ */ new Set(), o.set(r, c));
    c.has(l) || (c.add(l), n = ry.bind(null, n, r, l), r.then(n, n));
  }
  function Tv(n) {
    do {
      var r;
      if ((r = n.tag === 13) && (r = n.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r) return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function xi(n, r, l, o, c) {
    return n.mode & 1 ? (n.flags |= 65536, n.lanes = c, n) : (n === r ? n.flags |= 65536 : (n.flags |= 128, l.flags |= 131072, l.flags &= -52805, l.tag === 1 && (l.alternate === null ? l.tag = 17 : (r = $a(-1, 1), r.tag = 2, Ei(l, r, 1))), l.lanes |= 1), n);
  }
  var Eo = it.ReactCurrentOwner, At = !1;
  function nn(n, r, l, o) {
    r.child = n === null ? Y(r, null, l, o) : Tt(r, n.child, l, o);
  }
  function Zn(n, r, l, o, c) {
    l = l.render;
    var d = r.ref;
    return dt(r, c), o = Ti(n, r, l, o, d, c), l = na(), n !== null && !At ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~c, Hr(n, r, c)) : (st && l && Us(r), r.flags |= 1, nn(n, r, o, c), r.child);
  }
  function El(n, r, l, o, c) {
    if (n === null) {
      var d = l.type;
      return typeof d == "function" && !Sd(d) && d.defaultProps === void 0 && l.compare === null && l.defaultProps === void 0 ? (r.tag = 15, r.type = d, Re(n, r, d, o, c)) : (n = Ho(l.type, null, o, r, r.mode, c), n.ref = r.ref, n.return = r, r.child = n);
    }
    if (d = n.child, !(n.lanes & c)) {
      var h = d.memoizedProps;
      if (l = l.compare, l = l !== null ? l : Ku, l(h, o) && n.ref === r.ref) return Hr(n, r, c);
    }
    return r.flags |= 1, n = bi(d, o), n.ref = r.ref, n.return = r, r.child = n;
  }
  function Re(n, r, l, o, c) {
    if (n !== null) {
      var d = n.memoizedProps;
      if (Ku(d, o) && n.ref === r.ref) if (At = !1, r.pendingProps = o = d, (n.lanes & c) !== 0) n.flags & 131072 && (At = !0);
      else return r.lanes = n.lanes, Hr(n, r, c);
    }
    return Rv(n, r, l, o, c);
  }
  function To(n, r, l) {
    var o = r.pendingProps, c = o.children, d = n !== null ? n.memoizedState : null;
    if (o.mode === "hidden") if (!(r.mode & 1)) r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, ie(du, mr), mr |= l;
    else {
      if (!(l & 1073741824)) return n = d !== null ? d.baseLanes | l : l, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, r.updateQueue = null, ie(du, mr), mr |= n, null;
      r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, o = d !== null ? d.baseLanes : l, ie(du, mr), mr |= o;
    }
    else d !== null ? (o = d.baseLanes | l, r.memoizedState = null) : o = l, ie(du, mr), mr |= o;
    return nn(n, r, c, l), r.child;
  }
  function ld(n, r) {
    var l = r.ref;
    (n === null && l !== null || n !== null && n.ref !== l) && (r.flags |= 512, r.flags |= 2097152);
  }
  function Rv(n, r, l, o, c) {
    var d = Nt(l) ? Gn : Ct.current;
    return d = Or(r, d), dt(r, c), l = Ti(n, r, l, o, d, c), o = na(), n !== null && !At ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~c, Hr(n, r, c)) : (st && o && Us(r), r.flags |= 1, nn(n, r, l, c), r.child);
  }
  function xv(n, r, l, o, c) {
    if (Nt(l)) {
      var d = !0;
      Wn(r);
    } else d = !1;
    if (dt(r, c), r.stateNode === null) Ar(n, r), lc(r, l, o), Co(r, l, o, c), o = !0;
    else if (n === null) {
      var h = r.stateNode, g = r.memoizedProps;
      h.props = g;
      var C = h.context, _ = l.contextType;
      typeof _ == "object" && _ !== null ? _ = Ur(_) : (_ = Nt(l) ? Gn : Ct.current, _ = Or(r, _));
      var H = l.getDerivedStateFromProps, F = typeof H == "function" || typeof h.getSnapshotBeforeUpdate == "function";
      F || typeof h.UNSAFE_componentWillReceiveProps != "function" && typeof h.componentWillReceiveProps != "function" || (g !== o || C !== _) && Cv(r, h, o, _), vr = !1;
      var A = r.memoizedState;
      h.state = A, uo(r, o, h, c), C = r.memoizedState, g !== o || A !== C || $t.current || vr ? (typeof H == "function" && (td(r, l, H, o), C = r.memoizedState), (g = vr || Sv(r, l, g, o, A, C, _)) ? (F || typeof h.UNSAFE_componentWillMount != "function" && typeof h.componentWillMount != "function" || (typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount()), typeof h.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof h.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = o, r.memoizedState = C), h.props = o, h.state = C, h.context = _, o = g) : (typeof h.componentDidMount == "function" && (r.flags |= 4194308), o = !1);
    } else {
      h = r.stateNode, hv(n, r), g = r.memoizedProps, _ = r.type === r.elementType ? g : ra(r.type, g), h.props = _, F = r.pendingProps, A = h.context, C = l.contextType, typeof C == "object" && C !== null ? C = Ur(C) : (C = Nt(l) ? Gn : Ct.current, C = Or(r, C));
      var W = l.getDerivedStateFromProps;
      (H = typeof W == "function" || typeof h.getSnapshotBeforeUpdate == "function") || typeof h.UNSAFE_componentWillReceiveProps != "function" && typeof h.componentWillReceiveProps != "function" || (g !== F || A !== C) && Cv(r, h, o, C), vr = !1, A = r.memoizedState, h.state = A, uo(r, o, h, c);
      var J = r.memoizedState;
      g !== F || A !== J || $t.current || vr ? (typeof W == "function" && (td(r, l, W, o), J = r.memoizedState), (_ = vr || Sv(r, l, _, o, A, J, C) || !1) ? (H || typeof h.UNSAFE_componentWillUpdate != "function" && typeof h.componentWillUpdate != "function" || (typeof h.componentWillUpdate == "function" && h.componentWillUpdate(o, J, C), typeof h.UNSAFE_componentWillUpdate == "function" && h.UNSAFE_componentWillUpdate(o, J, C)), typeof h.componentDidUpdate == "function" && (r.flags |= 4), typeof h.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof h.componentDidUpdate != "function" || g === n.memoizedProps && A === n.memoizedState || (r.flags |= 4), typeof h.getSnapshotBeforeUpdate != "function" || g === n.memoizedProps && A === n.memoizedState || (r.flags |= 1024), r.memoizedProps = o, r.memoizedState = J), h.props = o, h.state = J, h.context = C, o = _) : (typeof h.componentDidUpdate != "function" || g === n.memoizedProps && A === n.memoizedState || (r.flags |= 4), typeof h.getSnapshotBeforeUpdate != "function" || g === n.memoizedProps && A === n.memoizedState || (r.flags |= 1024), o = !1);
    }
    return Ro(n, r, l, o, d, c);
  }
  function Ro(n, r, l, o, c, d) {
    ld(n, r);
    var h = (r.flags & 128) !== 0;
    if (!o && !h) return c && Ns(r, l, !1), Hr(n, r, d);
    o = r.stateNode, Eo.current = r;
    var g = h && typeof l.getDerivedStateFromError != "function" ? null : o.render();
    return r.flags |= 1, n !== null && h ? (r.child = Tt(r, n.child, null, d), r.child = Tt(r, null, g, d)) : nn(n, r, g, d), r.memoizedState = o.state, c && Ns(r, l, !0), r.child;
  }
  function cu(n) {
    var r = n.stateNode;
    r.pendingContext ? fv(n, r.pendingContext, r.pendingContext !== r.context) : r.context && fv(n, r.context, !1), Zf(n, r.containerInfo);
  }
  function wv(n, r, l, o, c) {
    return Ci(), Pa(c), r.flags |= 256, nn(n, r, l, o), r.child;
  }
  var oc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function ud(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function sc(n, r, l) {
    var o = r.pendingProps, c = pt.current, d = !1, h = (r.flags & 128) !== 0, g;
    if ((g = h) || (g = n !== null && n.memoizedState === null ? !1 : (c & 2) !== 0), g ? (d = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (c |= 1), ie(pt, c & 1), n === null)
      return $f(r), n = r.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? (r.mode & 1 ? n.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824 : r.lanes = 1, null) : (h = o.children, n = o.fallback, d ? (o = r.mode, d = r.child, h = { mode: "hidden", children: h }, !(o & 1) && d !== null ? (d.childLanes = 0, d.pendingProps = h) : d = _i(h, o, 0, null), n = Wa(n, o, l, null), d.return = r, n.return = r, d.sibling = n, r.child = d, r.child.memoizedState = ud(l), r.memoizedState = oc, n) : od(r, h));
    if (c = n.memoizedState, c !== null && (g = c.dehydrated, g !== null)) return Dv(n, r, h, o, g, c, l);
    if (d) {
      d = o.fallback, h = r.mode, c = n.child, g = c.sibling;
      var C = { mode: "hidden", children: o.children };
      return !(h & 1) && r.child !== c ? (o = r.child, o.childLanes = 0, o.pendingProps = C, r.deletions = null) : (o = bi(c, C), o.subtreeFlags = c.subtreeFlags & 14680064), g !== null ? d = bi(g, d) : (d = Wa(d, h, l, null), d.flags |= 2), d.return = r, o.return = r, o.sibling = d, r.child = o, o = d, d = r.child, h = n.child.memoizedState, h = h === null ? ud(l) : { baseLanes: h.baseLanes | l, cachePool: null, transitions: h.transitions }, d.memoizedState = h, d.childLanes = n.childLanes & ~l, r.memoizedState = oc, o;
    }
    return d = n.child, n = d.sibling, o = bi(d, { mode: "visible", children: o.children }), !(r.mode & 1) && (o.lanes = l), o.return = r, o.sibling = null, n !== null && (l = r.deletions, l === null ? (r.deletions = [n], r.flags |= 16) : l.push(n)), r.child = o, r.memoizedState = null, o;
  }
  function od(n, r) {
    return r = _i({ mode: "visible", children: r }, n.mode, 0, null), r.return = n, n.child = r;
  }
  function xo(n, r, l, o) {
    return o !== null && Pa(o), Tt(r, n.child, null, l), n = od(r, r.pendingProps.children), n.flags |= 2, r.memoizedState = null, n;
  }
  function Dv(n, r, l, o, c, d, h) {
    if (l)
      return r.flags & 256 ? (r.flags &= -257, o = nd(Error(N(422))), xo(n, r, h, o)) : r.memoizedState !== null ? (r.child = n.child, r.flags |= 128, null) : (d = o.fallback, c = r.mode, o = _i({ mode: "visible", children: o.children }, c, 0, null), d = Wa(d, c, h, null), d.flags |= 2, o.return = r, d.return = r, o.sibling = d, r.child = o, r.mode & 1 && Tt(r, n.child, null, h), r.child.memoizedState = ud(h), r.memoizedState = oc, d);
    if (!(r.mode & 1)) return xo(n, r, h, null);
    if (c.data === "$!") {
      if (o = c.nextSibling && c.nextSibling.dataset, o) var g = o.dgst;
      return o = g, d = Error(N(419)), o = nd(d, o, void 0), xo(n, r, h, o);
    }
    if (g = (h & n.childLanes) !== 0, At || g) {
      if (o = Qt, o !== null) {
        switch (h & -h) {
          case 4:
            c = 2;
            break;
          case 16:
            c = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            c = 32;
            break;
          case 536870912:
            c = 268435456;
            break;
          default:
            c = 0;
        }
        c = c & (o.suspendedLanes | h) ? 0 : c, c !== 0 && c !== d.retryLane && (d.retryLane = c, pr(n, c), bn(o, n, c, -1));
      }
      return gd(), o = nd(Error(N(421))), xo(n, r, h, o);
    }
    return c.data === "$?" ? (r.flags |= 128, r.child = n.child, r = ay.bind(null, n), c._reactRetry = r, null) : (n = d.treeContext, qn = va(c.nextSibling), Xn = r, st = !0, zr = null, n !== null && (zt[Nr++] = ga, zt[Nr++] = Sa, zt[Nr++] = fr, ga = n.id, Sa = n.overflow, fr = r), r = od(r, o.children), r.flags |= 4096, r);
  }
  function sd(n, r, l) {
    n.lanes |= r;
    var o = n.alternate;
    o !== null && (o.lanes |= r), Gf(n.return, r, l);
  }
  function wn(n, r, l, o, c) {
    var d = n.memoizedState;
    d === null ? n.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: o, tail: l, tailMode: c } : (d.isBackwards = r, d.rendering = null, d.renderingStartTime = 0, d.last = o, d.tail = l, d.tailMode = c);
  }
  function Ea(n, r, l) {
    var o = r.pendingProps, c = o.revealOrder, d = o.tail;
    if (nn(n, r, o.children, l), o = pt.current, o & 2) o = o & 1 | 2, r.flags |= 128;
    else {
      if (n !== null && n.flags & 128) e: for (n = r.child; n !== null; ) {
        if (n.tag === 13) n.memoizedState !== null && sd(n, l, r);
        else if (n.tag === 19) sd(n, l, r);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === r) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === r) break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      o &= 1;
    }
    if (ie(pt, o), !(r.mode & 1)) r.memoizedState = null;
    else switch (c) {
      case "forwards":
        for (l = r.child, c = null; l !== null; ) n = l.alternate, n !== null && Bs(n) === null && (c = l), l = l.sibling;
        l = c, l === null ? (c = r.child, r.child = null) : (c = l.sibling, l.sibling = null), wn(r, !1, c, l, d);
        break;
      case "backwards":
        for (l = null, c = r.child, r.child = null; c !== null; ) {
          if (n = c.alternate, n !== null && Bs(n) === null) {
            r.child = c;
            break;
          }
          n = c.sibling, c.sibling = l, l = c, c = n;
        }
        wn(r, !0, l, null, d);
        break;
      case "together":
        wn(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function Ar(n, r) {
    !(r.mode & 1) && n !== null && (n.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function Hr(n, r, l) {
    if (n !== null && (r.dependencies = n.dependencies), xa |= r.lanes, !(l & r.childLanes)) return null;
    if (n !== null && r.child !== n.child) throw Error(N(153));
    if (r.child !== null) {
      for (n = r.child, l = bi(n, n.pendingProps), r.child = l, l.return = r; n.sibling !== null; ) n = n.sibling, l = l.sibling = bi(n, n.pendingProps), l.return = r;
      l.sibling = null;
    }
    return r.child;
  }
  function wo(n, r, l) {
    switch (r.tag) {
      case 3:
        cu(r), Ci();
        break;
      case 5:
        yv(r);
        break;
      case 1:
        Nt(r.type) && Wn(r);
        break;
      case 4:
        Zf(r, r.stateNode.containerInfo);
        break;
      case 10:
        var o = r.type._context, c = r.memoizedProps.value;
        ie(dr, o._currentValue), o._currentValue = c;
        break;
      case 13:
        if (o = r.memoizedState, o !== null)
          return o.dehydrated !== null ? (ie(pt, pt.current & 1), r.flags |= 128, null) : l & r.child.childLanes ? sc(n, r, l) : (ie(pt, pt.current & 1), n = Hr(n, r, l), n !== null ? n.sibling : null);
        ie(pt, pt.current & 1);
        break;
      case 19:
        if (o = (l & r.childLanes) !== 0, n.flags & 128) {
          if (o) return Ea(n, r, l);
          r.flags |= 128;
        }
        if (c = r.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), ie(pt, pt.current), o) break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, To(n, r, l);
    }
    return Hr(n, r, l);
  }
  var Fr, Ht, kv, bv;
  Fr = function(n, r) {
    for (var l = r.child; l !== null; ) {
      if (l.tag === 5 || l.tag === 6) n.appendChild(l.stateNode);
      else if (l.tag !== 4 && l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === r) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === r) return;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
  }, Ht = function() {
  }, kv = function(n, r, l, o) {
    var c = n.memoizedProps;
    if (c !== o) {
      n = r.stateNode, dl(Ca.current);
      var d = null;
      switch (l) {
        case "input":
          c = or(n, c), o = or(n, o), d = [];
          break;
        case "select":
          c = Z({}, c, { value: void 0 }), o = Z({}, o, { value: void 0 }), d = [];
          break;
        case "textarea":
          c = Dr(n, c), o = Dr(n, o), d = [];
          break;
        default:
          typeof c.onClick != "function" && typeof o.onClick == "function" && (n.onclick = vi);
      }
      Lt(l, o);
      var h;
      l = null;
      for (_ in c) if (!o.hasOwnProperty(_) && c.hasOwnProperty(_) && c[_] != null) if (_ === "style") {
        var g = c[_];
        for (h in g) g.hasOwnProperty(h) && (l || (l = {}), l[h] = "");
      } else _ !== "dangerouslySetInnerHTML" && _ !== "children" && _ !== "suppressContentEditableWarning" && _ !== "suppressHydrationWarning" && _ !== "autoFocus" && (ht.hasOwnProperty(_) ? d || (d = []) : (d = d || []).push(_, null));
      for (_ in o) {
        var C = o[_];
        if (g = c != null ? c[_] : void 0, o.hasOwnProperty(_) && C !== g && (C != null || g != null)) if (_ === "style") if (g) {
          for (h in g) !g.hasOwnProperty(h) || C && C.hasOwnProperty(h) || (l || (l = {}), l[h] = "");
          for (h in C) C.hasOwnProperty(h) && g[h] !== C[h] && (l || (l = {}), l[h] = C[h]);
        } else l || (d || (d = []), d.push(
          _,
          l
        )), l = C;
        else _ === "dangerouslySetInnerHTML" ? (C = C ? C.__html : void 0, g = g ? g.__html : void 0, C != null && g !== C && (d = d || []).push(_, C)) : _ === "children" ? typeof C != "string" && typeof C != "number" || (d = d || []).push(_, "" + C) : _ !== "suppressContentEditableWarning" && _ !== "suppressHydrationWarning" && (ht.hasOwnProperty(_) ? (C != null && _ === "onScroll" && Ye("scroll", n), d || g === C || (d = [])) : (d = d || []).push(_, C));
      }
      l && (d = d || []).push("style", l);
      var _ = d;
      (r.updateQueue = _) && (r.flags |= 4);
    }
  }, bv = function(n, r, l, o) {
    l !== o && (r.flags |= 4);
  };
  function Do(n, r) {
    if (!st) switch (n.tailMode) {
      case "hidden":
        r = n.tail;
        for (var l = null; r !== null; ) r.alternate !== null && (l = r), r = r.sibling;
        l === null ? n.tail = null : l.sibling = null;
        break;
      case "collapsed":
        l = n.tail;
        for (var o = null; l !== null; ) l.alternate !== null && (o = l), l = l.sibling;
        o === null ? r || n.tail === null ? n.tail = null : n.tail.sibling = null : o.sibling = null;
    }
  }
  function qt(n) {
    var r = n.alternate !== null && n.alternate.child === n.child, l = 0, o = 0;
    if (r) for (var c = n.child; c !== null; ) l |= c.lanes | c.childLanes, o |= c.subtreeFlags & 14680064, o |= c.flags & 14680064, c.return = n, c = c.sibling;
    else for (c = n.child; c !== null; ) l |= c.lanes | c.childLanes, o |= c.subtreeFlags, o |= c.flags, c.return = n, c = c.sibling;
    return n.subtreeFlags |= o, n.childLanes = l, r;
  }
  function _v(n, r, l) {
    var o = r.pendingProps;
    switch (As(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return qt(r), null;
      case 1:
        return Nt(r.type) && iu(), qt(r), null;
      case 3:
        return o = r.stateNode, pl(), rt($t), rt(Ct), oe(), o.pendingContext && (o.context = o.pendingContext, o.pendingContext = null), (n === null || n.child === null) && (Hs(r) ? r.flags |= 4 : n === null || n.memoizedState.isDehydrated && !(r.flags & 256) || (r.flags |= 1024, zr !== null && (xl(zr), zr = null))), Ht(n, r), qt(r), null;
      case 5:
        js(r);
        var c = dl(co.current);
        if (l = r.type, n !== null && r.stateNode != null) kv(n, r, l, o, c), n.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!o) {
            if (r.stateNode === null) throw Error(N(166));
            return qt(r), null;
          }
          if (n = dl(Ca.current), Hs(r)) {
            o = r.stateNode, l = r.type;
            var d = r.memoizedProps;
            switch (o[ha] = r, o[ro] = d, n = (r.mode & 1) !== 0, l) {
              case "dialog":
                Ye("cancel", o), Ye("close", o);
                break;
              case "iframe":
              case "object":
              case "embed":
                Ye("load", o);
                break;
              case "video":
              case "audio":
                for (c = 0; c < eo.length; c++) Ye(eo[c], o);
                break;
              case "source":
                Ye("error", o);
                break;
              case "img":
              case "image":
              case "link":
                Ye(
                  "error",
                  o
                ), Ye("load", o);
                break;
              case "details":
                Ye("toggle", o);
                break;
              case "input":
                wr(o, d), Ye("invalid", o);
                break;
              case "select":
                o._wrapperState = { wasMultiple: !!d.multiple }, Ye("invalid", o);
                break;
              case "textarea":
                Wr(o, d), Ye("invalid", o);
            }
            Lt(l, d), c = null;
            for (var h in d) if (d.hasOwnProperty(h)) {
              var g = d[h];
              h === "children" ? typeof g == "string" ? o.textContent !== g && (d.suppressHydrationWarning !== !0 && _s(o.textContent, g, n), c = ["children", g]) : typeof g == "number" && o.textContent !== "" + g && (d.suppressHydrationWarning !== !0 && _s(
                o.textContent,
                g,
                n
              ), c = ["children", "" + g]) : ht.hasOwnProperty(h) && g != null && h === "onScroll" && Ye("scroll", o);
            }
            switch (l) {
              case "input":
                hn(o), Au(o, d, !0);
                break;
              case "textarea":
                hn(o), cr(o);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof d.onClick == "function" && (o.onclick = vi);
            }
            o = c, r.updateQueue = o, o !== null && (r.flags |= 4);
          } else {
            h = c.nodeType === 9 ? c : c.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = da(l)), n === "http://www.w3.org/1999/xhtml" ? l === "script" ? (n = h.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof o.is == "string" ? n = h.createElement(l, { is: o.is }) : (n = h.createElement(l), l === "select" && (h = n, o.multiple ? h.multiple = !0 : o.size && (h.size = o.size))) : n = h.createElementNS(n, l), n[ha] = r, n[ro] = o, Fr(n, r, !1, !1), r.stateNode = n;
            e: {
              switch (h = $n(l, o), l) {
                case "dialog":
                  Ye("cancel", n), Ye("close", n), c = o;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Ye("load", n), c = o;
                  break;
                case "video":
                case "audio":
                  for (c = 0; c < eo.length; c++) Ye(eo[c], n);
                  c = o;
                  break;
                case "source":
                  Ye("error", n), c = o;
                  break;
                case "img":
                case "image":
                case "link":
                  Ye(
                    "error",
                    n
                  ), Ye("load", n), c = o;
                  break;
                case "details":
                  Ye("toggle", n), c = o;
                  break;
                case "input":
                  wr(n, o), c = or(n, o), Ye("invalid", n);
                  break;
                case "option":
                  c = o;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!o.multiple }, c = Z({}, o, { value: void 0 }), Ye("invalid", n);
                  break;
                case "textarea":
                  Wr(n, o), c = Dr(n, o), Ye("invalid", n);
                  break;
                default:
                  c = o;
              }
              Lt(l, c), g = c;
              for (d in g) if (g.hasOwnProperty(d)) {
                var C = g[d];
                d === "style" ? yt(n, C) : d === "dangerouslySetInnerHTML" ? (C = C ? C.__html : void 0, C != null && Fu(n, C)) : d === "children" ? typeof C == "string" ? (l !== "textarea" || C !== "") && $(n, C) : typeof C == "number" && $(n, "" + C) : d !== "suppressContentEditableWarning" && d !== "suppressHydrationWarning" && d !== "autoFocus" && (ht.hasOwnProperty(d) ? C != null && d === "onScroll" && Ye("scroll", n) : C != null && _e(n, d, C, h));
              }
              switch (l) {
                case "input":
                  hn(n), Au(n, o, !1);
                  break;
                case "textarea":
                  hn(n), cr(n);
                  break;
                case "option":
                  o.value != null && n.setAttribute("value", "" + xr(o.value));
                  break;
                case "select":
                  n.multiple = !!o.multiple, d = o.value, d != null ? sr(n, !!o.multiple, d, !1) : o.defaultValue != null && sr(
                    n,
                    !!o.multiple,
                    o.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof c.onClick == "function" && (n.onclick = vi);
              }
              switch (l) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  o = !!o.autoFocus;
                  break e;
                case "img":
                  o = !0;
                  break e;
                default:
                  o = !1;
              }
            }
            o && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return qt(r), null;
      case 6:
        if (n && r.stateNode != null) bv(n, r, n.memoizedProps, o);
        else {
          if (typeof o != "string" && r.stateNode === null) throw Error(N(166));
          if (l = dl(co.current), dl(Ca.current), Hs(r)) {
            if (o = r.stateNode, l = r.memoizedProps, o[ha] = r, (d = o.nodeValue !== l) && (n = Xn, n !== null)) switch (n.tag) {
              case 3:
                _s(o.nodeValue, l, (n.mode & 1) !== 0);
                break;
              case 5:
                n.memoizedProps.suppressHydrationWarning !== !0 && _s(o.nodeValue, l, (n.mode & 1) !== 0);
            }
            d && (r.flags |= 4);
          } else o = (l.nodeType === 9 ? l : l.ownerDocument).createTextNode(o), o[ha] = r, r.stateNode = o;
        }
        return qt(r), null;
      case 13:
        if (rt(pt), o = r.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (st && qn !== null && r.mode & 1 && !(r.flags & 128)) lo(), Ci(), r.flags |= 98560, d = !1;
          else if (d = Hs(r), o !== null && o.dehydrated !== null) {
            if (n === null) {
              if (!d) throw Error(N(318));
              if (d = r.memoizedState, d = d !== null ? d.dehydrated : null, !d) throw Error(N(317));
              d[ha] = r;
            } else Ci(), !(r.flags & 128) && (r.memoizedState = null), r.flags |= 4;
            qt(r), d = !1;
          } else zr !== null && (xl(zr), zr = null), d = !0;
          if (!d) return r.flags & 65536 ? r : null;
        }
        return r.flags & 128 ? (r.lanes = l, r) : (o = o !== null, o !== (n !== null && n.memoizedState !== null) && o && (r.child.flags |= 8192, r.mode & 1 && (n === null || pt.current & 1 ? wt === 0 && (wt = 3) : gd())), r.updateQueue !== null && (r.flags |= 4), qt(r), null);
      case 4:
        return pl(), Ht(n, r), n === null && eu(r.stateNode.containerInfo), qt(r), null;
      case 10:
        return If(r.type._context), qt(r), null;
      case 17:
        return Nt(r.type) && iu(), qt(r), null;
      case 19:
        if (rt(pt), d = r.memoizedState, d === null) return qt(r), null;
        if (o = (r.flags & 128) !== 0, h = d.rendering, h === null) if (o) Do(d, !1);
        else {
          if (wt !== 0 || n !== null && n.flags & 128) for (n = r.child; n !== null; ) {
            if (h = Bs(n), h !== null) {
              for (r.flags |= 128, Do(d, !1), o = h.updateQueue, o !== null && (r.updateQueue = o, r.flags |= 4), r.subtreeFlags = 0, o = l, l = r.child; l !== null; ) d = l, n = o, d.flags &= 14680066, h = d.alternate, h === null ? (d.childLanes = 0, d.lanes = n, d.child = null, d.subtreeFlags = 0, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null) : (d.childLanes = h.childLanes, d.lanes = h.lanes, d.child = h.child, d.subtreeFlags = 0, d.deletions = null, d.memoizedProps = h.memoizedProps, d.memoizedState = h.memoizedState, d.updateQueue = h.updateQueue, d.type = h.type, n = h.dependencies, d.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), l = l.sibling;
              return ie(pt, pt.current & 1 | 2), r.child;
            }
            n = n.sibling;
          }
          d.tail !== null && tt() > vu && (r.flags |= 128, o = !0, Do(d, !1), r.lanes = 4194304);
        }
        else {
          if (!o) if (n = Bs(h), n !== null) {
            if (r.flags |= 128, o = !0, l = n.updateQueue, l !== null && (r.updateQueue = l, r.flags |= 4), Do(d, !0), d.tail === null && d.tailMode === "hidden" && !h.alternate && !st) return qt(r), null;
          } else 2 * tt() - d.renderingStartTime > vu && l !== 1073741824 && (r.flags |= 128, o = !0, Do(d, !1), r.lanes = 4194304);
          d.isBackwards ? (h.sibling = r.child, r.child = h) : (l = d.last, l !== null ? l.sibling = h : r.child = h, d.last = h);
        }
        return d.tail !== null ? (r = d.tail, d.rendering = r, d.tail = r.sibling, d.renderingStartTime = tt(), r.sibling = null, l = pt.current, ie(pt, o ? l & 1 | 2 : l & 1), r) : (qt(r), null);
      case 22:
      case 23:
        return yd(), o = r.memoizedState !== null, n !== null && n.memoizedState !== null !== o && (r.flags |= 8192), o && r.mode & 1 ? mr & 1073741824 && (qt(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : qt(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(N(156, r.tag));
  }
  function cc(n, r) {
    switch (As(r), r.tag) {
      case 1:
        return Nt(r.type) && iu(), n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 3:
        return pl(), rt($t), rt(Ct), oe(), n = r.flags, n & 65536 && !(n & 128) ? (r.flags = n & -65537 | 128, r) : null;
      case 5:
        return js(r), null;
      case 13:
        if (rt(pt), n = r.memoizedState, n !== null && n.dehydrated !== null) {
          if (r.alternate === null) throw Error(N(340));
          Ci();
        }
        return n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 19:
        return rt(pt), null;
      case 4:
        return pl(), null;
      case 10:
        return If(r.type._context), null;
      case 22:
      case 23:
        return yd(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var ko = !1, gn = !1, Km = typeof WeakSet == "function" ? WeakSet : Set, K = null;
  function fu(n, r) {
    var l = n.ref;
    if (l !== null) if (typeof l == "function") try {
      l(null);
    } catch (o) {
      ct(n, r, o);
    }
    else l.current = null;
  }
  function fc(n, r, l) {
    try {
      l();
    } catch (o) {
      ct(n, r, o);
    }
  }
  var Lv = !1;
  function Mv(n, r) {
    if (no = Ji, n = Zu(), Es(n)) {
      if ("selectionStart" in n) var l = { start: n.selectionStart, end: n.selectionEnd };
      else e: {
        l = (l = n.ownerDocument) && l.defaultView || window;
        var o = l.getSelection && l.getSelection();
        if (o && o.rangeCount !== 0) {
          l = o.anchorNode;
          var c = o.anchorOffset, d = o.focusNode;
          o = o.focusOffset;
          try {
            l.nodeType, d.nodeType;
          } catch {
            l = null;
            break e;
          }
          var h = 0, g = -1, C = -1, _ = 0, H = 0, F = n, A = null;
          t: for (; ; ) {
            for (var W; F !== l || c !== 0 && F.nodeType !== 3 || (g = h + c), F !== d || o !== 0 && F.nodeType !== 3 || (C = h + o), F.nodeType === 3 && (h += F.nodeValue.length), (W = F.firstChild) !== null; )
              A = F, F = W;
            for (; ; ) {
              if (F === n) break t;
              if (A === l && ++_ === c && (g = h), A === d && ++H === o && (C = h), (W = F.nextSibling) !== null) break;
              F = A, A = F.parentNode;
            }
            F = W;
          }
          l = g === -1 || C === -1 ? null : { start: g, end: C };
        } else l = null;
      }
      l = l || { start: 0, end: 0 };
    } else l = null;
    for (ll = { focusedElem: n, selectionRange: l }, Ji = !1, K = r; K !== null; ) if (r = K, n = r.child, (r.subtreeFlags & 1028) !== 0 && n !== null) n.return = r, K = n;
    else for (; K !== null; ) {
      r = K;
      try {
        var J = r.alternate;
        if (r.flags & 1024) switch (r.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (J !== null) {
              var te = J.memoizedProps, Dt = J.memoizedState, x = r.stateNode, T = x.getSnapshotBeforeUpdate(r.elementType === r.type ? te : ra(r.type, te), Dt);
              x.__reactInternalSnapshotBeforeUpdate = T;
            }
            break;
          case 3:
            var k = r.stateNode.containerInfo;
            k.nodeType === 1 ? k.textContent = "" : k.nodeType === 9 && k.documentElement && k.removeChild(k.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(N(163));
        }
      } catch (j) {
        ct(r, r.return, j);
      }
      if (n = r.sibling, n !== null) {
        n.return = r.return, K = n;
        break;
      }
      K = r.return;
    }
    return J = Lv, Lv = !1, J;
  }
  function bo(n, r, l) {
    var o = r.updateQueue;
    if (o = o !== null ? o.lastEffect : null, o !== null) {
      var c = o = o.next;
      do {
        if ((c.tag & n) === n) {
          var d = c.destroy;
          c.destroy = void 0, d !== void 0 && fc(r, l, d);
        }
        c = c.next;
      } while (c !== o);
    }
  }
  function _o(n, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var l = r = r.next;
      do {
        if ((l.tag & n) === n) {
          var o = l.create;
          l.destroy = o();
        }
        l = l.next;
      } while (l !== r);
    }
  }
  function cd(n) {
    var r = n.ref;
    if (r !== null) {
      var l = n.stateNode;
      switch (n.tag) {
        case 5:
          n = l;
          break;
        default:
          n = l;
      }
      typeof r == "function" ? r(n) : r.current = n;
    }
  }
  function dc(n) {
    var r = n.alternate;
    r !== null && (n.alternate = null, dc(r)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (r = n.stateNode, r !== null && (delete r[ha], delete r[ro], delete r[ao], delete r[au], delete r[Xm])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function Lo(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function Qa(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || Lo(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function Ta(n, r, l) {
    var o = n.tag;
    if (o === 5 || o === 6) n = n.stateNode, r ? l.nodeType === 8 ? l.parentNode.insertBefore(n, r) : l.insertBefore(n, r) : (l.nodeType === 8 ? (r = l.parentNode, r.insertBefore(n, l)) : (r = l, r.appendChild(n)), l = l._reactRootContainer, l != null || r.onclick !== null || (r.onclick = vi));
    else if (o !== 4 && (n = n.child, n !== null)) for (Ta(n, r, l), n = n.sibling; n !== null; ) Ta(n, r, l), n = n.sibling;
  }
  function Ra(n, r, l) {
    var o = n.tag;
    if (o === 5 || o === 6) n = n.stateNode, r ? l.insertBefore(n, r) : l.appendChild(n);
    else if (o !== 4 && (n = n.child, n !== null)) for (Ra(n, r, l), n = n.sibling; n !== null; ) Ra(n, r, l), n = n.sibling;
  }
  var xt = null, Dn = !1;
  function kn(n, r, l) {
    for (l = l.child; l !== null; ) Ov(n, r, l), l = l.sibling;
  }
  function Ov(n, r, l) {
    if (Kr && typeof Kr.onCommitFiberUnmount == "function") try {
      Kr.onCommitFiberUnmount(Bu, l);
    } catch {
    }
    switch (l.tag) {
      case 5:
        gn || fu(l, r);
      case 6:
        var o = xt, c = Dn;
        xt = null, kn(n, r, l), xt = o, Dn = c, xt !== null && (Dn ? (n = xt, l = l.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(l) : n.removeChild(l)) : xt.removeChild(l.stateNode));
        break;
      case 18:
        xt !== null && (Dn ? (n = xt, l = l.stateNode, n.nodeType === 8 ? ru(n.parentNode, l) : n.nodeType === 1 && ru(n, l), fi(n)) : ru(xt, l.stateNode));
        break;
      case 4:
        o = xt, c = Dn, xt = l.stateNode.containerInfo, Dn = !0, kn(n, r, l), xt = o, Dn = c;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!gn && (o = l.updateQueue, o !== null && (o = o.lastEffect, o !== null))) {
          c = o = o.next;
          do {
            var d = c, h = d.destroy;
            d = d.tag, h !== void 0 && (d & 2 || d & 4) && fc(l, r, h), c = c.next;
          } while (c !== o);
        }
        kn(n, r, l);
        break;
      case 1:
        if (!gn && (fu(l, r), o = l.stateNode, typeof o.componentWillUnmount == "function")) try {
          o.props = l.memoizedProps, o.state = l.memoizedState, o.componentWillUnmount();
        } catch (g) {
          ct(l, r, g);
        }
        kn(n, r, l);
        break;
      case 21:
        kn(n, r, l);
        break;
      case 22:
        l.mode & 1 ? (gn = (o = gn) || l.memoizedState !== null, kn(n, r, l), gn = o) : kn(n, r, l);
        break;
      default:
        kn(n, r, l);
    }
  }
  function Nv(n) {
    var r = n.updateQueue;
    if (r !== null) {
      n.updateQueue = null;
      var l = n.stateNode;
      l === null && (l = n.stateNode = new Km()), r.forEach(function(o) {
        var c = Pv.bind(null, n, o);
        l.has(o) || (l.add(o), o.then(c, c));
      });
    }
  }
  function aa(n, r) {
    var l = r.deletions;
    if (l !== null) for (var o = 0; o < l.length; o++) {
      var c = l[o];
      try {
        var d = n, h = r, g = h;
        e: for (; g !== null; ) {
          switch (g.tag) {
            case 5:
              xt = g.stateNode, Dn = !1;
              break e;
            case 3:
              xt = g.stateNode.containerInfo, Dn = !0;
              break e;
            case 4:
              xt = g.stateNode.containerInfo, Dn = !0;
              break e;
          }
          g = g.return;
        }
        if (xt === null) throw Error(N(160));
        Ov(d, h, c), xt = null, Dn = !1;
        var C = c.alternate;
        C !== null && (C.return = null), c.return = null;
      } catch (_) {
        ct(c, r, _);
      }
    }
    if (r.subtreeFlags & 12854) for (r = r.child; r !== null; ) fd(r, n), r = r.sibling;
  }
  function fd(n, r) {
    var l = n.alternate, o = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (aa(r, n), Jn(n), o & 4) {
          try {
            bo(3, n, n.return), _o(3, n);
          } catch (te) {
            ct(n, n.return, te);
          }
          try {
            bo(5, n, n.return);
          } catch (te) {
            ct(n, n.return, te);
          }
        }
        break;
      case 1:
        aa(r, n), Jn(n), o & 512 && l !== null && fu(l, l.return);
        break;
      case 5:
        if (aa(r, n), Jn(n), o & 512 && l !== null && fu(l, l.return), n.flags & 32) {
          var c = n.stateNode;
          try {
            $(c, "");
          } catch (te) {
            ct(n, n.return, te);
          }
        }
        if (o & 4 && (c = n.stateNode, c != null)) {
          var d = n.memoizedProps, h = l !== null ? l.memoizedProps : d, g = n.type, C = n.updateQueue;
          if (n.updateQueue = null, C !== null) try {
            g === "input" && d.type === "radio" && d.name != null && fa(c, d), $n(g, h);
            var _ = $n(g, d);
            for (h = 0; h < C.length; h += 2) {
              var H = C[h], F = C[h + 1];
              H === "style" ? yt(c, F) : H === "dangerouslySetInnerHTML" ? Fu(c, F) : H === "children" ? $(c, F) : _e(c, H, F, _);
            }
            switch (g) {
              case "input":
                Vl(c, d);
                break;
              case "textarea":
                jl(c, d);
                break;
              case "select":
                var A = c._wrapperState.wasMultiple;
                c._wrapperState.wasMultiple = !!d.multiple;
                var W = d.value;
                W != null ? sr(c, !!d.multiple, W, !1) : A !== !!d.multiple && (d.defaultValue != null ? sr(
                  c,
                  !!d.multiple,
                  d.defaultValue,
                  !0
                ) : sr(c, !!d.multiple, d.multiple ? [] : "", !1));
            }
            c[ro] = d;
          } catch (te) {
            ct(n, n.return, te);
          }
        }
        break;
      case 6:
        if (aa(r, n), Jn(n), o & 4) {
          if (n.stateNode === null) throw Error(N(162));
          c = n.stateNode, d = n.memoizedProps;
          try {
            c.nodeValue = d;
          } catch (te) {
            ct(n, n.return, te);
          }
        }
        break;
      case 3:
        if (aa(r, n), Jn(n), o & 4 && l !== null && l.memoizedState.isDehydrated) try {
          fi(r.containerInfo);
        } catch (te) {
          ct(n, n.return, te);
        }
        break;
      case 4:
        aa(r, n), Jn(n);
        break;
      case 13:
        aa(r, n), Jn(n), c = n.child, c.flags & 8192 && (d = c.memoizedState !== null, c.stateNode.isHidden = d, !d || c.alternate !== null && c.alternate.memoizedState !== null || (vd = tt())), o & 4 && Nv(n);
        break;
      case 22:
        if (H = l !== null && l.memoizedState !== null, n.mode & 1 ? (gn = (_ = gn) || H, aa(r, n), gn = _) : aa(r, n), Jn(n), o & 8192) {
          if (_ = n.memoizedState !== null, (n.stateNode.isHidden = _) && !H && n.mode & 1) for (K = n, H = n.child; H !== null; ) {
            for (F = K = H; K !== null; ) {
              switch (A = K, W = A.child, A.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  bo(4, A, A.return);
                  break;
                case 1:
                  fu(A, A.return);
                  var J = A.stateNode;
                  if (typeof J.componentWillUnmount == "function") {
                    o = A, l = A.return;
                    try {
                      r = o, J.props = r.memoizedProps, J.state = r.memoizedState, J.componentWillUnmount();
                    } catch (te) {
                      ct(o, l, te);
                    }
                  }
                  break;
                case 5:
                  fu(A, A.return);
                  break;
                case 22:
                  if (A.memoizedState !== null) {
                    Mo(F);
                    continue;
                  }
              }
              W !== null ? (W.return = A, K = W) : Mo(F);
            }
            H = H.sibling;
          }
          e: for (H = null, F = n; ; ) {
            if (F.tag === 5) {
              if (H === null) {
                H = F;
                try {
                  c = F.stateNode, _ ? (d = c.style, typeof d.setProperty == "function" ? d.setProperty("display", "none", "important") : d.display = "none") : (g = F.stateNode, C = F.memoizedProps.style, h = C != null && C.hasOwnProperty("display") ? C.display : null, g.style.display = et("display", h));
                } catch (te) {
                  ct(n, n.return, te);
                }
              }
            } else if (F.tag === 6) {
              if (H === null) try {
                F.stateNode.nodeValue = _ ? "" : F.memoizedProps;
              } catch (te) {
                ct(n, n.return, te);
              }
            } else if ((F.tag !== 22 && F.tag !== 23 || F.memoizedState === null || F === n) && F.child !== null) {
              F.child.return = F, F = F.child;
              continue;
            }
            if (F === n) break e;
            for (; F.sibling === null; ) {
              if (F.return === null || F.return === n) break e;
              H === F && (H = null), F = F.return;
            }
            H === F && (H = null), F.sibling.return = F.return, F = F.sibling;
          }
        }
        break;
      case 19:
        aa(r, n), Jn(n), o & 4 && Nv(n);
        break;
      case 21:
        break;
      default:
        aa(
          r,
          n
        ), Jn(n);
    }
  }
  function Jn(n) {
    var r = n.flags;
    if (r & 2) {
      try {
        e: {
          for (var l = n.return; l !== null; ) {
            if (Lo(l)) {
              var o = l;
              break e;
            }
            l = l.return;
          }
          throw Error(N(160));
        }
        switch (o.tag) {
          case 5:
            var c = o.stateNode;
            o.flags & 32 && ($(c, ""), o.flags &= -33);
            var d = Qa(n);
            Ra(n, d, c);
            break;
          case 3:
          case 4:
            var h = o.stateNode.containerInfo, g = Qa(n);
            Ta(n, g, h);
            break;
          default:
            throw Error(N(161));
        }
      } catch (C) {
        ct(n, n.return, C);
      }
      n.flags &= -3;
    }
    r & 4096 && (n.flags &= -4097);
  }
  function Zm(n, r, l) {
    K = n, dd(n);
  }
  function dd(n, r, l) {
    for (var o = (n.mode & 1) !== 0; K !== null; ) {
      var c = K, d = c.child;
      if (c.tag === 22 && o) {
        var h = c.memoizedState !== null || ko;
        if (!h) {
          var g = c.alternate, C = g !== null && g.memoizedState !== null || gn;
          g = ko;
          var _ = gn;
          if (ko = h, (gn = C) && !_) for (K = c; K !== null; ) h = K, C = h.child, h.tag === 22 && h.memoizedState !== null ? pd(c) : C !== null ? (C.return = h, K = C) : pd(c);
          for (; d !== null; ) K = d, dd(d), d = d.sibling;
          K = c, ko = g, gn = _;
        }
        zv(n);
      } else c.subtreeFlags & 8772 && d !== null ? (d.return = c, K = d) : zv(n);
    }
  }
  function zv(n) {
    for (; K !== null; ) {
      var r = K;
      if (r.flags & 8772) {
        var l = r.alternate;
        try {
          if (r.flags & 8772) switch (r.tag) {
            case 0:
            case 11:
            case 15:
              gn || _o(5, r);
              break;
            case 1:
              var o = r.stateNode;
              if (r.flags & 4 && !gn) if (l === null) o.componentDidMount();
              else {
                var c = r.elementType === r.type ? l.memoizedProps : ra(r.type, l.memoizedProps);
                o.componentDidUpdate(c, l.memoizedState, o.__reactInternalSnapshotBeforeUpdate);
              }
              var d = r.updateQueue;
              d !== null && Kf(r, d, o);
              break;
            case 3:
              var h = r.updateQueue;
              if (h !== null) {
                if (l = null, r.child !== null) switch (r.child.tag) {
                  case 5:
                    l = r.child.stateNode;
                    break;
                  case 1:
                    l = r.child.stateNode;
                }
                Kf(r, h, l);
              }
              break;
            case 5:
              var g = r.stateNode;
              if (l === null && r.flags & 4) {
                l = g;
                var C = r.memoizedProps;
                switch (r.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    C.autoFocus && l.focus();
                    break;
                  case "img":
                    C.src && (l.src = C.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (r.memoizedState === null) {
                var _ = r.alternate;
                if (_ !== null) {
                  var H = _.memoizedState;
                  if (H !== null) {
                    var F = H.dehydrated;
                    F !== null && fi(F);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(N(163));
          }
          gn || r.flags & 512 && cd(r);
        } catch (A) {
          ct(r, r.return, A);
        }
      }
      if (r === n) {
        K = null;
        break;
      }
      if (l = r.sibling, l !== null) {
        l.return = r.return, K = l;
        break;
      }
      K = r.return;
    }
  }
  function Mo(n) {
    for (; K !== null; ) {
      var r = K;
      if (r === n) {
        K = null;
        break;
      }
      var l = r.sibling;
      if (l !== null) {
        l.return = r.return, K = l;
        break;
      }
      K = r.return;
    }
  }
  function pd(n) {
    for (; K !== null; ) {
      var r = K;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var l = r.return;
            try {
              _o(4, r);
            } catch (C) {
              ct(r, l, C);
            }
            break;
          case 1:
            var o = r.stateNode;
            if (typeof o.componentDidMount == "function") {
              var c = r.return;
              try {
                o.componentDidMount();
              } catch (C) {
                ct(r, c, C);
              }
            }
            var d = r.return;
            try {
              cd(r);
            } catch (C) {
              ct(r, d, C);
            }
            break;
          case 5:
            var h = r.return;
            try {
              cd(r);
            } catch (C) {
              ct(r, h, C);
            }
        }
      } catch (C) {
        ct(r, r.return, C);
      }
      if (r === n) {
        K = null;
        break;
      }
      var g = r.sibling;
      if (g !== null) {
        g.return = r.return, K = g;
        break;
      }
      K = r.return;
    }
  }
  var Jm = Math.ceil, wi = it.ReactCurrentDispatcher, Tl = it.ReactCurrentOwner, rn = it.ReactCurrentBatchConfig, Ne = 0, Qt = null, Ft = null, an = 0, mr = 0, du = ta(0), wt = 0, Oo = null, xa = 0, pu = 0, pc = 0, No = null, er = null, vd = 0, vu = 1 / 0, yr = null, hu = !1, Rl = null, Di = null, vc = !1, Ia = null, zo = 0, ki = 0, mu = null, Uo = -1, Sn = 0;
  function Vt() {
    return Ne & 6 ? tt() : Uo !== -1 ? Uo : Uo = tt();
  }
  function wa(n) {
    return n.mode & 1 ? Ne & 2 && an !== 0 ? an & -an : qm.transition !== null ? (Sn === 0 && (Sn = us()), Sn) : (n = Ge, n !== 0 || (n = window.event, n = n === void 0 ? 16 : fs(n.type)), n) : 1;
  }
  function bn(n, r, l, o) {
    if (50 < ki) throw ki = 0, mu = null, Error(N(185));
    Ki(n, l, o), (!(Ne & 2) || n !== Qt) && (n === Qt && (!(Ne & 2) && (pu |= l), wt === 4 && ia(n, an)), tr(n, o), l === 1 && Ne === 0 && !(r.mode & 1) && (vu = tt() + 500, lu && ya()));
  }
  function tr(n, r) {
    var l = n.callbackNode;
    cf(n, r);
    var o = qi(n, n === Qt ? an : 0);
    if (o === 0) l !== null && _p(l), n.callbackNode = null, n.callbackPriority = 0;
    else if (r = o & -o, n.callbackPriority !== r) {
      if (l != null && _p(l), r === 1) n.tag === 0 ? mi(hd.bind(null, n)) : zs(hd.bind(null, n)), nu(function() {
        !(Ne & 6) && ya();
      }), l = null;
      else {
        switch (pf(o)) {
          case 1:
            l = Wi;
            break;
          case 4:
            l = uf;
            break;
          case 16:
            l = ju;
            break;
          case 536870912:
            l = of;
            break;
          default:
            l = ju;
        }
        l = Yv(l, hc.bind(null, n));
      }
      n.callbackPriority = r, n.callbackNode = l;
    }
  }
  function hc(n, r) {
    if (Uo = -1, Sn = 0, Ne & 6) throw Error(N(327));
    var l = n.callbackNode;
    if (yu() && n.callbackNode !== l) return null;
    var o = qi(n, n === Qt ? an : 0);
    if (o === 0) return null;
    if (o & 30 || o & n.expiredLanes || r) r = mc(n, o);
    else {
      r = o;
      var c = Ne;
      Ne |= 2;
      var d = Av();
      (Qt !== n || an !== r) && (yr = null, vu = tt() + 500, Ga(n, r));
      do
        try {
          Hv();
          break;
        } catch (g) {
          Uv(n, g);
        }
      while (!0);
      Qf(), wi.current = d, Ne = c, Ft !== null ? r = 0 : (Qt = null, an = 0, r = wt);
    }
    if (r !== 0) {
      if (r === 2 && (c = ff(n), c !== 0 && (o = c, r = Ao(n, c))), r === 1) throw l = Oo, Ga(n, 0), ia(n, o), tr(n, tt()), l;
      if (r === 6) ia(n, o);
      else {
        if (c = n.current.alternate, !(o & 30) && !ey(c) && (r = mc(n, o), r === 2 && (d = ff(n), d !== 0 && (o = d, r = Ao(n, d))), r === 1)) throw l = Oo, Ga(n, 0), ia(n, o), tr(n, tt()), l;
        switch (n.finishedWork = c, n.finishedLanes = o, r) {
          case 0:
          case 1:
            throw Error(N(345));
          case 2:
            Dl(n, er, yr);
            break;
          case 3:
            if (ia(n, o), (o & 130023424) === o && (r = vd + 500 - tt(), 10 < r)) {
              if (qi(n, 0) !== 0) break;
              if (c = n.suspendedLanes, (c & o) !== o) {
                Vt(), n.pingedLanes |= n.suspendedLanes & c;
                break;
              }
              n.timeoutHandle = Ms(Dl.bind(null, n, er, yr), r);
              break;
            }
            Dl(n, er, yr);
            break;
          case 4:
            if (ia(n, o), (o & 4194240) === o) break;
            for (r = n.eventTimes, c = -1; 0 < o; ) {
              var h = 31 - kr(o);
              d = 1 << h, h = r[h], h > c && (c = h), o &= ~d;
            }
            if (o = c, o = tt() - o, o = (120 > o ? 120 : 480 > o ? 480 : 1080 > o ? 1080 : 1920 > o ? 1920 : 3e3 > o ? 3e3 : 4320 > o ? 4320 : 1960 * Jm(o / 1960)) - o, 10 < o) {
              n.timeoutHandle = Ms(Dl.bind(null, n, er, yr), o);
              break;
            }
            Dl(n, er, yr);
            break;
          case 5:
            Dl(n, er, yr);
            break;
          default:
            throw Error(N(329));
        }
      }
    }
    return tr(n, tt()), n.callbackNode === l ? hc.bind(null, n) : null;
  }
  function Ao(n, r) {
    var l = No;
    return n.current.memoizedState.isDehydrated && (Ga(n, r).flags |= 256), n = mc(n, r), n !== 2 && (r = er, er = l, r !== null && xl(r)), n;
  }
  function xl(n) {
    er === null ? er = n : er.push.apply(er, n);
  }
  function ey(n) {
    for (var r = n; ; ) {
      if (r.flags & 16384) {
        var l = r.updateQueue;
        if (l !== null && (l = l.stores, l !== null)) for (var o = 0; o < l.length; o++) {
          var c = l[o], d = c.getSnapshot;
          c = c.value;
          try {
            if (!Jr(d(), c)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (l = r.child, r.subtreeFlags & 16384 && l !== null) l.return = r, r = l;
      else {
        if (r === n) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n) return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function ia(n, r) {
    for (r &= ~pc, r &= ~pu, n.suspendedLanes |= r, n.pingedLanes &= ~r, n = n.expirationTimes; 0 < r; ) {
      var l = 31 - kr(r), o = 1 << l;
      n[l] = -1, r &= ~o;
    }
  }
  function hd(n) {
    if (Ne & 6) throw Error(N(327));
    yu();
    var r = qi(n, 0);
    if (!(r & 1)) return tr(n, tt()), null;
    var l = mc(n, r);
    if (n.tag !== 0 && l === 2) {
      var o = ff(n);
      o !== 0 && (r = o, l = Ao(n, o));
    }
    if (l === 1) throw l = Oo, Ga(n, 0), ia(n, r), tr(n, tt()), l;
    if (l === 6) throw Error(N(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = r, Dl(n, er, yr), tr(n, tt()), null;
  }
  function md(n, r) {
    var l = Ne;
    Ne |= 1;
    try {
      return n(r);
    } finally {
      Ne = l, Ne === 0 && (vu = tt() + 500, lu && ya());
    }
  }
  function wl(n) {
    Ia !== null && Ia.tag === 0 && !(Ne & 6) && yu();
    var r = Ne;
    Ne |= 1;
    var l = rn.transition, o = Ge;
    try {
      if (rn.transition = null, Ge = 1, n) return n();
    } finally {
      Ge = o, rn.transition = l, Ne = r, !(Ne & 6) && ya();
    }
  }
  function yd() {
    mr = du.current, rt(du);
  }
  function Ga(n, r) {
    n.finishedWork = null, n.finishedLanes = 0;
    var l = n.timeoutHandle;
    if (l !== -1 && (n.timeoutHandle = -1, jf(l)), Ft !== null) for (l = Ft.return; l !== null; ) {
      var o = l;
      switch (As(o), o.tag) {
        case 1:
          o = o.type.childContextTypes, o != null && iu();
          break;
        case 3:
          pl(), rt($t), rt(Ct), oe();
          break;
        case 5:
          js(o);
          break;
        case 4:
          pl();
          break;
        case 13:
          rt(pt);
          break;
        case 19:
          rt(pt);
          break;
        case 10:
          If(o.type._context);
          break;
        case 22:
        case 23:
          yd();
      }
      l = l.return;
    }
    if (Qt = n, Ft = n = bi(n.current, null), an = mr = r, wt = 0, Oo = null, pc = pu = xa = 0, er = No = null, fl !== null) {
      for (r = 0; r < fl.length; r++) if (l = fl[r], o = l.interleaved, o !== null) {
        l.interleaved = null;
        var c = o.next, d = l.pending;
        if (d !== null) {
          var h = d.next;
          d.next = c, o.next = h;
        }
        l.pending = o;
      }
      fl = null;
    }
    return n;
  }
  function Uv(n, r) {
    do {
      var l = Ft;
      try {
        if (Qf(), xe.current = Sl, Ps) {
          for (var o = je.memoizedState; o !== null; ) {
            var c = o.queue;
            c !== null && (c.pending = null), o = o.next;
          }
          Ps = !1;
        }
        if (Ke = 0, Xt = Ut = je = null, po = !1, vl = 0, Tl.current = null, l === null || l.return === null) {
          wt = 1, Oo = r, Ft = null;
          break;
        }
        e: {
          var d = n, h = l.return, g = l, C = r;
          if (r = an, g.flags |= 32768, C !== null && typeof C == "object" && typeof C.then == "function") {
            var _ = C, H = g, F = H.tag;
            if (!(H.mode & 1) && (F === 0 || F === 11 || F === 15)) {
              var A = H.alternate;
              A ? (H.updateQueue = A.updateQueue, H.memoizedState = A.memoizedState, H.lanes = A.lanes) : (H.updateQueue = null, H.memoizedState = null);
            }
            var W = Tv(h);
            if (W !== null) {
              W.flags &= -257, xi(W, h, g, d, r), W.mode & 1 && id(d, _, r), r = W, C = _;
              var J = r.updateQueue;
              if (J === null) {
                var te = /* @__PURE__ */ new Set();
                te.add(C), r.updateQueue = te;
              } else J.add(C);
              break e;
            } else {
              if (!(r & 1)) {
                id(d, _, r), gd();
                break e;
              }
              C = Error(N(426));
            }
          } else if (st && g.mode & 1) {
            var Dt = Tv(h);
            if (Dt !== null) {
              !(Dt.flags & 65536) && (Dt.flags |= 256), xi(Dt, h, g, d, r), Pa(Cl(C, g));
              break e;
            }
          }
          d = C = Cl(C, g), wt !== 4 && (wt = 2), No === null ? No = [d] : No.push(d), d = h;
          do {
            switch (d.tag) {
              case 3:
                d.flags |= 65536, r &= -r, d.lanes |= r;
                var x = Ev(d, C, r);
                mv(d, x);
                break e;
              case 1:
                g = C;
                var T = d.type, k = d.stateNode;
                if (!(d.flags & 128) && (typeof T.getDerivedStateFromError == "function" || k !== null && typeof k.componentDidCatch == "function" && (Di === null || !Di.has(k)))) {
                  d.flags |= 65536, r &= -r, d.lanes |= r;
                  var j = ad(d, g, r);
                  mv(d, j);
                  break e;
                }
            }
            d = d.return;
          } while (d !== null);
        }
        Vv(l);
      } catch (I) {
        r = I, Ft === l && l !== null && (Ft = l = l.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Av() {
    var n = wi.current;
    return wi.current = Sl, n === null ? Sl : n;
  }
  function gd() {
    (wt === 0 || wt === 3 || wt === 2) && (wt = 4), Qt === null || !(xa & 268435455) && !(pu & 268435455) || ia(Qt, an);
  }
  function mc(n, r) {
    var l = Ne;
    Ne |= 2;
    var o = Av();
    (Qt !== n || an !== r) && (yr = null, Ga(n, r));
    do
      try {
        ty();
        break;
      } catch (c) {
        Uv(n, c);
      }
    while (!0);
    if (Qf(), Ne = l, wi.current = o, Ft !== null) throw Error(N(261));
    return Qt = null, an = 0, wt;
  }
  function ty() {
    for (; Ft !== null; ) Fv(Ft);
  }
  function Hv() {
    for (; Ft !== null && !Lp(); ) Fv(Ft);
  }
  function Fv(n) {
    var r = $v(n.alternate, n, mr);
    n.memoizedProps = n.pendingProps, r === null ? Vv(n) : Ft = r, Tl.current = null;
  }
  function Vv(n) {
    var r = n;
    do {
      var l = r.alternate;
      if (n = r.return, r.flags & 32768) {
        if (l = cc(l, r), l !== null) {
          l.flags &= 32767, Ft = l;
          return;
        }
        if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          wt = 6, Ft = null;
          return;
        }
      } else if (l = _v(l, r, mr), l !== null) {
        Ft = l;
        return;
      }
      if (r = r.sibling, r !== null) {
        Ft = r;
        return;
      }
      Ft = r = n;
    } while (r !== null);
    wt === 0 && (wt = 5);
  }
  function Dl(n, r, l) {
    var o = Ge, c = rn.transition;
    try {
      rn.transition = null, Ge = 1, ny(n, r, l, o);
    } finally {
      rn.transition = c, Ge = o;
    }
    return null;
  }
  function ny(n, r, l, o) {
    do
      yu();
    while (Ia !== null);
    if (Ne & 6) throw Error(N(327));
    l = n.finishedWork;
    var c = n.finishedLanes;
    if (l === null) return null;
    if (n.finishedWork = null, n.finishedLanes = 0, l === n.current) throw Error(N(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var d = l.lanes | l.childLanes;
    if (Mm(n, d), n === Qt && (Ft = Qt = null, an = 0), !(l.subtreeFlags & 2064) && !(l.flags & 2064) || vc || (vc = !0, Yv(ju, function() {
      return yu(), null;
    })), d = (l.flags & 15990) !== 0, l.subtreeFlags & 15990 || d) {
      d = rn.transition, rn.transition = null;
      var h = Ge;
      Ge = 1;
      var g = Ne;
      Ne |= 4, Tl.current = null, Mv(n, l), fd(l, n), Zl(ll), Ji = !!no, ll = no = null, n.current = l, Zm(l), km(), Ne = g, Ge = h, rn.transition = d;
    } else n.current = l;
    if (vc && (vc = !1, Ia = n, zo = c), d = n.pendingLanes, d === 0 && (Di = null), Op(l.stateNode), tr(n, tt()), r !== null) for (o = n.onRecoverableError, l = 0; l < r.length; l++) c = r[l], o(c.value, { componentStack: c.stack, digest: c.digest });
    if (hu) throw hu = !1, n = Rl, Rl = null, n;
    return zo & 1 && n.tag !== 0 && yu(), d = n.pendingLanes, d & 1 ? n === mu ? ki++ : (ki = 0, mu = n) : ki = 0, ya(), null;
  }
  function yu() {
    if (Ia !== null) {
      var n = pf(zo), r = rn.transition, l = Ge;
      try {
        if (rn.transition = null, Ge = 16 > n ? 16 : n, Ia === null) var o = !1;
        else {
          if (n = Ia, Ia = null, zo = 0, Ne & 6) throw Error(N(331));
          var c = Ne;
          for (Ne |= 4, K = n.current; K !== null; ) {
            var d = K, h = d.child;
            if (K.flags & 16) {
              var g = d.deletions;
              if (g !== null) {
                for (var C = 0; C < g.length; C++) {
                  var _ = g[C];
                  for (K = _; K !== null; ) {
                    var H = K;
                    switch (H.tag) {
                      case 0:
                      case 11:
                      case 15:
                        bo(8, H, d);
                    }
                    var F = H.child;
                    if (F !== null) F.return = H, K = F;
                    else for (; K !== null; ) {
                      H = K;
                      var A = H.sibling, W = H.return;
                      if (dc(H), H === _) {
                        K = null;
                        break;
                      }
                      if (A !== null) {
                        A.return = W, K = A;
                        break;
                      }
                      K = W;
                    }
                  }
                }
                var J = d.alternate;
                if (J !== null) {
                  var te = J.child;
                  if (te !== null) {
                    J.child = null;
                    do {
                      var Dt = te.sibling;
                      te.sibling = null, te = Dt;
                    } while (te !== null);
                  }
                }
                K = d;
              }
            }
            if (d.subtreeFlags & 2064 && h !== null) h.return = d, K = h;
            else e: for (; K !== null; ) {
              if (d = K, d.flags & 2048) switch (d.tag) {
                case 0:
                case 11:
                case 15:
                  bo(9, d, d.return);
              }
              var x = d.sibling;
              if (x !== null) {
                x.return = d.return, K = x;
                break e;
              }
              K = d.return;
            }
          }
          var T = n.current;
          for (K = T; K !== null; ) {
            h = K;
            var k = h.child;
            if (h.subtreeFlags & 2064 && k !== null) k.return = h, K = k;
            else e: for (h = T; K !== null; ) {
              if (g = K, g.flags & 2048) try {
                switch (g.tag) {
                  case 0:
                  case 11:
                  case 15:
                    _o(9, g);
                }
              } catch (I) {
                ct(g, g.return, I);
              }
              if (g === h) {
                K = null;
                break e;
              }
              var j = g.sibling;
              if (j !== null) {
                j.return = g.return, K = j;
                break e;
              }
              K = g.return;
            }
          }
          if (Ne = c, ya(), Kr && typeof Kr.onPostCommitFiberRoot == "function") try {
            Kr.onPostCommitFiberRoot(Bu, n);
          } catch {
          }
          o = !0;
        }
        return o;
      } finally {
        Ge = l, rn.transition = r;
      }
    }
    return !1;
  }
  function jv(n, r, l) {
    r = Cl(l, r), r = Ev(n, r, 1), n = Ei(n, r, 1), r = Vt(), n !== null && (Ki(n, 1, r), tr(n, r));
  }
  function ct(n, r, l) {
    if (n.tag === 3) jv(n, n, l);
    else for (; r !== null; ) {
      if (r.tag === 3) {
        jv(r, n, l);
        break;
      } else if (r.tag === 1) {
        var o = r.stateNode;
        if (typeof r.type.getDerivedStateFromError == "function" || typeof o.componentDidCatch == "function" && (Di === null || !Di.has(o))) {
          n = Cl(l, n), n = ad(r, n, 1), r = Ei(r, n, 1), n = Vt(), r !== null && (Ki(r, 1, n), tr(r, n));
          break;
        }
      }
      r = r.return;
    }
  }
  function ry(n, r, l) {
    var o = n.pingCache;
    o !== null && o.delete(r), r = Vt(), n.pingedLanes |= n.suspendedLanes & l, Qt === n && (an & l) === l && (wt === 4 || wt === 3 && (an & 130023424) === an && 500 > tt() - vd ? Ga(n, 0) : pc |= l), tr(n, r);
  }
  function Bv(n, r) {
    r === 0 && (n.mode & 1 ? (r = Zr, Zr <<= 1, !(Zr & 130023424) && (Zr = 4194304)) : r = 1);
    var l = Vt();
    n = pr(n, r), n !== null && (Ki(n, r, l), tr(n, l));
  }
  function ay(n) {
    var r = n.memoizedState, l = 0;
    r !== null && (l = r.retryLane), Bv(n, l);
  }
  function Pv(n, r) {
    var l = 0;
    switch (n.tag) {
      case 13:
        var o = n.stateNode, c = n.memoizedState;
        c !== null && (l = c.retryLane);
        break;
      case 19:
        o = n.stateNode;
        break;
      default:
        throw Error(N(314));
    }
    o !== null && o.delete(r), Bv(n, l);
  }
  var $v;
  $v = function(n, r, l) {
    if (n !== null) if (n.memoizedProps !== r.pendingProps || $t.current) At = !0;
    else {
      if (!(n.lanes & l) && !(r.flags & 128)) return At = !1, wo(n, r, l);
      At = !!(n.flags & 131072);
    }
    else At = !1, st && r.flags & 1048576 && dv(r, Ba, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var o = r.type;
        Ar(n, r), n = r.pendingProps;
        var c = Or(r, Ct.current);
        dt(r, l), c = Ti(null, r, o, n, c, l);
        var d = na();
        return r.flags |= 1, typeof c == "object" && c !== null && typeof c.render == "function" && c.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, Nt(o) ? (d = !0, Wn(r)) : d = !1, r.memoizedState = c.state !== null && c.state !== void 0 ? c.state : null, qf(r), c.updater = ic, r.stateNode = c, c._reactInternals = r, Co(r, o, n, l), r = Ro(null, r, o, !0, d, l)) : (r.tag = 0, st && d && Us(r), nn(null, r, c, l), r = r.child), r;
      case 16:
        o = r.elementType;
        e: {
          switch (Ar(n, r), n = r.pendingProps, c = o._init, o = c(o._payload), r.type = o, c = r.tag = ly(o), n = ra(o, n), c) {
            case 0:
              r = Rv(null, r, o, n, l);
              break e;
            case 1:
              r = xv(null, r, o, n, l);
              break e;
            case 11:
              r = Zn(null, r, o, n, l);
              break e;
            case 14:
              r = El(null, r, o, ra(o.type, n), l);
              break e;
          }
          throw Error(N(
            306,
            o,
            ""
          ));
        }
        return r;
      case 0:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ra(o, c), Rv(n, r, o, c, l);
      case 1:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ra(o, c), xv(n, r, o, c, l);
      case 3:
        e: {
          if (cu(r), n === null) throw Error(N(387));
          o = r.pendingProps, d = r.memoizedState, c = d.element, hv(n, r), uo(r, o, null, l);
          var h = r.memoizedState;
          if (o = h.element, d.isDehydrated) if (d = { element: o, isDehydrated: !1, cache: h.cache, pendingSuspenseBoundaries: h.pendingSuspenseBoundaries, transitions: h.transitions }, r.updateQueue.baseState = d, r.memoizedState = d, r.flags & 256) {
            c = Cl(Error(N(423)), r), r = wv(n, r, o, l, c);
            break e;
          } else if (o !== c) {
            c = Cl(Error(N(424)), r), r = wv(n, r, o, l, c);
            break e;
          } else for (qn = va(r.stateNode.containerInfo.firstChild), Xn = r, st = !0, zr = null, l = Y(r, null, o, l), r.child = l; l; ) l.flags = l.flags & -3 | 4096, l = l.sibling;
          else {
            if (Ci(), o === c) {
              r = Hr(n, r, l);
              break e;
            }
            nn(n, r, o, l);
          }
          r = r.child;
        }
        return r;
      case 5:
        return yv(r), n === null && $f(r), o = r.type, c = r.pendingProps, d = n !== null ? n.memoizedProps : null, h = c.children, Ls(o, c) ? h = null : d !== null && Ls(o, d) && (r.flags |= 32), ld(n, r), nn(n, r, h, l), r.child;
      case 6:
        return n === null && $f(r), null;
      case 13:
        return sc(n, r, l);
      case 4:
        return Zf(r, r.stateNode.containerInfo), o = r.pendingProps, n === null ? r.child = Tt(r, null, o, l) : nn(n, r, o, l), r.child;
      case 11:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ra(o, c), Zn(n, r, o, c, l);
      case 7:
        return nn(n, r, r.pendingProps, l), r.child;
      case 8:
        return nn(n, r, r.pendingProps.children, l), r.child;
      case 12:
        return nn(n, r, r.pendingProps.children, l), r.child;
      case 10:
        e: {
          if (o = r.type._context, c = r.pendingProps, d = r.memoizedProps, h = c.value, ie(dr, o._currentValue), o._currentValue = h, d !== null) if (Jr(d.value, h)) {
            if (d.children === c.children && !$t.current) {
              r = Hr(n, r, l);
              break e;
            }
          } else for (d = r.child, d !== null && (d.return = r); d !== null; ) {
            var g = d.dependencies;
            if (g !== null) {
              h = d.child;
              for (var C = g.firstContext; C !== null; ) {
                if (C.context === o) {
                  if (d.tag === 1) {
                    C = $a(-1, l & -l), C.tag = 2;
                    var _ = d.updateQueue;
                    if (_ !== null) {
                      _ = _.shared;
                      var H = _.pending;
                      H === null ? C.next = C : (C.next = H.next, H.next = C), _.pending = C;
                    }
                  }
                  d.lanes |= l, C = d.alternate, C !== null && (C.lanes |= l), Gf(
                    d.return,
                    l,
                    r
                  ), g.lanes |= l;
                  break;
                }
                C = C.next;
              }
            } else if (d.tag === 10) h = d.type === r.type ? null : d.child;
            else if (d.tag === 18) {
              if (h = d.return, h === null) throw Error(N(341));
              h.lanes |= l, g = h.alternate, g !== null && (g.lanes |= l), Gf(h, l, r), h = d.sibling;
            } else h = d.child;
            if (h !== null) h.return = d;
            else for (h = d; h !== null; ) {
              if (h === r) {
                h = null;
                break;
              }
              if (d = h.sibling, d !== null) {
                d.return = h.return, h = d;
                break;
              }
              h = h.return;
            }
            d = h;
          }
          nn(n, r, c.children, l), r = r.child;
        }
        return r;
      case 9:
        return c = r.type, o = r.pendingProps.children, dt(r, l), c = Ur(c), o = o(c), r.flags |= 1, nn(n, r, o, l), r.child;
      case 14:
        return o = r.type, c = ra(o, r.pendingProps), c = ra(o.type, c), El(n, r, o, c, l);
      case 15:
        return Re(n, r, r.type, r.pendingProps, l);
      case 17:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ra(o, c), Ar(n, r), r.tag = 1, Nt(o) ? (n = !0, Wn(r)) : n = !1, dt(r, l), lc(r, o, c), Co(r, o, c, l), Ro(null, r, o, !0, n, l);
      case 19:
        return Ea(n, r, l);
      case 22:
        return To(n, r, l);
    }
    throw Error(N(156, r.tag));
  };
  function Yv(n, r) {
    return bp(n, r);
  }
  function iy(n, r, l, o) {
    this.tag = n, this.key = l, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = o, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Vr(n, r, l, o) {
    return new iy(n, r, l, o);
  }
  function Sd(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function ly(n) {
    if (typeof n == "function") return Sd(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === lt) return 11;
      if (n === Tn) return 14;
    }
    return 2;
  }
  function bi(n, r) {
    var l = n.alternate;
    return l === null ? (l = Vr(n.tag, r, n.key, n.mode), l.elementType = n.elementType, l.type = n.type, l.stateNode = n.stateNode, l.alternate = n, n.alternate = l) : (l.pendingProps = r, l.type = n.type, l.flags = 0, l.subtreeFlags = 0, l.deletions = null), l.flags = n.flags & 14680064, l.childLanes = n.childLanes, l.lanes = n.lanes, l.child = n.child, l.memoizedProps = n.memoizedProps, l.memoizedState = n.memoizedState, l.updateQueue = n.updateQueue, r = n.dependencies, l.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, l.sibling = n.sibling, l.index = n.index, l.ref = n.ref, l;
  }
  function Ho(n, r, l, o, c, d) {
    var h = 2;
    if (o = n, typeof n == "function") Sd(n) && (h = 1);
    else if (typeof n == "string") h = 5;
    else e: switch (n) {
      case De:
        return Wa(l.children, c, d, r);
      case En:
        h = 8, c |= 8;
        break;
      case mt:
        return n = Vr(12, l, r, c | 2), n.elementType = mt, n.lanes = d, n;
      case we:
        return n = Vr(13, l, r, c), n.elementType = we, n.lanes = d, n;
      case vn:
        return n = Vr(19, l, r, c), n.elementType = vn, n.lanes = d, n;
      case Na:
        return _i(l, c, d, r);
      default:
        if (typeof n == "object" && n !== null) switch (n.$$typeof) {
          case Wt:
            h = 10;
            break e;
          case Bt:
            h = 9;
            break e;
          case lt:
            h = 11;
            break e;
          case Tn:
            h = 14;
            break e;
          case _t:
            h = 16, o = null;
            break e;
        }
        throw Error(N(130, n == null ? n : typeof n, ""));
    }
    return r = Vr(h, l, r, c), r.elementType = n, r.type = o, r.lanes = d, r;
  }
  function Wa(n, r, l, o) {
    return n = Vr(7, n, o, r), n.lanes = l, n;
  }
  function _i(n, r, l, o) {
    return n = Vr(22, n, o, r), n.elementType = Na, n.lanes = l, n.stateNode = { isHidden: !1 }, n;
  }
  function Cd(n, r, l) {
    return n = Vr(6, n, null, r), n.lanes = l, n;
  }
  function yc(n, r, l) {
    return r = Vr(4, n.children !== null ? n.children : [], n.key, r), r.lanes = l, r.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, r;
  }
  function Qv(n, r, l, o, c) {
    this.tag = r, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = df(0), this.expirationTimes = df(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = df(0), this.identifierPrefix = o, this.onRecoverableError = c, this.mutableSourceEagerHydrationData = null;
  }
  function gc(n, r, l, o, c, d, h, g, C) {
    return n = new Qv(n, r, l, g, C), r === 1 ? (r = 1, d === !0 && (r |= 8)) : r = 0, d = Vr(3, null, null, r), n.current = d, d.stateNode = n, d.memoizedState = { element: o, isDehydrated: l, cache: null, transitions: null, pendingSuspenseBoundaries: null }, qf(d), n;
  }
  function uy(n, r, l) {
    var o = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ft, key: o == null ? null : "" + o, children: n, containerInfo: r, implementation: l };
  }
  function Ed(n) {
    if (!n) return In;
    n = n._reactInternals;
    e: {
      if (qr(n) !== n || n.tag !== 1) throw Error(N(170));
      var r = n;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (Nt(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(N(171));
    }
    if (n.tag === 1) {
      var l = n.type;
      if (Nt(l)) return io(n, l, r);
    }
    return r;
  }
  function Iv(n, r, l, o, c, d, h, g, C) {
    return n = gc(l, o, !0, n, c, d, h, g, C), n.context = Ed(null), l = n.current, o = Vt(), c = wa(l), d = $a(o, c), d.callback = r ?? null, Ei(l, d, c), n.current.lanes = c, Ki(n, c, o), tr(n, o), n;
  }
  function Sc(n, r, l, o) {
    var c = r.current, d = Vt(), h = wa(c);
    return l = Ed(l), r.context === null ? r.context = l : r.pendingContext = l, r = $a(d, h), r.payload = { element: n }, o = o === void 0 ? null : o, o !== null && (r.callback = o), n = Ei(c, r, h), n !== null && (bn(n, c, h, d), Vs(n, c, h)), h;
  }
  function Cc(n) {
    if (n = n.current, !n.child) return null;
    switch (n.child.tag) {
      case 5:
        return n.child.stateNode;
      default:
        return n.child.stateNode;
    }
  }
  function Td(n, r) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var l = n.retryLane;
      n.retryLane = l !== 0 && l < r ? l : r;
    }
  }
  function Ec(n, r) {
    Td(n, r), (n = n.alternate) && Td(n, r);
  }
  var Rd = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function Li(n) {
    this._internalRoot = n;
  }
  Tc.prototype.render = Li.prototype.render = function(n) {
    var r = this._internalRoot;
    if (r === null) throw Error(N(409));
    Sc(n, r, null, null);
  }, Tc.prototype.unmount = Li.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var r = n.containerInfo;
      wl(function() {
        Sc(null, n, null, null);
      }), r[Va] = null;
    }
  };
  function Tc(n) {
    this._internalRoot = n;
  }
  Tc.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var r = Te();
      n = { blockedOn: null, target: n, priority: r };
      for (var l = 0; l < Jt.length && r !== 0 && r < Jt[l].priority; l++) ;
      Jt.splice(l, 0, n), l === 0 && gf(n);
    }
  };
  function xd(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function Rc(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function Gv() {
  }
  function oy(n, r, l, o, c) {
    if (c) {
      if (typeof o == "function") {
        var d = o;
        o = function() {
          var _ = Cc(h);
          d.call(_);
        };
      }
      var h = Iv(r, o, n, 0, null, !1, !1, "", Gv);
      return n._reactRootContainer = h, n[Va] = h.current, eu(n.nodeType === 8 ? n.parentNode : n), wl(), h;
    }
    for (; c = n.lastChild; ) n.removeChild(c);
    if (typeof o == "function") {
      var g = o;
      o = function() {
        var _ = Cc(C);
        g.call(_);
      };
    }
    var C = gc(n, 0, !1, null, null, !1, !1, "", Gv);
    return n._reactRootContainer = C, n[Va] = C.current, eu(n.nodeType === 8 ? n.parentNode : n), wl(function() {
      Sc(r, C, l, o);
    }), C;
  }
  function xc(n, r, l, o, c) {
    var d = l._reactRootContainer;
    if (d) {
      var h = d;
      if (typeof c == "function") {
        var g = c;
        c = function() {
          var C = Cc(h);
          g.call(C);
        };
      }
      Sc(r, h, n, c);
    } else h = oy(l, r, n, c, o);
    return Cc(h);
  }
  We = function(n) {
    switch (n.tag) {
      case 3:
        var r = n.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var l = Xi(r.pendingLanes);
          l !== 0 && (os(r, l | 1), tr(r, tt()), !(Ne & 6) && (vu = tt() + 500, ya()));
        }
        break;
      case 13:
        wl(function() {
          var o = pr(n, 1);
          if (o !== null) {
            var c = Vt();
            bn(o, n, 1, c);
          }
        }), Ec(n, 1);
    }
  }, vf = function(n) {
    if (n.tag === 13) {
      var r = pr(n, 134217728);
      if (r !== null) {
        var l = Vt();
        bn(r, n, 134217728, l);
      }
      Ec(n, 134217728);
    }
  }, hf = function(n) {
    if (n.tag === 13) {
      var r = wa(n), l = pr(n, r);
      if (l !== null) {
        var o = Vt();
        bn(l, n, r, o);
      }
      Ec(n, r);
    }
  }, Te = function() {
    return Ge;
  }, mf = function(n, r) {
    var l = Ge;
    try {
      return Ge = n, r();
    } finally {
      Ge = l;
    }
  }, Pt = function(n, r, l) {
    switch (r) {
      case "input":
        if (Vl(n, l), r = l.name, l.type === "radio" && r != null) {
          for (l = n; l.parentNode; ) l = l.parentNode;
          for (l = l.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < l.length; r++) {
            var o = l[r];
            if (o !== n && o.form === n.form) {
              var c = Et(o);
              if (!c) throw Error(N(90));
              ca(o), Vl(o, c);
            }
          }
        }
        break;
      case "textarea":
        jl(n, l);
        break;
      case "select":
        r = l.value, r != null && sr(n, !!l.multiple, r, !1);
    }
  }, tf = md, nf = wl;
  var Wv = { usingClientEntryPoint: !1, Events: [ue, ea, Et, xp, wp, md] }, Fo = { findFiberByHostInstance: ul, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, sy = { bundleType: Fo.bundleType, version: Fo.version, rendererPackageName: Fo.rendererPackageName, rendererConfig: Fo.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: it.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = lf(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: Fo.findFiberByHostInstance, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Vo = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Vo.isDisabled && Vo.supportsFiber) try {
      Bu = Vo.inject(sy), Kr = Vo;
    } catch {
    }
  }
  return Qr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Wv, Qr.createPortal = function(n, r) {
    var l = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!xd(r)) throw Error(N(200));
    return uy(n, r, null, l);
  }, Qr.createRoot = function(n, r) {
    if (!xd(n)) throw Error(N(299));
    var l = !1, o = "", c = Rd;
    return r != null && (r.unstable_strictMode === !0 && (l = !0), r.identifierPrefix !== void 0 && (o = r.identifierPrefix), r.onRecoverableError !== void 0 && (c = r.onRecoverableError)), r = gc(n, 1, !1, null, null, l, !1, o, c), n[Va] = r.current, eu(n.nodeType === 8 ? n.parentNode : n), new Li(r);
  }, Qr.findDOMNode = function(n) {
    if (n == null) return null;
    if (n.nodeType === 1) return n;
    var r = n._reactInternals;
    if (r === void 0)
      throw typeof n.render == "function" ? Error(N(188)) : (n = Object.keys(n).join(","), Error(N(268, n)));
    return n = lf(r), n = n === null ? null : n.stateNode, n;
  }, Qr.flushSync = function(n) {
    return wl(n);
  }, Qr.hydrate = function(n, r, l) {
    if (!Rc(r)) throw Error(N(200));
    return xc(null, n, r, !0, l);
  }, Qr.hydrateRoot = function(n, r, l) {
    if (!xd(n)) throw Error(N(405));
    var o = l != null && l.hydratedSources || null, c = !1, d = "", h = Rd;
    if (l != null && (l.unstable_strictMode === !0 && (c = !0), l.identifierPrefix !== void 0 && (d = l.identifierPrefix), l.onRecoverableError !== void 0 && (h = l.onRecoverableError)), r = Iv(r, null, n, 1, l ?? null, c, !1, d, h), n[Va] = r.current, eu(n), o) for (n = 0; n < o.length; n++) l = o[n], c = l._getVersion, c = c(l._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [l, c] : r.mutableSourceEagerHydrationData.push(
      l,
      c
    );
    return new Tc(r);
  }, Qr.render = function(n, r, l) {
    if (!Rc(r)) throw Error(N(200));
    return xc(null, n, r, !1, l);
  }, Qr.unmountComponentAtNode = function(n) {
    if (!Rc(n)) throw Error(N(40));
    return n._reactRootContainer ? (wl(function() {
      xc(null, null, n, !1, function() {
        n._reactRootContainer = null, n[Va] = null;
      });
    }), !0) : !1;
  }, Qr.unstable_batchedUpdates = md, Qr.unstable_renderSubtreeIntoContainer = function(n, r, l, o) {
    if (!Rc(l)) throw Error(N(200));
    if (n == null || n._reactInternals === void 0) throw Error(N(38));
    return xc(n, r, l, !1, o);
  }, Qr.version = "18.3.1-next-f1338f8080-20240426", Qr;
}
var Ir = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $T;
function Hk() {
  return $T || ($T = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var le = YT, Ae = QT(), N = le.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ur = !1;
    function ht(e) {
      ur = e;
    }
    function bt(e) {
      if (!ur) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        Fn("warn", e, a);
      }
    }
    function S(e) {
      if (!ur) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        Fn("error", e, a);
      }
    }
    function Fn(e, t, a) {
      {
        var i = N.ReactDebugCurrentFrame, u = i.getStackAddendum();
        u !== "" && (t += "%s", a = a.concat([u]));
        var s = a.map(function(f) {
          return String(f);
        });
        s.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var ge = 0, fe = 1, Zt = 2, ne = 3, Se = 4, ae = 5, He = 6, Xe = 7, at = 8, Rr = 9, Cn = 10, _e = 11, it = 12, Me = 13, ft = 14, De = 15, En = 16, mt = 17, Wt = 18, Bt = 19, lt = 21, we = 22, vn = 23, Tn = 24, _t = 25, Na = !0, P = !1, ve = !1, Z = !1, Ie = !1, qe = !0, Gr = !0, Rn = !0, Pi = !0, Vn = /* @__PURE__ */ new Set(), jn = {}, xr = {};
    function sa(e, t) {
      li(e, t), li(e + "Capture", t);
    }
    function li(e, t) {
      jn[e] && S("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), jn[e] = t;
      {
        var a = e.toLowerCase();
        xr[a] = e, e === "onDoubleClick" && (xr.ondblclick = e);
      }
      for (var i = 0; i < t.length; i++)
        Vn.add(t[i]);
    }
    var hn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ca = Object.prototype.hasOwnProperty;
    function Bn(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, a = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function or(e) {
      try {
        return wr(e), !1;
      } catch {
        return !0;
      }
    }
    function wr(e) {
      return "" + e;
    }
    function fa(e, t) {
      if (or(e))
        return S("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Bn(e)), wr(e);
    }
    function Vl(e) {
      if (or(e))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Bn(e)), wr(e);
    }
    function Au(e, t) {
      if (or(e))
        return S("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Bn(e)), wr(e);
    }
    function Hu(e, t) {
      if (or(e))
        return S("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Bn(e)), wr(e);
    }
    function $i(e) {
      if (or(e))
        return S("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Bn(e)), wr(e);
    }
    function sr(e) {
      if (or(e))
        return S("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Bn(e)), wr(e);
    }
    var Dr = 0, Wr = 1, jl = 2, cr = 3, da = 4, Yi = 5, Qi = 6, Fu = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", $ = Fu + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", de = new RegExp("^[" + Fu + "][" + $ + "]*$"), ke = {}, et = {};
    function yt(e) {
      return ca.call(et, e) ? !0 : ca.call(ke, e) ? !1 : de.test(e) ? (et[e] = !0, !0) : (ke[e] = !0, S("Invalid attribute name: `%s`", e), !1);
    }
    function Pn(e, t, a) {
      return t !== null ? t.type === Dr : a ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function Lt(e, t, a, i) {
      if (a !== null && a.type === Dr)
        return !1;
      switch (typeof t) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (i)
            return !1;
          if (a !== null)
            return !a.acceptsBooleans;
          var u = e.toLowerCase().slice(0, 5);
          return u !== "data-" && u !== "aria-";
        }
        default:
          return !1;
      }
    }
    function $n(e, t, a, i) {
      if (t === null || typeof t > "u" || Lt(e, t, a, i))
        return !0;
      if (i)
        return !1;
      if (a !== null)
        switch (a.type) {
          case cr:
            return !t;
          case da:
            return t === !1;
          case Yi:
            return isNaN(t);
          case Qi:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function Mt(e) {
      return Pt.hasOwnProperty(e) ? Pt[e] : null;
    }
    function gt(e, t, a, i, u, s, f) {
      this.acceptsBooleans = t === jl || t === cr || t === da, this.attributeName = i, this.attributeNamespace = u, this.mustUseProperty = a, this.propertyName = e, this.type = t, this.sanitizeURL = s, this.removeEmptyString = f;
    }
    var Pt = {}, Bl = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Bl.forEach(function(e) {
      Pt[e] = new gt(
        e,
        Dr,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], a = e[1];
      Pt[t] = new gt(
        t,
        Wr,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      Pt[e] = new gt(
        e,
        jl,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      Pt[e] = new gt(
        e,
        jl,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      Pt[e] = new gt(
        e,
        cr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Pt[e] = new gt(
        e,
        cr,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Pt[e] = new gt(
        e,
        da,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Pt[e] = new gt(
        e,
        Qi,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      Pt[e] = new gt(
        e,
        Yi,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var ui = /[\-\:]([a-z])/g, as = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(ui, as);
      Pt[t] = new gt(
        t,
        Wr,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(ui, as);
      Pt[t] = new gt(
        t,
        Wr,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(ui, as);
      Pt[t] = new gt(
        t,
        Wr,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      Pt[e] = new gt(
        e,
        Wr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var xp = "xlinkHref";
    Pt[xp] = new gt(
      "xlinkHref",
      Wr,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      Pt[e] = new gt(
        e,
        Wr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var wp = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, tf = !1;
    function nf(e) {
      !tf && wp.test(e) && (tf = !0, S("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function rf(e, t, a, i) {
      if (i.mustUseProperty) {
        var u = i.propertyName;
        return e[u];
      } else {
        fa(a, t), i.sanitizeURL && nf("" + a);
        var s = i.attributeName, f = null;
        if (i.type === da) {
          if (e.hasAttribute(s)) {
            var p = e.getAttribute(s);
            return p === "" ? !0 : $n(t, a, i, !1) ? p : p === "" + a ? a : p;
          }
        } else if (e.hasAttribute(s)) {
          if ($n(t, a, i, !1))
            return e.getAttribute(s);
          if (i.type === cr)
            return a;
          f = e.getAttribute(s);
        }
        return $n(t, a, i, !1) ? f === null ? a : f : f === "" + a ? a : f;
      }
    }
    function af(e, t, a, i) {
      {
        if (!yt(t))
          return;
        if (!e.hasAttribute(t))
          return a === void 0 ? void 0 : null;
        var u = e.getAttribute(t);
        return fa(a, t), u === "" + a ? a : u;
      }
    }
    function Ii(e, t, a, i) {
      var u = Mt(t);
      if (!Pn(t, u, i)) {
        if ($n(t, a, u, i) && (a = null), i || u === null) {
          if (yt(t)) {
            var s = t;
            a === null ? e.removeAttribute(s) : (fa(a, t), e.setAttribute(s, "" + a));
          }
          return;
        }
        var f = u.mustUseProperty;
        if (f) {
          var p = u.propertyName;
          if (a === null) {
            var v = u.type;
            e[p] = v === cr ? !1 : "";
          } else
            e[p] = a;
          return;
        }
        var m = u.attributeName, y = u.attributeNamespace;
        if (a === null)
          e.removeAttribute(m);
        else {
          var R = u.type, E;
          R === cr || R === da && a === !0 ? E = "" : (fa(a, m), E = "" + a, u.sanitizeURL && nf(E.toString())), y ? e.setAttributeNS(y, m, E) : e.setAttribute(m, E);
        }
      }
    }
    var oi = Symbol.for("react.element"), Xr = Symbol.for("react.portal"), Pl = Symbol.for("react.fragment"), Gi = Symbol.for("react.strict_mode"), $l = Symbol.for("react.profiler"), Yl = Symbol.for("react.provider"), Vu = Symbol.for("react.context"), Ql = Symbol.for("react.forward_ref"), is = Symbol.for("react.suspense"), ls = Symbol.for("react.suspense_list"), qr = Symbol.for("react.memo"), mn = Symbol.for("react.lazy"), Dp = Symbol.for("react.scope"), Dm = Symbol.for("react.debug_trace_mode"), lf = Symbol.for("react.offscreen"), kp = Symbol.for("react.legacy_hidden"), bp = Symbol.for("react.cache"), _p = Symbol.for("react.tracing_marker"), Lp = Symbol.iterator, km = "@@iterator";
    function tt(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Lp && e[Lp] || e[km];
      return typeof t == "function" ? t : null;
    }
    var Le = Object.assign, Wi = 0, uf, ju, Mp, of, Bu, Kr, Op;
    function kr() {
    }
    kr.__reactDisabledLog = !0;
    function bm() {
      {
        if (Wi === 0) {
          uf = console.log, ju = console.info, Mp = console.warn, of = console.error, Bu = console.group, Kr = console.groupCollapsed, Op = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: kr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        Wi++;
      }
    }
    function _m() {
      {
        if (Wi--, Wi === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Le({}, e, {
              value: uf
            }),
            info: Le({}, e, {
              value: ju
            }),
            warn: Le({}, e, {
              value: Mp
            }),
            error: Le({}, e, {
              value: of
            }),
            group: Le({}, e, {
              value: Bu
            }),
            groupCollapsed: Le({}, e, {
              value: Kr
            }),
            groupEnd: Le({}, e, {
              value: Op
            })
          });
        }
        Wi < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var sf = N.ReactCurrentDispatcher, Il;
    function Zr(e, t, a) {
      {
        if (Il === void 0)
          try {
            throw Error();
          } catch (u) {
            var i = u.stack.trim().match(/\n( *(at )?)/);
            Il = i && i[1] || "";
          }
        return `
` + Il + e;
      }
    }
    var Xi = !1, qi;
    {
      var Lm = typeof WeakMap == "function" ? WeakMap : Map;
      qi = new Lm();
    }
    function cf(e, t) {
      if (!e || Xi)
        return "";
      {
        var a = qi.get(e);
        if (a !== void 0)
          return a;
      }
      var i;
      Xi = !0;
      var u = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = sf.current, sf.current = null, bm();
      try {
        if (t) {
          var f = function() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (L) {
              i = L;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (L) {
              i = L;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (L) {
            i = L;
          }
          e();
        }
      } catch (L) {
        if (L && i && typeof L.stack == "string") {
          for (var p = L.stack.split(`
`), v = i.stack.split(`
`), m = p.length - 1, y = v.length - 1; m >= 1 && y >= 0 && p[m] !== v[y]; )
            y--;
          for (; m >= 1 && y >= 0; m--, y--)
            if (p[m] !== v[y]) {
              if (m !== 1 || y !== 1)
                do
                  if (m--, y--, y < 0 || p[m] !== v[y]) {
                    var R = `
` + p[m].replace(" at new ", " at ");
                    return e.displayName && R.includes("<anonymous>") && (R = R.replace("<anonymous>", e.displayName)), typeof e == "function" && qi.set(e, R), R;
                  }
                while (m >= 1 && y >= 0);
              break;
            }
        }
      } finally {
        Xi = !1, sf.current = s, _m(), Error.prepareStackTrace = u;
      }
      var E = e ? e.displayName || e.name : "", b = E ? Zr(E) : "";
      return typeof e == "function" && qi.set(e, b), b;
    }
    function ff(e, t, a) {
      return cf(e, !0);
    }
    function us(e, t, a) {
      return cf(e, !1);
    }
    function df(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function Ki(e, t, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return cf(e, df(e));
      if (typeof e == "string")
        return Zr(e);
      switch (e) {
        case is:
          return Zr("Suspense");
        case ls:
          return Zr("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Ql:
            return us(e.render);
          case qr:
            return Ki(e.type, t, a);
          case mn: {
            var i = e, u = i._payload, s = i._init;
            try {
              return Ki(s(u), t, a);
            } catch {
            }
          }
        }
      return "";
    }
    function Mm(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case ae:
          return Zr(e.type);
        case En:
          return Zr("Lazy");
        case Me:
          return Zr("Suspense");
        case Bt:
          return Zr("SuspenseList");
        case ge:
        case Zt:
        case De:
          return us(e.type);
        case _e:
          return us(e.type.render);
        case fe:
          return ff(e.type);
        default:
          return "";
      }
    }
    function os(e) {
      try {
        var t = "", a = e;
        do
          t += Mm(a), a = a.return;
        while (a);
        return t;
      } catch (i) {
        return `
Error generating stack: ` + i.message + `
` + i.stack;
      }
    }
    function Ge(e, t, a) {
      var i = e.displayName;
      if (i)
        return i;
      var u = t.displayName || t.name || "";
      return u !== "" ? a + "(" + u + ")" : a;
    }
    function pf(e) {
      return e.displayName || "Context";
    }
    function We(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case Pl:
          return "Fragment";
        case Xr:
          return "Portal";
        case $l:
          return "Profiler";
        case Gi:
          return "StrictMode";
        case is:
          return "Suspense";
        case ls:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Vu:
            var t = e;
            return pf(t) + ".Consumer";
          case Yl:
            var a = e;
            return pf(a._context) + ".Provider";
          case Ql:
            return Ge(e, e.render, "ForwardRef");
          case qr:
            var i = e.displayName || null;
            return i !== null ? i : We(e.type) || "Memo";
          case mn: {
            var u = e, s = u._payload, f = u._init;
            try {
              return We(f(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function vf(e, t, a) {
      var i = t.displayName || t.name || "";
      return e.displayName || (i !== "" ? a + "(" + i + ")" : a);
    }
    function hf(e) {
      return e.displayName || "Context";
    }
    function Te(e) {
      var t = e.tag, a = e.type;
      switch (t) {
        case Tn:
          return "Cache";
        case Rr:
          var i = a;
          return hf(i) + ".Consumer";
        case Cn:
          var u = a;
          return hf(u._context) + ".Provider";
        case Wt:
          return "DehydratedFragment";
        case _e:
          return vf(a, a.render, "ForwardRef");
        case Xe:
          return "Fragment";
        case ae:
          return a;
        case Se:
          return "Portal";
        case ne:
          return "Root";
        case He:
          return "Text";
        case En:
          return We(a);
        case at:
          return a === Gi ? "StrictMode" : "Mode";
        case we:
          return "Offscreen";
        case it:
          return "Profiler";
        case lt:
          return "Scope";
        case Me:
          return "Suspense";
        case Bt:
          return "SuspenseList";
        case _t:
          return "TracingMarker";
        case fe:
        case ge:
        case mt:
        case Zt:
        case ft:
        case De:
          if (typeof a == "function")
            return a.displayName || a.name || null;
          if (typeof a == "string")
            return a;
          break;
      }
      return null;
    }
    var mf = N.ReactDebugCurrentFrame, xn = null, si = !1;
    function br() {
      {
        if (xn === null)
          return null;
        var e = xn._debugOwner;
        if (e !== null && typeof e < "u")
          return Te(e);
      }
      return null;
    }
    function ci() {
      return xn === null ? "" : os(xn);
    }
    function St() {
      mf.getCurrentStack = null, xn = null, si = !1;
    }
    function ut(e) {
      mf.getCurrentStack = e === null ? null : ci, xn = e, si = !1;
    }
    function Pu() {
      return xn;
    }
    function Jt(e) {
      si = e;
    }
    function _r(e) {
      return "" + e;
    }
    function za(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return sr(e), e;
        default:
          return "";
      }
    }
    var $u = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function yf(e, t) {
      $u[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || S("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || S("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function gf(e) {
      var t = e.type, a = e.nodeName;
      return a && a.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function Yu(e) {
      return e._valueTracker;
    }
    function Np(e) {
      e._valueTracker = null;
    }
    function Om(e) {
      var t = "";
      return e && (gf(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function Qu(e) {
      var t = gf(e) ? "checked" : "value", a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      sr(e[t]);
      var i = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof a > "u" || typeof a.get != "function" || typeof a.set != "function")) {
        var u = a.get, s = a.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return u.call(this);
          },
          set: function(p) {
            sr(p), i = "" + p, s.call(this, p);
          }
        }), Object.defineProperty(e, t, {
          enumerable: a.enumerable
        });
        var f = {
          getValue: function() {
            return i;
          },
          setValue: function(p) {
            sr(p), i = "" + p;
          },
          stopTracking: function() {
            Np(e), delete e[t];
          }
        };
        return f;
      }
    }
    function fi(e) {
      Yu(e) || (e._valueTracker = Qu(e));
    }
    function Zi(e) {
      if (!e)
        return !1;
      var t = Yu(e);
      if (!t)
        return !0;
      var a = t.getValue(), i = Om(e);
      return i !== a ? (t.setValue(i), !0) : !1;
    }
    function Ji(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var zp = !1, Up = !1, ss = !1, Iu = !1;
    function cs(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function fs(e, t) {
      var a = e, i = t.checked, u = Le({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: i ?? a._wrapperState.initialChecked
      });
      return u;
    }
    function Ua(e, t) {
      yf("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !Up && (S("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", br() || "A component", t.type), Up = !0), t.value !== void 0 && t.defaultValue !== void 0 && !zp && (S("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", br() || "A component", t.type), zp = !0);
      var a = e, i = t.defaultValue == null ? "" : t.defaultValue;
      a._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: za(t.value != null ? t.value : i),
        controlled: cs(t)
      };
    }
    function ds(e, t) {
      var a = e, i = t.checked;
      i != null && Ii(a, "checked", i, !1);
    }
    function Gl(e, t) {
      var a = e;
      {
        var i = cs(t);
        !a._wrapperState.controlled && i && !Iu && (S("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Iu = !0), a._wrapperState.controlled && !i && !ss && (S("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), ss = !0);
      }
      ds(e, t);
      var u = za(t.value), s = t.type;
      if (u != null)
        s === "number" ? (u === 0 && a.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        a.value != u) && (a.value = _r(u)) : a.value !== _r(u) && (a.value = _r(u));
      else if (s === "submit" || s === "reset") {
        a.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? hs(a, t.type, u) : t.hasOwnProperty("defaultValue") && hs(a, t.type, za(t.defaultValue)), t.checked == null && t.defaultChecked != null && (a.defaultChecked = !!t.defaultChecked);
    }
    function Sf(e, t, a) {
      var i = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var u = t.type, s = u === "submit" || u === "reset";
        if (s && (t.value === void 0 || t.value === null))
          return;
        var f = _r(i._wrapperState.initialValue);
        a || f !== i.value && (i.value = f), i.defaultValue = f;
      }
      var p = i.name;
      p !== "" && (i.name = ""), i.defaultChecked = !i.defaultChecked, i.defaultChecked = !!i._wrapperState.initialChecked, p !== "" && (i.name = p);
    }
    function ps(e, t) {
      var a = e;
      Gl(a, t), vs(a, t);
    }
    function vs(e, t) {
      var a = t.name;
      if (t.type === "radio" && a != null) {
        for (var i = e; i.parentNode; )
          i = i.parentNode;
        fa(a, "name");
        for (var u = i.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), s = 0; s < u.length; s++) {
          var f = u[s];
          if (!(f === e || f.form !== e.form)) {
            var p = fh(f);
            if (!p)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Zi(f), Gl(f, p);
          }
        }
      }
    }
    function hs(e, t, a) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (t !== "number" || Ji(e.ownerDocument) !== e) && (a == null ? e.defaultValue = _r(e._wrapperState.initialValue) : e.defaultValue !== _r(a) && (e.defaultValue = _r(a)));
    }
    var Yn = !1, el = !1, ms = !1;
    function Wl(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? le.Children.forEach(t.children, function(a) {
        a != null && (typeof a == "string" || typeof a == "number" || el || (el = !0, S("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (ms || (ms = !0, S("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !Yn && (S("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Yn = !0);
    }
    function Nm(e, t) {
      t.value != null && e.setAttribute("value", _r(za(t.value)));
    }
    var Cf = Array.isArray;
    function en(e) {
      return Cf(e);
    }
    var tl;
    tl = !1;
    function Gu() {
      var e = br();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var Ef = ["value", "defaultValue"];
    function zm(e) {
      {
        yf("select", e);
        for (var t = 0; t < Ef.length; t++) {
          var a = Ef[t];
          if (e[a] != null) {
            var i = en(e[a]);
            e.multiple && !i ? S("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", a, Gu()) : !e.multiple && i && S("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", a, Gu());
          }
        }
      }
    }
    function Xl(e, t, a, i) {
      var u = e.options;
      if (t) {
        for (var s = a, f = {}, p = 0; p < s.length; p++)
          f["$" + s[p]] = !0;
        for (var v = 0; v < u.length; v++) {
          var m = f.hasOwnProperty("$" + u[v].value);
          u[v].selected !== m && (u[v].selected = m), m && i && (u[v].defaultSelected = !0);
        }
      } else {
        for (var y = _r(za(a)), R = null, E = 0; E < u.length; E++) {
          if (u[E].value === y) {
            u[E].selected = !0, i && (u[E].defaultSelected = !0);
            return;
          }
          R === null && !u[E].disabled && (R = u[E]);
        }
        R !== null && (R.selected = !0);
      }
    }
    function Tf(e, t) {
      return Le({}, t, {
        value: void 0
      });
    }
    function ys(e, t) {
      var a = e;
      zm(t), a._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !tl && (S("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), tl = !0);
    }
    function Um(e, t) {
      var a = e;
      a.multiple = !!t.multiple;
      var i = t.value;
      i != null ? Xl(a, !!t.multiple, i, !1) : t.defaultValue != null && Xl(a, !!t.multiple, t.defaultValue, !0);
    }
    function Am(e, t) {
      var a = e, i = a._wrapperState.wasMultiple;
      a._wrapperState.wasMultiple = !!t.multiple;
      var u = t.value;
      u != null ? Xl(a, !!t.multiple, u, !1) : i !== !!t.multiple && (t.defaultValue != null ? Xl(a, !!t.multiple, t.defaultValue, !0) : Xl(a, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function Hm(e, t) {
      var a = e, i = t.value;
      i != null && Xl(a, !!t.multiple, i, !1);
    }
    var Ap = !1;
    function Rf(e, t) {
      var a = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var i = Le({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: _r(a._wrapperState.initialValue)
      });
      return i;
    }
    function xf(e, t) {
      var a = e;
      yf("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !Ap && (S("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", br() || "A component"), Ap = !0);
      var i = t.value;
      if (i == null) {
        var u = t.children, s = t.defaultValue;
        if (u != null) {
          S("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (s != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (en(u)) {
              if (u.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              u = u[0];
            }
            s = u;
          }
        }
        s == null && (s = ""), i = s;
      }
      a._wrapperState = {
        initialValue: za(i)
      };
    }
    function Hp(e, t) {
      var a = e, i = za(t.value), u = za(t.defaultValue);
      if (i != null) {
        var s = _r(i);
        s !== a.value && (a.value = s), t.defaultValue == null && a.defaultValue !== s && (a.defaultValue = s);
      }
      u != null && (a.defaultValue = _r(u));
    }
    function Fp(e, t) {
      var a = e, i = a.textContent;
      i === a._wrapperState.initialValue && i !== "" && i !== null && (a.value = i);
    }
    function Fm(e, t) {
      Hp(e, t);
    }
    var Aa = "http://www.w3.org/1999/xhtml", wf = "http://www.w3.org/1998/Math/MathML", Df = "http://www.w3.org/2000/svg";
    function kf(e) {
      switch (e) {
        case "svg":
          return Df;
        case "math":
          return wf;
        default:
          return Aa;
      }
    }
    function bf(e, t) {
      return e == null || e === Aa ? kf(t) : e === Df && t === "foreignObject" ? Aa : e;
    }
    var Vp = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, a, i, u) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, a, i, u);
        });
      } : e;
    }, gs, jp = Vp(function(e, t) {
      if (e.namespaceURI === Df && !("innerHTML" in e)) {
        gs = gs || document.createElement("div"), gs.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var a = gs.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; a.firstChild; )
          e.appendChild(a.firstChild);
        return;
      }
      e.innerHTML = t;
    }), Qn = 1, Ha = 3, Ot = 8, Fa = 9, _f = 11, ql = function(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === Ha) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, Wu = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Xu = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Bp(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var Pp = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Xu).forEach(function(e) {
      Pp.forEach(function(t) {
        Xu[Bp(t, e)] = Xu[e];
      });
    });
    function Ss(e, t, a) {
      var i = t == null || typeof t == "boolean" || t === "";
      return i ? "" : !a && typeof t == "number" && t !== 0 && !(Xu.hasOwnProperty(e) && Xu[e]) ? t + "px" : (Hu(t, e), ("" + t).trim());
    }
    var $p = /([A-Z])/g, Yp = /^ms-/;
    function Kl(e) {
      return e.replace($p, "-$1").toLowerCase().replace(Yp, "-ms-");
    }
    var Qp = function() {
    };
    {
      var Vm = /^(?:webkit|moz|o)[A-Z]/, jm = /^-ms-/, Ip = /-(.)/g, Lf = /;\s*$/, pa = {}, nl = {}, Gp = !1, qu = !1, Bm = function(e) {
        return e.replace(Ip, function(t, a) {
          return a.toUpperCase();
        });
      }, Wp = function(e) {
        pa.hasOwnProperty(e) && pa[e] || (pa[e] = !0, S(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Bm(e.replace(jm, "ms-"))
        ));
      }, Mf = function(e) {
        pa.hasOwnProperty(e) && pa[e] || (pa[e] = !0, S("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, Of = function(e, t) {
        nl.hasOwnProperty(t) && nl[t] || (nl[t] = !0, S(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(Lf, "")));
      }, Xp = function(e, t) {
        Gp || (Gp = !0, S("`NaN` is an invalid value for the `%s` css style property.", e));
      }, qp = function(e, t) {
        qu || (qu = !0, S("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      Qp = function(e, t) {
        e.indexOf("-") > -1 ? Wp(e) : Vm.test(e) ? Mf(e) : Lf.test(t) && Of(e, t), typeof t == "number" && (isNaN(t) ? Xp(e, t) : isFinite(t) || qp(e, t));
      };
    }
    var Kp = Qp;
    function Pm(e) {
      {
        var t = "", a = "";
        for (var i in e)
          if (e.hasOwnProperty(i)) {
            var u = e[i];
            if (u != null) {
              var s = i.indexOf("--") === 0;
              t += a + (s ? i : Kl(i)) + ":", t += Ss(i, u, s), a = ";";
            }
          }
        return t || null;
      }
    }
    function Zp(e, t) {
      var a = e.style;
      for (var i in t)
        if (t.hasOwnProperty(i)) {
          var u = i.indexOf("--") === 0;
          u || Kp(i, t[i]);
          var s = Ss(i, t[i], u);
          i === "float" && (i = "cssFloat"), u ? a.setProperty(i, s) : a[i] = s;
        }
    }
    function $m(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function Jp(e) {
      var t = {};
      for (var a in e)
        for (var i = Wu[a] || [a], u = 0; u < i.length; u++)
          t[i[u]] = a;
      return t;
    }
    function Ym(e, t) {
      {
        if (!t)
          return;
        var a = Jp(e), i = Jp(t), u = {};
        for (var s in a) {
          var f = a[s], p = i[s];
          if (p && f !== p) {
            var v = f + "," + p;
            if (u[v])
              continue;
            u[v] = !0, S("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", $m(e[f]) ? "Removing" : "Updating", f, p);
          }
        }
      }
    }
    var Jr = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Ku = Le({
      menuitem: !0
    }, Jr), ev = "__html";
    function Cs(e, t) {
      if (t) {
        if (Ku[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(ev in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && S("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function di(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Zu = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Es = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Zl = {}, Qm = new RegExp("^(aria)-[" + $ + "]*$"), Jl = new RegExp("^(aria)[A-Z][" + $ + "]*$");
    function Nf(e, t) {
      {
        if (ca.call(Zl, t) && Zl[t])
          return !0;
        if (Jl.test(t)) {
          var a = "aria-" + t.slice(4).toLowerCase(), i = Es.hasOwnProperty(a) ? a : null;
          if (i == null)
            return S("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), Zl[t] = !0, !0;
          if (t !== i)
            return S("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, i), Zl[t] = !0, !0;
        }
        if (Qm.test(t)) {
          var u = t.toLowerCase(), s = Es.hasOwnProperty(u) ? u : null;
          if (s == null)
            return Zl[t] = !0, !1;
          if (t !== s)
            return S("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, s), Zl[t] = !0, !0;
        }
      }
      return !0;
    }
    function Ju(e, t) {
      {
        var a = [];
        for (var i in t) {
          var u = Nf(e, i);
          u || a.push(i);
        }
        var s = a.map(function(f) {
          return "`" + f + "`";
        }).join(", ");
        a.length === 1 ? S("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", s, e) : a.length > 1 && S("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", s, e);
      }
    }
    function zf(e, t) {
      di(e, t) || Ju(e, t);
    }
    var Uf = !1;
    function Ts(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !Uf && (Uf = !0, e === "select" && t.multiple ? S("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : S("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var rl = function() {
    };
    {
      var tn = {}, Af = /^on./, Rs = /^on[^A-Z]/, tv = new RegExp("^(aria)-[" + $ + "]*$"), nv = new RegExp("^(aria)[A-Z][" + $ + "]*$");
      rl = function(e, t, a, i) {
        if (ca.call(tn, t) && tn[t])
          return !0;
        var u = t.toLowerCase();
        if (u === "onfocusin" || u === "onfocusout")
          return S("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), tn[t] = !0, !0;
        if (i != null) {
          var s = i.registrationNameDependencies, f = i.possibleRegistrationNames;
          if (s.hasOwnProperty(t))
            return !0;
          var p = f.hasOwnProperty(u) ? f[u] : null;
          if (p != null)
            return S("Invalid event handler property `%s`. Did you mean `%s`?", t, p), tn[t] = !0, !0;
          if (Af.test(t))
            return S("Unknown event handler property `%s`. It will be ignored.", t), tn[t] = !0, !0;
        } else if (Af.test(t))
          return Rs.test(t) && S("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), tn[t] = !0, !0;
        if (tv.test(t) || nv.test(t))
          return !0;
        if (u === "innerhtml")
          return S("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), tn[t] = !0, !0;
        if (u === "aria")
          return S("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), tn[t] = !0, !0;
        if (u === "is" && a !== null && a !== void 0 && typeof a != "string")
          return S("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof a), tn[t] = !0, !0;
        if (typeof a == "number" && isNaN(a))
          return S("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), tn[t] = !0, !0;
        var v = Mt(t), m = v !== null && v.type === Dr;
        if (Zu.hasOwnProperty(u)) {
          var y = Zu[u];
          if (y !== t)
            return S("Invalid DOM property `%s`. Did you mean `%s`?", t, y), tn[t] = !0, !0;
        } else if (!m && t !== u)
          return S("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, u), tn[t] = !0, !0;
        return typeof a == "boolean" && Lt(t, a, v, !1) ? (a ? S('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', a, t, t, a, t) : S('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', a, t, t, a, t, t, t), tn[t] = !0, !0) : m ? !0 : Lt(t, a, v, !1) ? (tn[t] = !0, !1) : ((a === "false" || a === "true") && v !== null && v.type === cr && (S("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", a, t, a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, a), tn[t] = !0), !0);
      };
    }
    var rv = function(e, t, a) {
      {
        var i = [];
        for (var u in t) {
          var s = rl(e, u, t[u], a);
          s || i.push(u);
        }
        var f = i.map(function(p) {
          return "`" + p + "`";
        }).join(", ");
        i.length === 1 ? S("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, e) : i.length > 1 && S("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, e);
      }
    };
    function av(e, t, a) {
      di(e, t) || rv(e, t, a);
    }
    var Hf = 1, xs = 2, Lr = 4, Ff = Hf | xs | Lr, al = null;
    function Im(e) {
      al !== null && S("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), al = e;
    }
    function Gm() {
      al === null && S("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), al = null;
    }
    function eo(e) {
      return e === al;
    }
    function Vf(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === Ha ? t.parentNode : t;
    }
    var ws = null, il = null, Ye = null;
    function Ds(e) {
      var t = Cu(e);
      if (t) {
        if (typeof ws != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var a = t.stateNode;
        if (a) {
          var i = fh(a);
          ws(t.stateNode, t.type, i);
        }
      }
    }
    function ks(e) {
      ws = e;
    }
    function eu(e) {
      il ? Ye ? Ye.push(e) : Ye = [e] : il = e;
    }
    function iv() {
      return il !== null || Ye !== null;
    }
    function bs() {
      if (il) {
        var e = il, t = Ye;
        if (il = null, Ye = null, Ds(e), t)
          for (var a = 0; a < t.length; a++)
            Ds(t[a]);
      }
    }
    var tu = function(e, t) {
      return e(t);
    }, to = function() {
    }, pi = !1;
    function lv() {
      var e = iv();
      e && (to(), bs());
    }
    function uv(e, t, a) {
      if (pi)
        return e(t, a);
      pi = !0;
      try {
        return tu(e, t, a);
      } finally {
        pi = !1, lv();
      }
    }
    function Wm(e, t, a) {
      tu = e, to = a;
    }
    function ov(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function _s(e, t, a) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(a.disabled && ov(t));
        default:
          return !1;
      }
    }
    function vi(e, t) {
      var a = e.stateNode;
      if (a === null)
        return null;
      var i = fh(a);
      if (i === null)
        return null;
      var u = i[t];
      if (_s(t, e.type, i))
        return null;
      if (u && typeof u != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof u + "` type.");
      return u;
    }
    var no = !1;
    if (hn)
      try {
        var ll = {};
        Object.defineProperty(ll, "passive", {
          get: function() {
            no = !0;
          }
        }), window.addEventListener("test", ll, ll), window.removeEventListener("test", ll, ll);
      } catch {
        no = !1;
      }
    function Ls(e, t, a, i, u, s, f, p, v) {
      var m = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(a, m);
      } catch (y) {
        this.onError(y);
      }
    }
    var Ms = Ls;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var jf = document.createElement("react");
      Ms = function(t, a, i, u, s, f, p, v, m) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var y = document.createEvent("Event"), R = !1, E = !0, b = window.event, L = Object.getOwnPropertyDescriptor(window, "event");
        function M() {
          jf.removeEventListener(O, ce, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = b);
        }
        var Q = Array.prototype.slice.call(arguments, 3);
        function ce() {
          R = !0, M(), a.apply(i, Q), E = !1;
        }
        var re, Ue = !1, be = !1;
        function w(D) {
          if (re = D.error, Ue = !0, re === null && D.colno === 0 && D.lineno === 0 && (be = !0), D.defaultPrevented && re != null && typeof re == "object")
            try {
              re._suppressLogging = !0;
            } catch {
            }
        }
        var O = "react-" + (t || "invokeguardedcallback");
        if (window.addEventListener("error", w), jf.addEventListener(O, ce, !1), y.initEvent(O, !1, !1), jf.dispatchEvent(y), L && Object.defineProperty(window, "event", L), R && E && (Ue ? be && (re = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : re = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(re)), window.removeEventListener("error", w), !R)
          return M(), Ls.apply(this, arguments);
      };
    }
    var sv = Ms, nu = !1, Os = null, ru = !1, va = null, cv = {
      onError: function(e) {
        nu = !0, Os = e;
      }
    };
    function hi(e, t, a, i, u, s, f, p, v) {
      nu = !1, Os = null, sv.apply(cv, arguments);
    }
    function ha(e, t, a, i, u, s, f, p, v) {
      if (hi.apply(this, arguments), nu) {
        var m = ao();
        ru || (ru = !0, va = m);
      }
    }
    function ro() {
      if (ru) {
        var e = va;
        throw ru = !1, va = null, e;
      }
    }
    function Va() {
      return nu;
    }
    function ao() {
      if (nu) {
        var e = Os;
        return nu = !1, Os = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function au(e) {
      return e._reactInternals;
    }
    function Xm(e) {
      return e._reactInternals !== void 0;
    }
    function ul(e, t) {
      e._reactInternals = t;
    }
    var ue = (
      /*                      */
      0
    ), ea = (
      /*                */
      1
    ), Et = (
      /*                    */
      2
    ), Oe = (
      /*                       */
      4
    ), Mr = (
      /*                */
      16
    ), ta = (
      /*                 */
      32
    ), rt = (
      /*                     */
      64
    ), ie = (
      /*                   */
      128
    ), In = (
      /*            */
      256
    ), Ct = (
      /*                          */
      512
    ), $t = (
      /*                     */
      1024
    ), Gn = (
      /*                      */
      2048
    ), Or = (
      /*                    */
      4096
    ), Nt = (
      /*                   */
      8192
    ), iu = (
      /*             */
      16384
    ), fv = (
      /*               */
      32767
    ), io = (
      /*                   */
      32768
    ), Wn = (
      /*                */
      65536
    ), Ns = (
      /* */
      131072
    ), ma = (
      /*                       */
      1048576
    ), lu = (
      /*                    */
      2097152
    ), ja = (
      /*                 */
      4194304
    ), zs = (
      /*                */
      8388608
    ), mi = (
      /*               */
      16777216
    ), ya = (
      /*              */
      33554432
    ), yi = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Oe | $t | 0
    ), gi = Et | Oe | Mr | ta | Ct | Or | Nt, Si = Oe | rt | Ct | Nt, Ba = Gn | Mr, zt = ja | zs | lu, Nr = N.ReactCurrentOwner;
    function fr(e) {
      var t = e, a = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var i = t;
        do
          t = i, (t.flags & (Et | Or)) !== ue && (a = t.return), i = t.return;
        while (i);
      }
      return t.tag === ne ? a : null;
    }
    function ga(e) {
      if (e.tag === Me) {
        var t = e.memoizedState;
        if (t === null) {
          var a = e.alternate;
          a !== null && (t = a.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function Sa(e) {
      return e.tag === ne ? e.stateNode.containerInfo : null;
    }
    function ol(e) {
      return fr(e) === e;
    }
    function dv(e) {
      {
        var t = Nr.current;
        if (t !== null && t.tag === fe) {
          var a = t, i = a.stateNode;
          i._warnedAboutRefsInRender || S("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Te(a) || "A component"), i._warnedAboutRefsInRender = !0;
        }
      }
      var u = au(e);
      return u ? fr(u) === u : !1;
    }
    function Us(e) {
      if (fr(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function As(e) {
      var t = e.alternate;
      if (!t) {
        var a = fr(e);
        if (a === null)
          throw new Error("Unable to find node on an unmounted component.");
        return a !== e ? null : e;
      }
      for (var i = e, u = t; ; ) {
        var s = i.return;
        if (s === null)
          break;
        var f = s.alternate;
        if (f === null) {
          var p = s.return;
          if (p !== null) {
            i = u = p;
            continue;
          }
          break;
        }
        if (s.child === f.child) {
          for (var v = s.child; v; ) {
            if (v === i)
              return Us(s), e;
            if (v === u)
              return Us(s), t;
            v = v.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== u.return)
          i = s, u = f;
        else {
          for (var m = !1, y = s.child; y; ) {
            if (y === i) {
              m = !0, i = s, u = f;
              break;
            }
            if (y === u) {
              m = !0, u = s, i = f;
              break;
            }
            y = y.sibling;
          }
          if (!m) {
            for (y = f.child; y; ) {
              if (y === i) {
                m = !0, i = f, u = s;
                break;
              }
              if (y === u) {
                m = !0, u = f, i = s;
                break;
              }
              y = y.sibling;
            }
            if (!m)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (i.alternate !== u)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (i.tag !== ne)
        throw new Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function Xn(e) {
      var t = As(e);
      return t !== null ? qn(t) : null;
    }
    function qn(e) {
      if (e.tag === ae || e.tag === He)
        return e;
      for (var t = e.child; t !== null; ) {
        var a = qn(t);
        if (a !== null)
          return a;
        t = t.sibling;
      }
      return null;
    }
    function st(e) {
      var t = As(e);
      return t !== null ? zr(t) : null;
    }
    function zr(e) {
      if (e.tag === ae || e.tag === He)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== Se) {
          var a = zr(t);
          if (a !== null)
            return a;
        }
        t = t.sibling;
      }
      return null;
    }
    var Bf = Ae.unstable_scheduleCallback, pv = Ae.unstable_cancelCallback, Pf = Ae.unstable_shouldYield, $f = Ae.unstable_requestPaint, Yt = Ae.unstable_now, Hs = Ae.unstable_getCurrentPriorityLevel, lo = Ae.unstable_ImmediatePriority, Ci = Ae.unstable_UserBlockingPriority, Pa = Ae.unstable_NormalPriority, qm = Ae.unstable_LowPriority, sl = Ae.unstable_IdlePriority, Fs = Ae.unstable_yieldValue, vv = Ae.unstable_setDisableYieldValue, cl = null, Tt = null, Y = null, dr = !1, Kn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function uu(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled)
        return !0;
      if (!t.supportsFiber)
        return S("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Gr && (e = Le({}, e, {
          getLaneLabelMap: fl,
          injectProfilingHooks: Ur
        })), cl = t.inject(e), Tt = t;
      } catch (a) {
        S("React instrumentation encountered an error: %s.", a);
      }
      return !!t.checkDCE;
    }
    function Yf(e, t) {
      if (Tt && typeof Tt.onScheduleFiberRoot == "function")
        try {
          Tt.onScheduleFiberRoot(cl, e, t);
        } catch (a) {
          dr || (dr = !0, S("React instrumentation encountered an error: %s", a));
        }
    }
    function Qf(e, t) {
      if (Tt && typeof Tt.onCommitFiberRoot == "function")
        try {
          var a = (e.current.flags & ie) === ie;
          if (Rn) {
            var i;
            switch (t) {
              case wn:
                i = lo;
                break;
              case Ea:
                i = Ci;
                break;
              case Ar:
                i = Pa;
                break;
              case Hr:
                i = sl;
                break;
              default:
                i = Pa;
                break;
            }
            Tt.onCommitFiberRoot(cl, e, i, a);
          }
        } catch (u) {
          dr || (dr = !0, S("React instrumentation encountered an error: %s", u));
        }
    }
    function If(e) {
      if (Tt && typeof Tt.onPostCommitFiberRoot == "function")
        try {
          Tt.onPostCommitFiberRoot(cl, e);
        } catch (t) {
          dr || (dr = !0, S("React instrumentation encountered an error: %s", t));
        }
    }
    function Gf(e) {
      if (Tt && typeof Tt.onCommitFiberUnmount == "function")
        try {
          Tt.onCommitFiberUnmount(cl, e);
        } catch (t) {
          dr || (dr = !0, S("React instrumentation encountered an error: %s", t));
        }
    }
    function dt(e) {
      if (typeof Fs == "function" && (vv(e), ht(e)), Tt && typeof Tt.setStrictMode == "function")
        try {
          Tt.setStrictMode(cl, e);
        } catch (t) {
          dr || (dr = !0, S("React instrumentation encountered an error: %s", t));
        }
    }
    function Ur(e) {
      Y = e;
    }
    function fl() {
      {
        for (var e = /* @__PURE__ */ new Map(), t = 1, a = 0; a < vl; a++) {
          var i = gv(t);
          e.set(t, i), t *= 2;
        }
        return e;
      }
    }
    function Wf(e) {
      Y !== null && typeof Y.markCommitStarted == "function" && Y.markCommitStarted(e);
    }
    function Xf() {
      Y !== null && typeof Y.markCommitStopped == "function" && Y.markCommitStopped();
    }
    function pr(e) {
      Y !== null && typeof Y.markComponentRenderStarted == "function" && Y.markComponentRenderStarted(e);
    }
    function vr() {
      Y !== null && typeof Y.markComponentRenderStopped == "function" && Y.markComponentRenderStopped();
    }
    function qf(e) {
      Y !== null && typeof Y.markComponentPassiveEffectMountStarted == "function" && Y.markComponentPassiveEffectMountStarted(e);
    }
    function hv() {
      Y !== null && typeof Y.markComponentPassiveEffectMountStopped == "function" && Y.markComponentPassiveEffectMountStopped();
    }
    function $a(e) {
      Y !== null && typeof Y.markComponentPassiveEffectUnmountStarted == "function" && Y.markComponentPassiveEffectUnmountStarted(e);
    }
    function Ei() {
      Y !== null && typeof Y.markComponentPassiveEffectUnmountStopped == "function" && Y.markComponentPassiveEffectUnmountStopped();
    }
    function Vs(e) {
      Y !== null && typeof Y.markComponentLayoutEffectMountStarted == "function" && Y.markComponentLayoutEffectMountStarted(e);
    }
    function mv() {
      Y !== null && typeof Y.markComponentLayoutEffectMountStopped == "function" && Y.markComponentLayoutEffectMountStopped();
    }
    function uo(e) {
      Y !== null && typeof Y.markComponentLayoutEffectUnmountStarted == "function" && Y.markComponentLayoutEffectUnmountStarted(e);
    }
    function Kf() {
      Y !== null && typeof Y.markComponentLayoutEffectUnmountStopped == "function" && Y.markComponentLayoutEffectUnmountStopped();
    }
    function oo(e, t, a) {
      Y !== null && typeof Y.markComponentErrored == "function" && Y.markComponentErrored(e, t, a);
    }
    function Ca(e, t, a) {
      Y !== null && typeof Y.markComponentSuspended == "function" && Y.markComponentSuspended(e, t, a);
    }
    function so(e) {
      Y !== null && typeof Y.markLayoutEffectsStarted == "function" && Y.markLayoutEffectsStarted(e);
    }
    function co() {
      Y !== null && typeof Y.markLayoutEffectsStopped == "function" && Y.markLayoutEffectsStopped();
    }
    function dl(e) {
      Y !== null && typeof Y.markPassiveEffectsStarted == "function" && Y.markPassiveEffectsStarted(e);
    }
    function Zf() {
      Y !== null && typeof Y.markPassiveEffectsStopped == "function" && Y.markPassiveEffectsStopped();
    }
    function pl(e) {
      Y !== null && typeof Y.markRenderStarted == "function" && Y.markRenderStarted(e);
    }
    function yv() {
      Y !== null && typeof Y.markRenderYielded == "function" && Y.markRenderYielded();
    }
    function js() {
      Y !== null && typeof Y.markRenderStopped == "function" && Y.markRenderStopped();
    }
    function pt(e) {
      Y !== null && typeof Y.markRenderScheduled == "function" && Y.markRenderScheduled(e);
    }
    function Bs(e, t) {
      Y !== null && typeof Y.markForceUpdateScheduled == "function" && Y.markForceUpdateScheduled(e, t);
    }
    function fo(e, t) {
      Y !== null && typeof Y.markStateUpdateScheduled == "function" && Y.markStateUpdateScheduled(e, t);
    }
    var oe = (
      /*                         */
      0
    ), xe = (
      /*                 */
      1
    ), Ve = (
      /*                    */
      2
    ), Ke = (
      /*               */
      8
    ), je = (
      /*              */
      16
    ), Ut = Math.clz32 ? Math.clz32 : po, Xt = Math.log, Ps = Math.LN2;
    function po(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (Xt(t) / Ps | 0) | 0;
    }
    var vl = 31, U = (
      /*                        */
      0
    ), Fe = (
      /*                          */
      0
    ), he = (
      /*                        */
      1
    ), Ti = (
      /*    */
      2
    ), na = (
      /*             */
      4
    ), yn = (
      /*            */
      8
    ), Rt = (
      /*                     */
      16
    ), Ya = (
      /*                */
      32
    ), Ri = (
      /*                       */
      4194240
    ), hl = (
      /*                        */
      64
    ), $s = (
      /*                        */
      128
    ), Ys = (
      /*                        */
      256
    ), Qs = (
      /*                        */
      512
    ), Is = (
      /*                        */
      1024
    ), Gs = (
      /*                        */
      2048
    ), Ws = (
      /*                        */
      4096
    ), Xs = (
      /*                        */
      8192
    ), qs = (
      /*                        */
      16384
    ), ml = (
      /*                       */
      32768
    ), Ks = (
      /*                       */
      65536
    ), ou = (
      /*                       */
      131072
    ), su = (
      /*                       */
      262144
    ), Zs = (
      /*                       */
      524288
    ), vo = (
      /*                       */
      1048576
    ), Js = (
      /*                       */
      2097152
    ), ho = (
      /*                            */
      130023424
    ), yl = (
      /*                             */
      4194304
    ), ec = (
      /*                             */
      8388608
    ), mo = (
      /*                             */
      16777216
    ), tc = (
      /*                             */
      33554432
    ), nc = (
      /*                             */
      67108864
    ), Jf = yl, yo = (
      /*          */
      134217728
    ), ed = (
      /*                          */
      268435455
    ), go = (
      /*               */
      268435456
    ), gl = (
      /*                        */
      536870912
    ), hr = (
      /*                   */
      1073741824
    );
    function gv(e) {
      {
        if (e & he)
          return "Sync";
        if (e & Ti)
          return "InputContinuousHydration";
        if (e & na)
          return "InputContinuous";
        if (e & yn)
          return "DefaultHydration";
        if (e & Rt)
          return "Default";
        if (e & Ya)
          return "TransitionHydration";
        if (e & Ri)
          return "Transition";
        if (e & ho)
          return "Retry";
        if (e & yo)
          return "SelectiveHydration";
        if (e & go)
          return "IdleHydration";
        if (e & gl)
          return "Idle";
        if (e & hr)
          return "Offscreen";
      }
    }
    var nt = -1, Sl = hl, rc = yl;
    function So(e) {
      switch (xi(e)) {
        case he:
          return he;
        case Ti:
          return Ti;
        case na:
          return na;
        case yn:
          return yn;
        case Rt:
          return Rt;
        case Ya:
          return Ya;
        case hl:
        case $s:
        case Ys:
        case Qs:
        case Is:
        case Gs:
        case Ws:
        case Xs:
        case qs:
        case ml:
        case Ks:
        case ou:
        case su:
        case Zs:
        case vo:
        case Js:
          return e & Ri;
        case yl:
        case ec:
        case mo:
        case tc:
        case nc:
          return e & ho;
        case yo:
          return yo;
        case go:
          return go;
        case gl:
          return gl;
        case hr:
          return hr;
        default:
          return S("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function ac(e, t) {
      var a = e.pendingLanes;
      if (a === U)
        return U;
      var i = U, u = e.suspendedLanes, s = e.pingedLanes, f = a & ed;
      if (f !== U) {
        var p = f & ~u;
        if (p !== U)
          i = So(p);
        else {
          var v = f & s;
          v !== U && (i = So(v));
        }
      } else {
        var m = a & ~u;
        m !== U ? i = So(m) : s !== U && (i = So(s));
      }
      if (i === U)
        return U;
      if (t !== U && t !== i && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & u) === U) {
        var y = xi(i), R = xi(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          y >= R || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          y === Rt && (R & Ri) !== U
        )
          return t;
      }
      (i & na) !== U && (i |= a & Rt);
      var E = e.entangledLanes;
      if (E !== U)
        for (var b = e.entanglements, L = i & E; L > 0; ) {
          var M = At(L), Q = 1 << M;
          i |= b[M], L &= ~Q;
        }
      return i;
    }
    function ra(e, t) {
      for (var a = e.eventTimes, i = nt; t > 0; ) {
        var u = At(t), s = 1 << u, f = a[u];
        f > i && (i = f), t &= ~s;
      }
      return i;
    }
    function td(e, t) {
      switch (e) {
        case he:
        case Ti:
        case na:
          return t + 250;
        case yn:
        case Rt:
        case Ya:
        case hl:
        case $s:
        case Ys:
        case Qs:
        case Is:
        case Gs:
        case Ws:
        case Xs:
        case qs:
        case ml:
        case Ks:
        case ou:
        case su:
        case Zs:
        case vo:
        case Js:
          return t + 5e3;
        case yl:
        case ec:
        case mo:
        case tc:
        case nc:
          return nt;
        case yo:
        case go:
        case gl:
        case hr:
          return nt;
        default:
          return S("Should have found matching lanes. This is a bug in React."), nt;
      }
    }
    function ic(e, t) {
      for (var a = e.pendingLanes, i = e.suspendedLanes, u = e.pingedLanes, s = e.expirationTimes, f = a; f > 0; ) {
        var p = At(f), v = 1 << p, m = s[p];
        m === nt ? ((v & i) === U || (v & u) !== U) && (s[p] = td(v, t)) : m <= t && (e.expiredLanes |= v), f &= ~v;
      }
    }
    function Sv(e) {
      return So(e.pendingLanes);
    }
    function lc(e) {
      var t = e.pendingLanes & -1073741825;
      return t !== U ? t : t & hr ? hr : U;
    }
    function Cv(e) {
      return (e & he) !== U;
    }
    function Co(e) {
      return (e & ed) !== U;
    }
    function Cl(e) {
      return (e & ho) === e;
    }
    function nd(e) {
      var t = he | na | Rt;
      return (e & t) === U;
    }
    function rd(e) {
      return (e & Ri) === e;
    }
    function uc(e, t) {
      var a = Ti | na | yn | Rt;
      return (t & a) !== U;
    }
    function Ev(e, t) {
      return (t & e.expiredLanes) !== U;
    }
    function ad(e) {
      return (e & Ri) !== U;
    }
    function id() {
      var e = Sl;
      return Sl <<= 1, (Sl & Ri) === U && (Sl = hl), e;
    }
    function Tv() {
      var e = rc;
      return rc <<= 1, (rc & ho) === U && (rc = yl), e;
    }
    function xi(e) {
      return e & -e;
    }
    function Eo(e) {
      return xi(e);
    }
    function At(e) {
      return 31 - Ut(e);
    }
    function nn(e) {
      return At(e);
    }
    function Zn(e, t) {
      return (e & t) !== U;
    }
    function El(e, t) {
      return (e & t) === t;
    }
    function Re(e, t) {
      return e | t;
    }
    function To(e, t) {
      return e & ~t;
    }
    function ld(e, t) {
      return e & t;
    }
    function Rv(e) {
      return e;
    }
    function xv(e, t) {
      return e !== Fe && e < t ? e : t;
    }
    function Ro(e) {
      for (var t = [], a = 0; a < vl; a++)
        t.push(e);
      return t;
    }
    function cu(e, t, a) {
      e.pendingLanes |= t, t !== gl && (e.suspendedLanes = U, e.pingedLanes = U);
      var i = e.eventTimes, u = nn(t);
      i[u] = a;
    }
    function wv(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var a = e.expirationTimes, i = t; i > 0; ) {
        var u = At(i), s = 1 << u;
        a[u] = nt, i &= ~s;
      }
    }
    function oc(e, t, a) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function ud(e, t) {
      var a = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = U, e.pingedLanes = U, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var i = e.entanglements, u = e.eventTimes, s = e.expirationTimes, f = a; f > 0; ) {
        var p = At(f), v = 1 << p;
        i[p] = U, u[p] = nt, s[p] = nt, f &= ~v;
      }
    }
    function sc(e, t) {
      for (var a = e.entangledLanes |= t, i = e.entanglements, u = a; u; ) {
        var s = At(u), f = 1 << s;
        // Is this one of the newly entangled lanes?
        f & t | // Is this lane transitively entangled with the newly entangled lanes?
        i[s] & t && (i[s] |= t), u &= ~f;
      }
    }
    function od(e, t) {
      var a = xi(t), i;
      switch (a) {
        case na:
          i = Ti;
          break;
        case Rt:
          i = yn;
          break;
        case hl:
        case $s:
        case Ys:
        case Qs:
        case Is:
        case Gs:
        case Ws:
        case Xs:
        case qs:
        case ml:
        case Ks:
        case ou:
        case su:
        case Zs:
        case vo:
        case Js:
        case yl:
        case ec:
        case mo:
        case tc:
        case nc:
          i = Ya;
          break;
        case gl:
          i = go;
          break;
        default:
          i = Fe;
          break;
      }
      return (i & (e.suspendedLanes | t)) !== Fe ? Fe : i;
    }
    function xo(e, t, a) {
      if (Kn)
        for (var i = e.pendingUpdatersLaneMap; a > 0; ) {
          var u = nn(a), s = 1 << u, f = i[u];
          f.add(t), a &= ~s;
        }
    }
    function Dv(e, t) {
      if (Kn)
        for (var a = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; t > 0; ) {
          var u = nn(t), s = 1 << u, f = a[u];
          f.size > 0 && (f.forEach(function(p) {
            var v = p.alternate;
            (v === null || !i.has(v)) && i.add(p);
          }), f.clear()), t &= ~s;
        }
    }
    function sd(e, t) {
      return null;
    }
    var wn = he, Ea = na, Ar = Rt, Hr = gl, wo = Fe;
    function Fr() {
      return wo;
    }
    function Ht(e) {
      wo = e;
    }
    function kv(e, t) {
      var a = wo;
      try {
        return wo = e, t();
      } finally {
        wo = a;
      }
    }
    function bv(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function Do(e, t) {
      return e > t ? e : t;
    }
    function qt(e, t) {
      return e !== 0 && e < t;
    }
    function _v(e) {
      var t = xi(e);
      return qt(wn, t) ? qt(Ea, t) ? Co(t) ? Ar : Hr : Ea : wn;
    }
    function cc(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var ko;
    function gn(e) {
      ko = e;
    }
    function Km(e) {
      ko(e);
    }
    var K;
    function fu(e) {
      K = e;
    }
    var fc;
    function Lv(e) {
      fc = e;
    }
    var Mv;
    function bo(e) {
      Mv = e;
    }
    var _o;
    function cd(e) {
      _o = e;
    }
    var dc = !1, Lo = [], Qa = null, Ta = null, Ra = null, xt = /* @__PURE__ */ new Map(), Dn = /* @__PURE__ */ new Map(), kn = [], Ov = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Nv(e) {
      return Ov.indexOf(e) > -1;
    }
    function aa(e, t, a, i, u) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: a,
        nativeEvent: u,
        targetContainers: [i]
      };
    }
    function fd(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Qa = null;
          break;
        case "dragenter":
        case "dragleave":
          Ta = null;
          break;
        case "mouseover":
        case "mouseout":
          Ra = null;
          break;
        case "pointerover":
        case "pointerout": {
          var a = t.pointerId;
          xt.delete(a);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var i = t.pointerId;
          Dn.delete(i);
          break;
        }
      }
    }
    function Jn(e, t, a, i, u, s) {
      if (e === null || e.nativeEvent !== s) {
        var f = aa(t, a, i, u, s);
        if (t !== null) {
          var p = Cu(t);
          p !== null && K(p);
        }
        return f;
      }
      e.eventSystemFlags |= i;
      var v = e.targetContainers;
      return u !== null && v.indexOf(u) === -1 && v.push(u), e;
    }
    function Zm(e, t, a, i, u) {
      switch (t) {
        case "focusin": {
          var s = u;
          return Qa = Jn(Qa, e, t, a, i, s), !0;
        }
        case "dragenter": {
          var f = u;
          return Ta = Jn(Ta, e, t, a, i, f), !0;
        }
        case "mouseover": {
          var p = u;
          return Ra = Jn(Ra, e, t, a, i, p), !0;
        }
        case "pointerover": {
          var v = u, m = v.pointerId;
          return xt.set(m, Jn(xt.get(m) || null, e, t, a, i, v)), !0;
        }
        case "gotpointercapture": {
          var y = u, R = y.pointerId;
          return Dn.set(R, Jn(Dn.get(R) || null, e, t, a, i, y)), !0;
        }
      }
      return !1;
    }
    function dd(e) {
      var t = Po(e.target);
      if (t !== null) {
        var a = fr(t);
        if (a !== null) {
          var i = a.tag;
          if (i === Me) {
            var u = ga(a);
            if (u !== null) {
              e.blockedOn = u, _o(e.priority, function() {
                fc(a);
              });
              return;
            }
          } else if (i === ne) {
            var s = a.stateNode;
            if (cc(s)) {
              e.blockedOn = Sa(a);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function zv(e) {
      for (var t = Mv(), a = {
        blockedOn: null,
        target: e,
        priority: t
      }, i = 0; i < kn.length && qt(t, kn[i].priority); i++)
        ;
      kn.splice(i, 0, a), i === 0 && dd(a);
    }
    function Mo(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var a = t[0], i = pu(e.domEventName, e.eventSystemFlags, a, e.nativeEvent);
        if (i === null) {
          var u = e.nativeEvent, s = new u.constructor(u.type, u);
          Im(s), u.target.dispatchEvent(s), Gm();
        } else {
          var f = Cu(i);
          return f !== null && K(f), e.blockedOn = i, !1;
        }
        t.shift();
      }
      return !0;
    }
    function pd(e, t, a) {
      Mo(e) && a.delete(t);
    }
    function Jm() {
      dc = !1, Qa !== null && Mo(Qa) && (Qa = null), Ta !== null && Mo(Ta) && (Ta = null), Ra !== null && Mo(Ra) && (Ra = null), xt.forEach(pd), Dn.forEach(pd);
    }
    function wi(e, t) {
      e.blockedOn === t && (e.blockedOn = null, dc || (dc = !0, Ae.unstable_scheduleCallback(Ae.unstable_NormalPriority, Jm)));
    }
    function Tl(e) {
      if (Lo.length > 0) {
        wi(Lo[0], e);
        for (var t = 1; t < Lo.length; t++) {
          var a = Lo[t];
          a.blockedOn === e && (a.blockedOn = null);
        }
      }
      Qa !== null && wi(Qa, e), Ta !== null && wi(Ta, e), Ra !== null && wi(Ra, e);
      var i = function(p) {
        return wi(p, e);
      };
      xt.forEach(i), Dn.forEach(i);
      for (var u = 0; u < kn.length; u++) {
        var s = kn[u];
        s.blockedOn === e && (s.blockedOn = null);
      }
      for (; kn.length > 0; ) {
        var f = kn[0];
        if (f.blockedOn !== null)
          break;
        dd(f), f.blockedOn === null && kn.shift();
      }
    }
    var rn = N.ReactCurrentBatchConfig, Ne = !0;
    function Qt(e) {
      Ne = !!e;
    }
    function Ft() {
      return Ne;
    }
    function an(e, t, a) {
      var i = pc(t), u;
      switch (i) {
        case wn:
          u = mr;
          break;
        case Ea:
          u = du;
          break;
        case Ar:
        default:
          u = wt;
          break;
      }
      return u.bind(null, t, a, e);
    }
    function mr(e, t, a, i) {
      var u = Fr(), s = rn.transition;
      rn.transition = null;
      try {
        Ht(wn), wt(e, t, a, i);
      } finally {
        Ht(u), rn.transition = s;
      }
    }
    function du(e, t, a, i) {
      var u = Fr(), s = rn.transition;
      rn.transition = null;
      try {
        Ht(Ea), wt(e, t, a, i);
      } finally {
        Ht(u), rn.transition = s;
      }
    }
    function wt(e, t, a, i) {
      Ne && Oo(e, t, a, i);
    }
    function Oo(e, t, a, i) {
      var u = pu(e, t, a, i);
      if (u === null) {
        yy(e, t, i, xa, a), fd(e, i);
        return;
      }
      if (Zm(u, e, t, a, i)) {
        i.stopPropagation();
        return;
      }
      if (fd(e, i), t & Lr && Nv(e)) {
        for (; u !== null; ) {
          var s = Cu(u);
          s !== null && Km(s);
          var f = pu(e, t, a, i);
          if (f === null && yy(e, t, i, xa, a), f === u)
            break;
          u = f;
        }
        u !== null && i.stopPropagation();
        return;
      }
      yy(e, t, i, null, a);
    }
    var xa = null;
    function pu(e, t, a, i) {
      xa = null;
      var u = Vf(i), s = Po(u);
      if (s !== null) {
        var f = fr(s);
        if (f === null)
          s = null;
        else {
          var p = f.tag;
          if (p === Me) {
            var v = ga(f);
            if (v !== null)
              return v;
            s = null;
          } else if (p === ne) {
            var m = f.stateNode;
            if (cc(m))
              return Sa(f);
            s = null;
          } else f !== s && (s = null);
        }
      }
      return xa = s, null;
    }
    function pc(e) {
      switch (e) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return wn;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ea;
        case "message": {
          var t = Hs();
          switch (t) {
            case lo:
              return wn;
            case Ci:
              return Ea;
            case Pa:
            case qm:
              return Ar;
            case sl:
              return Hr;
            default:
              return Ar;
          }
        }
        default:
          return Ar;
      }
    }
    function No(e, t, a) {
      return e.addEventListener(t, a, !1), a;
    }
    function er(e, t, a) {
      return e.addEventListener(t, a, !0), a;
    }
    function vd(e, t, a, i) {
      return e.addEventListener(t, a, {
        capture: !0,
        passive: i
      }), a;
    }
    function vu(e, t, a, i) {
      return e.addEventListener(t, a, {
        passive: i
      }), a;
    }
    var yr = null, hu = null, Rl = null;
    function Di(e) {
      return yr = e, hu = zo(), !0;
    }
    function vc() {
      yr = null, hu = null, Rl = null;
    }
    function Ia() {
      if (Rl)
        return Rl;
      var e, t = hu, a = t.length, i, u = zo(), s = u.length;
      for (e = 0; e < a && t[e] === u[e]; e++)
        ;
      var f = a - e;
      for (i = 1; i <= f && t[a - i] === u[s - i]; i++)
        ;
      var p = i > 1 ? 1 - i : void 0;
      return Rl = u.slice(e, p), Rl;
    }
    function zo() {
      return "value" in yr ? yr.value : yr.textContent;
    }
    function ki(e) {
      var t, a = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && a === 13 && (t = 13)) : t = a, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function mu() {
      return !0;
    }
    function Uo() {
      return !1;
    }
    function Sn(e) {
      function t(a, i, u, s, f) {
        this._reactName = a, this._targetInst = u, this.type = i, this.nativeEvent = s, this.target = f, this.currentTarget = null;
        for (var p in e)
          if (e.hasOwnProperty(p)) {
            var v = e[p];
            v ? this[p] = v(s) : this[p] = s[p];
          }
        var m = s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1;
        return m ? this.isDefaultPrevented = mu : this.isDefaultPrevented = Uo, this.isPropagationStopped = Uo, this;
      }
      return Le(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = mu);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = mu);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: mu
      }), t;
    }
    var Vt = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, wa = Sn(Vt), bn = Le({}, Vt, {
      view: 0,
      detail: 0
    }), tr = Sn(bn), hc, Ao, xl;
    function ey(e) {
      e !== xl && (xl && e.type === "mousemove" ? (hc = e.screenX - xl.screenX, Ao = e.screenY - xl.screenY) : (hc = 0, Ao = 0), xl = e);
    }
    var ia = Le({}, bn, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: ct,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (ey(e), hc);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : Ao;
      }
    }), hd = Sn(ia), md = Le({}, ia, {
      dataTransfer: 0
    }), wl = Sn(md), yd = Le({}, bn, {
      relatedTarget: 0
    }), Ga = Sn(yd), Uv = Le({}, Vt, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Av = Sn(Uv), gd = Le({}, Vt, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), mc = Sn(gd), ty = Le({}, Vt, {
      data: 0
    }), Hv = Sn(ty), Fv = Hv, Vv = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Dl = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function ny(e) {
      if (e.key) {
        var t = Vv[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var a = ki(e);
        return a === 13 ? "Enter" : String.fromCharCode(a);
      }
      return e.type === "keydown" || e.type === "keyup" ? Dl[e.keyCode] || "Unidentified" : "";
    }
    var yu = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function jv(e) {
      var t = this, a = t.nativeEvent;
      if (a.getModifierState)
        return a.getModifierState(e);
      var i = yu[e];
      return i ? !!a[i] : !1;
    }
    function ct(e) {
      return jv;
    }
    var ry = Le({}, bn, {
      key: ny,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: ct,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? ki(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? ki(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), Bv = Sn(ry), ay = Le({}, ia, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Pv = Sn(ay), $v = Le({}, bn, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: ct
    }), Yv = Sn($v), iy = Le({}, Vt, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Vr = Sn(iy), Sd = Le({}, ia, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), ly = Sn(Sd), bi = [9, 13, 27, 32], Ho = 229, Wa = hn && "CompositionEvent" in window, _i = null;
    hn && "documentMode" in document && (_i = document.documentMode);
    var Cd = hn && "TextEvent" in window && !_i, yc = hn && (!Wa || _i && _i > 8 && _i <= 11), Qv = 32, gc = String.fromCharCode(Qv);
    function uy() {
      sa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), sa("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), sa("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), sa("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Ed = !1;
    function Iv(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function Sc(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Cc(e, t) {
      return e === "keydown" && t.keyCode === Ho;
    }
    function Td(e, t) {
      switch (e) {
        case "keyup":
          return bi.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== Ho;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ec(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function Rd(e) {
      return e.locale === "ko";
    }
    var Li = !1;
    function Tc(e, t, a, i, u) {
      var s, f;
      if (Wa ? s = Sc(t) : Li ? Td(t, i) && (s = "onCompositionEnd") : Cc(t, i) && (s = "onCompositionStart"), !s)
        return null;
      yc && !Rd(i) && (!Li && s === "onCompositionStart" ? Li = Di(u) : s === "onCompositionEnd" && Li && (f = Ia()));
      var p = Zv(a, s);
      if (p.length > 0) {
        var v = new Hv(s, t, null, i, u);
        if (e.push({
          event: v,
          listeners: p
        }), f)
          v.data = f;
        else {
          var m = Ec(i);
          m !== null && (v.data = m);
        }
      }
    }
    function xd(e, t) {
      switch (e) {
        case "compositionend":
          return Ec(t);
        case "keypress":
          var a = t.which;
          return a !== Qv ? null : (Ed = !0, gc);
        case "textInput":
          var i = t.data;
          return i === gc && Ed ? null : i;
        default:
          return null;
      }
    }
    function Rc(e, t) {
      if (Li) {
        if (e === "compositionend" || !Wa && Td(e, t)) {
          var a = Ia();
          return vc(), Li = !1, a;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!Iv(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return yc && !Rd(t) ? null : t.data;
        default:
          return null;
      }
    }
    function Gv(e, t, a, i, u) {
      var s;
      if (Cd ? s = xd(t, i) : s = Rc(t, i), !s)
        return null;
      var f = Zv(a, "onBeforeInput");
      if (f.length > 0) {
        var p = new Fv("onBeforeInput", "beforeinput", null, i, u);
        e.push({
          event: p,
          listeners: f
        }), p.data = s;
      }
    }
    function oy(e, t, a, i, u, s, f) {
      Tc(e, t, a, i, u), Gv(e, t, a, i, u);
    }
    var xc = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Wv(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!xc[e.type] : t === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Fo(e) {
      if (!hn)
        return !1;
      var t = "on" + e, a = t in document;
      if (!a) {
        var i = document.createElement("div");
        i.setAttribute(t, "return;"), a = typeof i[t] == "function";
      }
      return a;
    }
    function sy() {
      sa("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Vo(e, t, a, i) {
      eu(i);
      var u = Zv(t, "onChange");
      if (u.length > 0) {
        var s = new wa("onChange", "change", null, a, i);
        e.push({
          event: s,
          listeners: u
        });
      }
    }
    var n = null, r = null;
    function l(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function o(e) {
      var t = [];
      Vo(t, r, e, Vf(e)), uv(c, t);
    }
    function c(e) {
      mC(e, 0);
    }
    function d(e) {
      var t = Lc(e);
      if (Zi(t))
        return e;
    }
    function h(e, t) {
      if (e === "change")
        return t;
    }
    var g = !1;
    hn && (g = Fo("input") && (!document.documentMode || document.documentMode > 9));
    function C(e, t) {
      n = e, r = t, n.attachEvent("onpropertychange", H);
    }
    function _() {
      n && (n.detachEvent("onpropertychange", H), n = null, r = null);
    }
    function H(e) {
      e.propertyName === "value" && d(r) && o(e);
    }
    function F(e, t, a) {
      e === "focusin" ? (_(), C(t, a)) : e === "focusout" && _();
    }
    function A(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return d(r);
    }
    function W(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function J(e, t) {
      if (e === "click")
        return d(t);
    }
    function te(e, t) {
      if (e === "input" || e === "change")
        return d(t);
    }
    function Dt(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || hs(e, "number", e.value);
    }
    function x(e, t, a, i, u, s, f) {
      var p = a ? Lc(a) : window, v, m;
      if (l(p) ? v = h : Wv(p) ? g ? v = te : (v = A, m = F) : W(p) && (v = J), v) {
        var y = v(t, a);
        if (y) {
          Vo(e, y, i, u);
          return;
        }
      }
      m && m(t, p, a), t === "focusout" && Dt(p);
    }
    function T() {
      li("onMouseEnter", ["mouseout", "mouseover"]), li("onMouseLeave", ["mouseout", "mouseover"]), li("onPointerEnter", ["pointerout", "pointerover"]), li("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function k(e, t, a, i, u, s, f) {
      var p = t === "mouseover" || t === "pointerover", v = t === "mouseout" || t === "pointerout";
      if (p && !eo(i)) {
        var m = i.relatedTarget || i.fromElement;
        if (m && (Po(m) || Fd(m)))
          return;
      }
      if (!(!v && !p)) {
        var y;
        if (u.window === u)
          y = u;
        else {
          var R = u.ownerDocument;
          R ? y = R.defaultView || R.parentWindow : y = window;
        }
        var E, b;
        if (v) {
          var L = i.relatedTarget || i.toElement;
          if (E = a, b = L ? Po(L) : null, b !== null) {
            var M = fr(b);
            (b !== M || b.tag !== ae && b.tag !== He) && (b = null);
          }
        } else
          E = null, b = a;
        if (E !== b) {
          var Q = hd, ce = "onMouseLeave", re = "onMouseEnter", Ue = "mouse";
          (t === "pointerout" || t === "pointerover") && (Q = Pv, ce = "onPointerLeave", re = "onPointerEnter", Ue = "pointer");
          var be = E == null ? y : Lc(E), w = b == null ? y : Lc(b), O = new Q(ce, Ue + "leave", E, i, u);
          O.target = be, O.relatedTarget = w;
          var D = null, V = Po(u);
          if (V === a) {
            var q = new Q(re, Ue + "enter", b, i, u);
            q.target = w, q.relatedTarget = be, D = q;
          }
          f1(e, O, D, E, b);
        }
      }
    }
    function j(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var I = typeof Object.is == "function" ? Object.is : j;
    function se(e, t) {
      if (I(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), i = Object.keys(t);
      if (a.length !== i.length)
        return !1;
      for (var u = 0; u < a.length; u++) {
        var s = a[u];
        if (!ca.call(t, s) || !I(e[s], t[s]))
          return !1;
      }
      return !0;
    }
    function pe(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function ye(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function It(e, t) {
      for (var a = pe(e), i = 0, u = 0; a; ) {
        if (a.nodeType === Ha) {
          if (u = i + a.textContent.length, i <= t && u >= t)
            return {
              node: a,
              offset: t - i
            };
          i = u;
        }
        a = pe(ye(a));
      }
    }
    function Be(e) {
      var t = e.ownerDocument, a = t && t.defaultView || window, i = a.getSelection && a.getSelection();
      if (!i || i.rangeCount === 0)
        return null;
      var u = i.anchorNode, s = i.anchorOffset, f = i.focusNode, p = i.focusOffset;
      try {
        u.nodeType, f.nodeType;
      } catch {
        return null;
      }
      return Mi(e, u, s, f, p);
    }
    function Mi(e, t, a, i, u) {
      var s = 0, f = -1, p = -1, v = 0, m = 0, y = e, R = null;
      e: for (; ; ) {
        for (var E = null; y === t && (a === 0 || y.nodeType === Ha) && (f = s + a), y === i && (u === 0 || y.nodeType === Ha) && (p = s + u), y.nodeType === Ha && (s += y.nodeValue.length), (E = y.firstChild) !== null; )
          R = y, y = E;
        for (; ; ) {
          if (y === e)
            break e;
          if (R === t && ++v === a && (f = s), R === i && ++m === u && (p = s), (E = y.nextSibling) !== null)
            break;
          y = R, R = y.parentNode;
        }
        y = E;
      }
      return f === -1 || p === -1 ? null : {
        start: f,
        end: p
      };
    }
    function cy(e, t) {
      var a = e.ownerDocument || document, i = a && a.defaultView || window;
      if (i.getSelection) {
        var u = i.getSelection(), s = e.textContent.length, f = Math.min(t.start, s), p = t.end === void 0 ? f : Math.min(t.end, s);
        if (!u.extend && f > p) {
          var v = p;
          p = f, f = v;
        }
        var m = It(e, f), y = It(e, p);
        if (m && y) {
          if (u.rangeCount === 1 && u.anchorNode === m.node && u.anchorOffset === m.offset && u.focusNode === y.node && u.focusOffset === y.offset)
            return;
          var R = a.createRange();
          R.setStart(m.node, m.offset), u.removeAllRanges(), f > p ? (u.addRange(R), u.extend(y.node, y.offset)) : (R.setEnd(y.node, y.offset), u.addRange(R));
        }
      }
    }
    function aC(e) {
      return e && e.nodeType === Ha;
    }
    function iC(e, t) {
      return !e || !t ? !1 : e === t ? !0 : aC(e) ? !1 : aC(t) ? iC(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function GT(e) {
      return e && e.ownerDocument && iC(e.ownerDocument.documentElement, e);
    }
    function WT(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function lC() {
      for (var e = window, t = Ji(); t instanceof e.HTMLIFrameElement; ) {
        if (WT(t))
          e = t.contentWindow;
        else
          return t;
        t = Ji(e.document);
      }
      return t;
    }
    function fy(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function XT() {
      var e = lC();
      return {
        focusedElem: e,
        selectionRange: fy(e) ? KT(e) : null
      };
    }
    function qT(e) {
      var t = lC(), a = e.focusedElem, i = e.selectionRange;
      if (t !== a && GT(a)) {
        i !== null && fy(a) && ZT(a, i);
        for (var u = [], s = a; s = s.parentNode; )
          s.nodeType === Qn && u.push({
            element: s,
            left: s.scrollLeft,
            top: s.scrollTop
          });
        typeof a.focus == "function" && a.focus();
        for (var f = 0; f < u.length; f++) {
          var p = u[f];
          p.element.scrollLeft = p.left, p.element.scrollTop = p.top;
        }
      }
    }
    function KT(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = Be(e), t || {
        start: 0,
        end: 0
      };
    }
    function ZT(e, t) {
      var a = t.start, i = t.end;
      i === void 0 && (i = a), "selectionStart" in e ? (e.selectionStart = a, e.selectionEnd = Math.min(i, e.value.length)) : cy(e, t);
    }
    var JT = hn && "documentMode" in document && document.documentMode <= 11;
    function e1() {
      sa("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var wc = null, dy = null, wd = null, py = !1;
    function t1(e) {
      if ("selectionStart" in e && fy(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, a = t.getSelection();
      return {
        anchorNode: a.anchorNode,
        anchorOffset: a.anchorOffset,
        focusNode: a.focusNode,
        focusOffset: a.focusOffset
      };
    }
    function n1(e) {
      return e.window === e ? e.document : e.nodeType === Fa ? e : e.ownerDocument;
    }
    function uC(e, t, a) {
      var i = n1(a);
      if (!(py || wc == null || wc !== Ji(i))) {
        var u = t1(wc);
        if (!wd || !se(wd, u)) {
          wd = u;
          var s = Zv(dy, "onSelect");
          if (s.length > 0) {
            var f = new wa("onSelect", "select", null, t, a);
            e.push({
              event: f,
              listeners: s
            }), f.target = wc;
          }
        }
      }
    }
    function r1(e, t, a, i, u, s, f) {
      var p = a ? Lc(a) : window;
      switch (t) {
        case "focusin":
          (Wv(p) || p.contentEditable === "true") && (wc = p, dy = a, wd = null);
          break;
        case "focusout":
          wc = null, dy = null, wd = null;
          break;
        case "mousedown":
          py = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          py = !1, uC(e, i, u);
          break;
        case "selectionchange":
          if (JT)
            break;
        case "keydown":
        case "keyup":
          uC(e, i, u);
      }
    }
    function Xv(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    var Dc = {
      animationend: Xv("Animation", "AnimationEnd"),
      animationiteration: Xv("Animation", "AnimationIteration"),
      animationstart: Xv("Animation", "AnimationStart"),
      transitionend: Xv("Transition", "TransitionEnd")
    }, vy = {}, oC = {};
    hn && (oC = document.createElement("div").style, "AnimationEvent" in window || (delete Dc.animationend.animation, delete Dc.animationiteration.animation, delete Dc.animationstart.animation), "TransitionEvent" in window || delete Dc.transitionend.transition);
    function qv(e) {
      if (vy[e])
        return vy[e];
      if (!Dc[e])
        return e;
      var t = Dc[e];
      for (var a in t)
        if (t.hasOwnProperty(a) && a in oC)
          return vy[e] = t[a];
      return e;
    }
    var sC = qv("animationend"), cC = qv("animationiteration"), fC = qv("animationstart"), dC = qv("transitionend"), pC = /* @__PURE__ */ new Map(), vC = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function gu(e, t) {
      pC.set(e, t), sa(t, [e]);
    }
    function a1() {
      for (var e = 0; e < vC.length; e++) {
        var t = vC[e], a = t.toLowerCase(), i = t[0].toUpperCase() + t.slice(1);
        gu(a, "on" + i);
      }
      gu(sC, "onAnimationEnd"), gu(cC, "onAnimationIteration"), gu(fC, "onAnimationStart"), gu("dblclick", "onDoubleClick"), gu("focusin", "onFocus"), gu("focusout", "onBlur"), gu(dC, "onTransitionEnd");
    }
    function i1(e, t, a, i, u, s, f) {
      var p = pC.get(t);
      if (p !== void 0) {
        var v = wa, m = t;
        switch (t) {
          case "keypress":
            if (ki(i) === 0)
              return;
          case "keydown":
          case "keyup":
            v = Bv;
            break;
          case "focusin":
            m = "focus", v = Ga;
            break;
          case "focusout":
            m = "blur", v = Ga;
            break;
          case "beforeblur":
          case "afterblur":
            v = Ga;
            break;
          case "click":
            if (i.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            v = hd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            v = wl;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            v = Yv;
            break;
          case sC:
          case cC:
          case fC:
            v = Av;
            break;
          case dC:
            v = Vr;
            break;
          case "scroll":
            v = tr;
            break;
          case "wheel":
            v = ly;
            break;
          case "copy":
          case "cut":
          case "paste":
            v = mc;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            v = Pv;
            break;
        }
        var y = (s & Lr) !== 0;
        {
          var R = !y && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", E = s1(a, p, i.type, y, R);
          if (E.length > 0) {
            var b = new v(p, m, null, i, u);
            e.push({
              event: b,
              listeners: E
            });
          }
        }
      }
    }
    a1(), T(), sy(), e1(), uy();
    function l1(e, t, a, i, u, s, f) {
      i1(e, t, a, i, u, s);
      var p = (s & Ff) === 0;
      p && (k(e, t, a, i, u), x(e, t, a, i, u), r1(e, t, a, i, u), oy(e, t, a, i, u));
    }
    var Dd = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], hy = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Dd));
    function hC(e, t, a) {
      var i = e.type || "unknown-event";
      e.currentTarget = a, ha(i, t, void 0, e), e.currentTarget = null;
    }
    function u1(e, t, a) {
      var i;
      if (a)
        for (var u = t.length - 1; u >= 0; u--) {
          var s = t[u], f = s.instance, p = s.currentTarget, v = s.listener;
          if (f !== i && e.isPropagationStopped())
            return;
          hC(e, v, p), i = f;
        }
      else
        for (var m = 0; m < t.length; m++) {
          var y = t[m], R = y.instance, E = y.currentTarget, b = y.listener;
          if (R !== i && e.isPropagationStopped())
            return;
          hC(e, b, E), i = R;
        }
    }
    function mC(e, t) {
      for (var a = (t & Lr) !== 0, i = 0; i < e.length; i++) {
        var u = e[i], s = u.event, f = u.listeners;
        u1(s, f, a);
      }
      ro();
    }
    function o1(e, t, a, i, u) {
      var s = Vf(a), f = [];
      l1(f, e, i, a, s, t), mC(f, t);
    }
    function vt(e, t) {
      hy.has(e) || S('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var a = !1, i = FR(t), u = d1(e);
      i.has(u) || (yC(t, e, xs, a), i.add(u));
    }
    function my(e, t, a) {
      hy.has(e) && !t && S('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var i = 0;
      t && (i |= Lr), yC(a, e, i, t);
    }
    var Kv = "_reactListening" + Math.random().toString(36).slice(2);
    function kd(e) {
      if (!e[Kv]) {
        e[Kv] = !0, Vn.forEach(function(a) {
          a !== "selectionchange" && (hy.has(a) || my(a, !1, e), my(a, !0, e));
        });
        var t = e.nodeType === Fa ? e : e.ownerDocument;
        t !== null && (t[Kv] || (t[Kv] = !0, my("selectionchange", !1, t)));
      }
    }
    function yC(e, t, a, i, u) {
      var s = an(e, t, a), f = void 0;
      no && (t === "touchstart" || t === "touchmove" || t === "wheel") && (f = !0), e = e, i ? f !== void 0 ? vd(e, t, s, f) : er(e, t, s) : f !== void 0 ? vu(e, t, s, f) : No(e, t, s);
    }
    function gC(e, t) {
      return e === t || e.nodeType === Ot && e.parentNode === t;
    }
    function yy(e, t, a, i, u) {
      var s = i;
      if (!(t & Hf) && !(t & xs)) {
        var f = u;
        if (i !== null) {
          var p = i;
          e: for (; ; ) {
            if (p === null)
              return;
            var v = p.tag;
            if (v === ne || v === Se) {
              var m = p.stateNode.containerInfo;
              if (gC(m, f))
                break;
              if (v === Se)
                for (var y = p.return; y !== null; ) {
                  var R = y.tag;
                  if (R === ne || R === Se) {
                    var E = y.stateNode.containerInfo;
                    if (gC(E, f))
                      return;
                  }
                  y = y.return;
                }
              for (; m !== null; ) {
                var b = Po(m);
                if (b === null)
                  return;
                var L = b.tag;
                if (L === ae || L === He) {
                  p = s = b;
                  continue e;
                }
                m = m.parentNode;
              }
            }
            p = p.return;
          }
        }
      }
      uv(function() {
        return o1(e, t, a, s);
      });
    }
    function bd(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function s1(e, t, a, i, u, s) {
      for (var f = t !== null ? t + "Capture" : null, p = i ? f : t, v = [], m = e, y = null; m !== null; ) {
        var R = m, E = R.stateNode, b = R.tag;
        if (b === ae && E !== null && (y = E, p !== null)) {
          var L = vi(m, p);
          L != null && v.push(bd(m, L, y));
        }
        if (u)
          break;
        m = m.return;
      }
      return v;
    }
    function Zv(e, t) {
      for (var a = t + "Capture", i = [], u = e; u !== null; ) {
        var s = u, f = s.stateNode, p = s.tag;
        if (p === ae && f !== null) {
          var v = f, m = vi(u, a);
          m != null && i.unshift(bd(u, m, v));
          var y = vi(u, t);
          y != null && i.push(bd(u, y, v));
        }
        u = u.return;
      }
      return i;
    }
    function kc(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== ae);
      return e || null;
    }
    function c1(e, t) {
      for (var a = e, i = t, u = 0, s = a; s; s = kc(s))
        u++;
      for (var f = 0, p = i; p; p = kc(p))
        f++;
      for (; u - f > 0; )
        a = kc(a), u--;
      for (; f - u > 0; )
        i = kc(i), f--;
      for (var v = u; v--; ) {
        if (a === i || i !== null && a === i.alternate)
          return a;
        a = kc(a), i = kc(i);
      }
      return null;
    }
    function SC(e, t, a, i, u) {
      for (var s = t._reactName, f = [], p = a; p !== null && p !== i; ) {
        var v = p, m = v.alternate, y = v.stateNode, R = v.tag;
        if (m !== null && m === i)
          break;
        if (R === ae && y !== null) {
          var E = y;
          if (u) {
            var b = vi(p, s);
            b != null && f.unshift(bd(p, b, E));
          } else if (!u) {
            var L = vi(p, s);
            L != null && f.push(bd(p, L, E));
          }
        }
        p = p.return;
      }
      f.length !== 0 && e.push({
        event: t,
        listeners: f
      });
    }
    function f1(e, t, a, i, u) {
      var s = i && u ? c1(i, u) : null;
      i !== null && SC(e, t, i, s, !1), u !== null && a !== null && SC(e, a, u, s, !0);
    }
    function d1(e, t) {
      return e + "__bubble";
    }
    var jr = !1, _d = "dangerouslySetInnerHTML", Jv = "suppressContentEditableWarning", Su = "suppressHydrationWarning", CC = "autoFocus", jo = "children", Bo = "style", eh = "__html", gy, th, Ld, EC, nh, TC, RC;
    gy = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, th = function(e, t) {
      zf(e, t), Ts(e, t), av(e, t, {
        registrationNameDependencies: jn,
        possibleRegistrationNames: xr
      });
    }, TC = hn && !document.documentMode, Ld = function(e, t, a) {
      if (!jr) {
        var i = rh(a), u = rh(t);
        u !== i && (jr = !0, S("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(u), JSON.stringify(i)));
      }
    }, EC = function(e) {
      if (!jr) {
        jr = !0;
        var t = [];
        e.forEach(function(a) {
          t.push(a);
        }), S("Extra attributes from the server: %s", t);
      }
    }, nh = function(e, t) {
      t === !1 ? S("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : S("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, RC = function(e, t) {
      var a = e.namespaceURI === Aa ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return a.innerHTML = t, a.innerHTML;
    };
    var p1 = /\r\n?/g, v1 = /\u0000|\uFFFD/g;
    function rh(e) {
      $i(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(p1, `
`).replace(v1, "");
    }
    function ah(e, t, a, i) {
      var u = rh(t), s = rh(e);
      if (s !== u && (i && (jr || (jr = !0, S('Text content did not match. Server: "%s" Client: "%s"', s, u))), a && Na))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function xC(e) {
      return e.nodeType === Fa ? e : e.ownerDocument;
    }
    function h1() {
    }
    function ih(e) {
      e.onclick = h1;
    }
    function m1(e, t, a, i, u) {
      for (var s in i)
        if (i.hasOwnProperty(s)) {
          var f = i[s];
          if (s === Bo)
            f && Object.freeze(f), Zp(t, f);
          else if (s === _d) {
            var p = f ? f[eh] : void 0;
            p != null && jp(t, p);
          } else if (s === jo)
            if (typeof f == "string") {
              var v = e !== "textarea" || f !== "";
              v && ql(t, f);
            } else typeof f == "number" && ql(t, "" + f);
          else s === Jv || s === Su || s === CC || (jn.hasOwnProperty(s) ? f != null && (typeof f != "function" && nh(s, f), s === "onScroll" && vt("scroll", t)) : f != null && Ii(t, s, f, u));
        }
    }
    function y1(e, t, a, i) {
      for (var u = 0; u < t.length; u += 2) {
        var s = t[u], f = t[u + 1];
        s === Bo ? Zp(e, f) : s === _d ? jp(e, f) : s === jo ? ql(e, f) : Ii(e, s, f, i);
      }
    }
    function g1(e, t, a, i) {
      var u, s = xC(a), f, p = i;
      if (p === Aa && (p = kf(e)), p === Aa) {
        if (u = di(e, t), !u && e !== e.toLowerCase() && S("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var v = s.createElement("div");
          v.innerHTML = "<script><\/script>";
          var m = v.firstChild;
          f = v.removeChild(m);
        } else if (typeof t.is == "string")
          f = s.createElement(e, {
            is: t.is
          });
        else if (f = s.createElement(e), e === "select") {
          var y = f;
          t.multiple ? y.multiple = !0 : t.size && (y.size = t.size);
        }
      } else
        f = s.createElementNS(p, e);
      return p === Aa && !u && Object.prototype.toString.call(f) === "[object HTMLUnknownElement]" && !ca.call(gy, e) && (gy[e] = !0, S("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), f;
    }
    function S1(e, t) {
      return xC(t).createTextNode(e);
    }
    function C1(e, t, a, i) {
      var u = di(t, a);
      th(t, a);
      var s;
      switch (t) {
        case "dialog":
          vt("cancel", e), vt("close", e), s = a;
          break;
        case "iframe":
        case "object":
        case "embed":
          vt("load", e), s = a;
          break;
        case "video":
        case "audio":
          for (var f = 0; f < Dd.length; f++)
            vt(Dd[f], e);
          s = a;
          break;
        case "source":
          vt("error", e), s = a;
          break;
        case "img":
        case "image":
        case "link":
          vt("error", e), vt("load", e), s = a;
          break;
        case "details":
          vt("toggle", e), s = a;
          break;
        case "input":
          Ua(e, a), s = fs(e, a), vt("invalid", e);
          break;
        case "option":
          Wl(e, a), s = a;
          break;
        case "select":
          ys(e, a), s = Tf(e, a), vt("invalid", e);
          break;
        case "textarea":
          xf(e, a), s = Rf(e, a), vt("invalid", e);
          break;
        default:
          s = a;
      }
      switch (Cs(t, s), m1(t, e, i, s, u), t) {
        case "input":
          fi(e), Sf(e, a, !1);
          break;
        case "textarea":
          fi(e), Fp(e);
          break;
        case "option":
          Nm(e, a);
          break;
        case "select":
          Um(e, a);
          break;
        default:
          typeof s.onClick == "function" && ih(e);
          break;
      }
    }
    function E1(e, t, a, i, u) {
      th(t, i);
      var s = null, f, p;
      switch (t) {
        case "input":
          f = fs(e, a), p = fs(e, i), s = [];
          break;
        case "select":
          f = Tf(e, a), p = Tf(e, i), s = [];
          break;
        case "textarea":
          f = Rf(e, a), p = Rf(e, i), s = [];
          break;
        default:
          f = a, p = i, typeof f.onClick != "function" && typeof p.onClick == "function" && ih(e);
          break;
      }
      Cs(t, p);
      var v, m, y = null;
      for (v in f)
        if (!(p.hasOwnProperty(v) || !f.hasOwnProperty(v) || f[v] == null))
          if (v === Bo) {
            var R = f[v];
            for (m in R)
              R.hasOwnProperty(m) && (y || (y = {}), y[m] = "");
          } else v === _d || v === jo || v === Jv || v === Su || v === CC || (jn.hasOwnProperty(v) ? s || (s = []) : (s = s || []).push(v, null));
      for (v in p) {
        var E = p[v], b = f != null ? f[v] : void 0;
        if (!(!p.hasOwnProperty(v) || E === b || E == null && b == null))
          if (v === Bo)
            if (E && Object.freeze(E), b) {
              for (m in b)
                b.hasOwnProperty(m) && (!E || !E.hasOwnProperty(m)) && (y || (y = {}), y[m] = "");
              for (m in E)
                E.hasOwnProperty(m) && b[m] !== E[m] && (y || (y = {}), y[m] = E[m]);
            } else
              y || (s || (s = []), s.push(v, y)), y = E;
          else if (v === _d) {
            var L = E ? E[eh] : void 0, M = b ? b[eh] : void 0;
            L != null && M !== L && (s = s || []).push(v, L);
          } else v === jo ? (typeof E == "string" || typeof E == "number") && (s = s || []).push(v, "" + E) : v === Jv || v === Su || (jn.hasOwnProperty(v) ? (E != null && (typeof E != "function" && nh(v, E), v === "onScroll" && vt("scroll", e)), !s && b !== E && (s = [])) : (s = s || []).push(v, E));
      }
      return y && (Ym(y, p[Bo]), (s = s || []).push(Bo, y)), s;
    }
    function T1(e, t, a, i, u) {
      a === "input" && u.type === "radio" && u.name != null && ds(e, u);
      var s = di(a, i), f = di(a, u);
      switch (y1(e, t, s, f), a) {
        case "input":
          Gl(e, u);
          break;
        case "textarea":
          Hp(e, u);
          break;
        case "select":
          Am(e, u);
          break;
      }
    }
    function R1(e) {
      {
        var t = e.toLowerCase();
        return Zu.hasOwnProperty(t) && Zu[t] || null;
      }
    }
    function x1(e, t, a, i, u, s, f) {
      var p, v;
      switch (p = di(t, a), th(t, a), t) {
        case "dialog":
          vt("cancel", e), vt("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          vt("load", e);
          break;
        case "video":
        case "audio":
          for (var m = 0; m < Dd.length; m++)
            vt(Dd[m], e);
          break;
        case "source":
          vt("error", e);
          break;
        case "img":
        case "image":
        case "link":
          vt("error", e), vt("load", e);
          break;
        case "details":
          vt("toggle", e);
          break;
        case "input":
          Ua(e, a), vt("invalid", e);
          break;
        case "option":
          Wl(e, a);
          break;
        case "select":
          ys(e, a), vt("invalid", e);
          break;
        case "textarea":
          xf(e, a), vt("invalid", e);
          break;
      }
      Cs(t, a);
      {
        v = /* @__PURE__ */ new Set();
        for (var y = e.attributes, R = 0; R < y.length; R++) {
          var E = y[R].name.toLowerCase();
          switch (E) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              v.add(y[R].name);
          }
        }
      }
      var b = null;
      for (var L in a)
        if (a.hasOwnProperty(L)) {
          var M = a[L];
          if (L === jo)
            typeof M == "string" ? e.textContent !== M && (a[Su] !== !0 && ah(e.textContent, M, s, f), b = [jo, M]) : typeof M == "number" && e.textContent !== "" + M && (a[Su] !== !0 && ah(e.textContent, M, s, f), b = [jo, "" + M]);
          else if (jn.hasOwnProperty(L))
            M != null && (typeof M != "function" && nh(L, M), L === "onScroll" && vt("scroll", e));
          else if (f && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof p == "boolean") {
            var Q = void 0, ce = Mt(L);
            if (a[Su] !== !0) {
              if (!(L === Jv || L === Su || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              L === "value" || L === "checked" || L === "selected")) {
                if (L === _d) {
                  var re = e.innerHTML, Ue = M ? M[eh] : void 0;
                  if (Ue != null) {
                    var be = RC(e, Ue);
                    be !== re && Ld(L, re, be);
                  }
                } else if (L === Bo) {
                  if (v.delete(L), TC) {
                    var w = Pm(M);
                    Q = e.getAttribute("style"), w !== Q && Ld(L, Q, w);
                  }
                } else if (p)
                  v.delete(L.toLowerCase()), Q = af(e, L, M), M !== Q && Ld(L, Q, M);
                else if (!Pn(L, ce, p) && !$n(L, M, ce, p)) {
                  var O = !1;
                  if (ce !== null)
                    v.delete(ce.attributeName), Q = rf(e, L, M, ce);
                  else {
                    var D = i;
                    if (D === Aa && (D = kf(t)), D === Aa)
                      v.delete(L.toLowerCase());
                    else {
                      var V = R1(L);
                      V !== null && V !== L && (O = !0, v.delete(V)), v.delete(L);
                    }
                    Q = af(e, L, M);
                  }
                  var q = Ie;
                  !q && M !== Q && !O && Ld(L, Q, M);
                }
              }
            }
          }
        }
      switch (f && // $FlowFixMe - Should be inferred as not undefined.
      v.size > 0 && a[Su] !== !0 && EC(v), t) {
        case "input":
          fi(e), Sf(e, a, !0);
          break;
        case "textarea":
          fi(e), Fp(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof a.onClick == "function" && ih(e);
          break;
      }
      return b;
    }
    function w1(e, t, a) {
      var i = e.nodeValue !== t;
      return i;
    }
    function Sy(e, t) {
      {
        if (jr)
          return;
        jr = !0, S("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function Cy(e, t) {
      {
        if (jr)
          return;
        jr = !0, S('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function Ey(e, t, a) {
      {
        if (jr)
          return;
        jr = !0, S("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function Ty(e, t) {
      {
        if (t === "" || jr)
          return;
        jr = !0, S('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function D1(e, t, a) {
      switch (t) {
        case "input":
          ps(e, a);
          return;
        case "textarea":
          Fm(e, a);
          return;
        case "select":
          Hm(e, a);
          return;
      }
    }
    var Md = function() {
    }, Od = function() {
    };
    {
      var k1 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], wC = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], b1 = wC.concat(["button"]), _1 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], DC = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Od = function(e, t) {
        var a = Le({}, e || DC), i = {
          tag: t
        };
        return wC.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), b1.indexOf(t) !== -1 && (a.pTagInButtonScope = null), k1.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = i, t === "form" && (a.formTag = i), t === "a" && (a.aTagInScope = i), t === "button" && (a.buttonTagInScope = i), t === "nobr" && (a.nobrTagInScope = i), t === "p" && (a.pTagInButtonScope = i), t === "li" && (a.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = i), a;
      };
      var L1 = function(e, t) {
        switch (t) {
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          case "option":
            return e === "#text";
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          case "colgroup":
            return e === "col" || e === "template";
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return _1.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, M1 = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, kC = {};
      Md = function(e, t, a) {
        a = a || DC;
        var i = a.current, u = i && i.tag;
        t != null && (e != null && S("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var s = L1(e, u) ? null : i, f = s ? null : M1(e, a), p = s || f;
        if (p) {
          var v = p.tag, m = !!s + "|" + e + "|" + v;
          if (!kC[m]) {
            kC[m] = !0;
            var y = e, R = "";
            if (e === "#text" ? /\S/.test(t) ? y = "Text nodes" : (y = "Whitespace text nodes", R = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : y = "<" + e + ">", s) {
              var E = "";
              v === "table" && e === "tr" && (E += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), S("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", y, v, R, E);
            } else
              S("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", y, v);
          }
        }
      };
    }
    var lh = "suppressHydrationWarning", uh = "$", oh = "/$", Nd = "$?", zd = "$!", O1 = "style", Ry = null, xy = null;
    function N1(e) {
      var t, a, i = e.nodeType;
      switch (i) {
        case Fa:
        case _f: {
          t = i === Fa ? "#document" : "#fragment";
          var u = e.documentElement;
          a = u ? u.namespaceURI : bf(null, "");
          break;
        }
        default: {
          var s = i === Ot ? e.parentNode : e, f = s.namespaceURI || null;
          t = s.tagName, a = bf(f, t);
          break;
        }
      }
      {
        var p = t.toLowerCase(), v = Od(null, p);
        return {
          namespace: a,
          ancestorInfo: v
        };
      }
    }
    function z1(e, t, a) {
      {
        var i = e, u = bf(i.namespace, t), s = Od(i.ancestorInfo, t);
        return {
          namespace: u,
          ancestorInfo: s
        };
      }
    }
    function Vk(e) {
      return e;
    }
    function U1(e) {
      Ry = Ft(), xy = XT();
      var t = null;
      return Qt(!1), t;
    }
    function A1(e) {
      qT(xy), Qt(Ry), Ry = null, xy = null;
    }
    function H1(e, t, a, i, u) {
      var s;
      {
        var f = i;
        if (Md(e, null, f.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var p = "" + t.children, v = Od(f.ancestorInfo, e);
          Md(null, p, v);
        }
        s = f.namespace;
      }
      var m = g1(e, t, a, s);
      return Hd(u, m), Oy(m, t), m;
    }
    function F1(e, t) {
      e.appendChild(t);
    }
    function V1(e, t, a, i, u) {
      switch (C1(e, t, a, i), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!a.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function j1(e, t, a, i, u, s) {
      {
        var f = s;
        if (typeof i.children != typeof a.children && (typeof i.children == "string" || typeof i.children == "number")) {
          var p = "" + i.children, v = Od(f.ancestorInfo, t);
          Md(null, p, v);
        }
      }
      return E1(e, t, a, i);
    }
    function wy(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function B1(e, t, a, i) {
      {
        var u = a;
        Md(null, e, u.ancestorInfo);
      }
      var s = S1(e, t);
      return Hd(i, s), s;
    }
    function P1() {
      var e = window.event;
      return e === void 0 ? Ar : pc(e.type);
    }
    var Dy = typeof setTimeout == "function" ? setTimeout : void 0, $1 = typeof clearTimeout == "function" ? clearTimeout : void 0, ky = -1, bC = typeof Promise == "function" ? Promise : void 0, Y1 = typeof queueMicrotask == "function" ? queueMicrotask : typeof bC < "u" ? function(e) {
      return bC.resolve(null).then(e).catch(Q1);
    } : Dy;
    function Q1(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function I1(e, t, a, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          return;
        case "img": {
          a.src && (e.src = a.src);
          return;
        }
      }
    }
    function G1(e, t, a, i, u, s) {
      T1(e, t, a, i, u), Oy(e, u);
    }
    function _C(e) {
      ql(e, "");
    }
    function W1(e, t, a) {
      e.nodeValue = a;
    }
    function X1(e, t) {
      e.appendChild(t);
    }
    function q1(e, t) {
      var a;
      e.nodeType === Ot ? (a = e.parentNode, a.insertBefore(t, e)) : (a = e, a.appendChild(t));
      var i = e._reactRootContainer;
      i == null && a.onclick === null && ih(a);
    }
    function K1(e, t, a) {
      e.insertBefore(t, a);
    }
    function Z1(e, t, a) {
      e.nodeType === Ot ? e.parentNode.insertBefore(t, a) : e.insertBefore(t, a);
    }
    function J1(e, t) {
      e.removeChild(t);
    }
    function eR(e, t) {
      e.nodeType === Ot ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function by(e, t) {
      var a = t, i = 0;
      do {
        var u = a.nextSibling;
        if (e.removeChild(a), u && u.nodeType === Ot) {
          var s = u.data;
          if (s === oh)
            if (i === 0) {
              e.removeChild(u), Tl(t);
              return;
            } else
              i--;
          else (s === uh || s === Nd || s === zd) && i++;
        }
        a = u;
      } while (a);
      Tl(t);
    }
    function tR(e, t) {
      e.nodeType === Ot ? by(e.parentNode, t) : e.nodeType === Qn && by(e, t), Tl(e);
    }
    function nR(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function rR(e) {
      e.nodeValue = "";
    }
    function aR(e, t) {
      e = e;
      var a = t[O1], i = a != null && a.hasOwnProperty("display") ? a.display : null;
      e.style.display = Ss("display", i);
    }
    function iR(e, t) {
      e.nodeValue = t;
    }
    function lR(e) {
      e.nodeType === Qn ? e.textContent = "" : e.nodeType === Fa && e.documentElement && e.removeChild(e.documentElement);
    }
    function uR(e, t, a) {
      return e.nodeType !== Qn || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function oR(e, t) {
      return t === "" || e.nodeType !== Ha ? null : e;
    }
    function sR(e) {
      return e.nodeType !== Ot ? null : e;
    }
    function LC(e) {
      return e.data === Nd;
    }
    function _y(e) {
      return e.data === zd;
    }
    function cR(e) {
      var t = e.nextSibling && e.nextSibling.dataset, a, i, u;
      return t && (a = t.dgst, i = t.msg, u = t.stck), {
        message: i,
        digest: a,
        stack: u
      };
    }
    function fR(e, t) {
      e._reactRetry = t;
    }
    function sh(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === Qn || t === Ha)
          break;
        if (t === Ot) {
          var a = e.data;
          if (a === uh || a === zd || a === Nd)
            break;
          if (a === oh)
            return null;
        }
      }
      return e;
    }
    function Ud(e) {
      return sh(e.nextSibling);
    }
    function dR(e) {
      return sh(e.firstChild);
    }
    function pR(e) {
      return sh(e.firstChild);
    }
    function vR(e) {
      return sh(e.nextSibling);
    }
    function hR(e, t, a, i, u, s, f) {
      Hd(s, e), Oy(e, a);
      var p;
      {
        var v = u;
        p = v.namespace;
      }
      var m = (s.mode & xe) !== oe;
      return x1(e, t, a, p, i, m, f);
    }
    function mR(e, t, a, i) {
      return Hd(a, e), a.mode & xe, w1(e, t);
    }
    function yR(e, t) {
      Hd(t, e);
    }
    function gR(e) {
      for (var t = e.nextSibling, a = 0; t; ) {
        if (t.nodeType === Ot) {
          var i = t.data;
          if (i === oh) {
            if (a === 0)
              return Ud(t);
            a--;
          } else (i === uh || i === zd || i === Nd) && a++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function MC(e) {
      for (var t = e.previousSibling, a = 0; t; ) {
        if (t.nodeType === Ot) {
          var i = t.data;
          if (i === uh || i === zd || i === Nd) {
            if (a === 0)
              return t;
            a--;
          } else i === oh && a++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function SR(e) {
      Tl(e);
    }
    function CR(e) {
      Tl(e);
    }
    function ER(e) {
      return e !== "head" && e !== "body";
    }
    function TR(e, t, a, i) {
      var u = !0;
      ah(t.nodeValue, a, i, u);
    }
    function RR(e, t, a, i, u, s) {
      if (t[lh] !== !0) {
        var f = !0;
        ah(i.nodeValue, u, s, f);
      }
    }
    function xR(e, t) {
      t.nodeType === Qn ? Sy(e, t) : t.nodeType === Ot || Cy(e, t);
    }
    function wR(e, t) {
      {
        var a = e.parentNode;
        a !== null && (t.nodeType === Qn ? Sy(a, t) : t.nodeType === Ot || Cy(a, t));
      }
    }
    function DR(e, t, a, i, u) {
      (u || t[lh] !== !0) && (i.nodeType === Qn ? Sy(a, i) : i.nodeType === Ot || Cy(a, i));
    }
    function kR(e, t, a) {
      Ey(e, t);
    }
    function bR(e, t) {
      Ty(e, t);
    }
    function _R(e, t, a) {
      {
        var i = e.parentNode;
        i !== null && Ey(i, t);
      }
    }
    function LR(e, t) {
      {
        var a = e.parentNode;
        a !== null && Ty(a, t);
      }
    }
    function MR(e, t, a, i, u, s) {
      (s || t[lh] !== !0) && Ey(a, i);
    }
    function OR(e, t, a, i, u) {
      (u || t[lh] !== !0) && Ty(a, i);
    }
    function NR(e) {
      S("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function zR(e) {
      kd(e);
    }
    var bc = Math.random().toString(36).slice(2), _c = "__reactFiber$" + bc, Ly = "__reactProps$" + bc, Ad = "__reactContainer$" + bc, My = "__reactEvents$" + bc, UR = "__reactListeners$" + bc, AR = "__reactHandles$" + bc;
    function HR(e) {
      delete e[_c], delete e[Ly], delete e[My], delete e[UR], delete e[AR];
    }
    function Hd(e, t) {
      t[_c] = e;
    }
    function ch(e, t) {
      t[Ad] = e;
    }
    function OC(e) {
      e[Ad] = null;
    }
    function Fd(e) {
      return !!e[Ad];
    }
    function Po(e) {
      var t = e[_c];
      if (t)
        return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[Ad] || a[_c], t) {
          var i = t.alternate;
          if (t.child !== null || i !== null && i.child !== null)
            for (var u = MC(e); u !== null; ) {
              var s = u[_c];
              if (s)
                return s;
              u = MC(u);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function Cu(e) {
      var t = e[_c] || e[Ad];
      return t && (t.tag === ae || t.tag === He || t.tag === Me || t.tag === ne) ? t : null;
    }
    function Lc(e) {
      if (e.tag === ae || e.tag === He)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function fh(e) {
      return e[Ly] || null;
    }
    function Oy(e, t) {
      e[Ly] = t;
    }
    function FR(e) {
      var t = e[My];
      return t === void 0 && (t = e[My] = /* @__PURE__ */ new Set()), t;
    }
    var NC = {}, zC = N.ReactDebugCurrentFrame;
    function dh(e) {
      if (e) {
        var t = e._owner, a = Ki(e.type, e._source, t ? t.type : null);
        zC.setExtraStackFrame(a);
      } else
        zC.setExtraStackFrame(null);
    }
    function Xa(e, t, a, i, u) {
      {
        var s = Function.call.bind(ca);
        for (var f in e)
          if (s(e, f)) {
            var p = void 0;
            try {
              if (typeof e[f] != "function") {
                var v = Error((i || "React class") + ": " + a + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v.name = "Invariant Violation", v;
              }
              p = e[f](t, f, i, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (m) {
              p = m;
            }
            p && !(p instanceof Error) && (dh(u), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", a, f, typeof p), dh(null)), p instanceof Error && !(p.message in NC) && (NC[p.message] = !0, dh(u), S("Failed %s type: %s", a, p.message), dh(null));
          }
      }
    }
    var Ny = [], ph;
    ph = [];
    var kl = -1;
    function Eu(e) {
      return {
        current: e
      };
    }
    function nr(e, t) {
      if (kl < 0) {
        S("Unexpected pop.");
        return;
      }
      t !== ph[kl] && S("Unexpected Fiber popped."), e.current = Ny[kl], Ny[kl] = null, ph[kl] = null, kl--;
    }
    function rr(e, t, a) {
      kl++, Ny[kl] = e.current, ph[kl] = a, e.current = t;
    }
    var zy;
    zy = {};
    var la = {};
    Object.freeze(la);
    var bl = Eu(la), Oi = Eu(!1), Uy = la;
    function Mc(e, t, a) {
      return a && Ni(t) ? Uy : bl.current;
    }
    function UC(e, t, a) {
      {
        var i = e.stateNode;
        i.__reactInternalMemoizedUnmaskedChildContext = t, i.__reactInternalMemoizedMaskedChildContext = a;
      }
    }
    function Oc(e, t) {
      {
        var a = e.type, i = a.contextTypes;
        if (!i)
          return la;
        var u = e.stateNode;
        if (u && u.__reactInternalMemoizedUnmaskedChildContext === t)
          return u.__reactInternalMemoizedMaskedChildContext;
        var s = {};
        for (var f in i)
          s[f] = t[f];
        {
          var p = Te(e) || "Unknown";
          Xa(i, s, "context", p);
        }
        return u && UC(e, t, s), s;
      }
    }
    function vh() {
      return Oi.current;
    }
    function Ni(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function hh(e) {
      nr(Oi, e), nr(bl, e);
    }
    function Ay(e) {
      nr(Oi, e), nr(bl, e);
    }
    function AC(e, t, a) {
      {
        if (bl.current !== la)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        rr(bl, t, e), rr(Oi, a, e);
      }
    }
    function HC(e, t, a) {
      {
        var i = e.stateNode, u = t.childContextTypes;
        if (typeof i.getChildContext != "function") {
          {
            var s = Te(e) || "Unknown";
            zy[s] || (zy[s] = !0, S("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", s, s));
          }
          return a;
        }
        var f = i.getChildContext();
        for (var p in f)
          if (!(p in u))
            throw new Error((Te(e) || "Unknown") + '.getChildContext(): key "' + p + '" is not defined in childContextTypes.');
        {
          var v = Te(e) || "Unknown";
          Xa(u, f, "child context", v);
        }
        return Le({}, a, f);
      }
    }
    function mh(e) {
      {
        var t = e.stateNode, a = t && t.__reactInternalMemoizedMergedChildContext || la;
        return Uy = bl.current, rr(bl, a, e), rr(Oi, Oi.current, e), !0;
      }
    }
    function FC(e, t, a) {
      {
        var i = e.stateNode;
        if (!i)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (a) {
          var u = HC(e, t, Uy);
          i.__reactInternalMemoizedMergedChildContext = u, nr(Oi, e), nr(bl, e), rr(bl, u, e), rr(Oi, a, e);
        } else
          nr(Oi, e), rr(Oi, a, e);
      }
    }
    function VR(e) {
      {
        if (!ol(e) || e.tag !== fe)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case ne:
              return t.stateNode.context;
            case fe: {
              var a = t.type;
              if (Ni(a))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Tu = 0, yh = 1, _l = null, Hy = !1, Fy = !1;
    function VC(e) {
      _l === null ? _l = [e] : _l.push(e);
    }
    function jR(e) {
      Hy = !0, VC(e);
    }
    function jC() {
      Hy && Ru();
    }
    function Ru() {
      if (!Fy && _l !== null) {
        Fy = !0;
        var e = 0, t = Fr();
        try {
          var a = !0, i = _l;
          for (Ht(wn); e < i.length; e++) {
            var u = i[e];
            do
              u = u(a);
            while (u !== null);
          }
          _l = null, Hy = !1;
        } catch (s) {
          throw _l !== null && (_l = _l.slice(e + 1)), Bf(lo, Ru), s;
        } finally {
          Ht(t), Fy = !1;
        }
      }
      return null;
    }
    var Nc = [], zc = 0, gh = null, Sh = 0, Da = [], ka = 0, $o = null, Ll = 1, Ml = "";
    function BR(e) {
      return Qo(), (e.flags & ma) !== ue;
    }
    function PR(e) {
      return Qo(), Sh;
    }
    function $R() {
      var e = Ml, t = Ll, a = t & ~YR(t);
      return a.toString(32) + e;
    }
    function Yo(e, t) {
      Qo(), Nc[zc++] = Sh, Nc[zc++] = gh, gh = e, Sh = t;
    }
    function BC(e, t, a) {
      Qo(), Da[ka++] = Ll, Da[ka++] = Ml, Da[ka++] = $o, $o = e;
      var i = Ll, u = Ml, s = Ch(i) - 1, f = i & ~(1 << s), p = a + 1, v = Ch(t) + s;
      if (v > 30) {
        var m = s - s % 5, y = (1 << m) - 1, R = (f & y).toString(32), E = f >> m, b = s - m, L = Ch(t) + b, M = p << b, Q = M | E, ce = R + u;
        Ll = 1 << L | Q, Ml = ce;
      } else {
        var re = p << s, Ue = re | f, be = u;
        Ll = 1 << v | Ue, Ml = be;
      }
    }
    function Vy(e) {
      Qo();
      var t = e.return;
      if (t !== null) {
        var a = 1, i = 0;
        Yo(e, a), BC(e, a, i);
      }
    }
    function Ch(e) {
      return 32 - Ut(e);
    }
    function YR(e) {
      return 1 << Ch(e) - 1;
    }
    function jy(e) {
      for (; e === gh; )
        gh = Nc[--zc], Nc[zc] = null, Sh = Nc[--zc], Nc[zc] = null;
      for (; e === $o; )
        $o = Da[--ka], Da[ka] = null, Ml = Da[--ka], Da[ka] = null, Ll = Da[--ka], Da[ka] = null;
    }
    function QR() {
      return Qo(), $o !== null ? {
        id: Ll,
        overflow: Ml
      } : null;
    }
    function IR(e, t) {
      Qo(), Da[ka++] = Ll, Da[ka++] = Ml, Da[ka++] = $o, Ll = t.id, Ml = t.overflow, $o = e;
    }
    function Qo() {
      Ln() || S("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var _n = null, ba = null, qa = !1, Io = !1, xu = null;
    function GR() {
      qa && S("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function PC() {
      Io = !0;
    }
    function WR() {
      return Io;
    }
    function XR(e) {
      var t = e.stateNode.containerInfo;
      return ba = pR(t), _n = e, qa = !0, xu = null, Io = !1, !0;
    }
    function qR(e, t, a) {
      return ba = vR(t), _n = e, qa = !0, xu = null, Io = !1, a !== null && IR(e, a), !0;
    }
    function $C(e, t) {
      switch (e.tag) {
        case ne: {
          xR(e.stateNode.containerInfo, t);
          break;
        }
        case ae: {
          var a = (e.mode & xe) !== oe;
          DR(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            a
          );
          break;
        }
        case Me: {
          var i = e.memoizedState;
          i.dehydrated !== null && wR(i.dehydrated, t);
          break;
        }
      }
    }
    function YC(e, t) {
      $C(e, t);
      var a = ek();
      a.stateNode = t, a.return = e;
      var i = e.deletions;
      i === null ? (e.deletions = [a], e.flags |= Mr) : i.push(a);
    }
    function By(e, t) {
      {
        if (Io)
          return;
        switch (e.tag) {
          case ne: {
            var a = e.stateNode.containerInfo;
            switch (t.tag) {
              case ae:
                var i = t.type;
                t.pendingProps, kR(a, i);
                break;
              case He:
                var u = t.pendingProps;
                bR(a, u);
                break;
            }
            break;
          }
          case ae: {
            var s = e.type, f = e.memoizedProps, p = e.stateNode;
            switch (t.tag) {
              case ae: {
                var v = t.type, m = t.pendingProps, y = (e.mode & xe) !== oe;
                MR(
                  s,
                  f,
                  p,
                  v,
                  m,
                  // TODO: Delete this argument when we remove the legacy root API.
                  y
                );
                break;
              }
              case He: {
                var R = t.pendingProps, E = (e.mode & xe) !== oe;
                OR(
                  s,
                  f,
                  p,
                  R,
                  // TODO: Delete this argument when we remove the legacy root API.
                  E
                );
                break;
              }
            }
            break;
          }
          case Me: {
            var b = e.memoizedState, L = b.dehydrated;
            if (L !== null) switch (t.tag) {
              case ae:
                var M = t.type;
                t.pendingProps, _R(L, M);
                break;
              case He:
                var Q = t.pendingProps;
                LR(L, Q);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function QC(e, t) {
      t.flags = t.flags & -4097 | Et, By(e, t);
    }
    function IC(e, t) {
      switch (e.tag) {
        case ae: {
          var a = e.type;
          e.pendingProps;
          var i = uR(t, a);
          return i !== null ? (e.stateNode = i, _n = e, ba = dR(i), !0) : !1;
        }
        case He: {
          var u = e.pendingProps, s = oR(t, u);
          return s !== null ? (e.stateNode = s, _n = e, ba = null, !0) : !1;
        }
        case Me: {
          var f = sR(t);
          if (f !== null) {
            var p = {
              dehydrated: f,
              treeContext: QR(),
              retryLane: hr
            };
            e.memoizedState = p;
            var v = tk(f);
            return v.return = e, e.child = v, _n = e, ba = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function Py(e) {
      return (e.mode & xe) !== oe && (e.flags & ie) === ue;
    }
    function $y(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function Yy(e) {
      if (qa) {
        var t = ba;
        if (!t) {
          Py(e) && (By(_n, e), $y()), QC(_n, e), qa = !1, _n = e;
          return;
        }
        var a = t;
        if (!IC(e, t)) {
          Py(e) && (By(_n, e), $y()), t = Ud(a);
          var i = _n;
          if (!t || !IC(e, t)) {
            QC(_n, e), qa = !1, _n = e;
            return;
          }
          YC(i, a);
        }
      }
    }
    function KR(e, t, a) {
      var i = e.stateNode, u = !Io, s = hR(i, e.type, e.memoizedProps, t, a, e, u);
      return e.updateQueue = s, s !== null;
    }
    function ZR(e) {
      var t = e.stateNode, a = e.memoizedProps, i = mR(t, a, e);
      if (i) {
        var u = _n;
        if (u !== null)
          switch (u.tag) {
            case ne: {
              var s = u.stateNode.containerInfo, f = (u.mode & xe) !== oe;
              TR(
                s,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                f
              );
              break;
            }
            case ae: {
              var p = u.type, v = u.memoizedProps, m = u.stateNode, y = (u.mode & xe) !== oe;
              RR(
                p,
                v,
                m,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                y
              );
              break;
            }
          }
      }
      return i;
    }
    function JR(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      yR(a, e);
    }
    function ex(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return gR(a);
    }
    function GC(e) {
      for (var t = e.return; t !== null && t.tag !== ae && t.tag !== ne && t.tag !== Me; )
        t = t.return;
      _n = t;
    }
    function Eh(e) {
      if (e !== _n)
        return !1;
      if (!qa)
        return GC(e), qa = !0, !1;
      if (e.tag !== ne && (e.tag !== ae || ER(e.type) && !wy(e.type, e.memoizedProps))) {
        var t = ba;
        if (t)
          if (Py(e))
            WC(e), $y();
          else
            for (; t; )
              YC(e, t), t = Ud(t);
      }
      return GC(e), e.tag === Me ? ba = ex(e) : ba = _n ? Ud(e.stateNode) : null, !0;
    }
    function tx() {
      return qa && ba !== null;
    }
    function WC(e) {
      for (var t = ba; t; )
        $C(e, t), t = Ud(t);
    }
    function Uc() {
      _n = null, ba = null, qa = !1, Io = !1;
    }
    function XC() {
      xu !== null && (P0(xu), xu = null);
    }
    function Ln() {
      return qa;
    }
    function Qy(e) {
      xu === null ? xu = [e] : xu.push(e);
    }
    var nx = N.ReactCurrentBatchConfig, rx = null;
    function ax() {
      return nx.transition;
    }
    var Ka = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var ix = function(e) {
        for (var t = null, a = e; a !== null; )
          a.mode & Ke && (t = a), a = a.return;
        return t;
      }, Go = function(e) {
        var t = [];
        return e.forEach(function(a) {
          t.push(a);
        }), t.sort().join(", ");
      }, Vd = [], jd = [], Bd = [], Pd = [], $d = [], Yd = [], Wo = /* @__PURE__ */ new Set();
      Ka.recordUnsafeLifecycleWarnings = function(e, t) {
        Wo.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && Vd.push(e), e.mode & Ke && typeof t.UNSAFE_componentWillMount == "function" && jd.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Bd.push(e), e.mode & Ke && typeof t.UNSAFE_componentWillReceiveProps == "function" && Pd.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && $d.push(e), e.mode & Ke && typeof t.UNSAFE_componentWillUpdate == "function" && Yd.push(e));
      }, Ka.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        Vd.length > 0 && (Vd.forEach(function(E) {
          e.add(Te(E) || "Component"), Wo.add(E.type);
        }), Vd = []);
        var t = /* @__PURE__ */ new Set();
        jd.length > 0 && (jd.forEach(function(E) {
          t.add(Te(E) || "Component"), Wo.add(E.type);
        }), jd = []);
        var a = /* @__PURE__ */ new Set();
        Bd.length > 0 && (Bd.forEach(function(E) {
          a.add(Te(E) || "Component"), Wo.add(E.type);
        }), Bd = []);
        var i = /* @__PURE__ */ new Set();
        Pd.length > 0 && (Pd.forEach(function(E) {
          i.add(Te(E) || "Component"), Wo.add(E.type);
        }), Pd = []);
        var u = /* @__PURE__ */ new Set();
        $d.length > 0 && ($d.forEach(function(E) {
          u.add(Te(E) || "Component"), Wo.add(E.type);
        }), $d = []);
        var s = /* @__PURE__ */ new Set();
        if (Yd.length > 0 && (Yd.forEach(function(E) {
          s.add(Te(E) || "Component"), Wo.add(E.type);
        }), Yd = []), t.size > 0) {
          var f = Go(t);
          S(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, f);
        }
        if (i.size > 0) {
          var p = Go(i);
          S(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, p);
        }
        if (s.size > 0) {
          var v = Go(s);
          S(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, v);
        }
        if (e.size > 0) {
          var m = Go(e);
          bt(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, m);
        }
        if (a.size > 0) {
          var y = Go(a);
          bt(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, y);
        }
        if (u.size > 0) {
          var R = Go(u);
          bt(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, R);
        }
      };
      var Th = /* @__PURE__ */ new Map(), qC = /* @__PURE__ */ new Set();
      Ka.recordLegacyContextWarning = function(e, t) {
        var a = ix(e);
        if (a === null) {
          S("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!qC.has(e.type)) {
          var i = Th.get(a);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], Th.set(a, i)), i.push(e));
        }
      }, Ka.flushLegacyContextWarning = function() {
        Th.forEach(function(e, t) {
          if (e.length !== 0) {
            var a = e[0], i = /* @__PURE__ */ new Set();
            e.forEach(function(s) {
              i.add(Te(s) || "Component"), qC.add(s.type);
            });
            var u = Go(i);
            try {
              ut(a), S(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, u);
            } finally {
              St();
            }
          }
        });
      }, Ka.discardPendingWarnings = function() {
        Vd = [], jd = [], Bd = [], Pd = [], $d = [], Yd = [], Th = /* @__PURE__ */ new Map();
      };
    }
    var Iy, Gy, Wy, Xy, qy, KC = function(e, t) {
    };
    Iy = !1, Gy = !1, Wy = {}, Xy = {}, qy = {}, KC = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var a = Te(t) || "Component";
        Xy[a] || (Xy[a] = !0, S('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function lx(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function Qd(e, t, a) {
      var i = a.ref;
      if (i !== null && typeof i != "function" && typeof i != "object") {
        if ((e.mode & Ke || qe) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(a._owner && a._self && a._owner.stateNode !== a._self) && // Will already throw with "Function components cannot have string refs"
        !(a._owner && a._owner.tag !== fe) && // Will already warn with "Function components cannot be given refs"
        !(typeof a.type == "function" && !lx(a.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        a._owner) {
          var u = Te(e) || "Component";
          Wy[u] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', u, i), Wy[u] = !0);
        }
        if (a._owner) {
          var s = a._owner, f;
          if (s) {
            var p = s;
            if (p.tag !== fe)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            f = p.stateNode;
          }
          if (!f)
            throw new Error("Missing owner for string ref " + i + ". This error is likely caused by a bug in React. Please file an issue.");
          var v = f;
          Au(i, "ref");
          var m = "" + i;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === m)
            return t.ref;
          var y = function(R) {
            var E = v.refs;
            R === null ? delete E[m] : E[m] = R;
          };
          return y._stringRef = m, y;
        } else {
          if (typeof i != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!a._owner)
            throw new Error("Element ref was specified as a string (" + i + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return i;
    }
    function Rh(e, t) {
      var a = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead.");
    }
    function xh(e) {
      {
        var t = Te(e) || "Component";
        if (qy[t])
          return;
        qy[t] = !0, S("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function ZC(e) {
      var t = e._payload, a = e._init;
      return a(t);
    }
    function JC(e) {
      function t(w, O) {
        if (e) {
          var D = w.deletions;
          D === null ? (w.deletions = [O], w.flags |= Mr) : D.push(O);
        }
      }
      function a(w, O) {
        if (!e)
          return null;
        for (var D = O; D !== null; )
          t(w, D), D = D.sibling;
        return null;
      }
      function i(w, O) {
        for (var D = /* @__PURE__ */ new Map(), V = O; V !== null; )
          V.key !== null ? D.set(V.key, V) : D.set(V.index, V), V = V.sibling;
        return D;
      }
      function u(w, O) {
        var D = rs(w, O);
        return D.index = 0, D.sibling = null, D;
      }
      function s(w, O, D) {
        if (w.index = D, !e)
          return w.flags |= ma, O;
        var V = w.alternate;
        if (V !== null) {
          var q = V.index;
          return q < O ? (w.flags |= Et, O) : q;
        } else
          return w.flags |= Et, O;
      }
      function f(w) {
        return e && w.alternate === null && (w.flags |= Et), w;
      }
      function p(w, O, D, V) {
        if (O === null || O.tag !== He) {
          var q = QS(D, w.mode, V);
          return q.return = w, q;
        } else {
          var G = u(O, D);
          return G.return = w, G;
        }
      }
      function v(w, O, D, V) {
        var q = D.type;
        if (q === Pl)
          return y(w, O, D.props.children, V, D.key);
        if (O !== null && (O.elementType === q || // Keep this check inline so it only runs on the false path:
        aT(O, D) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof q == "object" && q !== null && q.$$typeof === mn && ZC(q) === O.type)) {
          var G = u(O, D.props);
          return G.ref = Qd(w, O, D), G.return = w, G._debugSource = D._source, G._debugOwner = D._owner, G;
        }
        var me = YS(D, w.mode, V);
        return me.ref = Qd(w, O, D), me.return = w, me;
      }
      function m(w, O, D, V) {
        if (O === null || O.tag !== Se || O.stateNode.containerInfo !== D.containerInfo || O.stateNode.implementation !== D.implementation) {
          var q = IS(D, w.mode, V);
          return q.return = w, q;
        } else {
          var G = u(O, D.children || []);
          return G.return = w, G;
        }
      }
      function y(w, O, D, V, q) {
        if (O === null || O.tag !== Xe) {
          var G = Uu(D, w.mode, V, q);
          return G.return = w, G;
        } else {
          var me = u(O, D);
          return me.return = w, me;
        }
      }
      function R(w, O, D) {
        if (typeof O == "string" && O !== "" || typeof O == "number") {
          var V = QS("" + O, w.mode, D);
          return V.return = w, V;
        }
        if (typeof O == "object" && O !== null) {
          switch (O.$$typeof) {
            case oi: {
              var q = YS(O, w.mode, D);
              return q.ref = Qd(w, null, O), q.return = w, q;
            }
            case Xr: {
              var G = IS(O, w.mode, D);
              return G.return = w, G;
            }
            case mn: {
              var me = O._payload, Ee = O._init;
              return R(w, Ee(me), D);
            }
          }
          if (en(O) || tt(O)) {
            var Je = Uu(O, w.mode, D, null);
            return Je.return = w, Je;
          }
          Rh(w, O);
        }
        return typeof O == "function" && xh(w), null;
      }
      function E(w, O, D, V) {
        var q = O !== null ? O.key : null;
        if (typeof D == "string" && D !== "" || typeof D == "number")
          return q !== null ? null : p(w, O, "" + D, V);
        if (typeof D == "object" && D !== null) {
          switch (D.$$typeof) {
            case oi:
              return D.key === q ? v(w, O, D, V) : null;
            case Xr:
              return D.key === q ? m(w, O, D, V) : null;
            case mn: {
              var G = D._payload, me = D._init;
              return E(w, O, me(G), V);
            }
          }
          if (en(D) || tt(D))
            return q !== null ? null : y(w, O, D, V, null);
          Rh(w, D);
        }
        return typeof D == "function" && xh(w), null;
      }
      function b(w, O, D, V, q) {
        if (typeof V == "string" && V !== "" || typeof V == "number") {
          var G = w.get(D) || null;
          return p(O, G, "" + V, q);
        }
        if (typeof V == "object" && V !== null) {
          switch (V.$$typeof) {
            case oi: {
              var me = w.get(V.key === null ? D : V.key) || null;
              return v(O, me, V, q);
            }
            case Xr: {
              var Ee = w.get(V.key === null ? D : V.key) || null;
              return m(O, Ee, V, q);
            }
            case mn:
              var Je = V._payload, Pe = V._init;
              return b(w, O, D, Pe(Je), q);
          }
          if (en(V) || tt(V)) {
            var Gt = w.get(D) || null;
            return y(O, Gt, V, q, null);
          }
          Rh(O, V);
        }
        return typeof V == "function" && xh(O), null;
      }
      function L(w, O, D) {
        {
          if (typeof w != "object" || w === null)
            return O;
          switch (w.$$typeof) {
            case oi:
            case Xr:
              KC(w, D);
              var V = w.key;
              if (typeof V != "string")
                break;
              if (O === null) {
                O = /* @__PURE__ */ new Set(), O.add(V);
                break;
              }
              if (!O.has(V)) {
                O.add(V);
                break;
              }
              S("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", V);
              break;
            case mn:
              var q = w._payload, G = w._init;
              L(G(q), O, D);
              break;
          }
        }
        return O;
      }
      function M(w, O, D, V) {
        for (var q = null, G = 0; G < D.length; G++) {
          var me = D[G];
          q = L(me, q, w);
        }
        for (var Ee = null, Je = null, Pe = O, Gt = 0, $e = 0, jt = null; Pe !== null && $e < D.length; $e++) {
          Pe.index > $e ? (jt = Pe, Pe = null) : jt = Pe.sibling;
          var ir = E(w, Pe, D[$e], V);
          if (ir === null) {
            Pe === null && (Pe = jt);
            break;
          }
          e && Pe && ir.alternate === null && t(w, Pe), Gt = s(ir, Gt, $e), Je === null ? Ee = ir : Je.sibling = ir, Je = ir, Pe = jt;
        }
        if ($e === D.length) {
          if (a(w, Pe), Ln()) {
            var Hn = $e;
            Yo(w, Hn);
          }
          return Ee;
        }
        if (Pe === null) {
          for (; $e < D.length; $e++) {
            var oa = R(w, D[$e], V);
            oa !== null && (Gt = s(oa, Gt, $e), Je === null ? Ee = oa : Je.sibling = oa, Je = oa);
          }
          if (Ln()) {
            var Er = $e;
            Yo(w, Er);
          }
          return Ee;
        }
        for (var Tr = i(w, Pe); $e < D.length; $e++) {
          var lr = b(Tr, w, $e, D[$e], V);
          lr !== null && (e && lr.alternate !== null && Tr.delete(lr.key === null ? $e : lr.key), Gt = s(lr, Gt, $e), Je === null ? Ee = lr : Je.sibling = lr, Je = lr);
        }
        if (e && Tr.forEach(function(ef) {
          return t(w, ef);
        }), Ln()) {
          var Fl = $e;
          Yo(w, Fl);
        }
        return Ee;
      }
      function Q(w, O, D, V) {
        var q = tt(D);
        if (typeof q != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          D[Symbol.toStringTag] === "Generator" && (Gy || S("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Gy = !0), D.entries === q && (Iy || S("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Iy = !0);
          var G = q.call(D);
          if (G)
            for (var me = null, Ee = G.next(); !Ee.done; Ee = G.next()) {
              var Je = Ee.value;
              me = L(Je, me, w);
            }
        }
        var Pe = q.call(D);
        if (Pe == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Gt = null, $e = null, jt = O, ir = 0, Hn = 0, oa = null, Er = Pe.next(); jt !== null && !Er.done; Hn++, Er = Pe.next()) {
          jt.index > Hn ? (oa = jt, jt = null) : oa = jt.sibling;
          var Tr = E(w, jt, Er.value, V);
          if (Tr === null) {
            jt === null && (jt = oa);
            break;
          }
          e && jt && Tr.alternate === null && t(w, jt), ir = s(Tr, ir, Hn), $e === null ? Gt = Tr : $e.sibling = Tr, $e = Tr, jt = oa;
        }
        if (Er.done) {
          if (a(w, jt), Ln()) {
            var lr = Hn;
            Yo(w, lr);
          }
          return Gt;
        }
        if (jt === null) {
          for (; !Er.done; Hn++, Er = Pe.next()) {
            var Fl = R(w, Er.value, V);
            Fl !== null && (ir = s(Fl, ir, Hn), $e === null ? Gt = Fl : $e.sibling = Fl, $e = Fl);
          }
          if (Ln()) {
            var ef = Hn;
            Yo(w, ef);
          }
          return Gt;
        }
        for (var Rp = i(w, jt); !Er.done; Hn++, Er = Pe.next()) {
          var Bi = b(Rp, w, Hn, Er.value, V);
          Bi !== null && (e && Bi.alternate !== null && Rp.delete(Bi.key === null ? Hn : Bi.key), ir = s(Bi, ir, Hn), $e === null ? Gt = Bi : $e.sibling = Bi, $e = Bi);
        }
        if (e && Rp.forEach(function(Ok) {
          return t(w, Ok);
        }), Ln()) {
          var Mk = Hn;
          Yo(w, Mk);
        }
        return Gt;
      }
      function ce(w, O, D, V) {
        if (O !== null && O.tag === He) {
          a(w, O.sibling);
          var q = u(O, D);
          return q.return = w, q;
        }
        a(w, O);
        var G = QS(D, w.mode, V);
        return G.return = w, G;
      }
      function re(w, O, D, V) {
        for (var q = D.key, G = O; G !== null; ) {
          if (G.key === q) {
            var me = D.type;
            if (me === Pl) {
              if (G.tag === Xe) {
                a(w, G.sibling);
                var Ee = u(G, D.props.children);
                return Ee.return = w, Ee._debugSource = D._source, Ee._debugOwner = D._owner, Ee;
              }
            } else if (G.elementType === me || // Keep this check inline so it only runs on the false path:
            aT(G, D) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof me == "object" && me !== null && me.$$typeof === mn && ZC(me) === G.type) {
              a(w, G.sibling);
              var Je = u(G, D.props);
              return Je.ref = Qd(w, G, D), Je.return = w, Je._debugSource = D._source, Je._debugOwner = D._owner, Je;
            }
            a(w, G);
            break;
          } else
            t(w, G);
          G = G.sibling;
        }
        if (D.type === Pl) {
          var Pe = Uu(D.props.children, w.mode, V, D.key);
          return Pe.return = w, Pe;
        } else {
          var Gt = YS(D, w.mode, V);
          return Gt.ref = Qd(w, O, D), Gt.return = w, Gt;
        }
      }
      function Ue(w, O, D, V) {
        for (var q = D.key, G = O; G !== null; ) {
          if (G.key === q)
            if (G.tag === Se && G.stateNode.containerInfo === D.containerInfo && G.stateNode.implementation === D.implementation) {
              a(w, G.sibling);
              var me = u(G, D.children || []);
              return me.return = w, me;
            } else {
              a(w, G);
              break;
            }
          else
            t(w, G);
          G = G.sibling;
        }
        var Ee = IS(D, w.mode, V);
        return Ee.return = w, Ee;
      }
      function be(w, O, D, V) {
        var q = typeof D == "object" && D !== null && D.type === Pl && D.key === null;
        if (q && (D = D.props.children), typeof D == "object" && D !== null) {
          switch (D.$$typeof) {
            case oi:
              return f(re(w, O, D, V));
            case Xr:
              return f(Ue(w, O, D, V));
            case mn:
              var G = D._payload, me = D._init;
              return be(w, O, me(G), V);
          }
          if (en(D))
            return M(w, O, D, V);
          if (tt(D))
            return Q(w, O, D, V);
          Rh(w, D);
        }
        return typeof D == "string" && D !== "" || typeof D == "number" ? f(ce(w, O, "" + D, V)) : (typeof D == "function" && xh(w), a(w, O));
      }
      return be;
    }
    var Ac = JC(!0), eE = JC(!1);
    function ux(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var a = t.child, i = rs(a, a.pendingProps);
        for (t.child = i, i.return = t; a.sibling !== null; )
          a = a.sibling, i = i.sibling = rs(a, a.pendingProps), i.return = t;
        i.sibling = null;
      }
    }
    function ox(e, t) {
      for (var a = e.child; a !== null; )
        XD(a, t), a = a.sibling;
    }
    var Ky = Eu(null), Zy;
    Zy = {};
    var wh = null, Hc = null, Jy = null, Dh = !1;
    function kh() {
      wh = null, Hc = null, Jy = null, Dh = !1;
    }
    function tE() {
      Dh = !0;
    }
    function nE() {
      Dh = !1;
    }
    function rE(e, t, a) {
      rr(Ky, t._currentValue, e), t._currentValue = a, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== Zy && S("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = Zy;
    }
    function eg(e, t) {
      var a = Ky.current;
      nr(Ky, t), e._currentValue = a;
    }
    function tg(e, t, a) {
      for (var i = e; i !== null; ) {
        var u = i.alternate;
        if (El(i.childLanes, t) ? u !== null && !El(u.childLanes, t) && (u.childLanes = Re(u.childLanes, t)) : (i.childLanes = Re(i.childLanes, t), u !== null && (u.childLanes = Re(u.childLanes, t))), i === a)
          break;
        i = i.return;
      }
      i !== a && S("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function sx(e, t, a) {
      cx(e, t, a);
    }
    function cx(e, t, a) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null; ) {
        var u = void 0, s = i.dependencies;
        if (s !== null) {
          u = i.child;
          for (var f = s.firstContext; f !== null; ) {
            if (f.context === t) {
              if (i.tag === fe) {
                var p = Eo(a), v = Ol(nt, p);
                v.tag = _h;
                var m = i.updateQueue;
                if (m !== null) {
                  var y = m.shared, R = y.pending;
                  R === null ? v.next = v : (v.next = R.next, R.next = v), y.pending = v;
                }
              }
              i.lanes = Re(i.lanes, a);
              var E = i.alternate;
              E !== null && (E.lanes = Re(E.lanes, a)), tg(i.return, a, e), s.lanes = Re(s.lanes, a);
              break;
            }
            f = f.next;
          }
        } else if (i.tag === Cn)
          u = i.type === e.type ? null : i.child;
        else if (i.tag === Wt) {
          var b = i.return;
          if (b === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          b.lanes = Re(b.lanes, a);
          var L = b.alternate;
          L !== null && (L.lanes = Re(L.lanes, a)), tg(b, a, e), u = i.sibling;
        } else
          u = i.child;
        if (u !== null)
          u.return = i;
        else
          for (u = i; u !== null; ) {
            if (u === e) {
              u = null;
              break;
            }
            var M = u.sibling;
            if (M !== null) {
              M.return = u.return, u = M;
              break;
            }
            u = u.return;
          }
        i = u;
      }
    }
    function Fc(e, t) {
      wh = e, Hc = null, Jy = null;
      var a = e.dependencies;
      if (a !== null) {
        var i = a.firstContext;
        i !== null && (Zn(a.lanes, t) && lp(), a.firstContext = null);
      }
    }
    function Kt(e) {
      Dh && S("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (Jy !== e) {
        var a = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (Hc === null) {
          if (wh === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Hc = a, wh.dependencies = {
            lanes: U,
            firstContext: a
          };
        } else
          Hc = Hc.next = a;
      }
      return t;
    }
    var Xo = null;
    function ng(e) {
      Xo === null ? Xo = [e] : Xo.push(e);
    }
    function fx() {
      if (Xo !== null) {
        for (var e = 0; e < Xo.length; e++) {
          var t = Xo[e], a = t.interleaved;
          if (a !== null) {
            t.interleaved = null;
            var i = a.next, u = t.pending;
            if (u !== null) {
              var s = u.next;
              u.next = i, a.next = s;
            }
            t.pending = a;
          }
        }
        Xo = null;
      }
    }
    function aE(e, t, a, i) {
      var u = t.interleaved;
      return u === null ? (a.next = a, ng(t)) : (a.next = u.next, u.next = a), t.interleaved = a, bh(e, i);
    }
    function dx(e, t, a, i) {
      var u = t.interleaved;
      u === null ? (a.next = a, ng(t)) : (a.next = u.next, u.next = a), t.interleaved = a;
    }
    function px(e, t, a, i) {
      var u = t.interleaved;
      return u === null ? (a.next = a, ng(t)) : (a.next = u.next, u.next = a), t.interleaved = a, bh(e, i);
    }
    function Br(e, t) {
      return bh(e, t);
    }
    var vx = bh;
    function bh(e, t) {
      e.lanes = Re(e.lanes, t);
      var a = e.alternate;
      a !== null && (a.lanes = Re(a.lanes, t)), a === null && (e.flags & (Et | Or)) !== ue && eT(e);
      for (var i = e, u = e.return; u !== null; )
        u.childLanes = Re(u.childLanes, t), a = u.alternate, a !== null ? a.childLanes = Re(a.childLanes, t) : (u.flags & (Et | Or)) !== ue && eT(e), i = u, u = u.return;
      if (i.tag === ne) {
        var s = i.stateNode;
        return s;
      } else
        return null;
    }
    var iE = 0, lE = 1, _h = 2, rg = 3, Lh = !1, ag, Mh;
    ag = !1, Mh = null;
    function ig(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: U
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function uE(e, t) {
      var a = t.updateQueue, i = e.updateQueue;
      if (a === i) {
        var u = {
          baseState: i.baseState,
          firstBaseUpdate: i.firstBaseUpdate,
          lastBaseUpdate: i.lastBaseUpdate,
          shared: i.shared,
          effects: i.effects
        };
        t.updateQueue = u;
      }
    }
    function Ol(e, t) {
      var a = {
        eventTime: e,
        lane: t,
        tag: iE,
        payload: null,
        callback: null,
        next: null
      };
      return a;
    }
    function wu(e, t, a) {
      var i = e.updateQueue;
      if (i === null)
        return null;
      var u = i.shared;
      if (Mh === u && !ag && (S("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), ag = !0), dD()) {
        var s = u.pending;
        return s === null ? t.next = t : (t.next = s.next, s.next = t), u.pending = t, vx(e, a);
      } else
        return px(e, u, t, a);
    }
    function Oh(e, t, a) {
      var i = t.updateQueue;
      if (i !== null) {
        var u = i.shared;
        if (ad(a)) {
          var s = u.lanes;
          s = ld(s, e.pendingLanes);
          var f = Re(s, a);
          u.lanes = f, sc(e, f);
        }
      }
    }
    function lg(e, t) {
      var a = e.updateQueue, i = e.alternate;
      if (i !== null) {
        var u = i.updateQueue;
        if (a === u) {
          var s = null, f = null, p = a.firstBaseUpdate;
          if (p !== null) {
            var v = p;
            do {
              var m = {
                eventTime: v.eventTime,
                lane: v.lane,
                tag: v.tag,
                payload: v.payload,
                callback: v.callback,
                next: null
              };
              f === null ? s = f = m : (f.next = m, f = m), v = v.next;
            } while (v !== null);
            f === null ? s = f = t : (f.next = t, f = t);
          } else
            s = f = t;
          a = {
            baseState: u.baseState,
            firstBaseUpdate: s,
            lastBaseUpdate: f,
            shared: u.shared,
            effects: u.effects
          }, e.updateQueue = a;
          return;
        }
      }
      var y = a.lastBaseUpdate;
      y === null ? a.firstBaseUpdate = t : y.next = t, a.lastBaseUpdate = t;
    }
    function hx(e, t, a, i, u, s) {
      switch (a.tag) {
        case lE: {
          var f = a.payload;
          if (typeof f == "function") {
            tE();
            var p = f.call(s, i, u);
            {
              if (e.mode & Ke) {
                dt(!0);
                try {
                  f.call(s, i, u);
                } finally {
                  dt(!1);
                }
              }
              nE();
            }
            return p;
          }
          return f;
        }
        case rg:
          e.flags = e.flags & -65537 | ie;
        case iE: {
          var v = a.payload, m;
          if (typeof v == "function") {
            tE(), m = v.call(s, i, u);
            {
              if (e.mode & Ke) {
                dt(!0);
                try {
                  v.call(s, i, u);
                } finally {
                  dt(!1);
                }
              }
              nE();
            }
          } else
            m = v;
          return m == null ? i : Le({}, i, m);
        }
        case _h:
          return Lh = !0, i;
      }
      return i;
    }
    function Nh(e, t, a, i) {
      var u = e.updateQueue;
      Lh = !1, Mh = u.shared;
      var s = u.firstBaseUpdate, f = u.lastBaseUpdate, p = u.shared.pending;
      if (p !== null) {
        u.shared.pending = null;
        var v = p, m = v.next;
        v.next = null, f === null ? s = m : f.next = m, f = v;
        var y = e.alternate;
        if (y !== null) {
          var R = y.updateQueue, E = R.lastBaseUpdate;
          E !== f && (E === null ? R.firstBaseUpdate = m : E.next = m, R.lastBaseUpdate = v);
        }
      }
      if (s !== null) {
        var b = u.baseState, L = U, M = null, Q = null, ce = null, re = s;
        do {
          var Ue = re.lane, be = re.eventTime;
          if (El(i, Ue)) {
            if (ce !== null) {
              var O = {
                eventTime: be,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Fe,
                tag: re.tag,
                payload: re.payload,
                callback: re.callback,
                next: null
              };
              ce = ce.next = O;
            }
            b = hx(e, u, re, b, t, a);
            var D = re.callback;
            if (D !== null && // If the update was already committed, we should not queue its
            // callback again.
            re.lane !== Fe) {
              e.flags |= rt;
              var V = u.effects;
              V === null ? u.effects = [re] : V.push(re);
            }
          } else {
            var w = {
              eventTime: be,
              lane: Ue,
              tag: re.tag,
              payload: re.payload,
              callback: re.callback,
              next: null
            };
            ce === null ? (Q = ce = w, M = b) : ce = ce.next = w, L = Re(L, Ue);
          }
          if (re = re.next, re === null) {
            if (p = u.shared.pending, p === null)
              break;
            var q = p, G = q.next;
            q.next = null, re = G, u.lastBaseUpdate = q, u.shared.pending = null;
          }
        } while (!0);
        ce === null && (M = b), u.baseState = M, u.firstBaseUpdate = Q, u.lastBaseUpdate = ce;
        var me = u.shared.interleaved;
        if (me !== null) {
          var Ee = me;
          do
            L = Re(L, Ee.lane), Ee = Ee.next;
          while (Ee !== me);
        } else s === null && (u.shared.lanes = U);
        gp(L), e.lanes = L, e.memoizedState = b;
      }
      Mh = null;
    }
    function mx(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function oE() {
      Lh = !1;
    }
    function zh() {
      return Lh;
    }
    function sE(e, t, a) {
      var i = t.effects;
      if (t.effects = null, i !== null)
        for (var u = 0; u < i.length; u++) {
          var s = i[u], f = s.callback;
          f !== null && (s.callback = null, mx(f, a));
        }
    }
    var Id = {}, Du = Eu(Id), Gd = Eu(Id), Uh = Eu(Id);
    function Ah(e) {
      if (e === Id)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function cE() {
      var e = Ah(Uh.current);
      return e;
    }
    function ug(e, t) {
      rr(Uh, t, e), rr(Gd, e, e), rr(Du, Id, e);
      var a = N1(t);
      nr(Du, e), rr(Du, a, e);
    }
    function Vc(e) {
      nr(Du, e), nr(Gd, e), nr(Uh, e);
    }
    function og() {
      var e = Ah(Du.current);
      return e;
    }
    function fE(e) {
      Ah(Uh.current);
      var t = Ah(Du.current), a = z1(t, e.type);
      t !== a && (rr(Gd, e, e), rr(Du, a, e));
    }
    function sg(e) {
      Gd.current === e && (nr(Du, e), nr(Gd, e));
    }
    var yx = 0, dE = 1, pE = 1, Wd = 2, Za = Eu(yx);
    function cg(e, t) {
      return (e & t) !== 0;
    }
    function jc(e) {
      return e & dE;
    }
    function fg(e, t) {
      return e & dE | t;
    }
    function gx(e, t) {
      return e | t;
    }
    function ku(e, t) {
      rr(Za, t, e);
    }
    function Bc(e) {
      nr(Za, e);
    }
    function Sx(e, t) {
      var a = e.memoizedState;
      return a !== null ? a.dehydrated !== null : (e.memoizedProps, !0);
    }
    function Hh(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === Me) {
          var a = t.memoizedState;
          if (a !== null) {
            var i = a.dehydrated;
            if (i === null || LC(i) || _y(i))
              return t;
          }
        } else if (t.tag === Bt && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var u = (t.flags & ie) !== ue;
          if (u)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var Pr = (
      /*   */
      0
    ), ln = (
      /* */
      1
    ), zi = (
      /*  */
      2
    ), un = (
      /*    */
      4
    ), Mn = (
      /*   */
      8
    ), dg = [];
    function pg() {
      for (var e = 0; e < dg.length; e++) {
        var t = dg[e];
        t._workInProgressVersionPrimary = null;
      }
      dg.length = 0;
    }
    function Cx(e, t) {
      var a = t._getVersion, i = a(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, i] : e.mutableSourceEagerHydrationData.push(t, i);
    }
    var X = N.ReactCurrentDispatcher, Xd = N.ReactCurrentBatchConfig, vg, Pc;
    vg = /* @__PURE__ */ new Set();
    var qo = U, Ze = null, on = null, sn = null, Fh = !1, qd = !1, Kd = 0, Ex = 0, Tx = 25, z = null, _a = null, bu = -1, hg = !1;
    function Qe() {
      {
        var e = z;
        _a === null ? _a = [e] : _a.push(e);
      }
    }
    function B() {
      {
        var e = z;
        _a !== null && (bu++, _a[bu] !== e && Rx(e));
      }
    }
    function $c(e) {
      e != null && !en(e) && S("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", z, typeof e);
    }
    function Rx(e) {
      {
        var t = Te(Ze);
        if (!vg.has(t) && (vg.add(t), _a !== null)) {
          for (var a = "", i = 30, u = 0; u <= bu; u++) {
            for (var s = _a[u], f = u === bu ? e : s, p = u + 1 + ". " + s; p.length < i; )
              p += " ";
            p += f + `
`, a += p;
          }
          S(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, a);
        }
      }
    }
    function ar() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function mg(e, t) {
      if (hg)
        return !1;
      if (t === null)
        return S("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", z), !1;
      e.length !== t.length && S(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, z, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!I(e[a], t[a]))
          return !1;
      return !0;
    }
    function Yc(e, t, a, i, u, s) {
      qo = s, Ze = t, _a = e !== null ? e._debugHookTypes : null, bu = -1, hg = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = U, e !== null && e.memoizedState !== null ? X.current = UE : _a !== null ? X.current = zE : X.current = NE;
      var f = a(i, u);
      if (qd) {
        var p = 0;
        do {
          if (qd = !1, Kd = 0, p >= Tx)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          p += 1, hg = !1, on = null, sn = null, t.updateQueue = null, bu = -1, X.current = AE, f = a(i, u);
        } while (qd);
      }
      X.current = Kh, t._debugHookTypes = _a;
      var v = on !== null && on.next !== null;
      if (qo = U, Ze = null, on = null, sn = null, z = null, _a = null, bu = -1, e !== null && (e.flags & zt) !== (t.flags & zt) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & xe) !== oe && S("Internal React error: Expected static flag was missing. Please notify the React team."), Fh = !1, v)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return f;
    }
    function Qc() {
      var e = Kd !== 0;
      return Kd = 0, e;
    }
    function vE(e, t, a) {
      t.updateQueue = e.updateQueue, (t.mode & je) !== oe ? t.flags &= -50333701 : t.flags &= -2053, e.lanes = To(e.lanes, a);
    }
    function hE() {
      if (X.current = Kh, Fh) {
        for (var e = Ze.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        Fh = !1;
      }
      qo = U, Ze = null, on = null, sn = null, _a = null, bu = -1, z = null, bE = !1, qd = !1, Kd = 0;
    }
    function Ui() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return sn === null ? Ze.memoizedState = sn = e : sn = sn.next = e, sn;
    }
    function La() {
      var e;
      if (on === null) {
        var t = Ze.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = on.next;
      var a;
      if (sn === null ? a = Ze.memoizedState : a = sn.next, a !== null)
        sn = a, a = sn.next, on = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        on = e;
        var i = {
          memoizedState: on.memoizedState,
          baseState: on.baseState,
          baseQueue: on.baseQueue,
          queue: on.queue,
          next: null
        };
        sn === null ? Ze.memoizedState = sn = i : sn = sn.next = i;
      }
      return sn;
    }
    function mE() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function yg(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function gg(e, t, a) {
      var i = Ui(), u;
      a !== void 0 ? u = a(t) : u = t, i.memoizedState = i.baseState = u;
      var s = {
        pending: null,
        interleaved: null,
        lanes: U,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: u
      };
      i.queue = s;
      var f = s.dispatch = kx.bind(null, Ze, s);
      return [i.memoizedState, f];
    }
    function Sg(e, t, a) {
      var i = La(), u = i.queue;
      if (u === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      u.lastRenderedReducer = e;
      var s = on, f = s.baseQueue, p = u.pending;
      if (p !== null) {
        if (f !== null) {
          var v = f.next, m = p.next;
          f.next = m, p.next = v;
        }
        s.baseQueue !== f && S("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), s.baseQueue = f = p, u.pending = null;
      }
      if (f !== null) {
        var y = f.next, R = s.baseState, E = null, b = null, L = null, M = y;
        do {
          var Q = M.lane;
          if (El(qo, Q)) {
            if (L !== null) {
              var re = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Fe,
                action: M.action,
                hasEagerState: M.hasEagerState,
                eagerState: M.eagerState,
                next: null
              };
              L = L.next = re;
            }
            if (M.hasEagerState)
              R = M.eagerState;
            else {
              var Ue = M.action;
              R = e(R, Ue);
            }
          } else {
            var ce = {
              lane: Q,
              action: M.action,
              hasEagerState: M.hasEagerState,
              eagerState: M.eagerState,
              next: null
            };
            L === null ? (b = L = ce, E = R) : L = L.next = ce, Ze.lanes = Re(Ze.lanes, Q), gp(Q);
          }
          M = M.next;
        } while (M !== null && M !== y);
        L === null ? E = R : L.next = b, I(R, i.memoizedState) || lp(), i.memoizedState = R, i.baseState = E, i.baseQueue = L, u.lastRenderedState = R;
      }
      var be = u.interleaved;
      if (be !== null) {
        var w = be;
        do {
          var O = w.lane;
          Ze.lanes = Re(Ze.lanes, O), gp(O), w = w.next;
        } while (w !== be);
      } else f === null && (u.lanes = U);
      var D = u.dispatch;
      return [i.memoizedState, D];
    }
    function Cg(e, t, a) {
      var i = La(), u = i.queue;
      if (u === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      u.lastRenderedReducer = e;
      var s = u.dispatch, f = u.pending, p = i.memoizedState;
      if (f !== null) {
        u.pending = null;
        var v = f.next, m = v;
        do {
          var y = m.action;
          p = e(p, y), m = m.next;
        } while (m !== v);
        I(p, i.memoizedState) || lp(), i.memoizedState = p, i.baseQueue === null && (i.baseState = p), u.lastRenderedState = p;
      }
      return [p, s];
    }
    function jk(e, t, a) {
    }
    function Bk(e, t, a) {
    }
    function Eg(e, t, a) {
      var i = Ze, u = Ui(), s, f = Ln();
      if (f) {
        if (a === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        s = a(), Pc || s !== a() && (S("The result of getServerSnapshot should be cached to avoid an infinite loop"), Pc = !0);
      } else {
        if (s = t(), !Pc) {
          var p = t();
          I(s, p) || (S("The result of getSnapshot should be cached to avoid an infinite loop"), Pc = !0);
        }
        var v = mm();
        if (v === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        uc(v, qo) || yE(i, t, s);
      }
      u.memoizedState = s;
      var m = {
        value: s,
        getSnapshot: t
      };
      return u.queue = m, $h(SE.bind(null, i, m, e), [e]), i.flags |= Gn, Zd(ln | Mn, gE.bind(null, i, m, s, t), void 0, null), s;
    }
    function Vh(e, t, a) {
      var i = Ze, u = La(), s = t();
      if (!Pc) {
        var f = t();
        I(s, f) || (S("The result of getSnapshot should be cached to avoid an infinite loop"), Pc = !0);
      }
      var p = u.memoizedState, v = !I(p, s);
      v && (u.memoizedState = s, lp());
      var m = u.queue;
      if (ep(SE.bind(null, i, m, e), [e]), m.getSnapshot !== t || v || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      sn !== null && sn.memoizedState.tag & ln) {
        i.flags |= Gn, Zd(ln | Mn, gE.bind(null, i, m, s, t), void 0, null);
        var y = mm();
        if (y === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        uc(y, qo) || yE(i, t, s);
      }
      return s;
    }
    function yE(e, t, a) {
      e.flags |= iu;
      var i = {
        getSnapshot: t,
        value: a
      }, u = Ze.updateQueue;
      if (u === null)
        u = mE(), Ze.updateQueue = u, u.stores = [i];
      else {
        var s = u.stores;
        s === null ? u.stores = [i] : s.push(i);
      }
    }
    function gE(e, t, a, i) {
      t.value = a, t.getSnapshot = i, CE(t) && EE(e);
    }
    function SE(e, t, a) {
      var i = function() {
        CE(t) && EE(e);
      };
      return a(i);
    }
    function CE(e) {
      var t = e.getSnapshot, a = e.value;
      try {
        var i = t();
        return !I(a, i);
      } catch {
        return !0;
      }
    }
    function EE(e) {
      var t = Br(e, he);
      t !== null && pn(t, e, he, nt);
    }
    function jh(e) {
      var t = Ui();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        interleaved: null,
        lanes: U,
        dispatch: null,
        lastRenderedReducer: yg,
        lastRenderedState: e
      };
      t.queue = a;
      var i = a.dispatch = bx.bind(null, Ze, a);
      return [t.memoizedState, i];
    }
    function Tg(e) {
      return Sg(yg);
    }
    function Rg(e) {
      return Cg(yg);
    }
    function Zd(e, t, a, i) {
      var u = {
        tag: e,
        create: t,
        destroy: a,
        deps: i,
        // Circular
        next: null
      }, s = Ze.updateQueue;
      if (s === null)
        s = mE(), Ze.updateQueue = s, s.lastEffect = u.next = u;
      else {
        var f = s.lastEffect;
        if (f === null)
          s.lastEffect = u.next = u;
        else {
          var p = f.next;
          f.next = u, u.next = p, s.lastEffect = u;
        }
      }
      return u;
    }
    function xg(e) {
      var t = Ui();
      {
        var a = {
          current: e
        };
        return t.memoizedState = a, a;
      }
    }
    function Bh(e) {
      var t = La();
      return t.memoizedState;
    }
    function Jd(e, t, a, i) {
      var u = Ui(), s = i === void 0 ? null : i;
      Ze.flags |= e, u.memoizedState = Zd(ln | t, a, void 0, s);
    }
    function Ph(e, t, a, i) {
      var u = La(), s = i === void 0 ? null : i, f = void 0;
      if (on !== null) {
        var p = on.memoizedState;
        if (f = p.destroy, s !== null) {
          var v = p.deps;
          if (mg(s, v)) {
            u.memoizedState = Zd(t, a, f, s);
            return;
          }
        }
      }
      Ze.flags |= e, u.memoizedState = Zd(ln | t, a, f, s);
    }
    function $h(e, t) {
      return (Ze.mode & je) !== oe ? Jd(ya | Gn | zs, Mn, e, t) : Jd(Gn | zs, Mn, e, t);
    }
    function ep(e, t) {
      return Ph(Gn, Mn, e, t);
    }
    function wg(e, t) {
      return Jd(Oe, zi, e, t);
    }
    function Yh(e, t) {
      return Ph(Oe, zi, e, t);
    }
    function Dg(e, t) {
      var a = Oe;
      return a |= ja, (Ze.mode & je) !== oe && (a |= mi), Jd(a, un, e, t);
    }
    function Qh(e, t) {
      return Ph(Oe, un, e, t);
    }
    function TE(e, t) {
      if (typeof t == "function") {
        var a = t, i = e();
        return a(i), function() {
          a(null);
        };
      } else if (t != null) {
        var u = t;
        u.hasOwnProperty("current") || S("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(u).join(", ") + "}");
        var s = e();
        return u.current = s, function() {
          u.current = null;
        };
      }
    }
    function kg(e, t, a) {
      typeof t != "function" && S("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null, u = Oe;
      return u |= ja, (Ze.mode & je) !== oe && (u |= mi), Jd(u, un, TE.bind(null, t, e), i);
    }
    function Ih(e, t, a) {
      typeof t != "function" && S("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null;
      return Ph(Oe, un, TE.bind(null, t, e), i);
    }
    function xx(e, t) {
    }
    var Gh = xx;
    function bg(e, t) {
      var a = Ui(), i = t === void 0 ? null : t;
      return a.memoizedState = [e, i], e;
    }
    function Wh(e, t) {
      var a = La(), i = t === void 0 ? null : t, u = a.memoizedState;
      if (u !== null && i !== null) {
        var s = u[1];
        if (mg(i, s))
          return u[0];
      }
      return a.memoizedState = [e, i], e;
    }
    function _g(e, t) {
      var a = Ui(), i = t === void 0 ? null : t, u = e();
      return a.memoizedState = [u, i], u;
    }
    function Xh(e, t) {
      var a = La(), i = t === void 0 ? null : t, u = a.memoizedState;
      if (u !== null && i !== null) {
        var s = u[1];
        if (mg(i, s))
          return u[0];
      }
      var f = e();
      return a.memoizedState = [f, i], f;
    }
    function Lg(e) {
      var t = Ui();
      return t.memoizedState = e, e;
    }
    function RE(e) {
      var t = La(), a = on, i = a.memoizedState;
      return wE(t, i, e);
    }
    function xE(e) {
      var t = La();
      if (on === null)
        return t.memoizedState = e, e;
      var a = on.memoizedState;
      return wE(t, a, e);
    }
    function wE(e, t, a) {
      var i = !nd(qo);
      if (i) {
        if (!I(a, t)) {
          var u = id();
          Ze.lanes = Re(Ze.lanes, u), gp(u), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, lp()), e.memoizedState = a, a;
    }
    function wx(e, t, a) {
      var i = Fr();
      Ht(bv(i, Ea)), e(!0);
      var u = Xd.transition;
      Xd.transition = {};
      var s = Xd.transition;
      Xd.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if (Ht(i), Xd.transition = u, u === null && s._updatedFibers) {
          var f = s._updatedFibers.size;
          f > 10 && bt("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), s._updatedFibers.clear();
        }
      }
    }
    function Mg() {
      var e = jh(!1), t = e[0], a = e[1], i = wx.bind(null, a), u = Ui();
      return u.memoizedState = i, [t, i];
    }
    function DE() {
      var e = Tg(), t = e[0], a = La(), i = a.memoizedState;
      return [t, i];
    }
    function kE() {
      var e = Rg(), t = e[0], a = La(), i = a.memoizedState;
      return [t, i];
    }
    var bE = !1;
    function Dx() {
      return bE;
    }
    function Og() {
      var e = Ui(), t = mm(), a = t.identifierPrefix, i;
      if (Ln()) {
        var u = $R();
        i = ":" + a + "R" + u;
        var s = Kd++;
        s > 0 && (i += "H" + s.toString(32)), i += ":";
      } else {
        var f = Ex++;
        i = ":" + a + "r" + f.toString(32) + ":";
      }
      return e.memoizedState = i, i;
    }
    function qh() {
      var e = La(), t = e.memoizedState;
      return t;
    }
    function kx(e, t, a) {
      typeof arguments[3] == "function" && S("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = Nu(e), u = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (_E(e))
        LE(t, u);
      else {
        var s = aE(e, t, u, i);
        if (s !== null) {
          var f = Cr();
          pn(s, e, i, f), ME(s, t, i);
        }
      }
      OE(e, i);
    }
    function bx(e, t, a) {
      typeof arguments[3] == "function" && S("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = Nu(e), u = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (_E(e))
        LE(t, u);
      else {
        var s = e.alternate;
        if (e.lanes === U && (s === null || s.lanes === U)) {
          var f = t.lastRenderedReducer;
          if (f !== null) {
            var p;
            p = X.current, X.current = Ja;
            try {
              var v = t.lastRenderedState, m = f(v, a);
              if (u.hasEagerState = !0, u.eagerState = m, I(m, v)) {
                dx(e, t, u, i);
                return;
              }
            } catch {
            } finally {
              X.current = p;
            }
          }
        }
        var y = aE(e, t, u, i);
        if (y !== null) {
          var R = Cr();
          pn(y, e, i, R), ME(y, t, i);
        }
      }
      OE(e, i);
    }
    function _E(e) {
      var t = e.alternate;
      return e === Ze || t !== null && t === Ze;
    }
    function LE(e, t) {
      qd = Fh = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function ME(e, t, a) {
      if (ad(a)) {
        var i = t.lanes;
        i = ld(i, e.pendingLanes);
        var u = Re(i, a);
        t.lanes = u, sc(e, u);
      }
    }
    function OE(e, t, a) {
      fo(e, t);
    }
    var Kh = {
      readContext: Kt,
      useCallback: ar,
      useContext: ar,
      useEffect: ar,
      useImperativeHandle: ar,
      useInsertionEffect: ar,
      useLayoutEffect: ar,
      useMemo: ar,
      useReducer: ar,
      useRef: ar,
      useState: ar,
      useDebugValue: ar,
      useDeferredValue: ar,
      useTransition: ar,
      useMutableSource: ar,
      useSyncExternalStore: ar,
      useId: ar,
      unstable_isNewReconciler: P
    }, NE = null, zE = null, UE = null, AE = null, Ai = null, Ja = null, Zh = null;
    {
      var Ng = function() {
        S("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Ce = function() {
        S("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      NE = {
        readContext: function(e) {
          return Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", Qe(), $c(t), bg(e, t);
        },
        useContext: function(e) {
          return z = "useContext", Qe(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", Qe(), $c(t), $h(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", Qe(), $c(a), kg(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", Qe(), $c(t), wg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", Qe(), $c(t), Dg(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", Qe(), $c(t);
          var a = X.current;
          X.current = Ai;
          try {
            return _g(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", Qe();
          var i = X.current;
          X.current = Ai;
          try {
            return gg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", Qe(), xg(e);
        },
        useState: function(e) {
          z = "useState", Qe();
          var t = X.current;
          X.current = Ai;
          try {
            return jh(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", Qe(), void 0;
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", Qe(), Lg(e);
        },
        useTransition: function() {
          return z = "useTransition", Qe(), Mg();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", Qe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", Qe(), Eg(e, t, a);
        },
        useId: function() {
          return z = "useId", Qe(), Og();
        },
        unstable_isNewReconciler: P
      }, zE = {
        readContext: function(e) {
          return Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", B(), bg(e, t);
        },
        useContext: function(e) {
          return z = "useContext", B(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", B(), $h(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", B(), kg(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", B(), wg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", B(), Dg(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", B();
          var a = X.current;
          X.current = Ai;
          try {
            return _g(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", B();
          var i = X.current;
          X.current = Ai;
          try {
            return gg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", B(), xg(e);
        },
        useState: function(e) {
          z = "useState", B();
          var t = X.current;
          X.current = Ai;
          try {
            return jh(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", B(), void 0;
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", B(), Lg(e);
        },
        useTransition: function() {
          return z = "useTransition", B(), Mg();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", B(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", B(), Eg(e, t, a);
        },
        useId: function() {
          return z = "useId", B(), Og();
        },
        unstable_isNewReconciler: P
      }, UE = {
        readContext: function(e) {
          return Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", B(), Wh(e, t);
        },
        useContext: function(e) {
          return z = "useContext", B(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", B(), ep(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", B(), Ih(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", B(), Yh(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", B(), Qh(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", B();
          var a = X.current;
          X.current = Ja;
          try {
            return Xh(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", B();
          var i = X.current;
          X.current = Ja;
          try {
            return Sg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", B(), Bh();
        },
        useState: function(e) {
          z = "useState", B();
          var t = X.current;
          X.current = Ja;
          try {
            return Tg(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", B(), Gh();
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", B(), RE(e);
        },
        useTransition: function() {
          return z = "useTransition", B(), DE();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", B(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", B(), Vh(e, t);
        },
        useId: function() {
          return z = "useId", B(), qh();
        },
        unstable_isNewReconciler: P
      }, AE = {
        readContext: function(e) {
          return Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", B(), Wh(e, t);
        },
        useContext: function(e) {
          return z = "useContext", B(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", B(), ep(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", B(), Ih(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", B(), Yh(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", B(), Qh(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", B();
          var a = X.current;
          X.current = Zh;
          try {
            return Xh(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", B();
          var i = X.current;
          X.current = Zh;
          try {
            return Cg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", B(), Bh();
        },
        useState: function(e) {
          z = "useState", B();
          var t = X.current;
          X.current = Zh;
          try {
            return Rg(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", B(), Gh();
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", B(), xE(e);
        },
        useTransition: function() {
          return z = "useTransition", B(), kE();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", B(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", B(), Vh(e, t);
        },
        useId: function() {
          return z = "useId", B(), qh();
        },
        unstable_isNewReconciler: P
      }, Ai = {
        readContext: function(e) {
          return Ng(), Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", Ce(), Qe(), bg(e, t);
        },
        useContext: function(e) {
          return z = "useContext", Ce(), Qe(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", Ce(), Qe(), $h(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", Ce(), Qe(), kg(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", Ce(), Qe(), wg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", Ce(), Qe(), Dg(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", Ce(), Qe();
          var a = X.current;
          X.current = Ai;
          try {
            return _g(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", Ce(), Qe();
          var i = X.current;
          X.current = Ai;
          try {
            return gg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", Ce(), Qe(), xg(e);
        },
        useState: function(e) {
          z = "useState", Ce(), Qe();
          var t = X.current;
          X.current = Ai;
          try {
            return jh(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", Ce(), Qe(), void 0;
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", Ce(), Qe(), Lg(e);
        },
        useTransition: function() {
          return z = "useTransition", Ce(), Qe(), Mg();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", Ce(), Qe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", Ce(), Qe(), Eg(e, t, a);
        },
        useId: function() {
          return z = "useId", Ce(), Qe(), Og();
        },
        unstable_isNewReconciler: P
      }, Ja = {
        readContext: function(e) {
          return Ng(), Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", Ce(), B(), Wh(e, t);
        },
        useContext: function(e) {
          return z = "useContext", Ce(), B(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", Ce(), B(), ep(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", Ce(), B(), Ih(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", Ce(), B(), Yh(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", Ce(), B(), Qh(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", Ce(), B();
          var a = X.current;
          X.current = Ja;
          try {
            return Xh(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", Ce(), B();
          var i = X.current;
          X.current = Ja;
          try {
            return Sg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", Ce(), B(), Bh();
        },
        useState: function(e) {
          z = "useState", Ce(), B();
          var t = X.current;
          X.current = Ja;
          try {
            return Tg(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", Ce(), B(), Gh();
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", Ce(), B(), RE(e);
        },
        useTransition: function() {
          return z = "useTransition", Ce(), B(), DE();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", Ce(), B(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", Ce(), B(), Vh(e, t);
        },
        useId: function() {
          return z = "useId", Ce(), B(), qh();
        },
        unstable_isNewReconciler: P
      }, Zh = {
        readContext: function(e) {
          return Ng(), Kt(e);
        },
        useCallback: function(e, t) {
          return z = "useCallback", Ce(), B(), Wh(e, t);
        },
        useContext: function(e) {
          return z = "useContext", Ce(), B(), Kt(e);
        },
        useEffect: function(e, t) {
          return z = "useEffect", Ce(), B(), ep(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return z = "useImperativeHandle", Ce(), B(), Ih(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return z = "useInsertionEffect", Ce(), B(), Yh(e, t);
        },
        useLayoutEffect: function(e, t) {
          return z = "useLayoutEffect", Ce(), B(), Qh(e, t);
        },
        useMemo: function(e, t) {
          z = "useMemo", Ce(), B();
          var a = X.current;
          X.current = Ja;
          try {
            return Xh(e, t);
          } finally {
            X.current = a;
          }
        },
        useReducer: function(e, t, a) {
          z = "useReducer", Ce(), B();
          var i = X.current;
          X.current = Ja;
          try {
            return Cg(e, t, a);
          } finally {
            X.current = i;
          }
        },
        useRef: function(e) {
          return z = "useRef", Ce(), B(), Bh();
        },
        useState: function(e) {
          z = "useState", Ce(), B();
          var t = X.current;
          X.current = Ja;
          try {
            return Rg(e);
          } finally {
            X.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return z = "useDebugValue", Ce(), B(), Gh();
        },
        useDeferredValue: function(e) {
          return z = "useDeferredValue", Ce(), B(), xE(e);
        },
        useTransition: function() {
          return z = "useTransition", Ce(), B(), kE();
        },
        useMutableSource: function(e, t, a) {
          return z = "useMutableSource", Ce(), B(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return z = "useSyncExternalStore", Ce(), B(), Vh(e, t);
        },
        useId: function() {
          return z = "useId", Ce(), B(), qh();
        },
        unstable_isNewReconciler: P
      };
    }
    var _u = Ae.unstable_now, HE = 0, Jh = -1, tp = -1, em = -1, zg = !1, tm = !1;
    function FE() {
      return zg;
    }
    function _x() {
      tm = !0;
    }
    function Lx() {
      zg = !1, tm = !1;
    }
    function Mx() {
      zg = tm, tm = !1;
    }
    function VE() {
      return HE;
    }
    function jE() {
      HE = _u();
    }
    function Ug(e) {
      tp = _u(), e.actualStartTime < 0 && (e.actualStartTime = _u());
    }
    function BE(e) {
      tp = -1;
    }
    function nm(e, t) {
      if (tp >= 0) {
        var a = _u() - tp;
        e.actualDuration += a, t && (e.selfBaseDuration = a), tp = -1;
      }
    }
    function Hi(e) {
      if (Jh >= 0) {
        var t = _u() - Jh;
        Jh = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case ne:
              var i = a.stateNode;
              i.effectDuration += t;
              return;
            case it:
              var u = a.stateNode;
              u.effectDuration += t;
              return;
          }
          a = a.return;
        }
      }
    }
    function Ag(e) {
      if (em >= 0) {
        var t = _u() - em;
        em = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case ne:
              var i = a.stateNode;
              i !== null && (i.passiveEffectDuration += t);
              return;
            case it:
              var u = a.stateNode;
              u !== null && (u.passiveEffectDuration += t);
              return;
          }
          a = a.return;
        }
      }
    }
    function Fi() {
      Jh = _u();
    }
    function Hg() {
      em = _u();
    }
    function Fg(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function ei(e, t) {
      if (e && e.defaultProps) {
        var a = Le({}, t), i = e.defaultProps;
        for (var u in i)
          a[u] === void 0 && (a[u] = i[u]);
        return a;
      }
      return t;
    }
    var Vg = {}, jg, Bg, Pg, $g, Yg, PE, rm, Qg, Ig, Gg, np;
    {
      jg = /* @__PURE__ */ new Set(), Bg = /* @__PURE__ */ new Set(), Pg = /* @__PURE__ */ new Set(), $g = /* @__PURE__ */ new Set(), Qg = /* @__PURE__ */ new Set(), Yg = /* @__PURE__ */ new Set(), Ig = /* @__PURE__ */ new Set(), Gg = /* @__PURE__ */ new Set(), np = /* @__PURE__ */ new Set();
      var $E = /* @__PURE__ */ new Set();
      rm = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var a = t + "_" + e;
          $E.has(a) || ($E.add(a), S("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, PE = function(e, t) {
        if (t === void 0) {
          var a = We(e) || "Component";
          Yg.has(a) || (Yg.add(a), S("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", a));
        }
      }, Object.defineProperty(Vg, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Vg);
    }
    function Wg(e, t, a, i) {
      var u = e.memoizedState, s = a(i, u);
      {
        if (e.mode & Ke) {
          dt(!0);
          try {
            s = a(i, u);
          } finally {
            dt(!1);
          }
        }
        PE(t, s);
      }
      var f = s == null ? u : Le({}, u, s);
      if (e.memoizedState = f, e.lanes === U) {
        var p = e.updateQueue;
        p.baseState = f;
      }
    }
    var Xg = {
      isMounted: dv,
      enqueueSetState: function(e, t, a) {
        var i = au(e), u = Cr(), s = Nu(i), f = Ol(u, s);
        f.payload = t, a != null && (rm(a, "setState"), f.callback = a);
        var p = wu(i, f, s);
        p !== null && (pn(p, i, s, u), Oh(p, i, s)), fo(i, s);
      },
      enqueueReplaceState: function(e, t, a) {
        var i = au(e), u = Cr(), s = Nu(i), f = Ol(u, s);
        f.tag = lE, f.payload = t, a != null && (rm(a, "replaceState"), f.callback = a);
        var p = wu(i, f, s);
        p !== null && (pn(p, i, s, u), Oh(p, i, s)), fo(i, s);
      },
      enqueueForceUpdate: function(e, t) {
        var a = au(e), i = Cr(), u = Nu(a), s = Ol(i, u);
        s.tag = _h, t != null && (rm(t, "forceUpdate"), s.callback = t);
        var f = wu(a, s, u);
        f !== null && (pn(f, a, u, i), Oh(f, a, u)), Bs(a, u);
      }
    };
    function YE(e, t, a, i, u, s, f) {
      var p = e.stateNode;
      if (typeof p.shouldComponentUpdate == "function") {
        var v = p.shouldComponentUpdate(i, s, f);
        {
          if (e.mode & Ke) {
            dt(!0);
            try {
              v = p.shouldComponentUpdate(i, s, f);
            } finally {
              dt(!1);
            }
          }
          v === void 0 && S("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", We(t) || "Component");
        }
        return v;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !se(a, i) || !se(u, s) : !0;
    }
    function Ox(e, t, a) {
      var i = e.stateNode;
      {
        var u = We(t) || "Component", s = i.render;
        s || (t.prototype && typeof t.prototype.render == "function" ? S("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", u) : S("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", u)), i.getInitialState && !i.getInitialState.isReactClassApproved && !i.state && S("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", u), i.getDefaultProps && !i.getDefaultProps.isReactClassApproved && S("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", u), i.propTypes && S("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", u), i.contextType && S("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", u), t.childContextTypes && !np.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Ke) === oe && (np.add(t), S(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, u)), t.contextTypes && !np.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Ke) === oe && (np.add(t), S(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, u)), i.contextTypes && S("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", u), t.contextType && t.contextTypes && !Ig.has(t) && (Ig.add(t), S("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", u)), typeof i.componentShouldUpdate == "function" && S("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", u), t.prototype && t.prototype.isPureReactComponent && typeof i.shouldComponentUpdate < "u" && S("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", We(t) || "A pure component"), typeof i.componentDidUnmount == "function" && S("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", u), typeof i.componentDidReceiveProps == "function" && S("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", u), typeof i.componentWillRecieveProps == "function" && S("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", u), typeof i.UNSAFE_componentWillRecieveProps == "function" && S("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", u);
        var f = i.props !== a;
        i.props !== void 0 && f && S("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", u, u), i.defaultProps && S("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", u, u), typeof i.getSnapshotBeforeUpdate == "function" && typeof i.componentDidUpdate != "function" && !Pg.has(t) && (Pg.add(t), S("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", We(t))), typeof i.getDerivedStateFromProps == "function" && S("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", u), typeof i.getDerivedStateFromError == "function" && S("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", u), typeof t.getSnapshotBeforeUpdate == "function" && S("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", u);
        var p = i.state;
        p && (typeof p != "object" || en(p)) && S("%s.state: must be set to an object or null", u), typeof i.getChildContext == "function" && typeof t.childContextTypes != "object" && S("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", u);
      }
    }
    function QE(e, t) {
      t.updater = Xg, e.stateNode = t, ul(t, e), t._reactInternalInstance = Vg;
    }
    function IE(e, t, a) {
      var i = !1, u = la, s = la, f = t.contextType;
      if ("contextType" in t) {
        var p = (
          // Allow null for conditional declaration
          f === null || f !== void 0 && f.$$typeof === Vu && f._context === void 0
        );
        if (!p && !Gg.has(t)) {
          Gg.add(t);
          var v = "";
          f === void 0 ? v = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof f != "object" ? v = " However, it is set to a " + typeof f + "." : f.$$typeof === Yl ? v = " Did you accidentally pass the Context.Provider instead?" : f._context !== void 0 ? v = " Did you accidentally pass the Context.Consumer instead?" : v = " However, it is set to an object with keys {" + Object.keys(f).join(", ") + "}.", S("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", We(t) || "Component", v);
        }
      }
      if (typeof f == "object" && f !== null)
        s = Kt(f);
      else {
        u = Mc(e, t, !0);
        var m = t.contextTypes;
        i = m != null, s = i ? Oc(e, u) : la;
      }
      var y = new t(a, s);
      if (e.mode & Ke) {
        dt(!0);
        try {
          y = new t(a, s);
        } finally {
          dt(!1);
        }
      }
      var R = e.memoizedState = y.state !== null && y.state !== void 0 ? y.state : null;
      QE(e, y);
      {
        if (typeof t.getDerivedStateFromProps == "function" && R === null) {
          var E = We(t) || "Component";
          Bg.has(E) || (Bg.add(E), S("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", E, y.state === null ? "null" : "undefined", E));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof y.getSnapshotBeforeUpdate == "function") {
          var b = null, L = null, M = null;
          if (typeof y.componentWillMount == "function" && y.componentWillMount.__suppressDeprecationWarning !== !0 ? b = "componentWillMount" : typeof y.UNSAFE_componentWillMount == "function" && (b = "UNSAFE_componentWillMount"), typeof y.componentWillReceiveProps == "function" && y.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? L = "componentWillReceiveProps" : typeof y.UNSAFE_componentWillReceiveProps == "function" && (L = "UNSAFE_componentWillReceiveProps"), typeof y.componentWillUpdate == "function" && y.componentWillUpdate.__suppressDeprecationWarning !== !0 ? M = "componentWillUpdate" : typeof y.UNSAFE_componentWillUpdate == "function" && (M = "UNSAFE_componentWillUpdate"), b !== null || L !== null || M !== null) {
            var Q = We(t) || "Component", ce = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            $g.has(Q) || ($g.add(Q), S(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Q, ce, b !== null ? `
  ` + b : "", L !== null ? `
  ` + L : "", M !== null ? `
  ` + M : ""));
          }
        }
      }
      return i && UC(e, u, s), y;
    }
    function Nx(e, t) {
      var a = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), a !== t.state && (S("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Te(e) || "Component"), Xg.enqueueReplaceState(t, t.state, null));
    }
    function GE(e, t, a, i) {
      var u = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, i), t.state !== u) {
        {
          var s = Te(e) || "Component";
          jg.has(s) || (jg.add(s), S("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", s));
        }
        Xg.enqueueReplaceState(t, t.state, null);
      }
    }
    function qg(e, t, a, i) {
      Ox(e, t, a);
      var u = e.stateNode;
      u.props = a, u.state = e.memoizedState, u.refs = {}, ig(e);
      var s = t.contextType;
      if (typeof s == "object" && s !== null)
        u.context = Kt(s);
      else {
        var f = Mc(e, t, !0);
        u.context = Oc(e, f);
      }
      {
        if (u.state === a) {
          var p = We(t) || "Component";
          Qg.has(p) || (Qg.add(p), S("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", p));
        }
        e.mode & Ke && Ka.recordLegacyContextWarning(e, u), Ka.recordUnsafeLifecycleWarnings(e, u);
      }
      u.state = e.memoizedState;
      var v = t.getDerivedStateFromProps;
      if (typeof v == "function" && (Wg(e, t, v, a), u.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof u.getSnapshotBeforeUpdate != "function" && (typeof u.UNSAFE_componentWillMount == "function" || typeof u.componentWillMount == "function") && (Nx(e, u), Nh(e, a, u, i), u.state = e.memoizedState), typeof u.componentDidMount == "function") {
        var m = Oe;
        m |= ja, (e.mode & je) !== oe && (m |= mi), e.flags |= m;
      }
    }
    function zx(e, t, a, i) {
      var u = e.stateNode, s = e.memoizedProps;
      u.props = s;
      var f = u.context, p = t.contextType, v = la;
      if (typeof p == "object" && p !== null)
        v = Kt(p);
      else {
        var m = Mc(e, t, !0);
        v = Oc(e, m);
      }
      var y = t.getDerivedStateFromProps, R = typeof y == "function" || typeof u.getSnapshotBeforeUpdate == "function";
      !R && (typeof u.UNSAFE_componentWillReceiveProps == "function" || typeof u.componentWillReceiveProps == "function") && (s !== a || f !== v) && GE(e, u, a, v), oE();
      var E = e.memoizedState, b = u.state = E;
      if (Nh(e, a, u, i), b = e.memoizedState, s === a && E === b && !vh() && !zh()) {
        if (typeof u.componentDidMount == "function") {
          var L = Oe;
          L |= ja, (e.mode & je) !== oe && (L |= mi), e.flags |= L;
        }
        return !1;
      }
      typeof y == "function" && (Wg(e, t, y, a), b = e.memoizedState);
      var M = zh() || YE(e, t, s, a, E, b, v);
      if (M) {
        if (!R && (typeof u.UNSAFE_componentWillMount == "function" || typeof u.componentWillMount == "function") && (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function") {
          var Q = Oe;
          Q |= ja, (e.mode & je) !== oe && (Q |= mi), e.flags |= Q;
        }
      } else {
        if (typeof u.componentDidMount == "function") {
          var ce = Oe;
          ce |= ja, (e.mode & je) !== oe && (ce |= mi), e.flags |= ce;
        }
        e.memoizedProps = a, e.memoizedState = b;
      }
      return u.props = a, u.state = b, u.context = v, M;
    }
    function Ux(e, t, a, i, u) {
      var s = t.stateNode;
      uE(e, t);
      var f = t.memoizedProps, p = t.type === t.elementType ? f : ei(t.type, f);
      s.props = p;
      var v = t.pendingProps, m = s.context, y = a.contextType, R = la;
      if (typeof y == "object" && y !== null)
        R = Kt(y);
      else {
        var E = Mc(t, a, !0);
        R = Oc(t, E);
      }
      var b = a.getDerivedStateFromProps, L = typeof b == "function" || typeof s.getSnapshotBeforeUpdate == "function";
      !L && (typeof s.UNSAFE_componentWillReceiveProps == "function" || typeof s.componentWillReceiveProps == "function") && (f !== v || m !== R) && GE(t, s, i, R), oE();
      var M = t.memoizedState, Q = s.state = M;
      if (Nh(t, i, s, u), Q = t.memoizedState, f === v && M === Q && !vh() && !zh())
        return typeof s.componentDidUpdate == "function" && (f !== e.memoizedProps || M !== e.memoizedState) && (t.flags |= Oe), typeof s.getSnapshotBeforeUpdate == "function" && (f !== e.memoizedProps || M !== e.memoizedState) && (t.flags |= $t), !1;
      typeof b == "function" && (Wg(t, a, b, i), Q = t.memoizedState);
      var ce = zh() || YE(t, a, p, i, M, Q, R) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      ve;
      return ce ? (!L && (typeof s.UNSAFE_componentWillUpdate == "function" || typeof s.componentWillUpdate == "function") && (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(i, Q, R), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(i, Q, R)), typeof s.componentDidUpdate == "function" && (t.flags |= Oe), typeof s.getSnapshotBeforeUpdate == "function" && (t.flags |= $t)) : (typeof s.componentDidUpdate == "function" && (f !== e.memoizedProps || M !== e.memoizedState) && (t.flags |= Oe), typeof s.getSnapshotBeforeUpdate == "function" && (f !== e.memoizedProps || M !== e.memoizedState) && (t.flags |= $t), t.memoizedProps = i, t.memoizedState = Q), s.props = i, s.state = Q, s.context = R, ce;
    }
    function Ko(e, t) {
      return {
        value: e,
        source: t,
        stack: os(t),
        digest: null
      };
    }
    function Kg(e, t, a) {
      return {
        value: e,
        source: null,
        stack: a ?? null,
        digest: t ?? null
      };
    }
    function Ax(e, t) {
      return !0;
    }
    function Zg(e, t) {
      try {
        var a = Ax(e, t);
        if (a === !1)
          return;
        var i = t.value, u = t.source, s = t.stack, f = s !== null ? s : "";
        if (i != null && i._suppressLogging) {
          if (e.tag === fe)
            return;
          console.error(i);
        }
        var p = u ? Te(u) : null, v = p ? "The above error occurred in the <" + p + "> component:" : "The above error occurred in one of your React components:", m;
        if (e.tag === ne)
          m = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var y = Te(e) || "Anonymous";
          m = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + y + ".");
        }
        var R = v + `
` + f + `

` + ("" + m);
        console.error(R);
      } catch (E) {
        setTimeout(function() {
          throw E;
        });
      }
    }
    var Hx = typeof WeakMap == "function" ? WeakMap : Map;
    function WE(e, t, a) {
      var i = Ol(nt, a);
      i.tag = rg, i.payload = {
        element: null
      };
      var u = t.value;
      return i.callback = function() {
        _D(u), Zg(e, t);
      }, i;
    }
    function Jg(e, t, a) {
      var i = Ol(nt, a);
      i.tag = rg;
      var u = e.type.getDerivedStateFromError;
      if (typeof u == "function") {
        var s = t.value;
        i.payload = function() {
          return u(s);
        }, i.callback = function() {
          iT(e), Zg(e, t);
        };
      }
      var f = e.stateNode;
      return f !== null && typeof f.componentDidCatch == "function" && (i.callback = function() {
        iT(e), Zg(e, t), typeof u != "function" && kD(this);
        var v = t.value, m = t.stack;
        this.componentDidCatch(v, {
          componentStack: m !== null ? m : ""
        }), typeof u != "function" && (Zn(e.lanes, he) || S("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Te(e) || "Unknown"));
      }), i;
    }
    function XE(e, t, a) {
      var i = e.pingCache, u;
      if (i === null ? (i = e.pingCache = new Hx(), u = /* @__PURE__ */ new Set(), i.set(t, u)) : (u = i.get(t), u === void 0 && (u = /* @__PURE__ */ new Set(), i.set(t, u))), !u.has(a)) {
        u.add(a);
        var s = LD.bind(null, e, t, a);
        Kn && Sp(e, a), t.then(s, s);
      }
    }
    function Fx(e, t, a, i) {
      var u = e.updateQueue;
      if (u === null) {
        var s = /* @__PURE__ */ new Set();
        s.add(a), e.updateQueue = s;
      } else
        u.add(a);
    }
    function Vx(e, t) {
      var a = e.tag;
      if ((e.mode & xe) === oe && (a === ge || a === _e || a === De)) {
        var i = e.alternate;
        i ? (e.updateQueue = i.updateQueue, e.memoizedState = i.memoizedState, e.lanes = i.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function qE(e) {
      var t = e;
      do {
        if (t.tag === Me && Sx(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function KE(e, t, a, i, u) {
      if ((e.mode & xe) === oe) {
        if (e === t)
          e.flags |= Wn;
        else {
          if (e.flags |= ie, a.flags |= Ns, a.flags &= -52805, a.tag === fe) {
            var s = a.alternate;
            if (s === null)
              a.tag = mt;
            else {
              var f = Ol(nt, he);
              f.tag = _h, wu(a, f, he);
            }
          }
          a.lanes = Re(a.lanes, he);
        }
        return e;
      }
      return e.flags |= Wn, e.lanes = u, e;
    }
    function jx(e, t, a, i, u) {
      if (a.flags |= io, Kn && Sp(e, u), i !== null && typeof i == "object" && typeof i.then == "function") {
        var s = i;
        Vx(a), Ln() && a.mode & xe && PC();
        var f = qE(t);
        if (f !== null) {
          f.flags &= -257, KE(f, t, a, e, u), f.mode & xe && XE(e, s, u), Fx(f, e, s);
          return;
        } else {
          if (!Cv(u)) {
            XE(e, s, u), OS();
            return;
          }
          var p = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          i = p;
        }
      } else if (Ln() && a.mode & xe) {
        PC();
        var v = qE(t);
        if (v !== null) {
          (v.flags & Wn) === ue && (v.flags |= In), KE(v, t, a, e, u), Qy(Ko(i, a));
          return;
        }
      }
      i = Ko(i, a), SD(i);
      var m = t;
      do {
        switch (m.tag) {
          case ne: {
            var y = i;
            m.flags |= Wn;
            var R = Eo(u);
            m.lanes = Re(m.lanes, R);
            var E = WE(m, y, R);
            lg(m, E);
            return;
          }
          case fe:
            var b = i, L = m.type, M = m.stateNode;
            if ((m.flags & ie) === ue && (typeof L.getDerivedStateFromError == "function" || M !== null && typeof M.componentDidCatch == "function" && !q0(M))) {
              m.flags |= Wn;
              var Q = Eo(u);
              m.lanes = Re(m.lanes, Q);
              var ce = Jg(m, b, Q);
              lg(m, ce);
              return;
            }
            break;
        }
        m = m.return;
      } while (m !== null);
    }
    function Bx() {
      return null;
    }
    var rp = N.ReactCurrentOwner, ti = !1, eS, ap, tS, nS, rS, Zo, aS, am, ip;
    eS = {}, ap = {}, tS = {}, nS = {}, rS = {}, Zo = !1, aS = {}, am = {}, ip = {};
    function gr(e, t, a, i) {
      e === null ? t.child = eE(t, null, a, i) : t.child = Ac(t, e.child, a, i);
    }
    function Px(e, t, a, i) {
      t.child = Ac(t, e.child, null, i), t.child = Ac(t, null, a, i);
    }
    function ZE(e, t, a, i, u) {
      if (t.type !== t.elementType) {
        var s = a.propTypes;
        s && Xa(
          s,
          i,
          // Resolved props
          "prop",
          We(a)
        );
      }
      var f = a.render, p = t.ref, v, m;
      Fc(t, u), pr(t);
      {
        if (rp.current = t, Jt(!0), v = Yc(e, t, f, i, p, u), m = Qc(), t.mode & Ke) {
          dt(!0);
          try {
            v = Yc(e, t, f, i, p, u), m = Qc();
          } finally {
            dt(!1);
          }
        }
        Jt(!1);
      }
      return vr(), e !== null && !ti ? (vE(e, t, u), Nl(e, t, u)) : (Ln() && m && Vy(t), t.flags |= ea, gr(e, t, v, u), t.child);
    }
    function JE(e, t, a, i, u) {
      if (e === null) {
        var s = a.type;
        if (GD(s) && a.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        a.defaultProps === void 0) {
          var f = s;
          return f = Jc(s), t.tag = De, t.type = f, uS(t, s), e0(e, t, f, i, u);
        }
        {
          var p = s.propTypes;
          if (p && Xa(
            p,
            i,
            // Resolved props
            "prop",
            We(s)
          ), a.defaultProps !== void 0) {
            var v = We(s) || "Unknown";
            ip[v] || (S("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", v), ip[v] = !0);
          }
        }
        var m = $S(a.type, null, i, t, t.mode, u);
        return m.ref = t.ref, m.return = t, t.child = m, m;
      }
      {
        var y = a.type, R = y.propTypes;
        R && Xa(
          R,
          i,
          // Resolved props
          "prop",
          We(y)
        );
      }
      var E = e.child, b = pS(e, u);
      if (!b) {
        var L = E.memoizedProps, M = a.compare;
        if (M = M !== null ? M : se, M(L, i) && e.ref === t.ref)
          return Nl(e, t, u);
      }
      t.flags |= ea;
      var Q = rs(E, i);
      return Q.ref = t.ref, Q.return = t, t.child = Q, Q;
    }
    function e0(e, t, a, i, u) {
      if (t.type !== t.elementType) {
        var s = t.elementType;
        if (s.$$typeof === mn) {
          var f = s, p = f._payload, v = f._init;
          try {
            s = v(p);
          } catch {
            s = null;
          }
          var m = s && s.propTypes;
          m && Xa(
            m,
            i,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            We(s)
          );
        }
      }
      if (e !== null) {
        var y = e.memoizedProps;
        if (se(y, i) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (ti = !1, t.pendingProps = i = y, pS(e, u))
            (e.flags & Ns) !== ue && (ti = !0);
          else return t.lanes = e.lanes, Nl(e, t, u);
      }
      return iS(e, t, a, i, u);
    }
    function t0(e, t, a) {
      var i = t.pendingProps, u = i.children, s = e !== null ? e.memoizedState : null;
      if (i.mode === "hidden" || Z)
        if ((t.mode & xe) === oe) {
          var f = {
            baseLanes: U,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = f, ym(t, a);
        } else if (Zn(a, hr)) {
          var R = {
            baseLanes: U,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = R;
          var E = s !== null ? s.baseLanes : a;
          ym(t, E);
        } else {
          var p = null, v;
          if (s !== null) {
            var m = s.baseLanes;
            v = Re(m, a);
          } else
            v = a;
          t.lanes = t.childLanes = hr;
          var y = {
            baseLanes: v,
            cachePool: p,
            transitions: null
          };
          return t.memoizedState = y, t.updateQueue = null, ym(t, v), null;
        }
      else {
        var b;
        s !== null ? (b = Re(s.baseLanes, a), t.memoizedState = null) : b = a, ym(t, b);
      }
      return gr(e, t, u, a), t.child;
    }
    function $x(e, t, a) {
      var i = t.pendingProps;
      return gr(e, t, i, a), t.child;
    }
    function Yx(e, t, a) {
      var i = t.pendingProps.children;
      return gr(e, t, i, a), t.child;
    }
    function Qx(e, t, a) {
      {
        t.flags |= Oe;
        {
          var i = t.stateNode;
          i.effectDuration = 0, i.passiveEffectDuration = 0;
        }
      }
      var u = t.pendingProps, s = u.children;
      return gr(e, t, s, a), t.child;
    }
    function n0(e, t) {
      var a = t.ref;
      (e === null && a !== null || e !== null && e.ref !== a) && (t.flags |= Ct, t.flags |= lu);
    }
    function iS(e, t, a, i, u) {
      if (t.type !== t.elementType) {
        var s = a.propTypes;
        s && Xa(
          s,
          i,
          // Resolved props
          "prop",
          We(a)
        );
      }
      var f;
      {
        var p = Mc(t, a, !0);
        f = Oc(t, p);
      }
      var v, m;
      Fc(t, u), pr(t);
      {
        if (rp.current = t, Jt(!0), v = Yc(e, t, a, i, f, u), m = Qc(), t.mode & Ke) {
          dt(!0);
          try {
            v = Yc(e, t, a, i, f, u), m = Qc();
          } finally {
            dt(!1);
          }
        }
        Jt(!1);
      }
      return vr(), e !== null && !ti ? (vE(e, t, u), Nl(e, t, u)) : (Ln() && m && Vy(t), t.flags |= ea, gr(e, t, v, u), t.child);
    }
    function r0(e, t, a, i, u) {
      {
        switch (ok(t)) {
          case !1: {
            var s = t.stateNode, f = t.type, p = new f(t.memoizedProps, s.context), v = p.state;
            s.updater.enqueueSetState(s, v, null);
            break;
          }
          case !0: {
            t.flags |= ie, t.flags |= Wn;
            var m = new Error("Simulated error coming from DevTools"), y = Eo(u);
            t.lanes = Re(t.lanes, y);
            var R = Jg(t, Ko(m, t), y);
            lg(t, R);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var E = a.propTypes;
          E && Xa(
            E,
            i,
            // Resolved props
            "prop",
            We(a)
          );
        }
      }
      var b;
      Ni(a) ? (b = !0, mh(t)) : b = !1, Fc(t, u);
      var L = t.stateNode, M;
      L === null ? (lm(e, t), IE(t, a, i), qg(t, a, i, u), M = !0) : e === null ? M = zx(t, a, i, u) : M = Ux(e, t, a, i, u);
      var Q = lS(e, t, a, M, b, u);
      {
        var ce = t.stateNode;
        M && ce.props !== i && (Zo || S("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Te(t) || "a component"), Zo = !0);
      }
      return Q;
    }
    function lS(e, t, a, i, u, s) {
      n0(e, t);
      var f = (t.flags & ie) !== ue;
      if (!i && !f)
        return u && FC(t, a, !1), Nl(e, t, s);
      var p = t.stateNode;
      rp.current = t;
      var v;
      if (f && typeof a.getDerivedStateFromError != "function")
        v = null, BE();
      else {
        pr(t);
        {
          if (Jt(!0), v = p.render(), t.mode & Ke) {
            dt(!0);
            try {
              p.render();
            } finally {
              dt(!1);
            }
          }
          Jt(!1);
        }
        vr();
      }
      return t.flags |= ea, e !== null && f ? Px(e, t, v, s) : gr(e, t, v, s), t.memoizedState = p.state, u && FC(t, a, !0), t.child;
    }
    function a0(e) {
      var t = e.stateNode;
      t.pendingContext ? AC(e, t.pendingContext, t.pendingContext !== t.context) : t.context && AC(e, t.context, !1), ug(e, t.containerInfo);
    }
    function Ix(e, t, a) {
      if (a0(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var i = t.pendingProps, u = t.memoizedState, s = u.element;
      uE(e, t), Nh(t, i, null, a);
      var f = t.memoizedState;
      t.stateNode;
      var p = f.element;
      if (u.isDehydrated) {
        var v = {
          element: p,
          isDehydrated: !1,
          cache: f.cache,
          pendingSuspenseBoundaries: f.pendingSuspenseBoundaries,
          transitions: f.transitions
        }, m = t.updateQueue;
        if (m.baseState = v, t.memoizedState = v, t.flags & In) {
          var y = Ko(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return i0(e, t, p, a, y);
        } else if (p !== s) {
          var R = Ko(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return i0(e, t, p, a, R);
        } else {
          XR(t);
          var E = eE(t, null, p, a);
          t.child = E;
          for (var b = E; b; )
            b.flags = b.flags & -3 | Or, b = b.sibling;
        }
      } else {
        if (Uc(), p === s)
          return Nl(e, t, a);
        gr(e, t, p, a);
      }
      return t.child;
    }
    function i0(e, t, a, i, u) {
      return Uc(), Qy(u), t.flags |= In, gr(e, t, a, i), t.child;
    }
    function Gx(e, t, a) {
      fE(t), e === null && Yy(t);
      var i = t.type, u = t.pendingProps, s = e !== null ? e.memoizedProps : null, f = u.children, p = wy(i, u);
      return p ? f = null : s !== null && wy(i, s) && (t.flags |= ta), n0(e, t), gr(e, t, f, a), t.child;
    }
    function Wx(e, t) {
      return e === null && Yy(t), null;
    }
    function Xx(e, t, a, i) {
      lm(e, t);
      var u = t.pendingProps, s = a, f = s._payload, p = s._init, v = p(f);
      t.type = v;
      var m = t.tag = WD(v), y = ei(v, u), R;
      switch (m) {
        case ge:
          return uS(t, v), t.type = v = Jc(v), R = iS(null, t, v, y, i), R;
        case fe:
          return t.type = v = HS(v), R = r0(null, t, v, y, i), R;
        case _e:
          return t.type = v = FS(v), R = ZE(null, t, v, y, i), R;
        case ft: {
          if (t.type !== t.elementType) {
            var E = v.propTypes;
            E && Xa(
              E,
              y,
              // Resolved for outer only
              "prop",
              We(v)
            );
          }
          return R = JE(
            null,
            t,
            v,
            ei(v.type, y),
            // The inner type can have defaults too
            i
          ), R;
        }
      }
      var b = "";
      throw v !== null && typeof v == "object" && v.$$typeof === mn && (b = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + v + ". " + ("Lazy element type must resolve to a class or function." + b));
    }
    function qx(e, t, a, i, u) {
      lm(e, t), t.tag = fe;
      var s;
      return Ni(a) ? (s = !0, mh(t)) : s = !1, Fc(t, u), IE(t, a, i), qg(t, a, i, u), lS(null, t, a, !0, s, u);
    }
    function Kx(e, t, a, i) {
      lm(e, t);
      var u = t.pendingProps, s;
      {
        var f = Mc(t, a, !1);
        s = Oc(t, f);
      }
      Fc(t, i);
      var p, v;
      pr(t);
      {
        if (a.prototype && typeof a.prototype.render == "function") {
          var m = We(a) || "Unknown";
          eS[m] || (S("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", m, m), eS[m] = !0);
        }
        t.mode & Ke && Ka.recordLegacyContextWarning(t, null), Jt(!0), rp.current = t, p = Yc(null, t, a, u, s, i), v = Qc(), Jt(!1);
      }
      if (vr(), t.flags |= ea, typeof p == "object" && p !== null && typeof p.render == "function" && p.$$typeof === void 0) {
        var y = We(a) || "Unknown";
        ap[y] || (S("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", y, y, y), ap[y] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof p == "object" && p !== null && typeof p.render == "function" && p.$$typeof === void 0
      ) {
        {
          var R = We(a) || "Unknown";
          ap[R] || (S("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", R, R, R), ap[R] = !0);
        }
        t.tag = fe, t.memoizedState = null, t.updateQueue = null;
        var E = !1;
        return Ni(a) ? (E = !0, mh(t)) : E = !1, t.memoizedState = p.state !== null && p.state !== void 0 ? p.state : null, ig(t), QE(t, p), qg(t, a, u, i), lS(null, t, a, !0, E, i);
      } else {
        if (t.tag = ge, t.mode & Ke) {
          dt(!0);
          try {
            p = Yc(null, t, a, u, s, i), v = Qc();
          } finally {
            dt(!1);
          }
        }
        return Ln() && v && Vy(t), gr(null, t, p, i), uS(t, a), t.child;
      }
    }
    function uS(e, t) {
      {
        if (t && t.childContextTypes && S("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var a = "", i = br();
          i && (a += `

Check the render method of \`` + i + "`.");
          var u = i || "", s = e._debugSource;
          s && (u = s.fileName + ":" + s.lineNumber), rS[u] || (rS[u] = !0, S("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", a));
        }
        if (t.defaultProps !== void 0) {
          var f = We(t) || "Unknown";
          ip[f] || (S("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", f), ip[f] = !0);
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var p = We(t) || "Unknown";
          nS[p] || (S("%s: Function components do not support getDerivedStateFromProps.", p), nS[p] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var v = We(t) || "Unknown";
          tS[v] || (S("%s: Function components do not support contextType.", v), tS[v] = !0);
        }
      }
    }
    var oS = {
      dehydrated: null,
      treeContext: null,
      retryLane: Fe
    };
    function sS(e) {
      return {
        baseLanes: e,
        cachePool: Bx(),
        transitions: null
      };
    }
    function Zx(e, t) {
      var a = null;
      return {
        baseLanes: Re(e.baseLanes, t),
        cachePool: a,
        transitions: e.transitions
      };
    }
    function Jx(e, t, a, i) {
      if (t !== null) {
        var u = t.memoizedState;
        if (u === null)
          return !1;
      }
      return cg(e, Wd);
    }
    function ew(e, t) {
      return To(e.childLanes, t);
    }
    function l0(e, t, a) {
      var i = t.pendingProps;
      sk(t) && (t.flags |= ie);
      var u = Za.current, s = !1, f = (t.flags & ie) !== ue;
      if (f || Jx(u, e) ? (s = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (u = gx(u, pE)), u = jc(u), ku(t, u), e === null) {
        Yy(t);
        var p = t.memoizedState;
        if (p !== null) {
          var v = p.dehydrated;
          if (v !== null)
            return iw(t, v);
        }
        var m = i.children, y = i.fallback;
        if (s) {
          var R = tw(t, m, y, a), E = t.child;
          return E.memoizedState = sS(a), t.memoizedState = oS, R;
        } else
          return cS(t, m);
      } else {
        var b = e.memoizedState;
        if (b !== null) {
          var L = b.dehydrated;
          if (L !== null)
            return lw(e, t, f, i, L, b, a);
        }
        if (s) {
          var M = i.fallback, Q = i.children, ce = rw(e, t, Q, M, a), re = t.child, Ue = e.child.memoizedState;
          return re.memoizedState = Ue === null ? sS(a) : Zx(Ue, a), re.childLanes = ew(e, a), t.memoizedState = oS, ce;
        } else {
          var be = i.children, w = nw(e, t, be, a);
          return t.memoizedState = null, w;
        }
      }
    }
    function cS(e, t, a) {
      var i = e.mode, u = {
        mode: "visible",
        children: t
      }, s = fS(u, i);
      return s.return = e, e.child = s, s;
    }
    function tw(e, t, a, i) {
      var u = e.mode, s = e.child, f = {
        mode: "hidden",
        children: t
      }, p, v;
      return (u & xe) === oe && s !== null ? (p = s, p.childLanes = U, p.pendingProps = f, e.mode & Ve && (p.actualDuration = 0, p.actualStartTime = -1, p.selfBaseDuration = 0, p.treeBaseDuration = 0), v = Uu(a, u, i, null)) : (p = fS(f, u), v = Uu(a, u, i, null)), p.return = e, v.return = e, p.sibling = v, e.child = p, v;
    }
    function fS(e, t, a) {
      return uT(e, t, U, null);
    }
    function u0(e, t) {
      return rs(e, t);
    }
    function nw(e, t, a, i) {
      var u = e.child, s = u.sibling, f = u0(u, {
        mode: "visible",
        children: a
      });
      if ((t.mode & xe) === oe && (f.lanes = i), f.return = t, f.sibling = null, s !== null) {
        var p = t.deletions;
        p === null ? (t.deletions = [s], t.flags |= Mr) : p.push(s);
      }
      return t.child = f, f;
    }
    function rw(e, t, a, i, u) {
      var s = t.mode, f = e.child, p = f.sibling, v = {
        mode: "hidden",
        children: a
      }, m;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (s & xe) === oe && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== f
      ) {
        var y = t.child;
        m = y, m.childLanes = U, m.pendingProps = v, t.mode & Ve && (m.actualDuration = 0, m.actualStartTime = -1, m.selfBaseDuration = f.selfBaseDuration, m.treeBaseDuration = f.treeBaseDuration), t.deletions = null;
      } else
        m = u0(f, v), m.subtreeFlags = f.subtreeFlags & zt;
      var R;
      return p !== null ? R = rs(p, i) : (R = Uu(i, s, u, null), R.flags |= Et), R.return = t, m.return = t, m.sibling = R, t.child = m, R;
    }
    function im(e, t, a, i) {
      i !== null && Qy(i), Ac(t, e.child, null, a);
      var u = t.pendingProps, s = u.children, f = cS(t, s);
      return f.flags |= Et, t.memoizedState = null, f;
    }
    function aw(e, t, a, i, u) {
      var s = t.mode, f = {
        mode: "visible",
        children: a
      }, p = fS(f, s), v = Uu(i, s, u, null);
      return v.flags |= Et, p.return = t, v.return = t, p.sibling = v, t.child = p, (t.mode & xe) !== oe && Ac(t, e.child, null, u), v;
    }
    function iw(e, t, a) {
      return (e.mode & xe) === oe ? (S("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = he) : _y(t) ? e.lanes = yn : e.lanes = hr, null;
    }
    function lw(e, t, a, i, u, s, f) {
      if (a)
        if (t.flags & In) {
          t.flags &= -257;
          var w = Kg(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return im(e, t, f, w);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= ie, null;
          var O = i.children, D = i.fallback, V = aw(e, t, O, D, f), q = t.child;
          return q.memoizedState = sS(f), t.memoizedState = oS, V;
        }
      else {
        if (GR(), (t.mode & xe) === oe)
          return im(
            e,
            t,
            f,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (_y(u)) {
          var p, v, m;
          {
            var y = cR(u);
            p = y.digest, v = y.message, m = y.stack;
          }
          var R;
          v ? R = new Error(v) : R = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var E = Kg(R, p, m);
          return im(e, t, f, E);
        }
        var b = Zn(f, e.childLanes);
        if (ti || b) {
          var L = mm();
          if (L !== null) {
            var M = od(L, f);
            if (M !== Fe && M !== s.retryLane) {
              s.retryLane = M;
              var Q = nt;
              Br(e, M), pn(L, e, M, Q);
            }
          }
          OS();
          var ce = Kg(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return im(e, t, f, ce);
        } else if (LC(u)) {
          t.flags |= ie, t.child = e.child;
          var re = MD.bind(null, e);
          return fR(u, re), null;
        } else {
          qR(t, u, s.treeContext);
          var Ue = i.children, be = cS(t, Ue);
          return be.flags |= Or, be;
        }
      }
    }
    function o0(e, t, a) {
      e.lanes = Re(e.lanes, t);
      var i = e.alternate;
      i !== null && (i.lanes = Re(i.lanes, t)), tg(e.return, t, a);
    }
    function uw(e, t, a) {
      for (var i = t; i !== null; ) {
        if (i.tag === Me) {
          var u = i.memoizedState;
          u !== null && o0(i, a, e);
        } else if (i.tag === Bt)
          o0(i, a, e);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    function ow(e) {
      for (var t = e, a = null; t !== null; ) {
        var i = t.alternate;
        i !== null && Hh(i) === null && (a = t), t = t.sibling;
      }
      return a;
    }
    function sw(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !aS[e])
        if (aS[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              S('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              S('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              S('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          S('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function cw(e, t) {
      e !== void 0 && !am[e] && (e !== "collapsed" && e !== "hidden" ? (am[e] = !0, S('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (am[e] = !0, S('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function s0(e, t) {
      {
        var a = en(e), i = !a && typeof tt(e) == "function";
        if (a || i) {
          var u = a ? "array" : "iterable";
          return S("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", u, t, u), !1;
        }
      }
      return !0;
    }
    function fw(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (en(e)) {
          for (var a = 0; a < e.length; a++)
            if (!s0(e[a], a))
              return;
        } else {
          var i = tt(e);
          if (typeof i == "function") {
            var u = i.call(e);
            if (u)
              for (var s = u.next(), f = 0; !s.done; s = u.next()) {
                if (!s0(s.value, f))
                  return;
                f++;
              }
          } else
            S('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function dS(e, t, a, i, u) {
      var s = e.memoizedState;
      s === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: a,
        tailMode: u
      } : (s.isBackwards = t, s.rendering = null, s.renderingStartTime = 0, s.last = i, s.tail = a, s.tailMode = u);
    }
    function c0(e, t, a) {
      var i = t.pendingProps, u = i.revealOrder, s = i.tail, f = i.children;
      sw(u), cw(s, u), fw(f, u), gr(e, t, f, a);
      var p = Za.current, v = cg(p, Wd);
      if (v)
        p = fg(p, Wd), t.flags |= ie;
      else {
        var m = e !== null && (e.flags & ie) !== ue;
        m && uw(t, t.child, a), p = jc(p);
      }
      if (ku(t, p), (t.mode & xe) === oe)
        t.memoizedState = null;
      else
        switch (u) {
          case "forwards": {
            var y = ow(t.child), R;
            y === null ? (R = t.child, t.child = null) : (R = y.sibling, y.sibling = null), dS(
              t,
              !1,
              // isBackwards
              R,
              y,
              s
            );
            break;
          }
          case "backwards": {
            var E = null, b = t.child;
            for (t.child = null; b !== null; ) {
              var L = b.alternate;
              if (L !== null && Hh(L) === null) {
                t.child = b;
                break;
              }
              var M = b.sibling;
              b.sibling = E, E = b, b = M;
            }
            dS(
              t,
              !0,
              // isBackwards
              E,
              null,
              // last
              s
            );
            break;
          }
          case "together": {
            dS(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function dw(e, t, a) {
      ug(t, t.stateNode.containerInfo);
      var i = t.pendingProps;
      return e === null ? t.child = Ac(t, null, i, a) : gr(e, t, i, a), t.child;
    }
    var f0 = !1;
    function pw(e, t, a) {
      var i = t.type, u = i._context, s = t.pendingProps, f = t.memoizedProps, p = s.value;
      {
        "value" in s || f0 || (f0 = !0, S("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var v = t.type.propTypes;
        v && Xa(v, s, "prop", "Context.Provider");
      }
      if (rE(t, u, p), f !== null) {
        var m = f.value;
        if (I(m, p)) {
          if (f.children === s.children && !vh())
            return Nl(e, t, a);
        } else
          sx(t, u, a);
      }
      var y = s.children;
      return gr(e, t, y, a), t.child;
    }
    var d0 = !1;
    function vw(e, t, a) {
      var i = t.type;
      i._context === void 0 ? i !== i.Consumer && (d0 || (d0 = !0, S("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : i = i._context;
      var u = t.pendingProps, s = u.children;
      typeof s != "function" && S("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Fc(t, a);
      var f = Kt(i);
      pr(t);
      var p;
      return rp.current = t, Jt(!0), p = s(f), Jt(!1), vr(), t.flags |= ea, gr(e, t, p, a), t.child;
    }
    function lp() {
      ti = !0;
    }
    function lm(e, t) {
      (t.mode & xe) === oe && e !== null && (e.alternate = null, t.alternate = null, t.flags |= Et);
    }
    function Nl(e, t, a) {
      return e !== null && (t.dependencies = e.dependencies), BE(), gp(t.lanes), Zn(a, t.childLanes) ? (ux(e, t), t.child) : null;
    }
    function hw(e, t, a) {
      {
        var i = t.return;
        if (i === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, t === i.child)
          i.child = a;
        else {
          var u = i.child;
          if (u === null)
            throw new Error("Expected parent to have a child.");
          for (; u.sibling !== t; )
            if (u = u.sibling, u === null)
              throw new Error("Expected to find the previous sibling.");
          u.sibling = a;
        }
        var s = i.deletions;
        return s === null ? (i.deletions = [e], i.flags |= Mr) : s.push(e), a.flags |= Et, a;
      }
    }
    function pS(e, t) {
      var a = e.lanes;
      return !!Zn(a, t);
    }
    function mw(e, t, a) {
      switch (t.tag) {
        case ne:
          a0(t), t.stateNode, Uc();
          break;
        case ae:
          fE(t);
          break;
        case fe: {
          var i = t.type;
          Ni(i) && mh(t);
          break;
        }
        case Se:
          ug(t, t.stateNode.containerInfo);
          break;
        case Cn: {
          var u = t.memoizedProps.value, s = t.type._context;
          rE(t, s, u);
          break;
        }
        case it:
          {
            var f = Zn(a, t.childLanes);
            f && (t.flags |= Oe);
            {
              var p = t.stateNode;
              p.effectDuration = 0, p.passiveEffectDuration = 0;
            }
          }
          break;
        case Me: {
          var v = t.memoizedState;
          if (v !== null) {
            if (v.dehydrated !== null)
              return ku(t, jc(Za.current)), t.flags |= ie, null;
            var m = t.child, y = m.childLanes;
            if (Zn(a, y))
              return l0(e, t, a);
            ku(t, jc(Za.current));
            var R = Nl(e, t, a);
            return R !== null ? R.sibling : null;
          } else
            ku(t, jc(Za.current));
          break;
        }
        case Bt: {
          var E = (e.flags & ie) !== ue, b = Zn(a, t.childLanes);
          if (E) {
            if (b)
              return c0(e, t, a);
            t.flags |= ie;
          }
          var L = t.memoizedState;
          if (L !== null && (L.rendering = null, L.tail = null, L.lastEffect = null), ku(t, Za.current), b)
            break;
          return null;
        }
        case we:
        case vn:
          return t.lanes = U, t0(e, t, a);
      }
      return Nl(e, t, a);
    }
    function p0(e, t, a) {
      if (t._debugNeedsRemount && e !== null)
        return hw(e, t, $S(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var i = e.memoizedProps, u = t.pendingProps;
        if (i !== u || vh() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          ti = !0;
        else {
          var s = pS(e, a);
          if (!s && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & ie) === ue)
            return ti = !1, mw(e, t, a);
          (e.flags & Ns) !== ue ? ti = !0 : ti = !1;
        }
      } else if (ti = !1, Ln() && BR(t)) {
        var f = t.index, p = PR();
        BC(t, p, f);
      }
      switch (t.lanes = U, t.tag) {
        case Zt:
          return Kx(e, t, t.type, a);
        case En: {
          var v = t.elementType;
          return Xx(e, t, v, a);
        }
        case ge: {
          var m = t.type, y = t.pendingProps, R = t.elementType === m ? y : ei(m, y);
          return iS(e, t, m, R, a);
        }
        case fe: {
          var E = t.type, b = t.pendingProps, L = t.elementType === E ? b : ei(E, b);
          return r0(e, t, E, L, a);
        }
        case ne:
          return Ix(e, t, a);
        case ae:
          return Gx(e, t, a);
        case He:
          return Wx(e, t);
        case Me:
          return l0(e, t, a);
        case Se:
          return dw(e, t, a);
        case _e: {
          var M = t.type, Q = t.pendingProps, ce = t.elementType === M ? Q : ei(M, Q);
          return ZE(e, t, M, ce, a);
        }
        case Xe:
          return $x(e, t, a);
        case at:
          return Yx(e, t, a);
        case it:
          return Qx(e, t, a);
        case Cn:
          return pw(e, t, a);
        case Rr:
          return vw(e, t, a);
        case ft: {
          var re = t.type, Ue = t.pendingProps, be = ei(re, Ue);
          if (t.type !== t.elementType) {
            var w = re.propTypes;
            w && Xa(
              w,
              be,
              // Resolved for outer only
              "prop",
              We(re)
            );
          }
          return be = ei(re.type, be), JE(e, t, re, be, a);
        }
        case De:
          return e0(e, t, t.type, t.pendingProps, a);
        case mt: {
          var O = t.type, D = t.pendingProps, V = t.elementType === O ? D : ei(O, D);
          return qx(e, t, O, V, a);
        }
        case Bt:
          return c0(e, t, a);
        case lt:
          break;
        case we:
          return t0(e, t, a);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ic(e) {
      e.flags |= Oe;
    }
    function v0(e) {
      e.flags |= Ct, e.flags |= lu;
    }
    var h0, vS, m0, y0;
    h0 = function(e, t, a, i) {
      for (var u = t.child; u !== null; ) {
        if (u.tag === ae || u.tag === He)
          F1(e, u.stateNode);
        else if (u.tag !== Se) {
          if (u.child !== null) {
            u.child.return = u, u = u.child;
            continue;
          }
        }
        if (u === t)
          return;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === t)
            return;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }, vS = function(e, t) {
    }, m0 = function(e, t, a, i, u) {
      var s = e.memoizedProps;
      if (s !== i) {
        var f = t.stateNode, p = og(), v = j1(f, a, s, i, u, p);
        t.updateQueue = v, v && Ic(t);
      }
    }, y0 = function(e, t, a, i) {
      a !== i && Ic(t);
    };
    function up(e, t) {
      if (!Ln())
        switch (e.tailMode) {
          case "hidden": {
            for (var a = e.tail, i = null; a !== null; )
              a.alternate !== null && (i = a), a = a.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          }
          case "collapsed": {
            for (var u = e.tail, s = null; u !== null; )
              u.alternate !== null && (s = u), u = u.sibling;
            s === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : s.sibling = null;
            break;
          }
        }
    }
    function On(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = U, i = ue;
      if (t) {
        if ((e.mode & Ve) !== oe) {
          for (var v = e.selfBaseDuration, m = e.child; m !== null; )
            a = Re(a, Re(m.lanes, m.childLanes)), i |= m.subtreeFlags & zt, i |= m.flags & zt, v += m.treeBaseDuration, m = m.sibling;
          e.treeBaseDuration = v;
        } else
          for (var y = e.child; y !== null; )
            a = Re(a, Re(y.lanes, y.childLanes)), i |= y.subtreeFlags & zt, i |= y.flags & zt, y.return = e, y = y.sibling;
        e.subtreeFlags |= i;
      } else {
        if ((e.mode & Ve) !== oe) {
          for (var u = e.actualDuration, s = e.selfBaseDuration, f = e.child; f !== null; )
            a = Re(a, Re(f.lanes, f.childLanes)), i |= f.subtreeFlags, i |= f.flags, u += f.actualDuration, s += f.treeBaseDuration, f = f.sibling;
          e.actualDuration = u, e.treeBaseDuration = s;
        } else
          for (var p = e.child; p !== null; )
            a = Re(a, Re(p.lanes, p.childLanes)), i |= p.subtreeFlags, i |= p.flags, p.return = e, p = p.sibling;
        e.subtreeFlags |= i;
      }
      return e.childLanes = a, t;
    }
    function yw(e, t, a) {
      if (tx() && (t.mode & xe) !== oe && (t.flags & ie) === ue)
        return WC(t), Uc(), t.flags |= In | io | Wn, !1;
      var i = Eh(t);
      if (a !== null && a.dehydrated !== null)
        if (e === null) {
          if (!i)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (JR(t), On(t), (t.mode & Ve) !== oe) {
            var u = a !== null;
            if (u) {
              var s = t.child;
              s !== null && (t.treeBaseDuration -= s.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Uc(), (t.flags & ie) === ue && (t.memoizedState = null), t.flags |= Oe, On(t), (t.mode & Ve) !== oe) {
            var f = a !== null;
            if (f) {
              var p = t.child;
              p !== null && (t.treeBaseDuration -= p.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return XC(), !0;
    }
    function g0(e, t, a) {
      var i = t.pendingProps;
      switch (jy(t), t.tag) {
        case Zt:
        case En:
        case De:
        case ge:
        case _e:
        case Xe:
        case at:
        case it:
        case Rr:
        case ft:
          return On(t), null;
        case fe: {
          var u = t.type;
          return Ni(u) && hh(t), On(t), null;
        }
        case ne: {
          var s = t.stateNode;
          if (Vc(t), Ay(t), pg(), s.pendingContext && (s.context = s.pendingContext, s.pendingContext = null), e === null || e.child === null) {
            var f = Eh(t);
            if (f)
              Ic(t);
            else if (e !== null) {
              var p = e.memoizedState;
              // Check if this is a client root
              (!p.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & In) !== ue) && (t.flags |= $t, XC());
            }
          }
          return vS(e, t), On(t), null;
        }
        case ae: {
          sg(t);
          var v = cE(), m = t.type;
          if (e !== null && t.stateNode != null)
            m0(e, t, m, i, v), e.ref !== t.ref && v0(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return On(t), null;
            }
            var y = og(), R = Eh(t);
            if (R)
              KR(t, v, y) && Ic(t);
            else {
              var E = H1(m, i, v, y, t);
              h0(E, t, !1, !1), t.stateNode = E, V1(E, m, i, v) && Ic(t);
            }
            t.ref !== null && v0(t);
          }
          return On(t), null;
        }
        case He: {
          var b = i;
          if (e && t.stateNode != null) {
            var L = e.memoizedProps;
            y0(e, t, L, b);
          } else {
            if (typeof b != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var M = cE(), Q = og(), ce = Eh(t);
            ce ? ZR(t) && Ic(t) : t.stateNode = B1(b, M, Q, t);
          }
          return On(t), null;
        }
        case Me: {
          Bc(t);
          var re = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var Ue = yw(e, t, re);
            if (!Ue)
              return t.flags & Wn ? t : null;
          }
          if ((t.flags & ie) !== ue)
            return t.lanes = a, (t.mode & Ve) !== oe && Fg(t), t;
          var be = re !== null, w = e !== null && e.memoizedState !== null;
          if (be !== w && be) {
            var O = t.child;
            if (O.flags |= Nt, (t.mode & xe) !== oe) {
              var D = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              D || cg(Za.current, pE) ? gD() : OS();
            }
          }
          var V = t.updateQueue;
          if (V !== null && (t.flags |= Oe), On(t), (t.mode & Ve) !== oe && be) {
            var q = t.child;
            q !== null && (t.treeBaseDuration -= q.treeBaseDuration);
          }
          return null;
        }
        case Se:
          return Vc(t), vS(e, t), e === null && zR(t.stateNode.containerInfo), On(t), null;
        case Cn:
          var G = t.type._context;
          return eg(G, t), On(t), null;
        case mt: {
          var me = t.type;
          return Ni(me) && hh(t), On(t), null;
        }
        case Bt: {
          Bc(t);
          var Ee = t.memoizedState;
          if (Ee === null)
            return On(t), null;
          var Je = (t.flags & ie) !== ue, Pe = Ee.rendering;
          if (Pe === null)
            if (Je)
              up(Ee, !1);
            else {
              var Gt = CD() && (e === null || (e.flags & ie) === ue);
              if (!Gt)
                for (var $e = t.child; $e !== null; ) {
                  var jt = Hh($e);
                  if (jt !== null) {
                    Je = !0, t.flags |= ie, up(Ee, !1);
                    var ir = jt.updateQueue;
                    return ir !== null && (t.updateQueue = ir, t.flags |= Oe), t.subtreeFlags = ue, ox(t, a), ku(t, fg(Za.current, Wd)), t.child;
                  }
                  $e = $e.sibling;
                }
              Ee.tail !== null && Yt() > V0() && (t.flags |= ie, Je = !0, up(Ee, !1), t.lanes = Jf);
            }
          else {
            if (!Je) {
              var Hn = Hh(Pe);
              if (Hn !== null) {
                t.flags |= ie, Je = !0;
                var oa = Hn.updateQueue;
                if (oa !== null && (t.updateQueue = oa, t.flags |= Oe), up(Ee, !0), Ee.tail === null && Ee.tailMode === "hidden" && !Pe.alternate && !Ln())
                  return On(t), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Yt() * 2 - Ee.renderingStartTime > V0() && a !== hr && (t.flags |= ie, Je = !0, up(Ee, !1), t.lanes = Jf);
            }
            if (Ee.isBackwards)
              Pe.sibling = t.child, t.child = Pe;
            else {
              var Er = Ee.last;
              Er !== null ? Er.sibling = Pe : t.child = Pe, Ee.last = Pe;
            }
          }
          if (Ee.tail !== null) {
            var Tr = Ee.tail;
            Ee.rendering = Tr, Ee.tail = Tr.sibling, Ee.renderingStartTime = Yt(), Tr.sibling = null;
            var lr = Za.current;
            return Je ? lr = fg(lr, Wd) : lr = jc(lr), ku(t, lr), Tr;
          }
          return On(t), null;
        }
        case lt:
          break;
        case we:
        case vn: {
          MS(t);
          var Fl = t.memoizedState, ef = Fl !== null;
          if (e !== null) {
            var Rp = e.memoizedState, Bi = Rp !== null;
            Bi !== ef && (t.flags |= Nt);
          }
          return !ef || (t.mode & xe) === oe ? On(t) : Zn(ji, hr) && (On(t), t.subtreeFlags & (Et | Oe) && (t.flags |= Nt)), null;
        }
        case Tn:
          return null;
        case _t:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function gw(e, t, a) {
      switch (jy(t), t.tag) {
        case fe: {
          var i = t.type;
          Ni(i) && hh(t);
          var u = t.flags;
          return u & Wn ? (t.flags = u & -65537 | ie, (t.mode & Ve) !== oe && Fg(t), t) : null;
        }
        case ne: {
          t.stateNode, Vc(t), Ay(t), pg();
          var s = t.flags;
          return (s & Wn) !== ue && (s & ie) === ue ? (t.flags = s & -65537 | ie, t) : null;
        }
        case ae:
          return sg(t), null;
        case Me: {
          Bc(t);
          var f = t.memoizedState;
          if (f !== null && f.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Uc();
          }
          var p = t.flags;
          return p & Wn ? (t.flags = p & -65537 | ie, (t.mode & Ve) !== oe && Fg(t), t) : null;
        }
        case Bt:
          return Bc(t), null;
        case Se:
          return Vc(t), null;
        case Cn:
          var v = t.type._context;
          return eg(v, t), null;
        case we:
        case vn:
          return MS(t), null;
        case Tn:
          return null;
        default:
          return null;
      }
    }
    function S0(e, t, a) {
      switch (jy(t), t.tag) {
        case fe: {
          var i = t.type.childContextTypes;
          i != null && hh(t);
          break;
        }
        case ne: {
          t.stateNode, Vc(t), Ay(t), pg();
          break;
        }
        case ae: {
          sg(t);
          break;
        }
        case Se:
          Vc(t);
          break;
        case Me:
          Bc(t);
          break;
        case Bt:
          Bc(t);
          break;
        case Cn:
          var u = t.type._context;
          eg(u, t);
          break;
        case we:
        case vn:
          MS(t);
          break;
      }
    }
    var C0 = null;
    C0 = /* @__PURE__ */ new Set();
    var um = !1, Nn = !1, Sw = typeof WeakSet == "function" ? WeakSet : Set, ee = null, Gc = null, Wc = null;
    function Cw(e) {
      hi(null, function() {
        throw e;
      }), ao();
    }
    var Ew = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Ve)
        try {
          Fi(), t.componentWillUnmount();
        } finally {
          Hi(e);
        }
      else
        t.componentWillUnmount();
    };
    function E0(e, t) {
      try {
        Lu(un, e);
      } catch (a) {
        ot(e, t, a);
      }
    }
    function hS(e, t, a) {
      try {
        Ew(e, a);
      } catch (i) {
        ot(e, t, i);
      }
    }
    function Tw(e, t, a) {
      try {
        a.componentDidMount();
      } catch (i) {
        ot(e, t, i);
      }
    }
    function T0(e, t) {
      try {
        x0(e);
      } catch (a) {
        ot(e, t, a);
      }
    }
    function Xc(e, t) {
      var a = e.ref;
      if (a !== null)
        if (typeof a == "function") {
          var i;
          try {
            if (Rn && Pi && e.mode & Ve)
              try {
                Fi(), i = a(null);
              } finally {
                Hi(e);
              }
            else
              i = a(null);
          } catch (u) {
            ot(e, t, u);
          }
          typeof i == "function" && S("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Te(e));
        } else
          a.current = null;
    }
    function om(e, t, a) {
      try {
        a();
      } catch (i) {
        ot(e, t, i);
      }
    }
    var R0 = !1;
    function Rw(e, t) {
      U1(e.containerInfo), ee = t, xw();
      var a = R0;
      return R0 = !1, a;
    }
    function xw() {
      for (; ee !== null; ) {
        var e = ee, t = e.child;
        (e.subtreeFlags & yi) !== ue && t !== null ? (t.return = e, ee = t) : ww();
      }
    }
    function ww() {
      for (; ee !== null; ) {
        var e = ee;
        ut(e);
        try {
          Dw(e);
        } catch (a) {
          ot(e, e.return, a);
        }
        St();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, ee = t;
          return;
        }
        ee = e.return;
      }
    }
    function Dw(e) {
      var t = e.alternate, a = e.flags;
      if ((a & $t) !== ue) {
        switch (ut(e), e.tag) {
          case ge:
          case _e:
          case De:
            break;
          case fe: {
            if (t !== null) {
              var i = t.memoizedProps, u = t.memoizedState, s = e.stateNode;
              e.type === e.elementType && !Zo && (s.props !== e.memoizedProps && S("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Te(e) || "instance"), s.state !== e.memoizedState && S("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Te(e) || "instance"));
              var f = s.getSnapshotBeforeUpdate(e.elementType === e.type ? i : ei(e.type, i), u);
              {
                var p = C0;
                f === void 0 && !p.has(e.type) && (p.add(e.type), S("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Te(e)));
              }
              s.__reactInternalSnapshotBeforeUpdate = f;
            }
            break;
          }
          case ne: {
            {
              var v = e.stateNode;
              lR(v.containerInfo);
            }
            break;
          }
          case ae:
          case He:
          case Se:
          case mt:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        St();
      }
    }
    function ni(e, t, a) {
      var i = t.updateQueue, u = i !== null ? i.lastEffect : null;
      if (u !== null) {
        var s = u.next, f = s;
        do {
          if ((f.tag & e) === e) {
            var p = f.destroy;
            f.destroy = void 0, p !== void 0 && ((e & Mn) !== Pr ? $a(t) : (e & un) !== Pr && uo(t), (e & zi) !== Pr && Cp(!0), om(t, a, p), (e & zi) !== Pr && Cp(!1), (e & Mn) !== Pr ? Ei() : (e & un) !== Pr && Kf());
          }
          f = f.next;
        } while (f !== s);
      }
    }
    function Lu(e, t) {
      var a = t.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var u = i.next, s = u;
        do {
          if ((s.tag & e) === e) {
            (e & Mn) !== Pr ? qf(t) : (e & un) !== Pr && Vs(t);
            var f = s.create;
            (e & zi) !== Pr && Cp(!0), s.destroy = f(), (e & zi) !== Pr && Cp(!1), (e & Mn) !== Pr ? hv() : (e & un) !== Pr && mv();
            {
              var p = s.destroy;
              if (p !== void 0 && typeof p != "function") {
                var v = void 0;
                (s.tag & un) !== ue ? v = "useLayoutEffect" : (s.tag & zi) !== ue ? v = "useInsertionEffect" : v = "useEffect";
                var m = void 0;
                p === null ? m = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof p.then == "function" ? m = `

It looks like you wrote ` + v + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + v + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : m = " You returned: " + p, S("%s must not return anything besides a function, which is used for clean-up.%s", v, m);
              }
            }
          }
          s = s.next;
        } while (s !== u);
      }
    }
    function kw(e, t) {
      if ((t.flags & Oe) !== ue)
        switch (t.tag) {
          case it: {
            var a = t.stateNode.passiveEffectDuration, i = t.memoizedProps, u = i.id, s = i.onPostCommit, f = VE(), p = t.alternate === null ? "mount" : "update";
            FE() && (p = "nested-update"), typeof s == "function" && s(u, p, a, f);
            var v = t.return;
            e: for (; v !== null; ) {
              switch (v.tag) {
                case ne:
                  var m = v.stateNode;
                  m.passiveEffectDuration += a;
                  break e;
                case it:
                  var y = v.stateNode;
                  y.passiveEffectDuration += a;
                  break e;
              }
              v = v.return;
            }
            break;
          }
        }
    }
    function bw(e, t, a, i) {
      if ((a.flags & Si) !== ue)
        switch (a.tag) {
          case ge:
          case _e:
          case De: {
            if (!Nn)
              if (a.mode & Ve)
                try {
                  Fi(), Lu(un | ln, a);
                } finally {
                  Hi(a);
                }
              else
                Lu(un | ln, a);
            break;
          }
          case fe: {
            var u = a.stateNode;
            if (a.flags & Oe && !Nn)
              if (t === null)
                if (a.type === a.elementType && !Zo && (u.props !== a.memoizedProps && S("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Te(a) || "instance"), u.state !== a.memoizedState && S("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Te(a) || "instance")), a.mode & Ve)
                  try {
                    Fi(), u.componentDidMount();
                  } finally {
                    Hi(a);
                  }
                else
                  u.componentDidMount();
              else {
                var s = a.elementType === a.type ? t.memoizedProps : ei(a.type, t.memoizedProps), f = t.memoizedState;
                if (a.type === a.elementType && !Zo && (u.props !== a.memoizedProps && S("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Te(a) || "instance"), u.state !== a.memoizedState && S("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Te(a) || "instance")), a.mode & Ve)
                  try {
                    Fi(), u.componentDidUpdate(s, f, u.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Hi(a);
                  }
                else
                  u.componentDidUpdate(s, f, u.__reactInternalSnapshotBeforeUpdate);
              }
            var p = a.updateQueue;
            p !== null && (a.type === a.elementType && !Zo && (u.props !== a.memoizedProps && S("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Te(a) || "instance"), u.state !== a.memoizedState && S("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Te(a) || "instance")), sE(a, p, u));
            break;
          }
          case ne: {
            var v = a.updateQueue;
            if (v !== null) {
              var m = null;
              if (a.child !== null)
                switch (a.child.tag) {
                  case ae:
                    m = a.child.stateNode;
                    break;
                  case fe:
                    m = a.child.stateNode;
                    break;
                }
              sE(a, v, m);
            }
            break;
          }
          case ae: {
            var y = a.stateNode;
            if (t === null && a.flags & Oe) {
              var R = a.type, E = a.memoizedProps;
              I1(y, R, E);
            }
            break;
          }
          case He:
            break;
          case Se:
            break;
          case it: {
            {
              var b = a.memoizedProps, L = b.onCommit, M = b.onRender, Q = a.stateNode.effectDuration, ce = VE(), re = t === null ? "mount" : "update";
              FE() && (re = "nested-update"), typeof M == "function" && M(a.memoizedProps.id, re, a.actualDuration, a.treeBaseDuration, a.actualStartTime, ce);
              {
                typeof L == "function" && L(a.memoizedProps.id, re, Q, ce), wD(a);
                var Ue = a.return;
                e: for (; Ue !== null; ) {
                  switch (Ue.tag) {
                    case ne:
                      var be = Ue.stateNode;
                      be.effectDuration += Q;
                      break e;
                    case it:
                      var w = Ue.stateNode;
                      w.effectDuration += Q;
                      break e;
                  }
                  Ue = Ue.return;
                }
              }
            }
            break;
          }
          case Me: {
            Aw(e, a);
            break;
          }
          case Bt:
          case mt:
          case lt:
          case we:
          case vn:
          case _t:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Nn || a.flags & Ct && x0(a);
    }
    function _w(e) {
      switch (e.tag) {
        case ge:
        case _e:
        case De: {
          if (e.mode & Ve)
            try {
              Fi(), E0(e, e.return);
            } finally {
              Hi(e);
            }
          else
            E0(e, e.return);
          break;
        }
        case fe: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && Tw(e, e.return, t), T0(e, e.return);
          break;
        }
        case ae: {
          T0(e, e.return);
          break;
        }
      }
    }
    function Lw(e, t) {
      for (var a = null, i = e; ; ) {
        if (i.tag === ae) {
          if (a === null) {
            a = i;
            try {
              var u = i.stateNode;
              t ? nR(u) : aR(i.stateNode, i.memoizedProps);
            } catch (f) {
              ot(e, e.return, f);
            }
          }
        } else if (i.tag === He) {
          if (a === null)
            try {
              var s = i.stateNode;
              t ? rR(s) : iR(s, i.memoizedProps);
            } catch (f) {
              ot(e, e.return, f);
            }
        } else if (!((i.tag === we || i.tag === vn) && i.memoizedState !== null && i !== e)) {
          if (i.child !== null) {
            i.child.return = i, i = i.child;
            continue;
          }
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          a === i && (a = null), i = i.return;
        }
        a === i && (a = null), i.sibling.return = i.return, i = i.sibling;
      }
    }
    function x0(e) {
      var t = e.ref;
      if (t !== null) {
        var a = e.stateNode, i;
        switch (e.tag) {
          case ae:
            i = a;
            break;
          default:
            i = a;
        }
        if (typeof t == "function") {
          var u;
          if (e.mode & Ve)
            try {
              Fi(), u = t(i);
            } finally {
              Hi(e);
            }
          else
            u = t(i);
          typeof u == "function" && S("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Te(e));
        } else
          t.hasOwnProperty("current") || S("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Te(e)), t.current = i;
      }
    }
    function Mw(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function w0(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, w0(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === ae) {
          var a = e.stateNode;
          a !== null && HR(a);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function Ow(e) {
      for (var t = e.return; t !== null; ) {
        if (D0(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function D0(e) {
      return e.tag === ae || e.tag === ne || e.tag === Se;
    }
    function k0(e) {
      var t = e;
      e: for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || D0(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== ae && t.tag !== He && t.tag !== Wt; ) {
          if (t.flags & Et || t.child === null || t.tag === Se)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & Et))
          return t.stateNode;
      }
    }
    function Nw(e) {
      var t = Ow(e);
      switch (t.tag) {
        case ae: {
          var a = t.stateNode;
          t.flags & ta && (_C(a), t.flags &= -33);
          var i = k0(e);
          yS(e, i, a);
          break;
        }
        case ne:
        case Se: {
          var u = t.stateNode.containerInfo, s = k0(e);
          mS(e, s, u);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function mS(e, t, a) {
      var i = e.tag, u = i === ae || i === He;
      if (u) {
        var s = e.stateNode;
        t ? Z1(a, s, t) : q1(a, s);
      } else if (i !== Se) {
        var f = e.child;
        if (f !== null) {
          mS(f, t, a);
          for (var p = f.sibling; p !== null; )
            mS(p, t, a), p = p.sibling;
        }
      }
    }
    function yS(e, t, a) {
      var i = e.tag, u = i === ae || i === He;
      if (u) {
        var s = e.stateNode;
        t ? K1(a, s, t) : X1(a, s);
      } else if (i !== Se) {
        var f = e.child;
        if (f !== null) {
          yS(f, t, a);
          for (var p = f.sibling; p !== null; )
            yS(p, t, a), p = p.sibling;
        }
      }
    }
    var zn = null, ri = !1;
    function zw(e, t, a) {
      {
        var i = t;
        e: for (; i !== null; ) {
          switch (i.tag) {
            case ae: {
              zn = i.stateNode, ri = !1;
              break e;
            }
            case ne: {
              zn = i.stateNode.containerInfo, ri = !0;
              break e;
            }
            case Se: {
              zn = i.stateNode.containerInfo, ri = !0;
              break e;
            }
          }
          i = i.return;
        }
        if (zn === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        b0(e, t, a), zn = null, ri = !1;
      }
      Mw(a);
    }
    function Mu(e, t, a) {
      for (var i = a.child; i !== null; )
        b0(e, t, i), i = i.sibling;
    }
    function b0(e, t, a) {
      switch (Gf(a), a.tag) {
        case ae:
          Nn || Xc(a, t);
        case He: {
          {
            var i = zn, u = ri;
            zn = null, Mu(e, t, a), zn = i, ri = u, zn !== null && (ri ? eR(zn, a.stateNode) : J1(zn, a.stateNode));
          }
          return;
        }
        case Wt: {
          zn !== null && (ri ? tR(zn, a.stateNode) : by(zn, a.stateNode));
          return;
        }
        case Se: {
          {
            var s = zn, f = ri;
            zn = a.stateNode.containerInfo, ri = !0, Mu(e, t, a), zn = s, ri = f;
          }
          return;
        }
        case ge:
        case _e:
        case ft:
        case De: {
          if (!Nn) {
            var p = a.updateQueue;
            if (p !== null) {
              var v = p.lastEffect;
              if (v !== null) {
                var m = v.next, y = m;
                do {
                  var R = y, E = R.destroy, b = R.tag;
                  E !== void 0 && ((b & zi) !== Pr ? om(a, t, E) : (b & un) !== Pr && (uo(a), a.mode & Ve ? (Fi(), om(a, t, E), Hi(a)) : om(a, t, E), Kf())), y = y.next;
                } while (y !== m);
              }
            }
          }
          Mu(e, t, a);
          return;
        }
        case fe: {
          if (!Nn) {
            Xc(a, t);
            var L = a.stateNode;
            typeof L.componentWillUnmount == "function" && hS(a, t, L);
          }
          Mu(e, t, a);
          return;
        }
        case lt: {
          Mu(e, t, a);
          return;
        }
        case we: {
          if (
            // TODO: Remove this dead flag
            a.mode & xe
          ) {
            var M = Nn;
            Nn = M || a.memoizedState !== null, Mu(e, t, a), Nn = M;
          } else
            Mu(e, t, a);
          break;
        }
        default: {
          Mu(e, t, a);
          return;
        }
      }
    }
    function Uw(e) {
      e.memoizedState;
    }
    function Aw(e, t) {
      var a = t.memoizedState;
      if (a === null) {
        var i = t.alternate;
        if (i !== null) {
          var u = i.memoizedState;
          if (u !== null) {
            var s = u.dehydrated;
            s !== null && CR(s);
          }
        }
      }
    }
    function _0(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var a = e.stateNode;
        a === null && (a = e.stateNode = new Sw()), t.forEach(function(i) {
          var u = OD.bind(null, e, i);
          if (!a.has(i)) {
            if (a.add(i), Kn)
              if (Gc !== null && Wc !== null)
                Sp(Wc, Gc);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            i.then(u, u);
          }
        });
      }
    }
    function Hw(e, t, a) {
      Gc = a, Wc = e, ut(t), L0(t, e), ut(t), Gc = null, Wc = null;
    }
    function ai(e, t, a) {
      var i = t.deletions;
      if (i !== null)
        for (var u = 0; u < i.length; u++) {
          var s = i[u];
          try {
            zw(e, t, s);
          } catch (v) {
            ot(s, t, v);
          }
        }
      var f = Pu();
      if (t.subtreeFlags & gi)
        for (var p = t.child; p !== null; )
          ut(p), L0(p, e), p = p.sibling;
      ut(f);
    }
    function L0(e, t, a) {
      var i = e.alternate, u = e.flags;
      switch (e.tag) {
        case ge:
        case _e:
        case ft:
        case De: {
          if (ai(t, e), Vi(e), u & Oe) {
            try {
              ni(zi | ln, e, e.return), Lu(zi | ln, e);
            } catch (me) {
              ot(e, e.return, me);
            }
            if (e.mode & Ve) {
              try {
                Fi(), ni(un | ln, e, e.return);
              } catch (me) {
                ot(e, e.return, me);
              }
              Hi(e);
            } else
              try {
                ni(un | ln, e, e.return);
              } catch (me) {
                ot(e, e.return, me);
              }
          }
          return;
        }
        case fe: {
          ai(t, e), Vi(e), u & Ct && i !== null && Xc(i, i.return);
          return;
        }
        case ae: {
          ai(t, e), Vi(e), u & Ct && i !== null && Xc(i, i.return);
          {
            if (e.flags & ta) {
              var s = e.stateNode;
              try {
                _C(s);
              } catch (me) {
                ot(e, e.return, me);
              }
            }
            if (u & Oe) {
              var f = e.stateNode;
              if (f != null) {
                var p = e.memoizedProps, v = i !== null ? i.memoizedProps : p, m = e.type, y = e.updateQueue;
                if (e.updateQueue = null, y !== null)
                  try {
                    G1(f, y, m, v, p, e);
                  } catch (me) {
                    ot(e, e.return, me);
                  }
              }
            }
          }
          return;
        }
        case He: {
          if (ai(t, e), Vi(e), u & Oe) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var R = e.stateNode, E = e.memoizedProps, b = i !== null ? i.memoizedProps : E;
            try {
              W1(R, b, E);
            } catch (me) {
              ot(e, e.return, me);
            }
          }
          return;
        }
        case ne: {
          if (ai(t, e), Vi(e), u & Oe && i !== null) {
            var L = i.memoizedState;
            if (L.isDehydrated)
              try {
                SR(t.containerInfo);
              } catch (me) {
                ot(e, e.return, me);
              }
          }
          return;
        }
        case Se: {
          ai(t, e), Vi(e);
          return;
        }
        case Me: {
          ai(t, e), Vi(e);
          var M = e.child;
          if (M.flags & Nt) {
            var Q = M.stateNode, ce = M.memoizedState, re = ce !== null;
            if (Q.isHidden = re, re) {
              var Ue = M.alternate !== null && M.alternate.memoizedState !== null;
              Ue || yD();
            }
          }
          if (u & Oe) {
            try {
              Uw(e);
            } catch (me) {
              ot(e, e.return, me);
            }
            _0(e);
          }
          return;
        }
        case we: {
          var be = i !== null && i.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & xe
          ) {
            var w = Nn;
            Nn = w || be, ai(t, e), Nn = w;
          } else
            ai(t, e);
          if (Vi(e), u & Nt) {
            var O = e.stateNode, D = e.memoizedState, V = D !== null, q = e;
            if (O.isHidden = V, V && !be && (q.mode & xe) !== oe) {
              ee = q;
              for (var G = q.child; G !== null; )
                ee = G, Vw(G), G = G.sibling;
            }
            Lw(q, V);
          }
          return;
        }
        case Bt: {
          ai(t, e), Vi(e), u & Oe && _0(e);
          return;
        }
        case lt:
          return;
        default: {
          ai(t, e), Vi(e);
          return;
        }
      }
    }
    function Vi(e) {
      var t = e.flags;
      if (t & Et) {
        try {
          Nw(e);
        } catch (a) {
          ot(e, e.return, a);
        }
        e.flags &= -3;
      }
      t & Or && (e.flags &= -4097);
    }
    function Fw(e, t, a) {
      Gc = a, Wc = t, ee = e, M0(e, t, a), Gc = null, Wc = null;
    }
    function M0(e, t, a) {
      for (var i = (e.mode & xe) !== oe; ee !== null; ) {
        var u = ee, s = u.child;
        if (u.tag === we && i) {
          var f = u.memoizedState !== null, p = f || um;
          if (p) {
            gS(e, t, a);
            continue;
          } else {
            var v = u.alternate, m = v !== null && v.memoizedState !== null, y = m || Nn, R = um, E = Nn;
            um = p, Nn = y, Nn && !E && (ee = u, jw(u));
            for (var b = s; b !== null; )
              ee = b, M0(
                b,
                // New root; bubble back up to here and stop.
                t,
                a
              ), b = b.sibling;
            ee = u, um = R, Nn = E, gS(e, t, a);
            continue;
          }
        }
        (u.subtreeFlags & Si) !== ue && s !== null ? (s.return = u, ee = s) : gS(e, t, a);
      }
    }
    function gS(e, t, a) {
      for (; ee !== null; ) {
        var i = ee;
        if ((i.flags & Si) !== ue) {
          var u = i.alternate;
          ut(i);
          try {
            bw(t, u, i, a);
          } catch (f) {
            ot(i, i.return, f);
          }
          St();
        }
        if (i === e) {
          ee = null;
          return;
        }
        var s = i.sibling;
        if (s !== null) {
          s.return = i.return, ee = s;
          return;
        }
        ee = i.return;
      }
    }
    function Vw(e) {
      for (; ee !== null; ) {
        var t = ee, a = t.child;
        switch (t.tag) {
          case ge:
          case _e:
          case ft:
          case De: {
            if (t.mode & Ve)
              try {
                Fi(), ni(un, t, t.return);
              } finally {
                Hi(t);
              }
            else
              ni(un, t, t.return);
            break;
          }
          case fe: {
            Xc(t, t.return);
            var i = t.stateNode;
            typeof i.componentWillUnmount == "function" && hS(t, t.return, i);
            break;
          }
          case ae: {
            Xc(t, t.return);
            break;
          }
          case we: {
            var u = t.memoizedState !== null;
            if (u) {
              O0(e);
              continue;
            }
            break;
          }
        }
        a !== null ? (a.return = t, ee = a) : O0(e);
      }
    }
    function O0(e) {
      for (; ee !== null; ) {
        var t = ee;
        if (t === e) {
          ee = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, ee = a;
          return;
        }
        ee = t.return;
      }
    }
    function jw(e) {
      for (; ee !== null; ) {
        var t = ee, a = t.child;
        if (t.tag === we) {
          var i = t.memoizedState !== null;
          if (i) {
            N0(e);
            continue;
          }
        }
        a !== null ? (a.return = t, ee = a) : N0(e);
      }
    }
    function N0(e) {
      for (; ee !== null; ) {
        var t = ee;
        ut(t);
        try {
          _w(t);
        } catch (i) {
          ot(t, t.return, i);
        }
        if (St(), t === e) {
          ee = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, ee = a;
          return;
        }
        ee = t.return;
      }
    }
    function Bw(e, t, a, i) {
      ee = t, Pw(t, e, a, i);
    }
    function Pw(e, t, a, i) {
      for (; ee !== null; ) {
        var u = ee, s = u.child;
        (u.subtreeFlags & Ba) !== ue && s !== null ? (s.return = u, ee = s) : $w(e, t, a, i);
      }
    }
    function $w(e, t, a, i) {
      for (; ee !== null; ) {
        var u = ee;
        if ((u.flags & Gn) !== ue) {
          ut(u);
          try {
            Yw(t, u, a, i);
          } catch (f) {
            ot(u, u.return, f);
          }
          St();
        }
        if (u === e) {
          ee = null;
          return;
        }
        var s = u.sibling;
        if (s !== null) {
          s.return = u.return, ee = s;
          return;
        }
        ee = u.return;
      }
    }
    function Yw(e, t, a, i) {
      switch (t.tag) {
        case ge:
        case _e:
        case De: {
          if (t.mode & Ve) {
            Hg();
            try {
              Lu(Mn | ln, t);
            } finally {
              Ag(t);
            }
          } else
            Lu(Mn | ln, t);
          break;
        }
      }
    }
    function Qw(e) {
      ee = e, Iw();
    }
    function Iw() {
      for (; ee !== null; ) {
        var e = ee, t = e.child;
        if ((ee.flags & Mr) !== ue) {
          var a = e.deletions;
          if (a !== null) {
            for (var i = 0; i < a.length; i++) {
              var u = a[i];
              ee = u, Xw(u, e);
            }
            {
              var s = e.alternate;
              if (s !== null) {
                var f = s.child;
                if (f !== null) {
                  s.child = null;
                  do {
                    var p = f.sibling;
                    f.sibling = null, f = p;
                  } while (f !== null);
                }
              }
            }
            ee = e;
          }
        }
        (e.subtreeFlags & Ba) !== ue && t !== null ? (t.return = e, ee = t) : Gw();
      }
    }
    function Gw() {
      for (; ee !== null; ) {
        var e = ee;
        (e.flags & Gn) !== ue && (ut(e), Ww(e), St());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, ee = t;
          return;
        }
        ee = e.return;
      }
    }
    function Ww(e) {
      switch (e.tag) {
        case ge:
        case _e:
        case De: {
          e.mode & Ve ? (Hg(), ni(Mn | ln, e, e.return), Ag(e)) : ni(Mn | ln, e, e.return);
          break;
        }
      }
    }
    function Xw(e, t) {
      for (; ee !== null; ) {
        var a = ee;
        ut(a), Kw(a, t), St();
        var i = a.child;
        i !== null ? (i.return = a, ee = i) : qw(e);
      }
    }
    function qw(e) {
      for (; ee !== null; ) {
        var t = ee, a = t.sibling, i = t.return;
        if (w0(t), t === e) {
          ee = null;
          return;
        }
        if (a !== null) {
          a.return = i, ee = a;
          return;
        }
        ee = i;
      }
    }
    function Kw(e, t) {
      switch (e.tag) {
        case ge:
        case _e:
        case De: {
          e.mode & Ve ? (Hg(), ni(Mn, e, t), Ag(e)) : ni(Mn, e, t);
          break;
        }
      }
    }
    function Zw(e) {
      switch (e.tag) {
        case ge:
        case _e:
        case De: {
          try {
            Lu(un | ln, e);
          } catch (a) {
            ot(e, e.return, a);
          }
          break;
        }
        case fe: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (a) {
            ot(e, e.return, a);
          }
          break;
        }
      }
    }
    function Jw(e) {
      switch (e.tag) {
        case ge:
        case _e:
        case De: {
          try {
            Lu(Mn | ln, e);
          } catch (t) {
            ot(e, e.return, t);
          }
          break;
        }
      }
    }
    function eD(e) {
      switch (e.tag) {
        case ge:
        case _e:
        case De: {
          try {
            ni(un | ln, e, e.return);
          } catch (a) {
            ot(e, e.return, a);
          }
          break;
        }
        case fe: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && hS(e, e.return, t);
          break;
        }
      }
    }
    function tD(e) {
      switch (e.tag) {
        case ge:
        case _e:
        case De:
          try {
            ni(Mn | ln, e, e.return);
          } catch (t) {
            ot(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var op = Symbol.for;
      op("selector.component"), op("selector.has_pseudo_class"), op("selector.role"), op("selector.test_id"), op("selector.text");
    }
    var nD = [];
    function rD() {
      nD.forEach(function(e) {
        return e();
      });
    }
    var aD = N.ReactCurrentActQueue;
    function iD(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), a = typeof jest < "u";
        return a && t !== !1;
      }
    }
    function z0() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && aD.current !== null && S("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var lD = Math.ceil, SS = N.ReactCurrentDispatcher, CS = N.ReactCurrentOwner, Un = N.ReactCurrentBatchConfig, ii = N.ReactCurrentActQueue, cn = (
      /*             */
      0
    ), U0 = (
      /*               */
      1
    ), An = (
      /*                */
      2
    ), Ma = (
      /*                */
      4
    ), zl = 0, sp = 1, Jo = 2, sm = 3, cp = 4, A0 = 5, ES = 6, ze = cn, Sr = null, kt = null, fn = U, ji = U, TS = Eu(U), dn = zl, fp = null, cm = U, dp = U, fm = U, pp = null, $r = null, RS = 0, H0 = 500, F0 = 1 / 0, uD = 500, Ul = null;
    function vp() {
      F0 = Yt() + uD;
    }
    function V0() {
      return F0;
    }
    var dm = !1, xS = null, qc = null, es = !1, Ou = null, hp = U, wS = [], DS = null, oD = 50, mp = 0, kS = null, bS = !1, pm = !1, sD = 50, Kc = 0, vm = null, yp = nt, hm = U, j0 = !1;
    function mm() {
      return Sr;
    }
    function Cr() {
      return (ze & (An | Ma)) !== cn ? Yt() : (yp !== nt || (yp = Yt()), yp);
    }
    function Nu(e) {
      var t = e.mode;
      if ((t & xe) === oe)
        return he;
      if ((ze & An) !== cn && fn !== U)
        return Eo(fn);
      var a = ax() !== rx;
      if (a) {
        if (Un.transition !== null) {
          var i = Un.transition;
          i._updatedFibers || (i._updatedFibers = /* @__PURE__ */ new Set()), i._updatedFibers.add(e);
        }
        return hm === Fe && (hm = id()), hm;
      }
      var u = Fr();
      if (u !== Fe)
        return u;
      var s = P1();
      return s;
    }
    function cD(e) {
      var t = e.mode;
      return (t & xe) === oe ? he : Tv();
    }
    function pn(e, t, a, i) {
      zD(), j0 && S("useInsertionEffect must not schedule updates."), bS && (pm = !0), cu(e, a, i), (ze & An) !== U && e === Sr ? HD(t) : (Kn && xo(e, t, a), FD(t), e === Sr && ((ze & An) === cn && (dp = Re(dp, a)), dn === cp && zu(e, fn)), Yr(e, i), a === he && ze === cn && (t.mode & xe) === oe && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !ii.isBatchingLegacy && (vp(), jC()));
    }
    function fD(e, t, a) {
      var i = e.current;
      i.lanes = t, cu(e, t, a), Yr(e, a);
    }
    function dD(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (ze & An) !== cn
      );
    }
    function Yr(e, t) {
      var a = e.callbackNode;
      ic(e, t);
      var i = ac(e, e === Sr ? fn : U);
      if (i === U) {
        a !== null && nT(a), e.callbackNode = null, e.callbackPriority = Fe;
        return;
      }
      var u = xi(i), s = e.callbackPriority;
      if (s === u && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(ii.current !== null && a !== US)) {
        a == null && s !== he && S("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      a != null && nT(a);
      var f;
      if (u === he)
        e.tag === Tu ? (ii.isBatchingLegacy !== null && (ii.didScheduleLegacyUpdate = !0), jR($0.bind(null, e))) : VC($0.bind(null, e)), ii.current !== null ? ii.current.push(Ru) : Y1(function() {
          (ze & (An | Ma)) === cn && Ru();
        }), f = null;
      else {
        var p;
        switch (_v(i)) {
          case wn:
            p = lo;
            break;
          case Ea:
            p = Ci;
            break;
          case Ar:
            p = Pa;
            break;
          case Hr:
            p = sl;
            break;
          default:
            p = Pa;
            break;
        }
        f = AS(p, B0.bind(null, e));
      }
      e.callbackPriority = u, e.callbackNode = f;
    }
    function B0(e, t) {
      if (Lx(), yp = nt, hm = U, (ze & (An | Ma)) !== cn)
        throw new Error("Should not already be working.");
      var a = e.callbackNode, i = Hl();
      if (i && e.callbackNode !== a)
        return null;
      var u = ac(e, e === Sr ? fn : U);
      if (u === U)
        return null;
      var s = !uc(e, u) && !Ev(e, u) && !t, f = s ? TD(e, u) : gm(e, u);
      if (f !== zl) {
        if (f === Jo) {
          var p = lc(e);
          p !== U && (u = p, f = _S(e, p));
        }
        if (f === sp) {
          var v = fp;
          throw ts(e, U), zu(e, u), Yr(e, Yt()), v;
        }
        if (f === ES)
          zu(e, u);
        else {
          var m = !uc(e, u), y = e.current.alternate;
          if (m && !vD(y)) {
            if (f = gm(e, u), f === Jo) {
              var R = lc(e);
              R !== U && (u = R, f = _S(e, R));
            }
            if (f === sp) {
              var E = fp;
              throw ts(e, U), zu(e, u), Yr(e, Yt()), E;
            }
          }
          e.finishedWork = y, e.finishedLanes = u, pD(e, f, u);
        }
      }
      return Yr(e, Yt()), e.callbackNode === a ? B0.bind(null, e) : null;
    }
    function _S(e, t) {
      var a = pp;
      if (cc(e)) {
        var i = ts(e, t);
        i.flags |= In, NR(e.containerInfo);
      }
      var u = gm(e, t);
      if (u !== Jo) {
        var s = $r;
        $r = a, s !== null && P0(s);
      }
      return u;
    }
    function P0(e) {
      $r === null ? $r = e : $r.push.apply($r, e);
    }
    function pD(e, t, a) {
      switch (t) {
        case zl:
        case sp:
          throw new Error("Root did not complete. This is a bug in React.");
        case Jo: {
          ns(e, $r, Ul);
          break;
        }
        case sm: {
          if (zu(e, a), Cl(a) && // do not delay if we're inside an act() scope
          !rT()) {
            var i = RS + H0 - Yt();
            if (i > 10) {
              var u = ac(e, U);
              if (u !== U)
                break;
              var s = e.suspendedLanes;
              if (!El(s, a)) {
                Cr(), oc(e, s);
                break;
              }
              e.timeoutHandle = Dy(ns.bind(null, e, $r, Ul), i);
              break;
            }
          }
          ns(e, $r, Ul);
          break;
        }
        case cp: {
          if (zu(e, a), rd(a))
            break;
          if (!rT()) {
            var f = ra(e, a), p = f, v = Yt() - p, m = ND(v) - v;
            if (m > 10) {
              e.timeoutHandle = Dy(ns.bind(null, e, $r, Ul), m);
              break;
            }
          }
          ns(e, $r, Ul);
          break;
        }
        case A0: {
          ns(e, $r, Ul);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function vD(e) {
      for (var t = e; ; ) {
        if (t.flags & iu) {
          var a = t.updateQueue;
          if (a !== null) {
            var i = a.stores;
            if (i !== null)
              for (var u = 0; u < i.length; u++) {
                var s = i[u], f = s.getSnapshot, p = s.value;
                try {
                  if (!I(f(), p))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var v = t.child;
        if (t.subtreeFlags & iu && v !== null) {
          v.return = t, t = v;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function zu(e, t) {
      t = To(t, fm), t = To(t, dp), wv(e, t);
    }
    function $0(e) {
      if (Mx(), (ze & (An | Ma)) !== cn)
        throw new Error("Should not already be working.");
      Hl();
      var t = ac(e, U);
      if (!Zn(t, he))
        return Yr(e, Yt()), null;
      var a = gm(e, t);
      if (e.tag !== Tu && a === Jo) {
        var i = lc(e);
        i !== U && (t = i, a = _S(e, i));
      }
      if (a === sp) {
        var u = fp;
        throw ts(e, U), zu(e, t), Yr(e, Yt()), u;
      }
      if (a === ES)
        throw new Error("Root did not complete. This is a bug in React.");
      var s = e.current.alternate;
      return e.finishedWork = s, e.finishedLanes = t, ns(e, $r, Ul), Yr(e, Yt()), null;
    }
    function hD(e, t) {
      t !== U && (sc(e, Re(t, he)), Yr(e, Yt()), (ze & (An | Ma)) === cn && (vp(), Ru()));
    }
    function LS(e, t) {
      var a = ze;
      ze |= U0;
      try {
        return e(t);
      } finally {
        ze = a, ze === cn && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !ii.isBatchingLegacy && (vp(), jC());
      }
    }
    function mD(e, t, a, i, u) {
      var s = Fr(), f = Un.transition;
      try {
        return Un.transition = null, Ht(wn), e(t, a, i, u);
      } finally {
        Ht(s), Un.transition = f, ze === cn && vp();
      }
    }
    function Al(e) {
      Ou !== null && Ou.tag === Tu && (ze & (An | Ma)) === cn && Hl();
      var t = ze;
      ze |= U0;
      var a = Un.transition, i = Fr();
      try {
        return Un.transition = null, Ht(wn), e ? e() : void 0;
      } finally {
        Ht(i), Un.transition = a, ze = t, (ze & (An | Ma)) === cn && Ru();
      }
    }
    function Y0() {
      return (ze & (An | Ma)) !== cn;
    }
    function ym(e, t) {
      rr(TS, ji, e), ji = Re(ji, t);
    }
    function MS(e) {
      ji = TS.current, nr(TS, e);
    }
    function ts(e, t) {
      e.finishedWork = null, e.finishedLanes = U;
      var a = e.timeoutHandle;
      if (a !== ky && (e.timeoutHandle = ky, $1(a)), kt !== null)
        for (var i = kt.return; i !== null; ) {
          var u = i.alternate;
          S0(u, i), i = i.return;
        }
      Sr = e;
      var s = rs(e.current, null);
      return kt = s, fn = ji = t, dn = zl, fp = null, cm = U, dp = U, fm = U, pp = null, $r = null, fx(), Ka.discardPendingWarnings(), s;
    }
    function Q0(e, t) {
      do {
        var a = kt;
        try {
          if (kh(), hE(), St(), CS.current = null, a === null || a.return === null) {
            dn = sp, fp = t, kt = null;
            return;
          }
          if (Rn && a.mode & Ve && nm(a, !0), Gr)
            if (vr(), t !== null && typeof t == "object" && typeof t.then == "function") {
              var i = t;
              Ca(a, i, fn);
            } else
              oo(a, t, fn);
          jx(e, a.return, a, t, fn), X0(a);
        } catch (u) {
          t = u, kt === a && a !== null ? (a = a.return, kt = a) : a = kt;
          continue;
        }
        return;
      } while (!0);
    }
    function I0() {
      var e = SS.current;
      return SS.current = Kh, e === null ? Kh : e;
    }
    function G0(e) {
      SS.current = e;
    }
    function yD() {
      RS = Yt();
    }
    function gp(e) {
      cm = Re(e, cm);
    }
    function gD() {
      dn === zl && (dn = sm);
    }
    function OS() {
      (dn === zl || dn === sm || dn === Jo) && (dn = cp), Sr !== null && (Co(cm) || Co(dp)) && zu(Sr, fn);
    }
    function SD(e) {
      dn !== cp && (dn = Jo), pp === null ? pp = [e] : pp.push(e);
    }
    function CD() {
      return dn === zl;
    }
    function gm(e, t) {
      var a = ze;
      ze |= An;
      var i = I0();
      if (Sr !== e || fn !== t) {
        if (Kn) {
          var u = e.memoizedUpdaters;
          u.size > 0 && (Sp(e, fn), u.clear()), Dv(e, t);
        }
        Ul = sd(), ts(e, t);
      }
      pl(t);
      do
        try {
          ED();
          break;
        } catch (s) {
          Q0(e, s);
        }
      while (!0);
      if (kh(), ze = a, G0(i), kt !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return js(), Sr = null, fn = U, dn;
    }
    function ED() {
      for (; kt !== null; )
        W0(kt);
    }
    function TD(e, t) {
      var a = ze;
      ze |= An;
      var i = I0();
      if (Sr !== e || fn !== t) {
        if (Kn) {
          var u = e.memoizedUpdaters;
          u.size > 0 && (Sp(e, fn), u.clear()), Dv(e, t);
        }
        Ul = sd(), vp(), ts(e, t);
      }
      pl(t);
      do
        try {
          RD();
          break;
        } catch (s) {
          Q0(e, s);
        }
      while (!0);
      return kh(), G0(i), ze = a, kt !== null ? (yv(), zl) : (js(), Sr = null, fn = U, dn);
    }
    function RD() {
      for (; kt !== null && !Pf(); )
        W0(kt);
    }
    function W0(e) {
      var t = e.alternate;
      ut(e);
      var a;
      (e.mode & Ve) !== oe ? (Ug(e), a = NS(t, e, ji), nm(e, !0)) : a = NS(t, e, ji), St(), e.memoizedProps = e.pendingProps, a === null ? X0(e) : kt = a, CS.current = null;
    }
    function X0(e) {
      var t = e;
      do {
        var a = t.alternate, i = t.return;
        if ((t.flags & io) === ue) {
          ut(t);
          var u = void 0;
          if ((t.mode & Ve) === oe ? u = g0(a, t, ji) : (Ug(t), u = g0(a, t, ji), nm(t, !1)), St(), u !== null) {
            kt = u;
            return;
          }
        } else {
          var s = gw(a, t);
          if (s !== null) {
            s.flags &= fv, kt = s;
            return;
          }
          if ((t.mode & Ve) !== oe) {
            nm(t, !1);
            for (var f = t.actualDuration, p = t.child; p !== null; )
              f += p.actualDuration, p = p.sibling;
            t.actualDuration = f;
          }
          if (i !== null)
            i.flags |= io, i.subtreeFlags = ue, i.deletions = null;
          else {
            dn = ES, kt = null;
            return;
          }
        }
        var v = t.sibling;
        if (v !== null) {
          kt = v;
          return;
        }
        t = i, kt = t;
      } while (t !== null);
      dn === zl && (dn = A0);
    }
    function ns(e, t, a) {
      var i = Fr(), u = Un.transition;
      try {
        Un.transition = null, Ht(wn), xD(e, t, a, i);
      } finally {
        Un.transition = u, Ht(i);
      }
      return null;
    }
    function xD(e, t, a, i) {
      do
        Hl();
      while (Ou !== null);
      if (UD(), (ze & (An | Ma)) !== cn)
        throw new Error("Should not already be working.");
      var u = e.finishedWork, s = e.finishedLanes;
      if (Wf(s), u === null)
        return Xf(), null;
      if (s === U && S("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = U, u === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Fe;
      var f = Re(u.lanes, u.childLanes);
      ud(e, f), e === Sr && (Sr = null, kt = null, fn = U), ((u.subtreeFlags & Ba) !== ue || (u.flags & Ba) !== ue) && (es || (es = !0, DS = a, AS(Pa, function() {
        return Hl(), null;
      })));
      var p = (u.subtreeFlags & (yi | gi | Si | Ba)) !== ue, v = (u.flags & (yi | gi | Si | Ba)) !== ue;
      if (p || v) {
        var m = Un.transition;
        Un.transition = null;
        var y = Fr();
        Ht(wn);
        var R = ze;
        ze |= Ma, CS.current = null, Rw(e, u), jE(), Hw(e, u, s), A1(e.containerInfo), e.current = u, so(s), Fw(u, e, s), co(), $f(), ze = R, Ht(y), Un.transition = m;
      } else
        e.current = u, jE();
      var E = es;
      if (es ? (es = !1, Ou = e, hp = s) : (Kc = 0, vm = null), f = e.pendingLanes, f === U && (qc = null), E || J0(e.current, !1), Qf(u.stateNode, i), Kn && e.memoizedUpdaters.clear(), rD(), Yr(e, Yt()), t !== null)
        for (var b = e.onRecoverableError, L = 0; L < t.length; L++) {
          var M = t[L], Q = M.stack, ce = M.digest;
          b(M.value, {
            componentStack: Q,
            digest: ce
          });
        }
      if (dm) {
        dm = !1;
        var re = xS;
        throw xS = null, re;
      }
      return Zn(hp, he) && e.tag !== Tu && Hl(), f = e.pendingLanes, Zn(f, he) ? (_x(), e === kS ? mp++ : (mp = 0, kS = e)) : mp = 0, Ru(), Xf(), null;
    }
    function Hl() {
      if (Ou !== null) {
        var e = _v(hp), t = Do(Ar, e), a = Un.transition, i = Fr();
        try {
          return Un.transition = null, Ht(t), DD();
        } finally {
          Ht(i), Un.transition = a;
        }
      }
      return !1;
    }
    function wD(e) {
      wS.push(e), es || (es = !0, AS(Pa, function() {
        return Hl(), null;
      }));
    }
    function DD() {
      if (Ou === null)
        return !1;
      var e = DS;
      DS = null;
      var t = Ou, a = hp;
      if (Ou = null, hp = U, (ze & (An | Ma)) !== cn)
        throw new Error("Cannot flush passive effects while already rendering.");
      bS = !0, pm = !1, dl(a);
      var i = ze;
      ze |= Ma, Qw(t.current), Bw(t, t.current, a, e);
      {
        var u = wS;
        wS = [];
        for (var s = 0; s < u.length; s++) {
          var f = u[s];
          kw(t, f);
        }
      }
      Zf(), J0(t.current, !0), ze = i, Ru(), pm ? t === vm ? Kc++ : (Kc = 0, vm = t) : Kc = 0, bS = !1, pm = !1, If(t);
      {
        var p = t.current.stateNode;
        p.effectDuration = 0, p.passiveEffectDuration = 0;
      }
      return !0;
    }
    function q0(e) {
      return qc !== null && qc.has(e);
    }
    function kD(e) {
      qc === null ? qc = /* @__PURE__ */ new Set([e]) : qc.add(e);
    }
    function bD(e) {
      dm || (dm = !0, xS = e);
    }
    var _D = bD;
    function K0(e, t, a) {
      var i = Ko(a, t), u = WE(e, i, he), s = wu(e, u, he), f = Cr();
      s !== null && (cu(s, he, f), Yr(s, f));
    }
    function ot(e, t, a) {
      if (Cw(a), Cp(!1), e.tag === ne) {
        K0(e, e, a);
        return;
      }
      var i = null;
      for (i = t; i !== null; ) {
        if (i.tag === ne) {
          K0(i, e, a);
          return;
        } else if (i.tag === fe) {
          var u = i.type, s = i.stateNode;
          if (typeof u.getDerivedStateFromError == "function" || typeof s.componentDidCatch == "function" && !q0(s)) {
            var f = Ko(a, e), p = Jg(i, f, he), v = wu(i, p, he), m = Cr();
            v !== null && (cu(v, he, m), Yr(v, m));
            return;
          }
        }
        i = i.return;
      }
      S(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, a);
    }
    function LD(e, t, a) {
      var i = e.pingCache;
      i !== null && i.delete(t);
      var u = Cr();
      oc(e, a), VD(e), Sr === e && El(fn, a) && (dn === cp || dn === sm && Cl(fn) && Yt() - RS < H0 ? ts(e, U) : fm = Re(fm, a)), Yr(e, u);
    }
    function Z0(e, t) {
      t === Fe && (t = cD(e));
      var a = Cr(), i = Br(e, t);
      i !== null && (cu(i, t, a), Yr(i, a));
    }
    function MD(e) {
      var t = e.memoizedState, a = Fe;
      t !== null && (a = t.retryLane), Z0(e, a);
    }
    function OD(e, t) {
      var a = Fe, i;
      switch (e.tag) {
        case Me:
          i = e.stateNode;
          var u = e.memoizedState;
          u !== null && (a = u.retryLane);
          break;
        case Bt:
          i = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      i !== null && i.delete(t), Z0(e, a);
    }
    function ND(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : lD(e / 1960) * 1960;
    }
    function zD() {
      if (mp > oD)
        throw mp = 0, kS = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Kc > sD && (Kc = 0, vm = null, S("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function UD() {
      Ka.flushLegacyContextWarning(), Ka.flushPendingUnsafeLifecycleWarnings();
    }
    function J0(e, t) {
      ut(e), Sm(e, mi, eD), t && Sm(e, ya, tD), Sm(e, mi, Zw), t && Sm(e, ya, Jw), St();
    }
    function Sm(e, t, a) {
      for (var i = e, u = null; i !== null; ) {
        var s = i.subtreeFlags & t;
        i !== u && i.child !== null && s !== ue ? i = i.child : ((i.flags & t) !== ue && a(i), i.sibling !== null ? i = i.sibling : i = u = i.return);
      }
    }
    var Cm = null;
    function eT(e) {
      {
        if ((ze & An) !== cn || !(e.mode & xe))
          return;
        var t = e.tag;
        if (t !== Zt && t !== ne && t !== fe && t !== ge && t !== _e && t !== ft && t !== De)
          return;
        var a = Te(e) || "ReactComponent";
        if (Cm !== null) {
          if (Cm.has(a))
            return;
          Cm.add(a);
        } else
          Cm = /* @__PURE__ */ new Set([a]);
        var i = xn;
        try {
          ut(e), S("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          i ? ut(e) : St();
        }
      }
    }
    var NS;
    {
      var AD = null;
      NS = function(e, t, a) {
        var i = oT(AD, t);
        try {
          return p0(e, t, a);
        } catch (s) {
          if (WR() || s !== null && typeof s == "object" && typeof s.then == "function")
            throw s;
          if (kh(), hE(), S0(e, t), oT(t, i), t.mode & Ve && Ug(t), hi(null, p0, null, e, t, a), Va()) {
            var u = ao();
            typeof u == "object" && u !== null && u._suppressLogging && typeof s == "object" && s !== null && !s._suppressLogging && (s._suppressLogging = !0);
          }
          throw s;
        }
      };
    }
    var tT = !1, zS;
    zS = /* @__PURE__ */ new Set();
    function HD(e) {
      if (si && !Dx())
        switch (e.tag) {
          case ge:
          case _e:
          case De: {
            var t = kt && Te(kt) || "Unknown", a = t;
            if (!zS.has(a)) {
              zS.add(a);
              var i = Te(e) || "Unknown";
              S("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", i, t, t);
            }
            break;
          }
          case fe: {
            tT || (S("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), tT = !0);
            break;
          }
        }
    }
    function Sp(e, t) {
      if (Kn) {
        var a = e.memoizedUpdaters;
        a.forEach(function(i) {
          xo(e, i, t);
        });
      }
    }
    var US = {};
    function AS(e, t) {
      {
        var a = ii.current;
        return a !== null ? (a.push(t), US) : Bf(e, t);
      }
    }
    function nT(e) {
      if (e !== US)
        return pv(e);
    }
    function rT() {
      return ii.current !== null;
    }
    function FD(e) {
      {
        if (e.mode & xe) {
          if (!z0())
            return;
        } else if (!iD() || ze !== cn || e.tag !== ge && e.tag !== _e && e.tag !== De)
          return;
        if (ii.current === null) {
          var t = xn;
          try {
            ut(e), S(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Te(e));
          } finally {
            t ? ut(e) : St();
          }
        }
      }
    }
    function VD(e) {
      e.tag !== Tu && z0() && ii.current === null && S(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Cp(e) {
      j0 = e;
    }
    var Oa = null, Zc = null, jD = function(e) {
      Oa = e;
    };
    function Jc(e) {
      {
        if (Oa === null)
          return e;
        var t = Oa(e);
        return t === void 0 ? e : t.current;
      }
    }
    function HS(e) {
      return Jc(e);
    }
    function FS(e) {
      {
        if (Oa === null)
          return e;
        var t = Oa(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var a = Jc(e.render);
            if (e.render !== a) {
              var i = {
                $$typeof: Ql,
                render: a
              };
              return e.displayName !== void 0 && (i.displayName = e.displayName), i;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function aT(e, t) {
      {
        if (Oa === null)
          return !1;
        var a = e.elementType, i = t.type, u = !1, s = typeof i == "object" && i !== null ? i.$$typeof : null;
        switch (e.tag) {
          case fe: {
            typeof i == "function" && (u = !0);
            break;
          }
          case ge: {
            (typeof i == "function" || s === mn) && (u = !0);
            break;
          }
          case _e: {
            (s === Ql || s === mn) && (u = !0);
            break;
          }
          case ft:
          case De: {
            (s === qr || s === mn) && (u = !0);
            break;
          }
          default:
            return !1;
        }
        if (u) {
          var f = Oa(a);
          if (f !== void 0 && f === Oa(i))
            return !0;
        }
        return !1;
      }
    }
    function iT(e) {
      {
        if (Oa === null || typeof WeakSet != "function")
          return;
        Zc === null && (Zc = /* @__PURE__ */ new WeakSet()), Zc.add(e);
      }
    }
    var BD = function(e, t) {
      {
        if (Oa === null)
          return;
        var a = t.staleFamilies, i = t.updatedFamilies;
        Hl(), Al(function() {
          VS(e.current, i, a);
        });
      }
    }, PD = function(e, t) {
      {
        if (e.context !== la)
          return;
        Hl(), Al(function() {
          Ep(t, e, null, null);
        });
      }
    };
    function VS(e, t, a) {
      {
        var i = e.alternate, u = e.child, s = e.sibling, f = e.tag, p = e.type, v = null;
        switch (f) {
          case ge:
          case De:
          case fe:
            v = p;
            break;
          case _e:
            v = p.render;
            break;
        }
        if (Oa === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var m = !1, y = !1;
        if (v !== null) {
          var R = Oa(v);
          R !== void 0 && (a.has(R) ? y = !0 : t.has(R) && (f === fe ? y = !0 : m = !0));
        }
        if (Zc !== null && (Zc.has(e) || i !== null && Zc.has(i)) && (y = !0), y && (e._debugNeedsRemount = !0), y || m) {
          var E = Br(e, he);
          E !== null && pn(E, e, he, nt);
        }
        u !== null && !y && VS(u, t, a), s !== null && VS(s, t, a);
      }
    }
    var $D = function(e, t) {
      {
        var a = /* @__PURE__ */ new Set(), i = new Set(t.map(function(u) {
          return u.current;
        }));
        return jS(e.current, i, a), a;
      }
    };
    function jS(e, t, a) {
      {
        var i = e.child, u = e.sibling, s = e.tag, f = e.type, p = null;
        switch (s) {
          case ge:
          case De:
          case fe:
            p = f;
            break;
          case _e:
            p = f.render;
            break;
        }
        var v = !1;
        p !== null && t.has(p) && (v = !0), v ? YD(e, a) : i !== null && jS(i, t, a), u !== null && jS(u, t, a);
      }
    }
    function YD(e, t) {
      {
        var a = QD(e, t);
        if (a)
          return;
        for (var i = e; ; ) {
          switch (i.tag) {
            case ae:
              t.add(i.stateNode);
              return;
            case Se:
              t.add(i.stateNode.containerInfo);
              return;
            case ne:
              t.add(i.stateNode.containerInfo);
              return;
          }
          if (i.return === null)
            throw new Error("Expected to reach root first.");
          i = i.return;
        }
      }
    }
    function QD(e, t) {
      for (var a = e, i = !1; ; ) {
        if (a.tag === ae)
          i = !0, t.add(a.stateNode);
        else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === e)
          return i;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e)
            return i;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !1;
    }
    var BS;
    {
      BS = !1;
      try {
        var lT = Object.preventExtensions({});
      } catch {
        BS = !0;
      }
    }
    function ID(e, t, a, i) {
      this.tag = e, this.key = a, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = i, this.flags = ue, this.subtreeFlags = ue, this.deletions = null, this.lanes = U, this.childLanes = U, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !BS && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var ua = function(e, t, a, i) {
      return new ID(e, t, a, i);
    };
    function PS(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function GD(e) {
      return typeof e == "function" && !PS(e) && e.defaultProps === void 0;
    }
    function WD(e) {
      if (typeof e == "function")
        return PS(e) ? fe : ge;
      if (e != null) {
        var t = e.$$typeof;
        if (t === Ql)
          return _e;
        if (t === qr)
          return ft;
      }
      return Zt;
    }
    function rs(e, t) {
      var a = e.alternate;
      a === null ? (a = ua(e.tag, t, e.key, e.mode), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugSource = e._debugSource, a._debugOwner = e._debugOwner, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = ue, a.subtreeFlags = ue, a.deletions = null, a.actualDuration = 0, a.actualStartTime = -1), a.flags = e.flags & zt, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue;
      var i = e.dependencies;
      switch (a.dependencies = i === null ? null : {
        lanes: i.lanes,
        firstContext: i.firstContext
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case Zt:
        case ge:
        case De:
          a.type = Jc(e.type);
          break;
        case fe:
          a.type = HS(e.type);
          break;
        case _e:
          a.type = FS(e.type);
          break;
      }
      return a;
    }
    function XD(e, t) {
      e.flags &= zt | Et;
      var a = e.alternate;
      if (a === null)
        e.childLanes = U, e.lanes = t, e.child = null, e.subtreeFlags = ue, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = ue, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type;
        var i = a.dependencies;
        e.dependencies = i === null ? null : {
          lanes: i.lanes,
          firstContext: i.firstContext
        }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration;
      }
      return e;
    }
    function qD(e, t, a) {
      var i;
      return e === yh ? (i = xe, t === !0 && (i |= Ke, i |= je)) : i = oe, Kn && (i |= Ve), ua(ne, null, null, i);
    }
    function $S(e, t, a, i, u, s) {
      var f = Zt, p = e;
      if (typeof e == "function")
        PS(e) ? (f = fe, p = HS(p)) : p = Jc(p);
      else if (typeof e == "string")
        f = ae;
      else
        e: switch (e) {
          case Pl:
            return Uu(a.children, u, s, t);
          case Gi:
            f = at, u |= Ke, (u & xe) !== oe && (u |= je);
            break;
          case $l:
            return KD(a, u, s, t);
          case is:
            return ZD(a, u, s, t);
          case ls:
            return JD(a, u, s, t);
          case lf:
            return uT(a, u, s, t);
          case kp:
          case Dp:
          case bp:
          case _p:
          case Dm:
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case Yl:
                  f = Cn;
                  break e;
                case Vu:
                  f = Rr;
                  break e;
                case Ql:
                  f = _e, p = FS(p);
                  break e;
                case qr:
                  f = ft;
                  break e;
                case mn:
                  f = En, p = null;
                  break e;
              }
            var v = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var m = i ? Te(i) : null;
              m && (v += `

Check the render method of \`` + m + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + v));
          }
        }
      var y = ua(f, a, t, u);
      return y.elementType = e, y.type = p, y.lanes = s, y._debugOwner = i, y;
    }
    function YS(e, t, a) {
      var i = null;
      i = e._owner;
      var u = e.type, s = e.key, f = e.props, p = $S(u, s, f, i, t, a);
      return p._debugSource = e._source, p._debugOwner = e._owner, p;
    }
    function Uu(e, t, a, i) {
      var u = ua(Xe, e, i, t);
      return u.lanes = a, u;
    }
    function KD(e, t, a, i) {
      typeof e.id != "string" && S('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var u = ua(it, e, i, t | Ve);
      return u.elementType = $l, u.lanes = a, u.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, u;
    }
    function ZD(e, t, a, i) {
      var u = ua(Me, e, i, t);
      return u.elementType = is, u.lanes = a, u;
    }
    function JD(e, t, a, i) {
      var u = ua(Bt, e, i, t);
      return u.elementType = ls, u.lanes = a, u;
    }
    function uT(e, t, a, i) {
      var u = ua(we, e, i, t);
      u.elementType = lf, u.lanes = a;
      var s = {
        isHidden: !1
      };
      return u.stateNode = s, u;
    }
    function QS(e, t, a) {
      var i = ua(He, e, null, t);
      return i.lanes = a, i;
    }
    function ek() {
      var e = ua(ae, null, null, oe);
      return e.elementType = "DELETED", e;
    }
    function tk(e) {
      var t = ua(Wt, null, null, oe);
      return t.stateNode = e, t;
    }
    function IS(e, t, a) {
      var i = e.children !== null ? e.children : [], u = ua(Se, i, e.key, t);
      return u.lanes = a, u.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, u;
    }
    function oT(e, t) {
      return e === null && (e = ua(Zt, null, null, oe)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function nk(e, t, a, i, u) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = ky, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Fe, this.eventTimes = Ro(U), this.expirationTimes = Ro(nt), this.pendingLanes = U, this.suspendedLanes = U, this.pingedLanes = U, this.expiredLanes = U, this.mutableReadLanes = U, this.finishedLanes = U, this.entangledLanes = U, this.entanglements = Ro(U), this.identifierPrefix = i, this.onRecoverableError = u, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var s = this.pendingUpdatersLaneMap = [], f = 0; f < vl; f++)
          s.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case yh:
          this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
          break;
        case Tu:
          this._debugRootType = a ? "hydrate()" : "render()";
          break;
      }
    }
    function sT(e, t, a, i, u, s, f, p, v, m) {
      var y = new nk(e, t, a, p, v), R = qD(t, s);
      y.current = R, R.stateNode = y;
      {
        var E = {
          element: i,
          isDehydrated: a,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        R.memoizedState = E;
      }
      return ig(R), y;
    }
    var GS = "18.3.1";
    function rk(e, t, a) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Vl(i), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Xr,
        key: i == null ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: a
      };
    }
    var WS, XS;
    WS = !1, XS = {};
    function cT(e) {
      if (!e)
        return la;
      var t = au(e), a = VR(t);
      if (t.tag === fe) {
        var i = t.type;
        if (Ni(i))
          return HC(t, i, a);
      }
      return a;
    }
    function ak(e, t) {
      {
        var a = au(e);
        if (a === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var i = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + i);
        }
        var u = Xn(a);
        if (u === null)
          return null;
        if (u.mode & Ke) {
          var s = Te(a) || "Component";
          if (!XS[s]) {
            XS[s] = !0;
            var f = xn;
            try {
              ut(u), a.mode & Ke ? S("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, s) : S("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, s);
            } finally {
              f ? ut(f) : St();
            }
          }
        }
        return u.stateNode;
      }
    }
    function fT(e, t, a, i, u, s, f, p) {
      var v = !1, m = null;
      return sT(e, t, v, m, a, i, u, s, f);
    }
    function dT(e, t, a, i, u, s, f, p, v, m) {
      var y = !0, R = sT(a, i, y, e, u, s, f, p, v);
      R.context = cT(null);
      var E = R.current, b = Cr(), L = Nu(E), M = Ol(b, L);
      return M.callback = t ?? null, wu(E, M, L), fD(R, L, b), R;
    }
    function Ep(e, t, a, i) {
      Yf(t, e);
      var u = t.current, s = Cr(), f = Nu(u);
      pt(f);
      var p = cT(a);
      t.context === null ? t.context = p : t.pendingContext = p, si && xn !== null && !WS && (WS = !0, S(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Te(xn) || "Unknown"));
      var v = Ol(s, f);
      v.payload = {
        element: e
      }, i = i === void 0 ? null : i, i !== null && (typeof i != "function" && S("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i), v.callback = i);
      var m = wu(u, v, f);
      return m !== null && (pn(m, u, f, s), Oh(m, u, f)), f;
    }
    function Em(e) {
      var t = e.current;
      if (!t.child)
        return null;
      switch (t.child.tag) {
        case ae:
          return t.child.stateNode;
        default:
          return t.child.stateNode;
      }
    }
    function ik(e) {
      switch (e.tag) {
        case ne: {
          var t = e.stateNode;
          if (cc(t)) {
            var a = Sv(t);
            hD(t, a);
          }
          break;
        }
        case Me: {
          Al(function() {
            var u = Br(e, he);
            if (u !== null) {
              var s = Cr();
              pn(u, e, he, s);
            }
          });
          var i = he;
          qS(e, i);
          break;
        }
      }
    }
    function pT(e, t) {
      var a = e.memoizedState;
      a !== null && a.dehydrated !== null && (a.retryLane = xv(a.retryLane, t));
    }
    function qS(e, t) {
      pT(e, t);
      var a = e.alternate;
      a && pT(a, t);
    }
    function lk(e) {
      if (e.tag === Me) {
        var t = yo, a = Br(e, t);
        if (a !== null) {
          var i = Cr();
          pn(a, e, t, i);
        }
        qS(e, t);
      }
    }
    function uk(e) {
      if (e.tag === Me) {
        var t = Nu(e), a = Br(e, t);
        if (a !== null) {
          var i = Cr();
          pn(a, e, t, i);
        }
        qS(e, t);
      }
    }
    function vT(e) {
      var t = st(e);
      return t === null ? null : t.stateNode;
    }
    var hT = function(e) {
      return null;
    };
    function ok(e) {
      return hT(e);
    }
    var mT = function(e) {
      return !1;
    };
    function sk(e) {
      return mT(e);
    }
    var yT = null, gT = null, ST = null, CT = null, ET = null, TT = null, RT = null, xT = null, wT = null;
    {
      var DT = function(e, t, a) {
        var i = t[a], u = en(e) ? e.slice() : Le({}, e);
        return a + 1 === t.length ? (en(u) ? u.splice(i, 1) : delete u[i], u) : (u[i] = DT(e[i], t, a + 1), u);
      }, kT = function(e, t) {
        return DT(e, t, 0);
      }, bT = function(e, t, a, i) {
        var u = t[i], s = en(e) ? e.slice() : Le({}, e);
        if (i + 1 === t.length) {
          var f = a[i];
          s[f] = s[u], en(s) ? s.splice(u, 1) : delete s[u];
        } else
          s[u] = bT(
            // $FlowFixMe number or string is fine here
            e[u],
            t,
            a,
            i + 1
          );
        return s;
      }, _T = function(e, t, a) {
        if (t.length !== a.length) {
          bt("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var i = 0; i < a.length - 1; i++)
            if (t[i] !== a[i]) {
              bt("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return bT(e, t, a, 0);
      }, LT = function(e, t, a, i) {
        if (a >= t.length)
          return i;
        var u = t[a], s = en(e) ? e.slice() : Le({}, e);
        return s[u] = LT(e[u], t, a + 1, i), s;
      }, MT = function(e, t, a) {
        return LT(e, t, 0, a);
      }, KS = function(e, t) {
        for (var a = e.memoizedState; a !== null && t > 0; )
          a = a.next, t--;
        return a;
      };
      yT = function(e, t, a, i) {
        var u = KS(e, t);
        if (u !== null) {
          var s = MT(u.memoizedState, a, i);
          u.memoizedState = s, u.baseState = s, e.memoizedProps = Le({}, e.memoizedProps);
          var f = Br(e, he);
          f !== null && pn(f, e, he, nt);
        }
      }, gT = function(e, t, a) {
        var i = KS(e, t);
        if (i !== null) {
          var u = kT(i.memoizedState, a);
          i.memoizedState = u, i.baseState = u, e.memoizedProps = Le({}, e.memoizedProps);
          var s = Br(e, he);
          s !== null && pn(s, e, he, nt);
        }
      }, ST = function(e, t, a, i) {
        var u = KS(e, t);
        if (u !== null) {
          var s = _T(u.memoizedState, a, i);
          u.memoizedState = s, u.baseState = s, e.memoizedProps = Le({}, e.memoizedProps);
          var f = Br(e, he);
          f !== null && pn(f, e, he, nt);
        }
      }, CT = function(e, t, a) {
        e.pendingProps = MT(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Br(e, he);
        i !== null && pn(i, e, he, nt);
      }, ET = function(e, t) {
        e.pendingProps = kT(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var a = Br(e, he);
        a !== null && pn(a, e, he, nt);
      }, TT = function(e, t, a) {
        e.pendingProps = _T(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Br(e, he);
        i !== null && pn(i, e, he, nt);
      }, RT = function(e) {
        var t = Br(e, he);
        t !== null && pn(t, e, he, nt);
      }, xT = function(e) {
        hT = e;
      }, wT = function(e) {
        mT = e;
      };
    }
    function ck(e) {
      var t = Xn(e);
      return t === null ? null : t.stateNode;
    }
    function fk(e) {
      return null;
    }
    function dk() {
      return xn;
    }
    function pk(e) {
      var t = e.findFiberByHostInstance, a = N.ReactCurrentDispatcher;
      return uu({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: yT,
        overrideHookStateDeletePath: gT,
        overrideHookStateRenamePath: ST,
        overrideProps: CT,
        overridePropsDeletePath: ET,
        overridePropsRenamePath: TT,
        setErrorHandler: xT,
        setSuspenseHandler: wT,
        scheduleUpdate: RT,
        currentDispatcherRef: a,
        findHostInstanceByFiber: ck,
        findFiberByHostInstance: t || fk,
        // React Refresh
        findHostInstancesForRefresh: $D,
        scheduleRefresh: BD,
        scheduleRoot: PD,
        setRefreshHandler: jD,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: dk,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: GS
      });
    }
    var OT = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function ZS(e) {
      this._internalRoot = e;
    }
    Tm.prototype.render = ZS.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? S("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Rm(arguments[1]) ? S("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && S("You passed a second argument to root.render(...) but it only accepts one argument.");
        var a = t.containerInfo;
        if (a.nodeType !== Ot) {
          var i = vT(t.current);
          i && i.parentNode !== a && S("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Ep(e, t, null, null);
    }, Tm.prototype.unmount = ZS.prototype.unmount = function() {
      typeof arguments[0] == "function" && S("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        Y0() && S("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Al(function() {
          Ep(null, e, null, null);
        }), OC(t);
      }
    };
    function vk(e, t) {
      if (!Rm(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      NT(e);
      var a = !1, i = !1, u = "", s = OT;
      t != null && (t.hydrate ? bt("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === oi && S(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (u = t.identifierPrefix), t.onRecoverableError !== void 0 && (s = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var f = fT(e, yh, null, a, i, u, s);
      ch(f.current, e);
      var p = e.nodeType === Ot ? e.parentNode : e;
      return kd(p), new ZS(f);
    }
    function Tm(e) {
      this._internalRoot = e;
    }
    function hk(e) {
      e && zv(e);
    }
    Tm.prototype.unstable_scheduleHydration = hk;
    function mk(e, t, a) {
      if (!Rm(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      NT(e), t === void 0 && S("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var i = a ?? null, u = a != null && a.hydratedSources || null, s = !1, f = !1, p = "", v = OT;
      a != null && (a.unstable_strictMode === !0 && (s = !0), a.identifierPrefix !== void 0 && (p = a.identifierPrefix), a.onRecoverableError !== void 0 && (v = a.onRecoverableError));
      var m = dT(t, null, e, yh, i, s, f, p, v);
      if (ch(m.current, e), kd(e), u)
        for (var y = 0; y < u.length; y++) {
          var R = u[y];
          Cx(m, R);
        }
      return new Tm(m);
    }
    function Rm(e) {
      return !!(e && (e.nodeType === Qn || e.nodeType === Fa || e.nodeType === _f));
    }
    function Tp(e) {
      return !!(e && (e.nodeType === Qn || e.nodeType === Fa || e.nodeType === _f || e.nodeType === Ot && e.nodeValue === " react-mount-point-unstable "));
    }
    function NT(e) {
      e.nodeType === Qn && e.tagName && e.tagName.toUpperCase() === "BODY" && S("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Fd(e) && (e._reactRootContainer ? S("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : S("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var yk = N.ReactCurrentOwner, zT;
    zT = function(e) {
      if (e._reactRootContainer && e.nodeType !== Ot) {
        var t = vT(e._reactRootContainer.current);
        t && t.parentNode !== e && S("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var a = !!e._reactRootContainer, i = JS(e), u = !!(i && Cu(i));
      u && !a && S("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === Qn && e.tagName && e.tagName.toUpperCase() === "BODY" && S("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function JS(e) {
      return e ? e.nodeType === Fa ? e.documentElement : e.firstChild : null;
    }
    function UT() {
    }
    function gk(e, t, a, i, u) {
      if (u) {
        if (typeof i == "function") {
          var s = i;
          i = function() {
            var E = Em(f);
            s.call(E);
          };
        }
        var f = dT(
          t,
          i,
          e,
          Tu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          UT
        );
        e._reactRootContainer = f, ch(f.current, e);
        var p = e.nodeType === Ot ? e.parentNode : e;
        return kd(p), Al(), f;
      } else {
        for (var v; v = e.lastChild; )
          e.removeChild(v);
        if (typeof i == "function") {
          var m = i;
          i = function() {
            var E = Em(y);
            m.call(E);
          };
        }
        var y = fT(
          e,
          Tu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          UT
        );
        e._reactRootContainer = y, ch(y.current, e);
        var R = e.nodeType === Ot ? e.parentNode : e;
        return kd(R), Al(function() {
          Ep(t, y, a, i);
        }), y;
      }
    }
    function Sk(e, t) {
      e !== null && typeof e != "function" && S("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function xm(e, t, a, i, u) {
      zT(a), Sk(u === void 0 ? null : u, "render");
      var s = a._reactRootContainer, f;
      if (!s)
        f = gk(a, t, e, u, i);
      else {
        if (f = s, typeof u == "function") {
          var p = u;
          u = function() {
            var v = Em(f);
            p.call(v);
          };
        }
        Ep(t, f, e, u);
      }
      return Em(f);
    }
    var AT = !1;
    function Ck(e) {
      {
        AT || (AT = !0, S("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var t = yk.current;
        if (t !== null && t.stateNode !== null) {
          var a = t.stateNode._warnedAboutRefsInRender;
          a || S("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", We(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === Qn ? e : ak(e, "findDOMNode");
    }
    function Ek(e, t, a) {
      if (S("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Tp(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = Fd(t) && t._reactRootContainer === void 0;
        i && S("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return xm(null, e, t, !0, a);
    }
    function Tk(e, t, a) {
      if (S("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Tp(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = Fd(t) && t._reactRootContainer === void 0;
        i && S("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return xm(null, e, t, !1, a);
    }
    function Rk(e, t, a, i) {
      if (S("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Tp(a))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !Xm(e))
        throw new Error("parentComponent must be a valid React Component");
      return xm(e, t, a, !1, i);
    }
    var HT = !1;
    function xk(e) {
      if (HT || (HT = !0, S("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Tp(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = Fd(e) && e._reactRootContainer === void 0;
        t && S("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var a = JS(e), i = a && !Cu(a);
          i && S("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Al(function() {
          xm(null, null, e, !1, function() {
            e._reactRootContainer = null, OC(e);
          });
        }), !0;
      } else {
        {
          var u = JS(e), s = !!(u && Cu(u)), f = e.nodeType === Qn && Tp(e.parentNode) && !!e.parentNode._reactRootContainer;
          s && S("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", f ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    gn(ik), fu(lk), Lv(uk), bo(Fr), cd(kv), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && S("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), ks(D1), Wm(LS, mD, Al);
    function wk(e, t) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Rm(t))
        throw new Error("Target container is not a DOM element.");
      return rk(e, t, null, a);
    }
    function Dk(e, t, a, i) {
      return Rk(e, t, a, i);
    }
    var eC = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Cu, Lc, fh, eu, bs, LS]
    };
    function kk(e, t) {
      return eC.usingClientEntryPoint || S('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), vk(e, t);
    }
    function bk(e, t, a) {
      return eC.usingClientEntryPoint || S('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), mk(e, t, a);
    }
    function _k(e) {
      return Y0() && S("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Al(e);
    }
    var Lk = pk({
      findFiberByHostInstance: Po,
      bundleType: 1,
      version: GS,
      rendererPackageName: "react-dom"
    });
    if (!Lk && hn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var FT = window.location.protocol;
      /^(https?|file):$/.test(FT) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (FT === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Ir.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = eC, Ir.createPortal = wk, Ir.createRoot = kk, Ir.findDOMNode = Ck, Ir.flushSync = _k, Ir.hydrate = Ek, Ir.hydrateRoot = bk, Ir.render = Tk, Ir.unmountComponentAtNode = xk, Ir.unstable_batchedUpdates = LS, Ir.unstable_renderSubtreeIntoContainer = Dk, Ir.version = GS, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ir;
}
function IT() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(IT);
    } catch (le) {
      console.error(le);
    }
  }
}
process.env.NODE_ENV === "production" ? (IT(), rC.exports = Ak()) : rC.exports = Hk();
var Fk = rC.exports;
const Yk = /* @__PURE__ */ Nk(Fk);
export {
  Yk as $,
  Fk as r
};
